import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Time: { input: Date | string; output: string; }
};

export enum AccessSetting {
  AllowedEmailsOnly = 'allowed_emails_only',
  Anyone = 'anyone',
  AnyoneLeavingDetails = 'anyone_leaving_details'
}

/** An AlicloudAccountConfig stores the details of an AliCloud account */
export type AlicloudAccountConfig = {
  __typename?: 'AlicloudAccountConfig';
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** List of managed policies that should be applied to the account. See https://console.aws.amazon.com/iam/home?region=eu-west-1#/policies */
  managed_policies: Array<Scalars['String']['output']>;
  /** Name of the project */
  name: Scalars['String']['output'];
  /** RAM policy that should be applied to the account, can be empty */
  ram_policy: Maybe<Scalars['String']['output']>;
};

/** An AlicloudAccountInput stores the details of an Alicloud account */
export type AlicloudAccountConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of managed policies that should be applied to the account */
  managed_policies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']['input']>;
  /** RAM policy that should be applied to the account, can be empty */
  ram_policy?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
};

/** An arcade machine */
export type Arcade = {
  __typename?: 'Arcade';
  /** If the arcade machine is active */
  active: Scalars['Boolean']['output'];
  /** The alternative URL for the arcade machine */
  alternative_url: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Organization Slug */
  organization: Scalars['String']['output'];
  /** Serial Number */
  serial_number: Scalars['String']['output'];
};

export type ArcadeInput = {
  alternative_url?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type ArcadeLogin = {
  __typename?: 'ArcadeLogin';
  alternative_url: Maybe<Scalars['String']['output']>;
  organization: Organization;
  token: Scalars['String']['output'];
};

/** An AwsAccountConfig stores the details of an AWS account */
export type AwsAccountConfig = {
  __typename?: 'AwsAccountConfig';
  /** IAM policy that should be applied to the account, can be empty */
  iam_policy: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** List of managed policies that should be applied to the account. See https://console.aws.amazon.com/iam/home?region=eu-west-1#/policies */
  managed_policies: Array<Scalars['String']['output']>;
  /** Name of the project */
  name: Scalars['String']['output'];
  /** Service Control policy that will be applied to the account, can be empty */
  scp_policy: Maybe<Scalars['String']['output']>;
};

/** An AwsAccountConfigInput stores the details of an AWS account */
export type AwsAccountConfigInput = {
  /** IAM policy that should be applied to the account, can be empty */
  iam_policy?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of managed policies that should be applied to the account. See https://console.aws.amazon.com/iam/home?region=eu-west-1#/policies */
  managed_policies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Service Control policy that will be applied to the account, can be empty */
  scp_policy?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
};

/** An AzureSubscriptionConfig stores the details of an Azure Subscription */
export type AzureSubscriptionConfig = {
  __typename?: 'AzureSubscriptionConfig';
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Name of the project */
  name: Scalars['String']['output'];
  /** Roles to assign to the user */
  roles: Array<Scalars['String']['output']>;
  /** Only create an AAD user */
  user_only: Scalars['Boolean']['output'];
};

/** An AzureSubscriptionInput stores the details of an Azure Subscription */
export type AzureSubscriptionConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Roles to assign to the user */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
  /** Only create an AAD user */
  user_only?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A challenge is a bite-sized problem that needs to be solved. Each challenge consists of the explanation followed by a hands-on assignment or quiz. */
export type Challenge = {
  __typename?: 'Challenge';
  /** List of possible answers in case of a quiz type challenge */
  answers: Array<Scalars['String']['output']>;
  /** The assignment a user has to complete. In case of a quiz, this is the question. */
  assignment: Scalars['String']['output'];
  /** List of attempts the user has done to solve the challenge */
  attempts: Array<ChallengeAttempt>;
  /** Whether checking is available or not, this is dependent on the presence of a check script */
  can_check: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the challenge was completed. Will be 0 when not yet completed */
  completed: Scalars['Int']['output'];
  /** Difficulty of the challenge. This field is currently not used */
  difficulty: Scalars['String']['output'];
  /** Error message for when the challenge was failed. Will be null if there was no error */
  failMessage: Maybe<Scalars['String']['output']>;
  /** Timestamp when the challenge was failed. Will be 0 when there was no error */
  failed: Scalars['Int']['output'];
  /** True if there is only one correct answer */
  hasSingleAnswer: Scalars['Boolean']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Index of the challenge, used for ordering the challenges in a track. Starts at 0. */
  index: Scalars['Int']['output'];
  /** List of notes for this challenge */
  notes: Array<ChallengeNote>;
  /** Permalink for this challenge. Will be generated automatically, based on the slugs of the team, track and challenge. */
  permalink: Maybe<Scalars['String']['output']>;
  /** List of scripts for this challenge */
  scripts: Array<ChallengeScript>;
  /** Slug of the challenge. This will be visible in the address bar of the browser */
  slug: Scalars['String']['output'];
  /** List of valid answers for a quiz */
  solution: Array<Scalars['Int']['output']>;
  /** Timestamp when the challenge was started. Will be 0 when not yet started */
  started: Scalars['Int']['output'];
  /** Status of the challenge */
  status: ChallengeStatus;
  /** List of tabs for this challenge */
  tabs: Array<ChallengeTab>;
  /** Teaser of the challenge. This will be visible for the user when the challenge is not yet unlocked. */
  teaser: Scalars['String']['output'];
  /** Maximum time the challenge is available. The sum of timelimits of all challenges determine the total TTL for a track. */
  timelimit: Maybe<Scalars['Int']['output']>;
  /** Title of the challenge */
  title: Scalars['String']['output'];
  /** The track associated with the challenge */
  track: Track;
  /** Type of the challenge */
  type: ChallengeType;
  /** Which challenge will be unlocked after this challenge has been successfully completed. This field is currently not used (the next challenge in the list will automatically be unlocked) */
  unlocks: Maybe<Challenge>;
};

/** ChallengeAttempt stores an attempt to solve a challenge */
export type ChallengeAttempt = {
  __typename?: 'ChallengeAttempt';
  /** Result message of the attempt */
  message: Scalars['String']['output'];
  /** Timestamp of the attempt */
  timestamp: Scalars['Time']['output'];
};

/** A challenge is a bite-sized problem that needs to be solved. Each challenge consists of the explanation followed by a hands-on assignment or quiz. */
export type ChallengeInput = {
  /** List of possible answers in case of a quiz type challenge */
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The assignment a user has to complete. In case of a quiz, this is the question. */
  assignment?: InputMaybe<Scalars['String']['input']>;
  /** Difficulty of the challenge. This field is currently not used */
  difficulty?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Index of the challenge, used for ordering the challenges in a track. Starts at 0. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** List of notes for this challenge */
  notes?: InputMaybe<Array<ChallengeNoteInput>>;
  /** List of scripts for this challenge */
  scripts?: InputMaybe<Array<ChallengeScriptInput>>;
  /** Slug of the challenge. This will be visible in the address bar of the browser */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** List of valid answers for a quiz */
  solution?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of tabs for this challenge */
  tabs?: InputMaybe<Array<ChallengeTabInput>>;
  /** Teaser of the challenge. This will be visible for the user when the challenge is not yet unlocked. */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** Maximum time the challenge is available. The sum of timelimits of all challenges determine the total TTL for a track. */
  timelimit?: InputMaybe<Scalars['Int']['input']>;
  /** Title of the challenge */
  title?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this challenge belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
  /** Type of the challenge */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A ChallengeNote is displayed when the infrastructure of your challenge is being created. You can display markdown text but also show an image or video. */
export type ChallengeNote = {
  __typename?: 'ChallengeNote';
  /** Text contents */
  contents: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Index of the note, used for ordering the notes of a challenge. Starts at 0. */
  index: Scalars['Int']['output'];
  /** Type of the note */
  type: ChallengeNoteType;
  /** URL for image and video notes */
  url: Maybe<Scalars['String']['output']>;
};

/** A ChallengeNote is displayed when the infrastructure of your challenge is being created. You can display markdown text but also show an image or video. */
export type ChallengeNoteInput = {
  /** ID of the challenge this note belongs to */
  challenge?: InputMaybe<Scalars['String']['input']>;
  /** Text contents */
  contents?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Index of the note, used for ordering the notes of a challenge. Starts at 0. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the track this note belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
  /** Type of the note */
  type?: InputMaybe<ChallengeNoteType>;
  /** URL for image and video notes */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** ChallengeNoteType enumerated the possible note types */
export enum ChallengeNoteType {
  Image = 'image',
  Text = 'text',
  Video = 'video'
}

/**
 * Challenge scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 4 actions: setup, check, cleanup and solve
 */
export type ChallengeScript = {
  __typename?: 'ChallengeScript';
  /** One of: setup, check, cleanup and solve */
  action: Scalars['String']['output'];
  /** The script contents */
  contents: Scalars['String']['output'];
  /** On which host the script is executed. Must reference a host in the track config */
  host: Scalars['String']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
};

/**
 * Challenge scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 4 actions: setup, check, cleanup and solve
 */
export type ChallengeScriptInput = {
  /** One of: setup, check, cleanup and solve */
  action?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this challenge belongs to */
  challenge?: InputMaybe<Scalars['String']['input']>;
  /** The script contents */
  contents?: InputMaybe<Scalars['String']['input']>;
  /** On which host the script is executed. Must reference a host in the track config */
  host?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the track this script belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
};

export type ChallengeSeries = {
  __typename?: 'ChallengeSeries';
  completed: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  started: Scalars['Int']['output'];
  unlocked: Scalars['Int']['output'];
};

export type ChallengeStatistics = {
  __typename?: 'ChallengeStatistics';
  attempts_avg: Maybe<Scalars['Int']['output']>;
  attempts_max: Maybe<Scalars['Int']['output']>;
  attempts_min: Maybe<Scalars['Int']['output']>;
  attempts_stddev: Maybe<Scalars['Int']['output']>;
  attempts_total: Maybe<Scalars['Int']['output']>;
  completed_total: Maybe<Scalars['Int']['output']>;
  duration_avg: Maybe<Scalars['Int']['output']>;
  duration_max: Maybe<Scalars['Int']['output']>;
  duration_min: Maybe<Scalars['Int']['output']>;
  duration_stddev: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  series: Array<ChallengeSeries>;
  started_total: Maybe<Scalars['Int']['output']>;
  title: Maybe<Scalars['String']['output']>;
  unlocked_total: Maybe<Scalars['Int']['output']>;
};

/** ChallengeStatus enumerates the possible states for challenges */
export enum ChallengeStatus {
  /** The check script is being run */
  Checking = 'checking',
  /** The user has completed the challenge successfully */
  Completed = 'completed',
  /** The challenge is ready for the user to start playing */
  Created = 'created',
  /** The setup script is being run */
  Creating = 'creating',
  /** The setup script has failed to run */
  Failed = 'failed',
  /** The challenge is locked, another challenge has to be completed first */
  Locked = 'locked',
  /** The user has started the challenge */
  Started = 'started',
  /** The challenge is available to play, but has not yet been started by the user */
  Unlocked = 'unlocked'
}

/** A tab shows a service, terminal or (external) website for a challenge */
export type ChallengeTab = {
  __typename?: 'ChallengeTab';
  /** initial command to run, only valid for terminal tabs */
  cmd: Maybe<Scalars['String']['output']>;
  /** custom headers to send with proxy response */
  custom_headers: Maybe<Array<CustomHeader>>;
  /** custom headers to send from proxy response */
  custom_response_headers: Maybe<Array<CustomHeader>>;
  /** Refers to a host in the track config. Must be set for types service and terminal. */
  hostname: Maybe<Scalars['String']['output']>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Index of the tab, used for ordering the tabs of a challenge. Starts at 0. */
  index: Scalars['Int']['output'];
  /** Whether to open this tab in an external window */
  new_window: Scalars['Boolean']['output'];
  /** Path of a service. Only valid for type service, defaults to / */
  path: Maybe<Scalars['String']['output']>;
  /** Port of a service. Only valid for type service */
  port: Maybe<Scalars['Int']['output']>;
  /** Currently not used */
  target: Maybe<Scalars['String']['output']>;
  /** Title of the tab */
  title: Scalars['String']['output'];
  /** Type of the tab */
  type: ChallengeTabType;
  /** URL of an (external) website. Only valid for type website and external */
  url: Maybe<Scalars['String']['output']>;
  /** Initial work directory, only valid for terminal tabs */
  workdir: Maybe<Scalars['String']['output']>;
};

/** A tab shows a service, terminal or (external) website for a challenge */
export type ChallengeTabInput = {
  /** ID of the challenge this tab belongs to */
  challenge?: InputMaybe<Scalars['String']['input']>;
  /** initial command to run, only valid for terminal tabs */
  cmd?: InputMaybe<Scalars['String']['input']>;
  /** custom headers to send with proxy response */
  custom_headers?: InputMaybe<Array<CustomHeaderInput>>;
  /** custom headers to send from proxy response */
  custom_response_headers?: InputMaybe<Array<CustomHeaderInput>>;
  /** Refers to a host in the track config. Must be set for types service and terminal. */
  hostname?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Index of the tab, used for ordering the tabs of a challenge. Starts at 0. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to open this tab in an external window */
  new_window?: InputMaybe<Scalars['Boolean']['input']>;
  /** Path of a service. Only valid for type service, defaults to / */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Port of a service. Only valid for type service */
  port?: InputMaybe<Scalars['Int']['input']>;
  /** Title of the tab */
  title?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this tab belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
  /** Type of the tab */
  type?: InputMaybe<ChallengeTabType>;
  /** URL of an (external) website. Only valid for type website and external */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Initial work directory, only valid for terminal tabs */
  workdir?: InputMaybe<Scalars['String']['input']>;
};

/** ChallengeTabType enumerates the possible tab types */
export enum ChallengeTabType {
  /** Virtual browser provided as a service */
  Browser = 'browser',
  /** Simple code editor */
  Code = 'code',
  /** URL to an external website. Useful for sites that are not frameable */
  External = 'external',
  /** Internal service of your track, should reference a host in the track config */
  Service = 'service',
  /** Terminal to a host in the track config */
  Terminal = 'terminal',
  /** URL to a website. The website should be frameable in an iframe */
  Website = 'website'
}

/** ChallengeType enumerates the possible challenge types */
export enum ChallengeType {
  /** A challenge has setup and scripts */
  Challenge = 'challenge',
  /** A quiz has a question and one or more answers */
  Quiz = 'quiz'
}

export type CompletionRateSeries = {
  __typename?: 'CompletionRateSeries';
  Items: Array<CompletionRateSeriesItem>;
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
};

export type CompletionRateSeriesItem = {
  __typename?: 'CompletionRateSeriesItem';
  bucketStartTime: Scalars['Time']['output'];
  value: Scalars['Float']['output'];
};

export enum ConditionType {
  Contains = 'contains',
  EndsWith = 'ends_with',
  Equals = 'equals',
  StartsWith = 'starts_with'
}

/** A ContainerConfig stores the details of a container */
export type ContainerConfig = {
  __typename?: 'ContainerConfig';
  /** Override the CMD from the docker image */
  cmd: Maybe<Scalars['String']['output']>;
  /** Override the ENTRYPOINT from the docker image */
  entrypoint: Maybe<Scalars['String']['output']>;
  /** List of key-value pairs that are injected as environment variables */
  environment: Maybe<Array<EnvironmentVariable>>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Container image to use */
  image: Scalars['String']['output'];
  /** Amount of memory to use, in megabytes. Defaults to 32 */
  memory: Scalars['Int']['output'];
  /** Name of the container, will be used as hostname */
  name: Scalars['String']['output'];
  /** Ports to expose */
  ports: Maybe<Array<Scalars['Int']['output']>>;
  /** Deprecated */
  resources: ContainerResources;
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell: Scalars['String']['output'];
};

/** A ContainerConfig stores the details of a container */
export type ContainerConfigInput = {
  /** Override the CMD from the docker image */
  cmd?: InputMaybe<Scalars['String']['input']>;
  /** Override the ENTRYPOINT from the docker image */
  entrypoint?: InputMaybe<Scalars['String']['input']>;
  /** List of key-value pairs that are injected as environment variables */
  environment?: InputMaybe<Array<EnvironmentInput>>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Container image to use */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Amount of memory to use, in megabytes. Defaults to 32 */
  memory?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the container, will be used as hostname */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Ports to expose */
  ports?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Deprecated */
  resources?: InputMaybe<ContainerResourcesInput>;
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A ContainerConfigPreset stores the config for
 * a container preset.
 */
export type ContainerConfigPreset = {
  __typename?: 'ContainerConfigPreset';
  /** Container image to use */
  image: Scalars['String']['output'];
  /** The label of the preset */
  label: Scalars['String']['output'];
  /** Amount of memory to use */
  memory: Scalars['Int']['output'];
};

/** Deprecated */
export type ContainerResources = {
  __typename?: 'ContainerResources';
  memory: Scalars['Int']['output'];
};

/** Deprecated */
export type ContainerResourcesInput = {
  memory?: InputMaybe<Scalars['Int']['input']>;
};

/** CustomHeader represents a Instruqt CustomHeader */
export type CustomHeader = {
  __typename?: 'CustomHeader';
  /** The key of the header */
  key: Scalars['String']['output'];
  /** The value of the header */
  value: Scalars['String']['output'];
};

/** Parameters used to create or update a webhooks headers */
export type CustomHeaderInput = {
  /** The key of the header */
  key: Scalars['String']['input'];
  /** The value of the header */
  value: Scalars['String']['input'];
};

/** Key value pair of a custom parameter associated with a Play */
export type CustomParameter = {
  __typename?: 'CustomParameter';
  /** Key of custom parameter */
  key: Scalars['String']['output'];
  /** Value associated with the key of custom parameter */
  value: Scalars['String']['output'];
};

/** Filter for key value pair */
export type CustomParameterFilter = {
  /** Key of filter */
  key: Scalars['String']['input'];
  /** Value of filter */
  value: Scalars['String']['input'];
};

/**
 * A custom parameter can be used to add metadata to a track play.
 * You can use this metadata to integrate with external systems, like an LMS or
 * a marketing automation tool.
 */
export type CustomParametersInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CustomResource = {
  __typename?: 'CustomResource';
  canDelete: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  createdBy: User;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputs: Array<CustomResourceInput>;
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputs: Array<CustomResourceOutput>;
  provider: CustomResourceProvider;
  slug: Scalars['String']['output'];
  terraformModule: Maybe<TerraformModule>;
  version: Scalars['String']['output'];
};

/** A CustomResourceConfig stores the details of a custom resource */
export type CustomResourceConfig = {
  __typename?: 'CustomResourceConfig';
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** URL of the custom resource */
  inputs: Array<CustomResourceInputConfig>;
  /** The custom resource */
  name: Scalars['String']['output'];
};

/** A CustomResourceConfigInput is a custom resource that can be used in a sandbox */
export type CustomResourceConfigInput = {
  /** The inputs for the custom resource */
  inputs?: InputMaybe<Array<CustomResourceConfigInputInput>>;
  /** Name of the custom resource */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the custom resource */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** A CustomResourceConfigInputInput is an input for a custom resource config */
export type CustomResourceConfigInputInput = {
  /** Name of the input */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Source of the input */
  source?: InputMaybe<CustomResourceInputInputSource>;
  /** value of the input */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomResourceDataType {
  Bool = 'bool',
  Json = 'json',
  Number = 'number',
  String = 'string'
}

export type CustomResourceInput = {
  __typename?: 'CustomResourceInput';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: CustomResourceDataType;
};

/**
 * A CustomResourceInputConfig stores the
 * details of a custom resource input
 */
export type CustomResourceInputConfig = {
  __typename?: 'CustomResourceInputConfig';
  /** Name of the input */
  name: Scalars['String']['output'];
  /** Source of the input */
  source: CustomResourceInputSource;
  /** Value of the input depending on the source */
  value: Scalars['String']['output'];
};

/**
 * A CustomResourceInputSource stores of the
 * source of a custom resource input value
 */
export enum CustomResourceInputInputSource {
  /** The input is a secret */
  Secret = 'secret',
  /** The input is plain text */
  Text = 'text'
}

/**
 * A CustomResourceInputSource stores of the
 * source of a custom resource input value
 */
export enum CustomResourceInputSource {
  /** The input is a secret */
  Secret = 'secret',
  /** The input is plain text */
  Text = 'text'
}

export type CustomResourceOutput = {
  __typename?: 'CustomResourceOutput';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CustomResourceProvider {
  Terraform = 'terraform'
}

/** Filter for date range */
export type DateRangeFilter = {
  /** Begining of range */
  from?: InputMaybe<Scalars['Time']['input']>;
  /** End of range */
  to?: InputMaybe<Scalars['Time']['input']>;
};

export type DefaultSsoConnectionOptions = {
  __typename?: 'DefaultSsoConnectionOptions';
  clientID: Scalars['String']['output'];
  /** @deprecated We will no longer expose this */
  clientSecret: Scalars['String']['output'];
  domain: Scalars['String']['output'];
};

/** Sort direction, can be either Asc or Desc. */
export enum Direction {
  Asc = 'Asc',
  Desc = 'Desc'
}

/** Specifies a Environment Variable */
export type EnvironmentInput = {
  /** Name of the env var */
  key?: InputMaybe<Scalars['String']['input']>;
  /** Value of the env var */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type EnvironmentVariable = {
  __typename?: 'EnvironmentVariable';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Form = {
  __typename?: 'Form';
  consentNotice: Maybe<Scalars['String']['output']>;
  fields: Array<FormField>;
  formTitle: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  validateWorkEmail: Maybe<Scalars['Boolean']['output']>;
};

export type FormField = {
  __typename?: 'FormField';
  /** Name of the field */
  fieldName: FormFieldName;
  id: Scalars['ID']['output'];
  /** Is this field required to be filled in by the user */
  isRequired: Scalars['Boolean']['output'];
};

export type FormFieldInput = {
  fieldName: FormFieldName;
  isRequired: Scalars['Boolean']['input'];
};

export enum FormFieldName {
  CompanyName = 'company_name',
  Consent = 'consent',
  CountryCode = 'country_code',
  Email = 'email',
  FirstName = 'first_name',
  JobLevel = 'job_level',
  JobTitle = 'job_title',
  LastName = 'last_name',
  PhoneNumber = 'phone_number',
  UsState = 'us_state'
}

export type FormInput = {
  consentNotice?: InputMaybe<Scalars['String']['input']>;
  fields: Array<FormFieldInput>;
  formTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  validateWorkEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A GcpProjectConfig stores the details of a GCP Project */
export type GcpProjectConfig = {
  __typename?: 'GcpProjectConfig';
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Name of the project */
  name: Scalars['String']['output'];
  /** List of roles that should be applied to the project Service Account and User, e.g. roles/compute.admin. See predefined list https://cloud.google.com/iam/docs/understanding-roles#predefined */
  roles: Array<Scalars['String']['output']>;
  /** List of services that should be enabled. See https://cloud.google.com/service-usage/docs/list-services */
  services: Array<Scalars['String']['output']>;
};

/** A GcpProjectConfig stores the details of a GCP Project */
export type GcpProjectConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the project */
  name?: InputMaybe<Scalars['String']['input']>;
  /** List of roles that should be applied to the project Service Account and User, e.g. roles/compute.admin. See predefined list https://cloud.google.com/iam/docs/understanding-roles#predefined */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of services that should be enabled. See https://cloud.google.com/service-usage/docs/list-services */
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A GoogleCloudMachineTypePreset defines a Google
 * Cloud machine type.
 */
export type GoogleCloudMachineTypePreset = {
  __typename?: 'GoogleCloudMachineTypePreset';
  /** The label of the Google Cloud machine type preset */
  label: Scalars['String']['output'];
  /** The name of the Google Cloud machine type */
  machine_type: Scalars['String']['output'];
};

export type HappinessCount = {
  __typename?: 'HappinessCount';
  count: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type HotStartConfigTrackEdge = {
  __typename?: 'HotStartConfigTrackEdge';
  /** The amount of available sandboxes. */
  available: Scalars['Int']['output'];
  /** The amount of claimed sandboxes. */
  claimed: Scalars['Int']['output'];
  /** The amount of created sandboxes. */
  created: Scalars['Int']['output'];
  /** The amount of sandboxes currently being created. */
  creating: Scalars['Int']['output'];
  /** The amount of sandboxes that failed to create. */
  failed: Scalars['Int']['output'];
  /** The config version node */
  node: SandboxConfig;
  /** The total amount of sandboxes. */
  total: Scalars['Int']['output'];
};

/** A hot start pool manages the hot sandboxes available per track */
export type HotStartPool = {
  __typename?: 'HotStartPool';
  /** Flag that signals if the sandboxes should be auto refillable */
  auto_refill: Scalars['Boolean']['output'];
  /** Tracks in the hot start pool */
  configs: Array<HotStartConfigTrackEdge>;
  /** Creation time of the hot start pool */
  created: Maybe<Scalars['Time']['output']>;
  /** The user that created the pool */
  created_by: Maybe<User>;
  /** Schedule time for the hot start pool to stop creating sandboxes */
  ends_at: Maybe<Scalars['Time']['output']>;
  /** ID of the hot start pool */
  id: Scalars['ID']['output'];
  /** Name given to the hot start pool */
  name: Scalars['String']['output'];
  /** Region of a hotstart pool */
  region: Maybe<Scalars['String']['output']>;
  /** Number of sandboxes available per track */
  size: Scalars['Int']['output'];
  /** Schedule time for the hot start pool to start creating sandboxes */
  starts_at: Maybe<Scalars['Time']['output']>;
  /** Status of the hot start pool */
  status: HotStartStatus;
  /** The team that owns the hot start pool */
  team: Team;
  /** Tracks in the hot start pool */
  tracks: Array<HotStartPoolTrackEdge>;
  /** The type of hot start pool */
  type: HotStartPoolType;
};

export type HotStartPoolConnection = {
  __typename?: 'HotStartPoolConnection';
  /** A list of edges containing cursors to each node. */
  edges: Array<HotStartPoolEdge>;
  /** A list of nodes. */
  nodes: Array<HotStartPool>;
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total items in the current result set. */
  totalCount: Scalars['Int']['output'];
};

export type HotStartPoolEdge = {
  __typename?: 'HotStartPoolEdge';
  /** Cursor to the current node. */
  cursor: Scalars['String']['output'];
  /** The current node. */
  node: Maybe<HotStartPool>;
};

/** A hot start pool is a pool of sandboxes available before the tracks start */
export type HotStartPoolInput = {
  /** List of config IDs */
  configs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Scheduled time for the pool to start stopping sandboxes */
  ends_at?: InputMaybe<Scalars['Time']['input']>;
  /** Name of the hot start pool */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization Slug of the organization creating the pool */
  organization_slug?: InputMaybe<Scalars['String']['input']>;
  /** Region of the hotstart pool */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The amount of sandboxes per track */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Scheduled time for the pool to start creating sandboxes */
  starts_at?: InputMaybe<Scalars['Time']['input']>;
  /** Team Slug of the organization creating the pool */
  team_slug?: InputMaybe<Scalars['String']['input']>;
  /** List of track IDs */
  tracks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The type of hotstart pool */
  type?: InputMaybe<HotStartPoolType>;
};

export type HotStartPoolTrackEdge = {
  __typename?: 'HotStartPoolTrackEdge';
  /** The amount of available sandboxes. */
  available: Scalars['Int']['output'];
  /** The amount of claimed sandboxes. */
  claimed: Scalars['Int']['output'];
  /** The amount of created sandboxes. */
  created: Scalars['Int']['output'];
  /** The amount of sandboxes currently being created. */
  creating: Scalars['Int']['output'];
  /** The amount of sandboxes that failed to create. */
  failed: Scalars['Int']['output'];
  /** The track node */
  node: Track;
  /** The total amount of sandboxes. */
  total: Scalars['Int']['output'];
};

export enum HotStartPoolType {
  Dedicated = 'dedicated',
  Shared = 'shared'
}

export enum HotStartStatus {
  AutoRefill = 'AutoRefill',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Provisioning = 'Provisioning',
  Running = 'Running'
}

/** Represents a criterium to match against */
export type HtmlElement = {
  __typename?: 'HtmlElement';
  /** The custom error message that will be displayed if the check fails */
  errorMsg: Maybe<Scalars['String']['output']>;
  /** The CSS selector of the element */
  selector: Scalars['String']['output'];
  /** The expected value of the element */
  value: Scalars['String']['output'];
};

export type HtmlElementInput = {
  errorMsg?: InputMaybe<Scalars['String']['input']>;
  selector: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ImportTerraformModuleInput = {
  /** description of the custom resource */
  description?: InputMaybe<Scalars['String']['input']>;
  /** name of the custom resource */
  name?: InputMaybe<Scalars['String']['input']>;
  /** slug of the custom resource */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** id of the terraform module */
  terraformModuleID: Scalars['String']['input'];
};

/** An Insights has list of different insights */
export type Insights = {
  __typename?: 'Insights';
  play: PlayInsight;
  track: TrackInsight;
};

/** A claim is a used that has accepted an invite */
export type InviteClaim = {
  __typename?: 'InviteClaim';
  /** When the user claimed the invite */
  claimedAt: Maybe<Scalars['Time']['output']>;
  /** Custom parameters associated with this claim */
  customParameters: Array<CustomParameter>;
  /** A list of events for this track */
  events: Array<InviteEvent>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** The number of plays the end user has done */
  playCount: Scalars['Int']['output'];
  /** The number of plays the end user is allowed to do */
  playLimit: Maybe<Scalars['Int']['output']>;
  /** The TTL until when the end user can play the track */
  playTTL: Maybe<Scalars['Time']['output']>;
  /** The invite associated with this claim */
  trackInvite: Maybe<TrackInvite>;
  /** The list of library entries for the claim */
  trackLibrary: Array<TrackLibraryEntry>;
  /** The user that has accepted the invite */
  user: User;
  /**
   * Username of the user that has accepted the invite
   * @deprecated Replaced by user object
   */
  username: Scalars['String']['output'];
};

/** An event stores the timestamp and status of an invite */
export type InviteEvent = {
  __typename?: 'InviteEvent';
  /** Challenge of the event */
  challenge: Maybe<Challenge>;
  /** Message of the event */
  message: Scalars['String']['output'];
  /** participantID of the event */
  participantID: Maybe<Scalars['String']['output']>;
  /** Status of the event */
  status: InviteStatus;
  /** Time of the event */
  time: Scalars['Time']['output'];
  /** Track of the event */
  track: Maybe<Track>;
};

/** InviteFilterStatus options */
export enum InviteFilterStatus {
  /** Active invites */
  Active = 'active',
  /** All invites */
  All = 'all',
  /** Expired invites */
  Expired = 'expired',
  /** Upcoming invites */
  Upcoming = 'upcoming'
}

/** InviteFilters applies filters to the invite */
export type InviteFilters = {
  /**
   * Status filters the invite status.
   * Deprecated: Use `statuses`.
   */
  status?: InputMaybe<InviteFilterStatus>;
  /** Status filters the invite status */
  statuses?: InputMaybe<Array<TrackInviteStatus>>;
};

/** InvitePlay the metadata of a user's track play. */
export type InvitePlay = {
  __typename?: 'InvitePlay';
  /** Number of completed challenges. */
  completed_challenges: Scalars['Int']['output'];
  /** The number of failed challenge attempts. */
  failed_challenge_attempts: Scalars['Int']['output'];
  /** The last instant the user was active on this track. */
  last_activity: Scalars['Time']['output'];
  /** The play. */
  participant: Play;
  /** The time spent on this play in seconds. */
  time_spent: Scalars['Int']['output'];
  /** The amount of challenges associated with the track. */
  total_challenges: Scalars['Int']['output'];
  /** The track that the user played. */
  track: Track;
  /** The instant the track was completed. */
  track_completed_at: Maybe<Scalars['Time']['output']>;
  /** The instant the track was started. */
  track_started_at: Scalars['Time']['output'];
  /** The user. */
  user: User;
};

/** InviteStatus enumerated the status of the invite */
export enum InviteStatus {
  /** User has accessed the invite */
  Accessed = 'accessed',
  /** User has attempted to solve the challange */
  Attempted = 'attempted',
  /** User has completed the track */
  Completed = 'completed',
  /** User has created the track */
  Created = 'created',
  /**
   * User has accepted the invite
   * @deprecated invited was ambiguous, use 'accessed' instead.
   */
  Invited = 'invited',
  /** User has skipped the challenge */
  Skipped = 'skipped',
  /** User has started the track */
  Started = 'started',
  /** User has stopped the track */
  Stopped = 'stopped'
}

export type LtiCredentials = {
  __typename?: 'LTICredentials';
  /** The consumer key of LTI credentials. */
  consumer_key: Scalars['String']['output'];
  /** The consumer name of LTI credentials. */
  consumer_name: Scalars['String']['output'];
  /** The id of the LTI credentials. */
  id: Scalars['ID']['output'];
};

export type LabConfig = {
  __typename?: 'LabConfig';
  /** The seconds lab can be extended for */
  extendTTL: Maybe<Scalars['Int']['output']>;
  /** Whether to present a stop button to learners */
  hideStopButton: Scalars['Boolean']['output'];
  /** Defines if the assignment side bar for the track's lab will overlay on top of the content */
  overlay: Scalars['Boolean']['output'];
  /** Where in the screen will the assignment side bar show */
  position: Scalars['String']['output'];
  /** The amount of space the asignment side bar will take for the track's lab */
  width: Scalars['Int']['output'];
};

export type LabConfigInput = {
  /** The amount of time the sandbox will be extended */
  extendTTL?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to present a stop button to learners */
  hideStopButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** The lab's assignement side pannel overlays on top of the content */
  overlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** The position the side pannel starts on */
  position?: InputMaybe<Scalars['String']['input']>;
  /** The width the assignment side pannel starts with */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type LearnersReachedSeries = {
  __typename?: 'LearnersReachedSeries';
  items: Array<LearnersReachedSeriesItem>;
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  sum: Scalars['Int']['output'];
};

export type LearnersReachedSeriesItem = {
  __typename?: 'LearnersReachedSeriesItem';
  bucketStartTime: Scalars['Time']['output'];
  value: Scalars['Int']['output'];
};

/** A Learning path is a set of courses */
export type LearningPath = {
  __typename?: 'LearningPath';
  /**
   * The reason this user has access to this learning path.
   * Empty if the user has no access.
   */
  access_type: Maybe<LearningPathAccessType>;
  /** Accessible defines whether the learning path is accessible for the user, and thus is ready to play */
  accessible: Scalars['Boolean']['output'];
  /** List of authors for this learning path */
  authors: Array<User>;
  /** List of courses that are part of this learning path */
  courses: Array<Track>;
  /** Description of the learning path */
  description: Scalars['String']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Hero image, must be a URL to an image */
  image: Scalars['String']['output'];
  /** Level defines the for what skill level the learning path is designed */
  level: Level;
  /** Slug of the team that owns the learning path */
  owner: Scalars['String']['output'];
  /** Permalink will be generated automatically, based on the slug of the learning path */
  permalink: Scalars['String']['output'];
  /** Preview defines whether the learning path is in preview or not */
  preview: Scalars['Boolean']['output'];
  /** Published defines whether the learning path is published */
  published: Scalars['Boolean']['output'];
  /** Slug. This will be visible in the address bar of the browser */
  slug: Scalars['String']['output'];
  /** Short Teaser for the learning path */
  teaser: Scalars['String']['output'];
  /** Learning Path Title */
  title: Scalars['String']['output'];
};

/** The reason a user has access to a learning path. */
export enum LearningPathAccessType {
  /** One of the user's teams is the owner of this learning path. */
  Owner = 'owner',
  /** One of the user's teams purchased this content. */
  Purchased = 'purchased'
}

/** A Learning path is a set of courses */
export type LearningPathInput = {
  /** List of authors (by email) for this learning path */
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of course slugs that are part of this learning path */
  courses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description of the learning path */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Hero image, must be a URL to an image */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Level defines the for what skill level the learning path is designed */
  level?: InputMaybe<Level>;
  /** Slug of the organization that owns the learning path */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Preview defines whether the learning path is in preview or not */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** Published defines whether the learning path is published */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Slug. This will be visible in the address bar of the browser */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Short Teaser for the learning path */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** Learning Path Title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LearningPathProgress = Progress & {
  __typename?: 'LearningPathProgress';
  /** Whether the user has completed all the tracks belonging to this learning path. */
  completed: Scalars['Boolean']['output'];
  /** The number of tracks the user has completed. */
  completed_tracks: Scalars['Int']['output'];
  /** The last time this learning path was played. */
  last_played_at: Maybe<Scalars['Time']['output']>;
  /** The learning path. */
  learning_path: LearningPath;
};

/** Level defines the skill level, that is used in Learning Paths and Courses/Tracks */
export enum Level {
  Beginner = 'beginner',
  Expert = 'expert',
  Intermediate = 'intermediate'
}

/** Represents a browser URL criterium to match against */
export type Location = {
  __typename?: 'Location';
  /** URLs to match against together with their string matching rules */
  conditions: Array<UrlCondition>;
  /** The custom error message that will be displayed if none of the URLs match */
  errorMsg: Maybe<Scalars['String']['output']>;
};

export type LocationCheckConditionInput = {
  condition: ConditionType;
  urlPart: Scalars['String']['input'];
};

export type LocationCheckInput = {
  /** All conditions must be met for check to pass */
  conditions?: InputMaybe<Array<LocationCheckConditionInput>>;
  /** Error message if any of the conditions don't match */
  errorMsg?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A MachineTypePreset defines an instruqt
 * machine type.
 */
export type MachineTypePreset = {
  __typename?: 'MachineTypePreset';
  /** The amount of cpus for the machine */
  cpus: Scalars['Int']['output'];
  /** The label of the machine type preset */
  label: Scalars['String']['output'];
  /** The amount of memory for the machine in MB */
  memory: Scalars['Int']['output'];
};

/** The mode in which a play was started. */
export enum Mode {
  /** Embedded play */
  Embed = 'embed',
  /** Platform play */
  Platform = 'platform',
  /** CI test play */
  Test = 'test'
}

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Add a track to an arcade
   *
   * Note: you need to be a member of the organization that owns the track
   */
  addTrackToArcade: Scalars['Boolean']['output'];
  /**
   * Add a track to a topic
   *
   * Note: you need to be a member of the organization that owns the track and topic
   */
  addTrackToTopic: Maybe<Topic>;
  /**
   * Build a track
   *
   * This converts the track config into a participant environment definition. After a build, the (updated) track is available for new participant.
   *
   * Note: you need to be a developer for this track
   */
  buildTrack: Scalars['Boolean']['output'];
  /** Promote or demote a user within a team. */
  changeTeamUserRole: Maybe<Team>;
  /**
   * Promote or demote a user within an organization.
   * @deprecated No longer supported
   */
  changeUserRole: Maybe<Organization>;
  /** Check an arcade challenge */
  checkArcadeChallenge: Maybe<Challenge>;
  /** Runs the check script of the challenge */
  checkChallenge: Maybe<Challenge>;
  /** Check if a quiz type challenge is correct */
  checkQuiz: Maybe<Challenge>;
  /**
   * Claim an organizatation invite
   * @deprecated No longer supported
   */
  claimOrganizationInvite: Maybe<OrganizationInvite>;
  /** Claims team invites associated with the current user's email. */
  claimTeamInvites: Maybe<User>;
  /** Claim a track invite. */
  claimTrackInvite: Maybe<InviteClaim>;
  /**
   * Set whether or not the user gives consent to receive marketing updates from the given organization.
   * @deprecated No longer supported
   */
  consentToOrganizationPrivacyPolicy: Scalars['Boolean']['output'];
  /** Set whether or not the user gives consent to receive marketing updates from the given team. */
  consentToTeamPrivacyPolicy: Scalars['Boolean']['output'];
  /**
   * Create an Alicloud account config
   *
   * Note: you need to be a developer for this track
   */
  createAlicloudAccountConfig: Maybe<TrackConfig>;
  /**
   * Create an AWS account config
   *
   * Note: you need to be a developer for this track
   */
  createAwsAccountConfig: Maybe<TrackConfig>;
  /**
   * Create an Azure Subscription config
   *
   * Note: you need to be a developer for this track
   */
  createAzureSubscriptionConfig: Maybe<TrackConfig>;
  /**
   * Create a new challenge for a track
   *
   * Note: you need to be a developer for this track
   */
  createChallenge: Maybe<Challenge>;
  /**
   * Create a challenge note
   *
   * Note: you need to be a developer for this track
   */
  createChallengeNote: Maybe<ChallengeNote>;
  /**
   * Create a challenge tab
   *
   * Note: you need to be a developer for this track
   */
  createChallengeTab: Maybe<ChallengeTab>;
  /**
   * Create a container config
   *
   * Note: you need to be a developer for this track
   */
  createContainerConfig: Maybe<TrackConfig>;
  /**
   * Create a GCP project config
   *
   * Note: you need to be a developer for this track
   */
  createGcpProjectConfig: Maybe<TrackConfig>;
  /** Create a new hot start pool */
  createHotStartPool: Maybe<HotStartPool>;
  /**
   * Create a new learning path
   *
   * Note: you need to be a member of the organization that will own the learning path
   * @deprecated No longer supported
   */
  createLearningPath: Maybe<LearningPath>;
  /**
   * Create an organization
   *
   * Note: you need to be an instruqt admin to call this mutation
   * @deprecated No longer supported
   */
  createOrganization: Maybe<Organization>;
  /** Create a new Arcade player */
  createPlayer: Maybe<Player>;
  createSamlSsoConnection: Maybe<SsoConnection>;
  /**
   * Creates a sandbox config with
   * the given details and resources
   *
   */
  createSandboxConfig: Maybe<SandboxConfigVersion>;
  createSsoConnection: Maybe<SsoConnection>;
  /** Creates a new tag */
  createTag: Tag;
  /** Creates a new tag group */
  createTagGroup: TagGroup;
  /**
   * Create a team
   *
   * Note: you need to be an instruqt admin to call this mutation
   */
  createTeam: Maybe<Team>;
  /**
   * Create a new topic
   *
   * Note: you need to be a member of the organization that will own the topic
   */
  createTopic: Maybe<Topic>;
  /**
   * Create a track
   *
   * Note: you need to be a member of the organization that owns the track
   */
  createTrack: Maybe<Track>;
  /**
   * Create a track developer
   *
   * Note: you need to be a developer for this track
   */
  createTrackDeveloper: Maybe<Track>;
  /**
   * Create a new track invite
   *
   * Note: you need to be a member of the organization of the track the invite is for
   */
  createTrackInvite: Maybe<TrackInvite>;
  /**
   * Create track review.
   *
   * Note: this stores track review as the currently authenticated user.
   */
  createTrackReview: Maybe<TrackReview>;
  /**
   * Create a virtualbrowser config
   *
   * Note: you need to be a developer for this track
   */
  createVirtualBrowserConfig: Maybe<TrackConfig>;
  /**
   * Create a virtualmachine config
   *
   * Note: you need to be a developer for this track
   */
  createVirtualMachineConfig: Maybe<TrackConfig>;
  /** Create a webhook */
  createWebhook: Webhook;
  /**
   * Delete an Alicloud account config
   *
   * Note: you need to be a developer for this track
   */
  deleteAlicloudAccountConfig: Maybe<TrackConfig>;
  /**
   * Delete an AWS account config
   *
   * Note: you need to be a developer for this track
   */
  deleteAwsAccountConfig: Maybe<TrackConfig>;
  /**
   * Delete an Azure Subscription config
   *
   * Note: you need to be a developer for this track
   */
  deleteAzureSubscriptionConfig: Maybe<TrackConfig>;
  /**
   * Delete a challenge from a track
   *
   * Note: you need to be a developer for this track
   */
  deleteChallenge: Scalars['Boolean']['output'];
  /**
   * Delete a challenge note
   *
   * Note: you need to be a developer for this track
   */
  deleteChallengeNote: Scalars['Boolean']['output'];
  /**
   * Delete a challenge script
   *
   * Note: you need to be a developer for this track
   */
  deleteChallengeScript: Scalars['Boolean']['output'];
  /**
   * Delete a challenge tab
   *
   * Note: you need to be a developer for this track
   */
  deleteChallengeTab: Scalars['Boolean']['output'];
  /**
   * Delete a container config
   *
   * Note: you need to be a developer for this track
   */
  deleteContainerConfig: Maybe<TrackConfig>;
  /** deletes the custom resource with the given id */
  deleteCustomResource: Scalars['Boolean']['output'];
  /**
   * Delete a GCP project config
   *
   * Note: you need to be a developer for this track
   */
  deleteGcpProjectConfig: Maybe<TrackConfig>;
  /** Delete hot start pool */
  deleteHotStartPool: Scalars['Boolean']['output'];
  /**
   * Delete a learning path
   *
   * Note: you need to be a member of the organization that owns the learning path
   * @deprecated No longer supported
   */
  deleteLearningPath: Scalars['Boolean']['output'];
  /**
   * Delete an organization invite
   *
   * Note: you need to be a member of the organization to invite a user
   * @deprecated No longer supported
   */
  deleteOrganizationInvite: Maybe<Organization>;
  /**
   * Deletes the given config version
   * drafts are deleted published are archived
   *
   */
  deleteSandboxConfig: Scalars['Boolean']['output'];
  deleteSandboxConfigHost: Maybe<SandboxConfigVersion>;
  deleteSsoConnection: Scalars['Boolean']['output'];
  /** Deletes a tag */
  deleteTag: Scalars['Boolean']['output'];
  /** Deletes a tag group */
  deleteTagGroup: Scalars['Boolean']['output'];
  /**
   * Delete a team invite
   *
   * Note: you need to be a member of the team to invite a user
   */
  deleteTeamInvite: Maybe<Team>;
  deleteTeamSecret: Scalars['Boolean']['output'];
  /**
   * Delete a topic
   *
   * Note: you need to be a member of the organization that owns the topic
   */
  deleteTopic: Scalars['Boolean']['output'];
  /**
   * Delete a track
   *
   * Note: you need to be a developer for this track
   */
  deleteTrack: Scalars['Boolean']['output'];
  /**
   * Delete a track invite
   *
   * Deleting an invite does not delete the access to the track for users that have already accepted the invite.
   *
   * Note: you need to be a member of the organization of the track the invite is for
   */
  deleteTrackInvite: Scalars['Boolean']['output'];
  /** Delete a track invite claim. */
  deleteTrackInviteClaim: Scalars['Boolean']['output'];
  /** Deletes a user */
  deleteUser: Scalars['Boolean']['output'];
  /** Delete a virtual browser check */
  deleteVirtualBrowserCheck: Scalars['Boolean']['output'];
  /**
   * Delete a virtualbrowser config
   *
   * Note: you need to be a developer for this track
   */
  deleteVirtualBrowserConfig: Maybe<TrackConfig>;
  /**
   * Delete a virtualmachine config
   *
   * Note: you need to be a developer for this track
   */
  deleteVirtualMachineConfig: Maybe<TrackConfig>;
  /** Delete a webhook */
  deleteWebhook: Scalars['Boolean']['output'];
  /**
   * Generate a new one time play token for a track
   *
   * Note: you need to be a developer for this track
   */
  generateOneTimePlayToken: Scalars['String']['output'];
  /**
   * Generate an API key for an organization
   *
   * Either organizationSlug or organizationID must be specified
   *
   * Note: you need to be a member of the organization to generate an API key
   * @deprecated No longer supported
   */
  generateOrganizationAPIKey: Maybe<Scalars['String']['output']>;
  /**
   * Generate an API key for a team
   *
   * Either teamSlug or teamID must be specified
   *
   * Note: you need to be a member of the team to generate an API key
   */
  generateTeamAPIKey: Maybe<Scalars['String']['output']>;
  /**
   * Generate LTI credentials for a team
   *
   * Either teamSlug or teamID must be specified
   *
   * Note: you need to be a member of the team to generate an API key
   */
  generateTeamLTICredentials: Maybe<LtiCredentials>;
  /**
   * Generate a new embed token for a track
   *
   * Note: you need to be a developer for this track
   */
  generateTrackEmbedToken: Maybe<Track>;
  /** Imports a terraform module with the given ID into the given team */
  importTerraformModule: CustomResource;
  /**
   * Invite a user to an organization
   *
   * Note: you need to be a member of the organization to invite a user
   * @deprecated No longer supported
   */
  inviteOrganizationUser: Maybe<Organization>;
  /**
   * Invite a user to a team
   *
   * Note: you need to be a member of the team to invite a user
   */
  inviteTeamUser: Maybe<Team>;
  /** Notify the track idle service that a participant is still active */
  keepAlive: Scalars['Boolean']['output'];
  /**
   * Login the user identified by the token in the Authorization Header
   * @deprecated This function is no longer required and is a no-op
   */
  login: Maybe<User>;
  /**
   * Merge a anonymous account into a registered account
   *
   * Note: should be called by a logged in user
   */
  mergeAnonymousUser: Scalars['Boolean']['output'];
  /**
   * Publish publishes the draft version
   * for the given configID
   *
   */
  publishSandboxConfig: Maybe<SandboxConfigVersion>;
  /** Refresh an ID token using the given refeshtoken */
  refreshToken: Maybe<SecureToken>;
  /** Register an arcade machine */
  registerArcade: Maybe<Arcade>;
  /** Register a new score for the the current arcade player */
  registerScore: Maybe<Ranking>;
  /**
   * Remove a user from an organization
   *
   * Note: you need to be a member of the organization to remove a user
   * @deprecated No longer supported
   */
  removeOrganizationUser: Maybe<Organization>;
  /**
   * Remove a user from a team
   *
   * Note: you need to be a member of the team to remove a user
   */
  removeTeamUser: Maybe<Team>;
  /**
   * Remove a track developer
   *
   * Note: you need to be a developer for this track
   */
  removeTrackDeveloper: Scalars['Boolean']['output'];
  /**
   * Remove a track from an arcade
   *
   * Note: you need to be a member of the organization that owns the track
   */
  removeTrackFromArcade: Scalars['Boolean']['output'];
  /**
   * Remove a track from a topic
   *
   * Note: you need to be a member of the organization that owns the track and topic
   */
  removeTrackFromTopic: Maybe<Topic>;
  /**
   * Renames a sandbox config with
   * the given id
   *
   */
  renameSandboxConfig: Maybe<SandboxConfig>;
  renameSandboxConfigHost: Maybe<SandboxConfigVersion>;
  /**
   * Save a challenge script
   *
   * Note: you need to be a developer for this track
   */
  saveChallengeScript: Maybe<ChallengeScript>;
  /**
   * Set a track play limit
   *
   * This sets a limit how many times a public track can be played. You can use this to prevent excessive charges to your account.
   *
   * Note: you have to be a developer for this track
   */
  saveTrackPlayLimit: Maybe<Track>;
  /**
   * Set th track play limits for the given track and team
   *
   * Note: if the track ID is not specified the limits will
   * apply globally for all tracks
   */
  saveTrackPlayLimits: Array<TrackPlayLimit>;
  /**
   * Save a track script
   *
   * Note: you need to be a developer for this track
   */
  saveTrackScript: Maybe<TrackScript>;
  /** Set runtime variable value to sandbox host */
  setSandboxVariable: Maybe<SandboxVariable>;
  /**
   * Set maintenance flag for a track
   *
   * Note: you need to be a developer for this track
   */
  setTrackMaintenance: Maybe<Track>;
  setTrackSandboxConfigVersion: Scalars['Boolean']['output'];
  /** Runs the setup script for a challenge */
  setupChallenge: Maybe<Challenge>;
  /** Sign in anonymously, returns an ID token */
  signInAnonymously: Maybe<SecureToken>;
  /** Skip a specific challenge of a track */
  skipChallenge: Scalars['Boolean']['output'];
  /** Skip to a specific challenge of a track */
  skipToChallenge: Maybe<Track>;
  /** Solve callenge solves the challenge */
  solveChallenge: Maybe<Challenge>;
  /**
   * Starts a challenge
   *
   * Should be called after the setup has completed successfully
   */
  startChallenge: Maybe<Challenge>;
  /**
   * Starts a track
   *
   * Will start a new play for the logged in user. If the user already has a running instance of this track, that one will be returned rather than starting a new one.
   */
  startTrack: Maybe<Track>;
  /** Stop all active tracks */
  stopAllTracks: Scalars['Boolean']['output'];
  /** Stop a sandbox instance */
  stopSandbox: Maybe<Sandbox>;
  /** Stops a track */
  stopTrack: Maybe<Track>;
  /**
   * Update an Alicloud account config
   *
   * Note: you need to be a developer for this track
   */
  updateAlicloudAccountConfig: Maybe<TrackConfig>;
  /**
   * Update an existing arcade
   *
   * Note: you need to be a member of the organization that owns the arcade
   */
  updateArcade: Maybe<Arcade>;
  /**
   * Update an AWS account config
   *
   * Note: you need to be a developer for this track
   */
  updateAwsAccountConfig: Maybe<TrackConfig>;
  /**
   * Update an Azure Subscription config
   *
   * Note: you need to be a developer for this track
   */
  updateAzureSubscriptionConfig: Maybe<TrackConfig>;
  /**
   * Update a challenge of a track
   *
   * Note: you need to be a developer for this track
   */
  updateChallenge: Maybe<Challenge>;
  /**
   * Update the challenge order of a track
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeIndexes: Maybe<Array<Challenge>>;
  /**
   * Update a challenge note
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeNote: Maybe<ChallengeNote>;
  /**
   * Update challenge note order
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeNoteIndexes: Maybe<Array<ChallengeNote>>;
  /**
   * Update a challenge tab
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeTab: Maybe<ChallengeTab>;
  /**
   * Update challenge tab order
   *
   * Note: you need to be a developer for this track
   */
  updateChallengeTabIndexes: Maybe<Array<ChallengeTab>>;
  /**
   * Update a complete track
   *
   * This is similar to updateTrack, but will also update the developers, challenge scripts and track config. It expects that all these fields are set on the input. If they are not set, it will remove any existing values from the database. The main use-case for this is facilitating the CLI.
   *
   * Note: you need to be a developer for this track
   */
  updateCompleteTrack: Maybe<Track>;
  /**
   * Update a container config
   *
   * Note: you need to be a developer for this track
   */
  updateContainerConfig: Maybe<TrackConfig>;
  /** updates the custom resource with the given id */
  updateCustomResource: CustomResource;
  /** Updates the user details form for a team */
  updateForm: Maybe<Form>;
  /**
   * Update a GCP project config
   *
   * Note: you need to be a developer for this track
   */
  updateGcpProjectConfig: Maybe<TrackConfig>;
  /** Update hot start pool */
  updateHotStartPool: Maybe<HotStartPool>;
  /**
   * Update a learning path
   *
   * Note: you need to be a member of the organization that owns the learning path
   * @deprecated No longer supported
   */
  updateLearningPath: Maybe<LearningPath>;
  updateLocalTeam: Maybe<Team>;
  /**
   * Update an organization
   * @deprecated No longer supported
   */
  updateOrganization: Maybe<Organization>;
  /**
   * Update organization features
   * @deprecated No longer supported
   */
  updateOrganizationFeatures: Maybe<OrganizationFeatures>;
  updateSamlSsoConnection: Maybe<SsoConnection>;
  /**
   * Updates the given config
   *
   */
  updateSandboxConfig: Maybe<SandboxConfigVersion>;
  /** Update the sandbox ttl time */
  updateSandboxTTL: Maybe<Sandbox>;
  /**
   * Updates the secret configs for a track
   *
   * Note: you need to be a developer for this track
   */
  updateSecretConfig: Maybe<TrackConfig>;
  updateSsoConnection: Maybe<SsoConnection>;
  /** Updates an existing tag */
  updateTag: Tag;
  /** Updates an existing tag group */
  updateTagGroup: TagGroup;
  /** Update a team */
  updateTeam: Maybe<Team>;
  /** Update team features */
  updateTeamFeatures: Maybe<TeamFeatures>;
  /**
   * Update a topic
   *
   * Note: you need to be a member of the organization that owns the topic
   */
  updateTopic: Maybe<Topic>;
  /**
   * Update the indexes of tracks in a topic
   *
   * Note: you need to be a member of the organization that owns the topic
   */
  updateTopicTrackIndexes: Maybe<Topic>;
  /**
   * Update a track
   *
   * Note: you need to be a developer for this track
   */
  updateTrack: Maybe<Track>;
  /**
   * Update a track invite
   *
   * Note: you need to be a member of the organization of the track the invite is for
   */
  updateTrackInvite: Maybe<TrackInvite>;
  /**
   * Update track review with content.
   *
   * Note: this updates track review as the currently authenticated user.
   */
  updateTrackReview: Maybe<TrackReview>;
  /** Update a user with displayName and/or slug (username) */
  updateUser: Maybe<User>;
  /**
   * Update a virtualbrowser config
   *
   * Note: you need to be a developer for this track
   */
  updateVirtualBrowserConfig: Maybe<TrackConfig>;
  /**
   * Update a virtualmachine config
   *
   * Note: you need to be a developer for this track
   */
  updateVirtualMachineConfig: Maybe<TrackConfig>;
  /** Update a webhook */
  updateWebhook: Webhook;
  upsertTeamSecret: Maybe<Secret>;
  /** Create a new virtual browser check */
  upsertVirtualBrowserCheck: VirtualBrowserCheck;
};


export type MutationAddTrackToArcadeArgs = {
  trackID: Scalars['String']['input'];
};


export type MutationAddTrackToTopicArgs = {
  topicID: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
};


export type MutationBuildTrackArgs = {
  trackID: Scalars['String']['input'];
};


export type MutationChangeTeamUserRoleArgs = {
  role: RoleName;
  teamID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
};


export type MutationChangeUserRoleArgs = {
  organizationID: Scalars['String']['input'];
  role: RoleName;
  userID: Scalars['String']['input'];
};


export type MutationCheckArcadeChallengeArgs = {
  challengeID: Scalars['String']['input'];
  playerID: Scalars['String']['input'];
};


export type MutationCheckChallengeArgs = {
  challengeID: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
  waitForCleanup: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCheckQuizArgs = {
  challengeID: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
  solution: Array<Scalars['Int']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimOrganizationInviteArgs = {
  token: Scalars['String']['input'];
};


export type MutationClaimTeamInvitesArgs = {
  token: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimTrackInviteArgs = {
  customParameters: InputMaybe<Array<CustomParametersInput>>;
  inviteID: Scalars['String']['input'];
  userDetails: InputMaybe<UserDetailsInput>;
};


export type MutationConsentToOrganizationPrivacyPolicyArgs = {
  consent: Scalars['Boolean']['input'];
  organizationID: Scalars['String']['input'];
};


export type MutationConsentToTeamPrivacyPolicyArgs = {
  consent: Scalars['Boolean']['input'];
  teamID: Scalars['String']['input'];
};


export type MutationCreateAlicloudAccountConfigArgs = {
  config: AlicloudAccountConfigInput;
};


export type MutationCreateAwsAccountConfigArgs = {
  config: AwsAccountConfigInput;
};


export type MutationCreateAzureSubscriptionConfigArgs = {
  config: AzureSubscriptionConfigInput;
};


export type MutationCreateChallengeArgs = {
  challenge: ChallengeInput;
};


export type MutationCreateChallengeNoteArgs = {
  note: ChallengeNoteInput;
};


export type MutationCreateChallengeTabArgs = {
  tab: ChallengeTabInput;
};


export type MutationCreateContainerConfigArgs = {
  config: ContainerConfigInput;
};


export type MutationCreateGcpProjectConfigArgs = {
  config: GcpProjectConfigInput;
};


export type MutationCreateHotStartPoolArgs = {
  pool: HotStartPoolInput;
};


export type MutationCreateLearningPathArgs = {
  learningPath: LearningPathInput;
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
  ownerEmails: Array<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type MutationCreatePlayerArgs = {
  difficulty: InputMaybe<Scalars['String']['input']>;
  trackID: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSamlSsoConnectionArgs = {
  ssoConnection: SsoSamlConnectionInput;
  teamID: Scalars['ID']['input'];
};


export type MutationCreateSandboxConfigArgs = {
  config: SandboxConfigInput;
  name: InputMaybe<Scalars['String']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSsoConnectionArgs = {
  ssoConnection: SsoConnectionInput;
  teamID: Scalars['ID']['input'];
};


export type MutationCreateTagArgs = {
  input: TagInput;
  teamID: Scalars['ID']['input'];
};


export type MutationCreateTagGroupArgs = {
  input: TagGroupInput;
  tagIDs: Array<Scalars['ID']['input']>;
  teamID: Scalars['ID']['input'];
};


export type MutationCreateTeamArgs = {
  name: Scalars['String']['input'];
  ownerEmails: Array<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type MutationCreateTopicArgs = {
  topic: TopicInput;
};


export type MutationCreateTrackArgs = {
  track: TrackInput;
};


export type MutationCreateTrackDeveloperArgs = {
  trackID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
};


export type MutationCreateTrackInviteArgs = {
  invite: TrackInviteInput;
};


export type MutationCreateTrackReviewArgs = {
  participantID: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  trackID: Scalars['String']['input'];
};


export type MutationCreateVirtualBrowserConfigArgs = {
  config: VirtualBrowserConfigInput;
};


export type MutationCreateVirtualMachineConfigArgs = {
  config: VirtualMachineConfigInput;
};


export type MutationCreateWebhookArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  webhook: WebhookInput;
};


export type MutationDeleteAlicloudAccountConfigArgs = {
  alicloudAccountID: Scalars['String']['input'];
};


export type MutationDeleteAwsAccountConfigArgs = {
  awsAccountID: Scalars['String']['input'];
};


export type MutationDeleteAzureSubscriptionConfigArgs = {
  azureSubscriptionID: Scalars['String']['input'];
};


export type MutationDeleteChallengeArgs = {
  challengeID: Scalars['String']['input'];
};


export type MutationDeleteChallengeNoteArgs = {
  noteID: Scalars['String']['input'];
};


export type MutationDeleteChallengeScriptArgs = {
  challengeScriptID: Scalars['String']['input'];
};


export type MutationDeleteChallengeTabArgs = {
  tabID: Scalars['String']['input'];
};


export type MutationDeleteContainerConfigArgs = {
  containerID: Scalars['String']['input'];
};


export type MutationDeleteCustomResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGcpProjectConfigArgs = {
  gcpProjectID: Scalars['String']['input'];
};


export type MutationDeleteHotStartPoolArgs = {
  poolID: Scalars['ID']['input'];
};


export type MutationDeleteLearningPathArgs = {
  learningPathID: Scalars['String']['input'];
};


export type MutationDeleteOrganizationInviteArgs = {
  email: Scalars['String']['input'];
  organizationID: Scalars['String']['input'];
};


export type MutationDeleteSandboxConfigArgs = {
  configVersionID: Scalars['String']['input'];
};


export type MutationDeleteSandboxConfigHostArgs = {
  configID: Scalars['String']['input'];
  hostName: Scalars['String']['input'];
};


export type MutationDeleteSsoConnectionArgs = {
  connectionName: Scalars['String']['input'];
  teamID: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTagGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamInviteArgs = {
  email: Scalars['String']['input'];
  teamID: Scalars['String']['input'];
};


export type MutationDeleteTeamSecretArgs = {
  name: Scalars['String']['input'];
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteTopicArgs = {
  topicID: Scalars['String']['input'];
};


export type MutationDeleteTrackArgs = {
  trackID: Scalars['String']['input'];
};


export type MutationDeleteTrackInviteArgs = {
  inviteID: Scalars['String']['input'];
};


export type MutationDeleteTrackInviteClaimArgs = {
  claimID: Scalars['String']['input'];
};


export type MutationDeleteVirtualBrowserCheckArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVirtualBrowserConfigArgs = {
  virtualbrowserID: Scalars['String']['input'];
};


export type MutationDeleteVirtualMachineConfigArgs = {
  virtualmachineID: Scalars['String']['input'];
};


export type MutationDeleteWebhookArgs = {
  id: Scalars['String']['input'];
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateOneTimePlayTokenArgs = {
  trackID: Scalars['String']['input'];
};


export type MutationGenerateOrganizationApiKeyArgs = {
  organizationID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateTeamApiKeyArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateTeamLtiCredentialsArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateTrackEmbedTokenArgs = {
  trackID: Scalars['String']['input'];
};


export type MutationImportTerraformModuleArgs = {
  input: ImportTerraformModuleInput;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteOrganizationUserArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  organizationID: Scalars['String']['input'];
  role: InputMaybe<RoleName>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type MutationInviteTeamUserArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  role: InputMaybe<RoleName>;
  teamID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
};


export type MutationKeepAliveArgs = {
  trackID: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  inviteToken: InputMaybe<Scalars['String']['input']>;
};


export type MutationMergeAnonymousUserArgs = {
  token: Scalars['String']['input'];
};


export type MutationPublishSandboxConfigArgs = {
  changeLogEntry: InputMaybe<Scalars['String']['input']>;
  configID: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterArcadeArgs = {
  organizationSlug: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRegisterScoreArgs = {
  difficulty: Scalars['String']['input'];
  handle: Scalars['String']['input'];
  organizationID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  playerID: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
};


export type MutationRemoveOrganizationUserArgs = {
  organizationID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
};


export type MutationRemoveTeamUserArgs = {
  teamID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
};


export type MutationRemoveTrackDeveloperArgs = {
  trackID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
};


export type MutationRemoveTrackFromArcadeArgs = {
  trackID: Scalars['String']['input'];
};


export type MutationRemoveTrackFromTopicArgs = {
  topicID: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
};


export type MutationRenameSandboxConfigArgs = {
  configID: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenameSandboxConfigHostArgs = {
  configID: Scalars['String']['input'];
  hostName: Scalars['String']['input'];
  newName: Scalars['String']['input'];
};


export type MutationSaveChallengeScriptArgs = {
  base64Encoded: InputMaybe<Scalars['Boolean']['input']>;
  script: ChallengeScriptInput;
};


export type MutationSaveTrackPlayLimitArgs = {
  limit: Scalars['Int']['input'];
  organizationID: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
};


export type MutationSaveTrackPlayLimitsArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackID: InputMaybe<Scalars['String']['input']>;
  trackPlayLimits: TrackPlayLimitInput;
};


export type MutationSaveTrackScriptArgs = {
  base64Encoded: InputMaybe<Scalars['Boolean']['input']>;
  script: TrackScriptInput;
};


export type MutationSetSandboxVariableArgs = {
  hostname: Scalars['String']['input'];
  key: Scalars['String']['input'];
  sandboxID: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationSetTrackMaintenanceArgs = {
  maintenance: Scalars['Boolean']['input'];
  trackID: Scalars['String']['input'];
};


export type MutationSetTrackSandboxConfigVersionArgs = {
  configVersionID: InputMaybe<Scalars['String']['input']>;
  trackID: Scalars['String']['input'];
};


export type MutationSetupChallengeArgs = {
  challengeID: Scalars['String']['input'];
};


export type MutationSkipChallengeArgs = {
  challengeID: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
  trackID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
};


export type MutationSkipToChallengeArgs = {
  challengeID: Scalars['String']['input'];
  force: InputMaybe<Scalars['Boolean']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
  trackID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
};


export type MutationSolveChallengeArgs = {
  challengeID: Scalars['String']['input'];
};


export type MutationStartChallengeArgs = {
  challengeID: Scalars['String']['input'];
};


export type MutationStartTrackArgs = {
  customParameters: InputMaybe<Array<CustomParametersInput>>;
  force: InputMaybe<Scalars['Boolean']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
  mode: InputMaybe<Mode>;
  prestart: InputMaybe<Scalars['Boolean']['input']>;
  recaptchaToken: InputMaybe<Scalars['String']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
  runtimeParameters: InputMaybe<RuntimeParametersInput>;
  trackID: Scalars['String']['input'];
};


export type MutationStopSandboxArgs = {
  sandboxID: Scalars['String']['input'];
};


export type MutationStopTrackArgs = {
  trackID: Scalars['String']['input'];
};


export type MutationUpdateAlicloudAccountConfigArgs = {
  config: AlicloudAccountConfigInput;
};


export type MutationUpdateArcadeArgs = {
  arcade: ArcadeInput;
};


export type MutationUpdateAwsAccountConfigArgs = {
  config: AwsAccountConfigInput;
};


export type MutationUpdateAzureSubscriptionConfigArgs = {
  config: AzureSubscriptionConfigInput;
};


export type MutationUpdateChallengeArgs = {
  challenge: ChallengeInput;
};


export type MutationUpdateChallengeIndexesArgs = {
  challenges: Array<Scalars['String']['input']>;
  trackID: Scalars['String']['input'];
};


export type MutationUpdateChallengeNoteArgs = {
  note: ChallengeNoteInput;
};


export type MutationUpdateChallengeNoteIndexesArgs = {
  challengeID: Scalars['String']['input'];
  notes: Array<Scalars['String']['input']>;
};


export type MutationUpdateChallengeTabArgs = {
  tab: ChallengeTabInput;
};


export type MutationUpdateChallengeTabIndexesArgs = {
  challengeID: Scalars['String']['input'];
  tabs: Array<Scalars['String']['input']>;
};


export type MutationUpdateCompleteTrackArgs = {
  track: TrackInput;
};


export type MutationUpdateContainerConfigArgs = {
  config: ContainerConfigInput;
};


export type MutationUpdateCustomResourceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomResourceInput;
};


export type MutationUpdateFormArgs = {
  form: FormInput;
};


export type MutationUpdateGcpProjectConfigArgs = {
  config: GcpProjectConfigInput;
};


export type MutationUpdateHotStartPoolArgs = {
  id: Scalars['ID']['input'];
  pool: HotStartPoolInput;
};


export type MutationUpdateLearningPathArgs = {
  learningPath: LearningPathInput;
};


export type MutationUpdateLocalTeamArgs = {
  id: Scalars['String']['input'];
  team: TeamInput;
};


export type MutationUpdateOrganizationArgs = {
  organization: OrganizationInput;
};


export type MutationUpdateOrganizationFeaturesArgs = {
  features: OrganizationFeaturesInput;
  orgID: Scalars['String']['input'];
};


export type MutationUpdateSamlSsoConnectionArgs = {
  connectionName: Scalars['String']['input'];
  ssoConnection: SsoSamlConnectionInput;
  teamID: Scalars['ID']['input'];
};


export type MutationUpdateSandboxConfigArgs = {
  config: SandboxConfigInput;
  configID: Scalars['String']['input'];
};


export type MutationUpdateSandboxTtlArgs = {
  sandboxID: Scalars['String']['input'];
  until: Scalars['Time']['input'];
};


export type MutationUpdateSecretConfigArgs = {
  configs: Array<SecretConfigInput>;
  trackID: Scalars['String']['input'];
};


export type MutationUpdateSsoConnectionArgs = {
  connectionName: Scalars['String']['input'];
  ssoConnection: SsoConnectionInput;
  teamID: Scalars['ID']['input'];
};


export type MutationUpdateTagArgs = {
  id: Scalars['ID']['input'];
  input: TagInput;
};


export type MutationUpdateTagGroupArgs = {
  id: Scalars['ID']['input'];
  input: TagGroupInput;
  tagIDs: Array<Scalars['ID']['input']>;
};


export type MutationUpdateTeamArgs = {
  team: TeamInput;
};


export type MutationUpdateTeamFeaturesArgs = {
  features: TeamFeaturesInput;
  teamID: Scalars['String']['input'];
};


export type MutationUpdateTopicArgs = {
  topic: TopicInput;
};


export type MutationUpdateTopicTrackIndexesArgs = {
  topicID: Scalars['String']['input'];
  tracks: Array<Scalars['String']['input']>;
};


export type MutationUpdateTrackArgs = {
  track: TrackInput;
};


export type MutationUpdateTrackInviteArgs = {
  invite: TrackInviteInput;
};


export type MutationUpdateTrackReviewArgs = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  displayName: InputMaybe<Scalars['String']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateVirtualBrowserConfigArgs = {
  config: VirtualBrowserConfigInput;
};


export type MutationUpdateVirtualMachineConfigArgs = {
  config: VirtualMachineConfigInput;
};


export type MutationUpdateWebhookArgs = {
  id: Scalars['String']['input'];
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  webhook: WebhookInput;
};


export type MutationUpsertTeamSecretArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertVirtualBrowserCheckArgs = {
  virtualBrowserCheck: VirtualBrowserCheckInput;
};

/** Parameters to sort a result set. */
export type Ordering = {
  /** The sort direction to use, either Asc or Desc. */
  direction?: InputMaybe<Direction>;
  /** The column to sort by. */
  orderBy: Scalars['String']['input'];
};

/** An organization has members, and owns topics and tracks */
export type Organization = {
  __typename?: 'Organization';
  /** API Key for the organization */
  api_key: Maybe<Scalars['String']['output']>;
  /** The time the organization was created at. */
  created_at: Maybe<Scalars['Time']['output']>;
  /** The time the organization has become a customer at. */
  customer_since: Maybe<Scalars['Time']['output']>;
  /** The list of features that an organization can access or use */
  features: Maybe<OrganizationFeatures>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /**
   * Invited shows a list of email addresses that are invites
   * TODO: IN-378 Remove deprecated field.
   * @deprecated use field `invites`
   */
  invited: Array<Scalars['String']['output']>;
  /** A list of active invites for this organization */
  invites: Maybe<Array<OrganizationInvite>>;
  /** Logo of the organization */
  logo: Maybe<Scalars['String']['output']>;
  /**
   * List of members
   * TODO: IN-364 Remove deprecated members field from organization.
   * @deprecated use `users` field
   */
  members: Array<OrganizationMember>;
  /** Name of the organization */
  name: Scalars['String']['output'];
  /** Whether the organization is personal or not */
  personal: Maybe<Scalars['Boolean']['output']>;
  /** Text of the primary link of the organization */
  primary_link_text: Maybe<Scalars['String']['output']>;
  /** URL of the primary link of the organization */
  primary_link_url: Maybe<Scalars['String']['output']>;
  /** The URL of the organization's privacy policy, if any. */
  privacy_policy: Maybe<Scalars['String']['output']>;
  /** Text of the secondary link of the organization */
  secondary_link_text: Maybe<Scalars['String']['output']>;
  /** URL of the secondary link of the organization */
  secondary_link_url: Maybe<Scalars['String']['output']>;
  /** Slug of the organization */
  slug: Scalars['String']['output'];
  /** Subtitle of the organization */
  subtitle: Maybe<Scalars['String']['output']>;
  /** The theme that is used to style the organization page */
  theme: Maybe<OrganizationTheme>;
  /** Title of the organization */
  title: Maybe<Scalars['String']['output']>;
  /** The time the organization's trial terminates. */
  trial_end_at: Maybe<Scalars['Time']['output']>;
  /** List of users */
  users: Maybe<Array<OrganizationUserEdge>>;
  /** The one time use URL for the Svix dashboard to configure webhook endpoints. */
  webhook_dashboard_url: Scalars['String']['output'];
};

/** OrganizationFeatures define what features are enabled for an organization */
export type OrganizationFeatures = {
  __typename?: 'OrganizationFeatures';
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox: Scalars['Boolean']['output'];
  /** Whether Alicloud accounts can be used */
  alicloud_accounts: Scalars['Boolean']['output'];
  /** Whether arcades can be used */
  arcades: Scalars['Boolean']['output'];
  /** Whether AWS accounts can be used */
  aws_accounts: Scalars['Boolean']['output'];
  /** Whether Azure subscriptions can be used */
  azure_subscriptions: Scalars['Boolean']['output'];
  /** Whether containers can be used */
  containers: Scalars['Boolean']['output'];
  /** Whether tracks can be embedded in other pages */
  embedded: Scalars['Boolean']['output'];
  /** Whether GCP projects can be used */
  gcp_projects: Scalars['Boolean']['output'];
  /** Whether hot start is enabled for this organization */
  hot_start: Scalars['Boolean']['output'];
  /** Whether invites can be created */
  invites: Scalars['Boolean']['output'];
  /**
   * The maximum size of a hot start pool
   * @deprecated Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size: Scalars['Int']['output'];
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on: Scalars['Int']['output'];
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled: Scalars['Int']['output'];
  /** The maximum number of members in this organization */
  max_members: Scalars['Int']['output'];
  /** The maximum timelimit for a single track */
  max_timelimit: Scalars['Int']['output'];
  /** The maximum number of tracks that can be created */
  max_tracks: Scalars['Int']['output'];
  /** Whether organization members can skip to a challenge */
  members_skip_to_challenge: Scalars['Boolean']['output'];
  /** Whether private content is allowed */
  private_content: Scalars['Boolean']['output'];
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay: Scalars['Boolean']['output'];
  /** Whether statistics are accessible */
  statistics: Scalars['Boolean']['output'];
  /** Whether the new study room is enabled for this organization */
  study_room_v2: Scalars['Boolean']['output'];
  /** Whether students can leave a track review after finishing a track. */
  track_reviews: Scalars['Boolean']['output'];
  /** Whether virtual machines can be used */
  virtual_machines: Scalars['Boolean']['output'];
  /** Whether vm pooling can be used */
  vm_pooling: Scalars['Boolean']['output'];
  /** Whether webhooks are enabled for this organization */
  webhooks: Scalars['Boolean']['output'];
};

/** OrganizationFeaturesInput defines the input for mutating features of an organization. */
export type OrganizationFeaturesInput = {
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Alicloud accounts can be used */
  alicloud_accounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether arcades can be used */
  arcades?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether AWS accounts can be used */
  aws_accounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Azure subscriptions can be used */
  azure_subscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether containers can be used */
  containers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether tracks can be embedded in other pages */
  embedded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether GCP projects can be used */
  gcp_projects?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether hot start is enabled for this organization */
  hot_start?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether invites can be created */
  invites?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The maximum size of a hot start pool.
   * Deprecated: Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of members in this organization */
  max_members?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum timelimit for a single track */
  max_timelimit?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of tracks that can be created */
  max_tracks?: InputMaybe<Scalars['Int']['input']>;
  /** Whether organization members can skip to a challenge */
  members_skip_to_challenge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether private content is allowed */
  private_content?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether statistics are accessible */
  statistics?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the new study room is enabled for this organization */
  study_room_v2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether students can leave a track review after finishing a track. */
  track_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether virtual machines can be used */
  virtual_machines?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether vm pooling can be used */
  vm_pooling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether webhooks are enabled for this organization */
  webhooks?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An organization has members, and owns topics and tracks */
export type OrganizationInput = {
  /** time when the organization became a customer */
  customer_since?: InputMaybe<Scalars['Time']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Logo of the organization */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Name of the organization */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Text of the primary link of the organization */
  primary_link_text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the primary link of the organization */
  primary_link_url?: InputMaybe<Scalars['String']['input']>;
  /** Text of the secondary link of the organization */
  secondary_link_text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the secondary link of the organization */
  secondary_link_url?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the organization */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Subtitle of the organization */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** The theme that is used to style the organization page */
  theme?: InputMaybe<OrganizationThemeInput>;
  /** Title of the organization */
  title?: InputMaybe<Scalars['String']['input']>;
  /** instant at which the organization's ends / ended */
  trial_end_at?: InputMaybe<Scalars['Time']['input']>;
};

/** OrganizationInvite represents an outstanding invite for an email address to join the organization */
export type OrganizationInvite = {
  __typename?: 'OrganizationInvite';
  /** The time the invite was accepted */
  accepted_at: Maybe<Scalars['Time']['output']>;
  /** The user the invite was created by */
  created_by: Maybe<User>;
  /** The email of the invite */
  email: Scalars['String']['output'];
  /** The organization this invite belongs to */
  organization: Maybe<Organization>;
  /** The role that the user will get when accepting the invite */
  role: RoleName;
  /** Whether the token in the email invite has expired */
  token_expired: Scalars['Boolean']['output'];
};

/**
 * Member of an organization
 * TODO: IN-364 Remove deprecated type.
 */
export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  /**
   * The user's ID
   * @deprecated use field `user`
   */
  id: Scalars['ID']['output'];
  /**
   * The user's profile
   * @deprecated use field `user`
   */
  profile: Maybe<UserProfile>;
  /** The user's role in the organization */
  role: RoleName;
  /** The user */
  user: User;
};

export type OrganizationSeries = {
  __typename?: 'OrganizationSeries';
  completed: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  started: Scalars['Int']['output'];
};

export type OrganizationStatistics = {
  __typename?: 'OrganizationStatistics';
  completed_total: Maybe<Scalars['Int']['output']>;
  organization_series: Array<OrganizationSeries>;
  restarted_total: Maybe<Scalars['Int']['output']>;
  started_total: Maybe<Scalars['Int']['output']>;
  track_statistics: Array<TrackStatistics>;
};

/** An OrganizationTeme defines the look and feel for an organization */
export type OrganizationTheme = {
  __typename?: 'OrganizationTheme';
  /** The color used for the background of the header */
  background_color: Maybe<Scalars['String']['output']>;
  /** The image used for the background of the header */
  background_image: Maybe<Scalars['String']['output']>;
  /** The color used for the text in the header */
  foreground_color: Maybe<Scalars['String']['output']>;
  /** The image that is shown in the header */
  foreground_image: Maybe<Scalars['String']['output']>;
  /** The color used for the background of the primary button */
  primary_background_color: Maybe<Scalars['String']['output']>;
  /** The color used for the text of the primary button */
  primary_foreground_color: Maybe<Scalars['String']['output']>;
  /** The color used for the background of the secondary button */
  secondary_background_color: Maybe<Scalars['String']['output']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color: Maybe<Scalars['String']['output']>;
};

export type OrganizationThemeInput = {
  /** The color used for the background of the header */
  background_color?: InputMaybe<Scalars['String']['input']>;
  /** The image used for the background of the header */
  background_image?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the text in the header */
  foreground_color?: InputMaybe<Scalars['String']['input']>;
  /** The image that is shown in the header */
  foreground_image?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the background of the primary button */
  primary_background_color?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the text of the primary button */
  primary_foreground_color?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the background of the secondary button */
  secondary_background_color?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the user's which are member of an organization. */
export type OrganizationUserEdge = {
  __typename?: 'OrganizationUserEdge';
  /** ID of this edge; the compound of the org ID and the user ID. */
  id: Scalars['ID']['output'];
  /** The target user. */
  node: User;
  /** The user's role within this organization. */
  role: RoleName;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** Parameters to paginate a result set. */
export type Pagination = {
  After?: InputMaybe<Scalars['String']['input']>;
  First?: InputMaybe<Scalars['Int']['input']>;
};

/** Play is the domain model of a user's journey through a track. */
export type Play = {
  __typename?: 'Play';
  /** Custom parameters associated with this play. */
  customParameters: Array<CustomParameter>;
  /** The hot start pool used for the play, if the track was hot started. */
  hotStartPool: Maybe<HotStartPool>;
  /** The ID of this user's play. */
  id: Scalars['ID']['output'];
  /** The way this track was played */
  mode: Maybe<Mode>;
  /** The time of track start */
  startedAt: Maybe<Scalars['Time']['output']>;
  /** The track of a play. */
  track: Maybe<Track>;
  /** The track invitation of a play. */
  track_invite: Maybe<TrackInvite>;
  /** TTL has been extended by the user */
  ttlExtendedByUser: Scalars['Boolean']['output'];
  /** The user of a play. */
  user: Maybe<User>;
};

/** Events for play user's activity log */
export type PlayActivity = {
  __typename?: 'PlayActivity';
  /** Challange from play, where event was triggered */
  challenge: Maybe<Challenge>;
  /** Description message of activity */
  message: Scalars['String']['output'];
  /** Time of event trigger */
  time: Scalars['Time']['output'];
};

export type PlayInsight = {
  __typename?: 'PlayInsight';
  series: PlayInsightSeries;
};


export type PlayInsightSeriesArgs = {
  input: PlayInsightSeriesInput;
};

export type PlayInsightSeries = {
  __typename?: 'PlayInsightSeries';
  completionRate: CompletionRateSeries;
  granularity: TimeSeriesGranularity;
  learnersReached: LearnersReachedSeries;
  plays: PlaySeries;
  timeSpent: TimeSpentSeries;
};

/** Input types for track table */
export type PlayInsightSeriesInput = {
  /** Date range filter for plays */
  dateRangeFilter?: InputMaybe<DateRangeFilter>;
  /** Specify which granularity the time series should return */
  granularity?: InputMaybe<TimeSeriesGranularity>;
  /** Filter for play type */
  playType: PlayType;
  /** IDs of content tags for context */
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of track auhtors as context */
  trackAuthorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of tracks for which we want to get plays */
  trackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** track invite IDs for context */
  trackInviteIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** PlayInput defines input for plays for team tracks */
export type PlayReportInput = {
  /** Filter for custom parameters */
  customParameterFilters?: InputMaybe<Array<CustomParameterFilter>>;
  /** Date range filter for plays */
  dateRangeFilter?: InputMaybe<DateRangeFilter>;
  /** Sorting parameters */
  ordering?: InputMaybe<Ordering>;
  /** Pagination parameters */
  pagination?: InputMaybe<SkipTakePagination>;
  /** Slug of a team for which we want to get plays */
  teamSlug: Scalars['String']['input'];
  /** IDs of tracks for which we want to get plays */
  trackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Track invite IDs to filter on */
  trackInviteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of users as context */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Play is the domain model of a user's journey through a track. */
export type PlayReportItem = {
  __typename?: 'PlayReportItem';
  /** Log of activities in play */
  activity: Array<PlayActivity>;
  /** The number of the completed challenges of a user in all plays */
  completedChallenges: Scalars['Int']['output'];
  /** Percentage of play chellenges completed in track */
  completionPercent: Scalars['Float']['output'];
  /** Custom parameters associated with this play. */
  customParameters: Array<CustomParameter>;
  /** The hot start pool used for the play, if the track was hot started. */
  hotStartPool: Maybe<HotStartPool>;
  /** The ID of this user's play. */
  id: Scalars['ID']['output'];
  /** The way this track was played */
  mode: Maybe<Mode>;
  /** The review of the user for the play */
  playReview: Maybe<TrackReview>;
  /** The time of track start */
  startedAt: Scalars['Time']['output'];
  /** The reason the track was stopped */
  stoppedReason: Maybe<Scalars['String']['output']>;
  /** Time spent on play */
  timeSpent: Scalars['Int']['output'];
  /** The number of all the challenges of a user */
  totalChallenges: Scalars['Int']['output'];
  /** Track associated with this play */
  track: Track;
  /** The track invitation of a play. */
  trackInvite: Maybe<TrackInvite>;
  /** User associated with this play */
  user: User;
};

export type PlayReportPage = {
  __typename?: 'PlayReportPage';
  items: Array<PlayReportItem>;
  totalItems: Scalars['Int']['output'];
};

export type PlaySeries = {
  __typename?: 'PlaySeries';
  items: Array<PlaySeriesItem>;
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  sum: Scalars['Int']['output'];
};

export type PlaySeriesItem = {
  __typename?: 'PlaySeriesItem';
  bucketStartTime: Scalars['Time']['output'];
  value: Scalars['Int']['output'];
};

/** Types of play that could be played */
export enum PlayType {
  All = 'ALL',
  Developer = 'DEVELOPER',
  Normal = 'NORMAL'
}

/** A player is an arcade user */
export type Player = {
  __typename?: 'Player';
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Number of lives left */
  lives: Scalars['Int']['output'];
};

export type Progress = {
  /** The last time this content was played by the user. */
  last_played_at: Maybe<Scalars['Time']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Get an Alicloud Account config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  alicloudAccountConfig: Maybe<AlicloudAccountConfig>;
  /** Get a specific arcade machine */
  arcade: Maybe<Arcade>;
  /** Get jwt login token for an arcade */
  arcadeLogin: Maybe<ArcadeLogin>;
  /** Get a list of arcade machines */
  arcades: Maybe<Array<Arcade>>;
  /** Get a list of arcade tracks for the given organization */
  arcadetracks: Maybe<Array<Track>>;
  /**
   * Get an AWS Account config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  awsAccountConfig: Maybe<AwsAccountConfig>;
  /**
   * Get an Azure Subscription config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  azureSubscriptionConfig: Maybe<AzureSubscriptionConfig>;
  /**
   * Get a specific challenge
   *
   * Either challengeID must be specified, or challengeSlug, trackSlug and organizationSlug
   */
  challenge: Maybe<Challenge>;
  /**
   * Get a specific challenge script
   *
   * Note: you need to be developer of that track to access this
   */
  challengeScript: Maybe<ChallengeScript>;
  /**
   * Get the scripts for a challenge
   *
   * Note: you need to be developer of that track to access this
   */
  challengeScripts: Maybe<Array<ChallengeScript>>;
  /**
   * Get a all challenges of a track
   *
   * Either trackID must be specified, or both trackSlug and organizationSlug
   */
  challenges: Maybe<Array<Challenge>>;
  /**
   * Get a container config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  containerConfig: Maybe<ContainerConfig>;
  /** Returns the custom resource with the given ID. */
  customResource: Maybe<CustomResource>;
  /** Returns all custom resources for the given team. */
  customResources: Array<CustomResource>;
  /**
   * Get all tracks for an specific usr
   *
   * This will return all the tracks that a user is developer of.
   */
  developerTracks: Maybe<Array<Track>>;
  findTeamUsers: Maybe<Array<User>>;
  /** @deprecated No longer supported */
  findUsers: Maybe<Array<User>>;
  /**
   * Get a GCP Project config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  gcpProjectConfig: Maybe<GcpProjectConfig>;
  /** Get runtime variable value from sandbox host */
  getSandboxVariable: Maybe<SandboxVariable>;
  /** Get hot start pool */
  hotStartPool: HotStartPool;
  /** Get hot start pools in organization */
  hotStartPools: Maybe<HotStartPoolConnection>;
  /** Checks if the image is valid before it being created */
  isContainerImageValid: Scalars['Boolean']['output'];
  /** Checks whether a URL is embeddable via a frame. */
  isURLEmbeddable: Scalars['Boolean']['output'];
  /**
   * Get a specific learningPath
   *
   * Either learningPathID or learningPathSlug must be specified
   * @deprecated No longer supported
   */
  learningPath: Maybe<LearningPath>;
  /**
   * Get a list of learning paths
   * @deprecated No longer supported
   */
  learningPaths: Array<LearningPath>;
  /** Gets the currently logged in user */
  me: Maybe<User>;
  /** Get user's progress for tracks and learning paths. */
  myProgress: Array<Progress>;
  /**
   * Get progress on tracks for the current user.
   * @deprecated Use myProgress query
   */
  myTrackProgress: Maybe<Array<TrackProgress>>;
  /**
   * Get a list tracks of the current user
   *
   * This will return all tracks that are in a user's library. Currently this only includes tracks for which the user has been invited.
   * @deprecated Replaced by trackLibary()
   */
  myTracks: Maybe<Array<Track>>;
  /** Get a challenge note */
  note: Maybe<ChallengeNote>;
  /**
   * Get a specific organization
   * @deprecated No longer supported
   */
  organization: Maybe<Organization>;
  /**
   * Check if an organization exists
   * @deprecated No longer supported
   */
  organizationExists: Scalars['Boolean']['output'];
  /**
   * Get an organization invite
   * @deprecated No longer supported
   */
  organizationInvite: Maybe<OrganizationInvite>;
  /** @deprecated No longer supported */
  organizationStatistics: Maybe<OrganizationStatistics>;
  /**
   * Get the list of all organizations you have access to.
   * @deprecated No longer supported
   */
  organizations: Maybe<Array<Organization>>;
  /** playReportItem retrieves a single play with related statistics */
  playReportItem: Maybe<PlayReportItem>;
  /** Returns a page of plays for a team */
  playReports: PlayReportPage;
  /** Get a specific player */
  player: Maybe<Player>;
  /** Get the rankings for a track */
  rankings: Maybe<Array<Ranking>>;
  sandboxConfig: SandboxConfig;
  sandboxConfigVersion: Maybe<SandboxConfigVersion>;
  sandboxConfigVersionDiff: Maybe<SandboxConfigVersionDiff>;
  sandboxConfigVersions: Maybe<Array<SandboxConfigVersion>>;
  sandboxConfigs: Maybe<Array<SandboxConfig>>;
  /** Returns an array of filtered sandboxes */
  sandboxes: Maybe<SandboxConnection>;
  /** Returns all terraform modules for the given query. */
  searchTerraformModules: Maybe<SearchTerraformModuleResults>;
  /**
   * Get statistics for a track
   *
   * Either trackID must be specified, or both trackSlug and teamSlug
   */
  statistics: Maybe<Statistics>;
  /** Get the student for a given invite id and user id. */
  student: Maybe<Student>;
  /** Get the statistics related to the students. */
  studentStatistics: Maybe<StudentStatistics>;
  /** Get the students for a given invite id. */
  students: Maybe<Array<Student>>;
  /** Get a challenge tab */
  tab: Maybe<ChallengeTab>;
  /** Get a specific team */
  team: Maybe<Team>;
  /** Check if a team exists */
  teamExists: Scalars['Boolean']['output'];
  /** Get a team invite */
  teamInvite: Maybe<TeamInvite>;
  teamSecrets: Maybe<Array<Secret>>;
  teamStatistics: Maybe<TeamStatistics>;
  /** Get the list of all teams you have access to. */
  teams: Maybe<Array<Team>>;
  /** Returns a terraform module for the given id. */
  terraformModule: Maybe<TerraformModule>;
  /**
   * Get a specific topic
   *
   * Either topicID must be specified, or both topicSlug and organizationSlug
   */
  topic: Maybe<Topic>;
  /** Check if a topic exists */
  topicExists: Scalars['Boolean']['output'];
  /** Get a list of topics for a given organization */
  topics: Maybe<Array<Topic>>;
  /**
   * Get a specific track
   *
   * Either trackID must be specified, or both trackSlug and teamlug
   */
  track: Maybe<Track>;
  /**
   * Get the config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  trackConfig: Maybe<TrackConfig>;
  /**
   * Get presets for track config
   *
   */
  trackConfigPresets: Maybe<TrackConfigPresets>;
  /** Check if a track exists */
  trackExists: Scalars['Boolean']['output'];
  /** Get a specific invite for a track */
  trackInvite: Maybe<TrackInvite>;
  /**
   * Get an InviteClaim for a specific invite and user
   *
   * Either claimID or a combination of inviteID and userID must be specified
   */
  trackInviteClaim: Maybe<InviteClaim>;
  /**
   * Get all invites for a team
   *
   * Either teamSlug or teamID must be specified
   */
  trackInvites: Maybe<Array<TrackInvite>>;
  /**
   * Get a list tracks of the current user
   *
   * This will return all tracks that are in a user's library. Currently this only includes tracks for which the user has been invited.
   * @deprecated Query userTrackInvites instead
   */
  trackLibrary: Maybe<TrackLibraryEntryConnection>;
  /**
   * Get all the limits configured for the given team
   *
   */
  trackPlayLimits: Array<TrackPlayLimit>;
  /** Gets a track review by ID */
  trackReview: TrackReview;
  /**
   * Get reviews for a specific track
   *
   * A trackID must be specified
   */
  trackReviews: Maybe<TrackReviewConnection>;
  /**
   * Get a specific challenge script
   *
   * Note: you need to be developer of that track to access this
   */
  trackScript: Maybe<TrackScript>;
  /**
   * Get the scripts for a track
   *
   * Note: you need to be developer of that track to access this
   */
  trackScripts: Maybe<Array<TrackScript>>;
  /**
   * Get a list of tracks
   *
   * If either teamSlug or teamID is set, it will return only tracks for that team. Otherwise it will return tracks from all teams
   */
  tracks: Maybe<Array<Track>>;
  /**
   * Gets a user
   *
   * One of userID, email or slug must be specified
   */
  user: Maybe<User>;
  /** Check if the user consented to the team's privacy policy */
  userConsentedToPrivacyPolicy: Maybe<Scalars['Boolean']['output']>;
  /** Check whether the user exists */
  userExists: Scalars['Boolean']['output'];
  /**
   * Check if the currently logged in user is member of the given organiztion
   * @deprecated No longer supported
   */
  userInOrganization: Scalars['Boolean']['output'];
  /** Check if the currently logged in user is member of the given team */
  userInTeam: Scalars['Boolean']['output'];
  /**
   * Checks if the currently logged in user is a developer for the given track
   *
   * Either trackID must be specified, or both trackSlug and teamSlug
   */
  userIsTrackDeveloper: Scalars['Boolean']['output'];
  /**
   * Get all the accepted invites or a user
   * @deprecated User User.claims instead
   */
  userTrackInvites: Maybe<Array<TrackInvite>>;
  /** Check whether the user exists */
  userWithSlugExists: Scalars['Boolean']['output'];
  /**
   * Get a specific invite for a track
   *
   * This query is similar to trackInvite(inviteID), but will throw an error when the invite has expired
   */
  viewInvite: Maybe<TrackInvite>;
  /** Returns a single Virtual Browser Check corresponding to the given challenge and host. */
  virtualBrowserCheck: VirtualBrowserCheck;
  /** Returns all Virtual Browser Checks corresponding to the given track. */
  virtualBrowserChecks: Array<VirtualBrowserCheck>;
  /**
   * Get a virtual machine config for a track
   *
   * Note: you need to be developer of that track to access this
   */
  virtualMachineConfig: Maybe<VirtualMachineConfig>;
  /** Returns all a teams webhooks */
  webhooks: Array<Webhook>;
};


export type QueryAlicloudAccountConfigArgs = {
  alicloudAccountID: Scalars['String']['input'];
};


export type QueryArcadeArgs = {
  arcadeID: Scalars['String']['input'];
};


export type QueryArcadeLoginArgs = {
  token: Scalars['String']['input'];
};


export type QueryArcadesArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type QueryArcadetracksArgs = {
  organizationSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryAwsAccountConfigArgs = {
  awsAccountID: Scalars['String']['input'];
};


export type QueryAzureSubscriptionConfigArgs = {
  azureSubscriptionID: Scalars['String']['input'];
};


export type QueryChallengeArgs = {
  challengeID: InputMaybe<Scalars['String']['input']>;
  challengeSlug: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  parseAssignmentVariables: InputMaybe<Scalars['Boolean']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackSlug: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type QueryChallengeScriptArgs = {
  scriptID: Scalars['String']['input'];
};


export type QueryChallengeScriptsArgs = {
  challengeID: Scalars['String']['input'];
};


export type QueryChallengesArgs = {
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  parseAssignmentVariables: InputMaybe<Scalars['Boolean']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackID: InputMaybe<Scalars['String']['input']>;
  trackSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryContainerConfigArgs = {
  containerID: Scalars['String']['input'];
};


export type QueryCustomResourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomResourcesArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryDeveloperTracksArgs = {
  slug: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindTeamUsersArgs = {
  searchTerm: InputMaybe<Scalars['String']['input']>;
  teamSlug: Scalars['String']['input'];
};


export type QueryFindUsersArgs = {
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryGcpProjectConfigArgs = {
  gcpProjectID: Scalars['String']['input'];
};


export type QueryGetSandboxVariableArgs = {
  hostname: Scalars['String']['input'];
  key: Scalars['String']['input'];
  sandboxID: Scalars['String']['input'];
};


export type QueryHotStartPoolArgs = {
  id: Scalars['String']['input'];
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryHotStartPoolsArgs = {
  ordering: InputMaybe<Ordering>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  paging: InputMaybe<Pagination>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsContainerImageValidArgs = {
  image: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
};


export type QueryIsUrlEmbeddableArgs = {
  url: InputMaybe<Scalars['String']['input']>;
};


export type QueryLearningPathArgs = {
  learningPathID: InputMaybe<Scalars['String']['input']>;
  learningPathSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryNoteArgs = {
  noteID: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  organizationID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationExistsArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type QueryOrganizationInviteArgs = {
  token: Scalars['String']['input'];
};


export type QueryOrganizationStatisticsArgs = {
  end: InputMaybe<Scalars['Time']['input']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']['input']>;
  organizationID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['Time']['input']>;
  trackIDs: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPlayReportItemArgs = {
  input: PlayReportInput;
  playID: Scalars['String']['input'];
};


export type QueryPlayReportsArgs = {
  input: PlayReportInput;
};


export type QueryPlayerArgs = {
  playerID: Scalars['String']['input'];
};


export type QueryRankingsArgs = {
  trackID: InputMaybe<Scalars['String']['input']>;
};


export type QuerySandboxConfigArgs = {
  configID: InputMaybe<Scalars['String']['input']>;
  configSlug: InputMaybe<Scalars['String']['input']>;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QuerySandboxConfigVersionArgs = {
  configVersionID: Scalars['String']['input'];
};


export type QuerySandboxConfigVersionDiffArgs = {
  sourceConfigVersion: InputMaybe<SandboxConfigInput>;
  sourceConfigVersionID: InputMaybe<Scalars['String']['input']>;
  targetConfigVersionID: Scalars['String']['input'];
};


export type QuerySandboxConfigVersionsArgs = {
  filter: InputMaybe<SandboxConfigVersionsFilterInput>;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QuerySandboxConfigsArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QuerySandboxesArgs = {
  filter: InputMaybe<SandboxFilterInput>;
  ordering: InputMaybe<Ordering>;
  paging: InputMaybe<Pagination>;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchTerraformModulesArgs = {
  query: Scalars['String']['input'];
};


export type QueryStatisticsArgs = {
  end: InputMaybe<Scalars['Time']['input']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['Time']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackID: InputMaybe<Scalars['String']['input']>;
  trackSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryStudentArgs = {
  inviteID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};


export type QueryStudentStatisticsArgs = {
  inviteID: Scalars['ID']['input'];
};


export type QueryStudentsArgs = {
  inviteID: Scalars['ID']['input'];
};


export type QueryTabArgs = {
  tabID: Scalars['String']['input'];
};


export type QueryTeamArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamExistsArgs = {
  teamSlug: Scalars['String']['input'];
};


export type QueryTeamInviteArgs = {
  token: Scalars['String']['input'];
};


export type QueryTeamSecretsArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamStatisticsArgs = {
  end: InputMaybe<Scalars['Time']['input']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']['input']>;
  start: InputMaybe<Scalars['Time']['input']>;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackIDs: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTerraformModuleArgs = {
  id: InputMaybe<Scalars['ID']['input']>;
  module: InputMaybe<Scalars['String']['input']>;
  version: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopicArgs = {
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  topicID: InputMaybe<Scalars['String']['input']>;
  topicSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopicExistsArgs = {
  organizationSlug: Scalars['String']['input'];
  topicSlug: Scalars['String']['input'];
};


export type QueryTopicsArgs = {
  organizationSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrackArgs = {
  inviteID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackID: InputMaybe<Scalars['String']['input']>;
  trackSlug: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrackConfigArgs = {
  trackID: Scalars['String']['input'];
};


export type QueryTrackExistsArgs = {
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackSlug: Scalars['String']['input'];
};


export type QueryTrackInviteArgs = {
  inviteID: Scalars['String']['input'];
};


export type QueryTrackInviteClaimArgs = {
  claimID: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrackInvitesArgs = {
  filters: InputMaybe<InviteFilters>;
  organizationID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrackLibraryArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTrackPlayLimitsArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryTrackReviewArgs = {
  reviewID: Scalars['ID']['input'];
};


export type QueryTrackReviewsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
  trackID: Scalars['String']['input'];
};


export type QueryTrackScriptArgs = {
  scriptID: Scalars['String']['input'];
};


export type QueryTrackScriptsArgs = {
  trackID: Scalars['String']['input'];
};


export type QueryTracksArgs = {
  orderBy: InputMaybe<TrackOrder>;
  organizationID: InputMaybe<Scalars['String']['input']>;
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserConsentedToPrivacyPolicyArgs = {
  userID: Scalars['String']['input'];
};


export type QueryUserExistsArgs = {
  userID: Scalars['String']['input'];
};


export type QueryUserInOrganizationArgs = {
  organizationSlug: Scalars['String']['input'];
};


export type QueryUserInTeamArgs = {
  teamSlug: Scalars['String']['input'];
};


export type QueryUserIsTrackDeveloperArgs = {
  organizationSlug: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackID: InputMaybe<Scalars['String']['input']>;
  trackSlug: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTrackInvitesArgs = {
  userID: Scalars['String']['input'];
};


export type QueryUserWithSlugExistsArgs = {
  slug: Scalars['String']['input'];
};


export type QueryViewInviteArgs = {
  inviteID: Scalars['String']['input'];
};


export type QueryVirtualBrowserCheckArgs = {
  challenge: Scalars['String']['input'];
  host: Scalars['String']['input'];
};


export type QueryVirtualBrowserChecksArgs = {
  track: Scalars['String']['input'];
};


export type QueryVirtualMachineConfigArgs = {
  virtualmachineID: Scalars['String']['input'];
};


export type QueryWebhooksArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};

/** Ranking is an entry for an arcade leaderboard */
export type Ranking = {
  __typename?: 'Ranking';
  /** Difficulty level */
  difficulty: Scalars['String']['output'];
  /** Name of the highscore */
  handle: Scalars['String']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Player */
  player: Player;
  /** Score for this track */
  score: Scalars['Int']['output'];
  /** Track for which the ranking is for */
  track: Track;
};

export enum RoleName {
  ContentCreator = 'content_creator',
  Member = 'member',
  Owner = 'owner'
}

export type RuntimeParameters = {
  __typename?: 'RuntimeParameters';
  environmentVariables: Array<EnvironmentVariable>;
  secrets: Array<RuntimeSecret>;
};

/**
 * Runtime parameters can be used to inject additional metadata, such
 * as secrets and environment variables, into script executions.
 */
export type RuntimeParametersInput = {
  environmentVariables?: InputMaybe<Array<EnvironmentInput>>;
  secrets?: InputMaybe<Array<SecretInput>>;
};

export type RuntimeSecret = {
  __typename?: 'RuntimeSecret';
  key: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type SamlSsoConnectionOptions = {
  __typename?: 'SamlSsoConnectionOptions';
  entityID: Scalars['String']['output'];
  signingCert: Scalars['String']['output'];
  signingEndpoint: Scalars['String']['output'];
};

export type Sandbox = {
  __typename?: 'Sandbox';
  /** The created time of the sandbox */
  created: Maybe<Scalars['Time']['output']>;
  /** The hot start pool of the sandbox */
  hot_start_pool: Maybe<HotStartPool>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** The invite for the sandbox */
  invite: Maybe<TrackInvite>;
  /** The last time there was recorded activity in the sandbox */
  last_activity_at: Maybe<Scalars['Time']['output']>;
  /** State of the sandbox */
  state: SandboxState;
  /** Track for which the sandbox is for */
  track: Maybe<Track>;
  /** The TTL of the current active environment */
  ttl: Maybe<Scalars['Time']['output']>;
  /** The user of the sandbox */
  user: Maybe<User>;
};

export type SandboxConfig = {
  __typename?: 'SandboxConfig';
  /** Deleted time of the config */
  deleted: Maybe<Scalars['Time']['output']>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** The name of the config */
  name: Scalars['String']['output'];
  /** The slug of the config */
  slug: Scalars['String']['output'];
  /** Version of the config */
  version: Scalars['Int']['output'];
};

export type SandboxConfigInput = {
  /** Description of the config */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Resources for the config */
  resources?: InputMaybe<SandboxResourcesInput>;
  /** Scripts for the config */
  scripts?: InputMaybe<Array<SandboxScriptInput>>;
};

export type SandboxConfigVersion = {
  __typename?: 'SandboxConfigVersion';
  /** The change log entry of the config */
  change_log_entry: Scalars['String']['output'];
  /** The config */
  config: Maybe<SandboxConfig>;
  /** Description of the config */
  description: Scalars['String']['output'];
  /** The hot-start pools using the config version */
  hot_start_pools: Array<Maybe<HotStartPool>>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** The time the config was published */
  published_at: Maybe<Scalars['Time']['output']>;
  /** The user who published the config */
  published_by: Maybe<User>;
  /** The resources for the config */
  resources: Maybe<SandboxResources>;
  /** The scripts for the config version */
  scripts: Maybe<Array<SandboxScript>>;
  /** Status of the version */
  status: SandboxConfigVersionStatus;
  /** The tracks using the config version */
  tracks: Array<Maybe<Track>>;
  /** Version of the config */
  version: Scalars['Int']['output'];
};

export type SandboxConfigVersionDiff = {
  __typename?: 'SandboxConfigVersionDiff';
  /** The diff text */
  diff: Scalars['String']['output'];
};

/** Sandbox config statuses */
export enum SandboxConfigVersionStatus {
  Archived = 'archived',
  Draft = 'draft',
  Isolated = 'isolated',
  Published = 'published'
}

export type SandboxConfigVersionsFilterInput = {
  /** Config ID to filter on */
  config_id?: InputMaybe<Scalars['String']['input']>;
  /** Config version statuses to filter on */
  statuses?: InputMaybe<Array<SandboxConfigVersionStatus>>;
};

export type SandboxConnection = {
  __typename?: 'SandboxConnection';
  /** A list of edges containing cursors to each node. */
  edges: Array<SandboxEdge>;
  /** A list of nodes. */
  nodes: Array<Sandbox>;
  /** Total number of pages */
  pageCount: Scalars['Int']['output'];
  /** Pagination information. */
  pageInfo: PageInfo;
  /** Total items in the current result set. */
  totalCount: Scalars['Int']['output'];
};

export type SandboxEdge = {
  __typename?: 'SandboxEdge';
  /** Cursor to the current node. */
  cursor: Scalars['String']['output'];
  /** The current node. */
  node: Maybe<Sandbox>;
};

/** Filter fields for querying sandboxes */
export type SandboxFilterInput = {
  /** From time to filter on */
  from?: InputMaybe<Scalars['Time']['input']>;
  /** ID an invite to filter on */
  invite_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID a hot start pool to filter on */
  pool_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Status to filter on */
  state?: InputMaybe<Array<SandboxState>>;
  /** To time to filter on */
  to?: InputMaybe<Scalars['Time']['input']>;
  /** ID a track to filter on */
  track_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The users name or id */
  user_name_or_id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Sort options for the
 * sandboxes orderBy.
 */
export enum SandboxOrderBy {
  HotstartPoolName = 'hotstart_pool_name',
  InviteTitle = 'invite_title',
  SandboxCreated = 'sandbox_created',
  SandboxState = 'sandbox_state',
  TrackSlug = 'track_slug'
}

export type SandboxResources = {
  __typename?: 'SandboxResources';
  /** List of AWS accounts */
  aws_accounts: Array<AwsAccountConfig>;
  /** List of Azure subscriptions */
  azure_subscriptions: Array<AzureSubscriptionConfig>;
  /** List of containers */
  containers: Array<ContainerConfig>;
  /** List of custom resources */
  custom_resources: Array<CustomResourceConfig>;
  /** List of GCP projects */
  gcp_projects: Array<GcpProjectConfig>;
  /** List of secrets */
  secrets: Array<SecretConfig>;
  /** List of virtual browsers */
  virtualbrowsers: Array<VirtualBrowserConfig>;
  /** List of virtual machines */
  virtualmachines: Array<VirtualMachineConfig>;
};

export type SandboxResourcesInput = {
  /** List of AWS accounts */
  aws_accounts?: InputMaybe<Array<AwsAccountConfigInput>>;
  /** List of Azure subscriptions */
  azure_subscriptions?: InputMaybe<Array<AzureSubscriptionConfigInput>>;
  /** List of containers */
  containers?: InputMaybe<Array<ContainerConfigInput>>;
  /** List of custom resources */
  custom_resources?: InputMaybe<Array<CustomResourceConfigInput>>;
  /** List of GCP projects */
  gcp_projects?: InputMaybe<Array<GcpProjectConfigInput>>;
  /** List of secrets */
  secrets?: InputMaybe<Array<SecretConfigInput>>;
  /** List of virtual browsers */
  virtualbrowsers?: InputMaybe<Array<VirtualBrowserConfigInput>>;
  /** List of virtual machines */
  virtualmachines?: InputMaybe<Array<VirtualMachineConfigInput>>;
};

export type SandboxScript = {
  __typename?: 'SandboxScript';
  /** One of: setup, cleanup */
  action: Scalars['String']['output'];
  /** The script contents */
  contents: Scalars['String']['output'];
  /**
   * On which host the script is executed.
   * Must reference a host in the config resources.
   */
  host: Scalars['String']['output'];
};

export type SandboxScriptInput = {
  /** One of: setup, cleanup */
  action?: InputMaybe<Scalars['String']['input']>;
  /** The script contents */
  contents?: InputMaybe<Scalars['String']['input']>;
  /** On which host the script is executed. Must reference a host in the config */
  host?: InputMaybe<Scalars['String']['input']>;
};

/** Sandbox states */
export enum SandboxState {
  Active = 'active',
  Cleaned = 'cleaned',
  Cleaning = 'cleaning',
  Created = 'created',
  Creating = 'creating',
  Failed = 'failed',
  Pooled = 'pooled',
  Stopped = 'stopped'
}

export type SandboxVariable = {
  __typename?: 'SandboxVariable';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SearchTerraformModuleResults = {
  __typename?: 'SearchTerraformModuleResults';
  modules: Array<TerraformModule>;
};

export type Secret = {
  __typename?: 'Secret';
  /** The time the secret was created */
  created_at: Scalars['Time']['output'];
  /** The user who created the secret */
  created_by: User;
  /** A description of the secret. */
  description: Scalars['String']['output'];
  /** The name of the secret. */
  name: Scalars['String']['output'];
  /** ID of the team */
  teamID: Scalars['String']['output'];
  /** The time the secret was last updated */
  updated_at: Maybe<Scalars['Time']['output']>;
  /** The user who last updated the secret */
  updated_by: Maybe<User>;
};

/** A SecretConfig stores the details of an track secret */
export type SecretConfig = {
  __typename?: 'SecretConfig';
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Name of the secret */
  name: Scalars['String']['output'];
};

/** A SecretConfigInput stores details about a secret */
export type SecretConfigInput = {
  /** Name of the secret */
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Secrets can be used to inject secret value into script executions with
 * with a custom key using runtime parameters.
 */
export type SecretInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

/** SecureToken for a user */
export type SecureToken = {
  __typename?: 'SecureToken';
  /** IDToken for user */
  idToken: Scalars['String']['output'];
  /** RefreshToken for user */
  refreshToken: Scalars['String']['output'];
  /** User ID */
  userID: Scalars['String']['output'];
};

export type SkipTakePagination = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};

export type SsoConnection = {
  __typename?: 'SsoConnection';
  name: Scalars['String']['output'];
  options: SsoConnectionOptions;
  organizationID: Scalars['String']['output'];
  strategy: Strategy;
};

export type SsoConnectionInput = {
  clientID: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  domain: Scalars['String']['input'];
  strategy: Strategy;
};

export type SsoConnectionOptions = DefaultSsoConnectionOptions | SamlSsoConnectionOptions;

export type SsoSamlConnectionInput = {
  entityID: Scalars['String']['input'];
  signingCert: Scalars['String']['input'];
  signingEndpoint: Scalars['String']['input'];
};

export type Statistics = {
  __typename?: 'Statistics';
  track: Maybe<TrackStatistics>;
};

export enum Strategy {
  GoogleApps = 'google_apps',
  Okta = 'okta',
  Samlp = 'samlp',
  Waad = 'waad'
}

export type Student = {
  __typename?: 'Student';
  /** The time when the user has accessed the invite. */
  accessed_at: Maybe<Scalars['Time']['output']>;
  /** The amount of active sandboxes for the user */
  activeSandboxesTotal: Maybe<Scalars['Int']['output']>;
  /** Challenge the student currently is within the track. */
  challenge: Maybe<Challenge>;
  /** The claim associated to the student */
  claim: Maybe<InviteClaim>;
  /** Last time that the user has completed a track. */
  completed_at: Maybe<Scalars['Time']['output']>;
  /** Whether the student machine is available to inspect or not */
  inspectable: Maybe<Scalars['Boolean']['output']>;
  /** Last activity the user had in track's challenge. */
  last_activity_at: Maybe<Scalars['Time']['output']>;
  /** Name of the track the student is currently on. */
  track: Maybe<Track>;
  /** Student user. */
  user: Maybe<User>;
};

export type StudentStatistics = {
  __typename?: 'StudentStatistics';
  /** Total number of students that have completed all tracks within a live event. */
  completedTotal: Maybe<Scalars['Int']['output']>;
  /** Total number of students that have tracks in progress within a live event. */
  inProgressTotal: Maybe<Scalars['Int']['output']>;
};

/** Track statistics for a specific classroom. */
export type StudentTrackStatistics = {
  __typename?: 'StudentTrackStatistics';
  /** Number of students that have completed the track. */
  completedTotal: Maybe<Scalars['Int']['output']>;
  /** Number of students that have started the track but not completed it. */
  inProgressTotal: Maybe<Scalars['Int']['output']>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['Time']['output'];
  groups: Array<TagGroup>;
  id: Scalars['ID']['output'];
  tracks: Array<Track>;
  value: Scalars['String']['output'];
};

export type TagGroup = {
  __typename?: 'TagGroup';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: Array<Tag>;
};

export type TagGroupInput = {
  name: Scalars['String']['input'];
};

export type TagInput = {
  value: Scalars['String']['input'];
};

/** A team has members, and owns topics and tracks */
export type Team = {
  __typename?: 'Team';
  /** API Key for the team */
  api_key: Maybe<Scalars['String']['output']>;
  /** The time the team was created at. */
  created_at: Maybe<Scalars['Time']['output']>;
  /** The time the team has become a customer at. */
  customer_since: Maybe<Scalars['Time']['output']>;
  /** The list of features that a team can access or use */
  features: Maybe<TeamFeatures>;
  /** The user details form for a team. */
  form: Maybe<Form>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** A list of insights for this team */
  insights: Insights;
  /**
   * Invited shows a list of email addresses that are invites
   * TODO: IN-378 Remove deprecated field.
   * @deprecated use field `invites`
   */
  invited: Array<Scalars['String']['output']>;
  /** A list of active invites for this team */
  invites: Maybe<Array<TeamInvite>>;
  /** Logo of the team */
  logo: Maybe<Scalars['String']['output']>;
  /** The LTI credentials for a team. */
  lti_credentials: Maybe<LtiCredentials>;
  /**
   * List of members
   * TODO: IN-364 Remove deprecated members field from team.
   * @deprecated use `users` field
   */
  members: Array<TeamMember>;
  /** Name of the team */
  name: Scalars['String']['output'];
  /** Whether the team is personal or not */
  personal: Maybe<Scalars['Boolean']['output']>;
  /** Text of the primary link of the team */
  primary_link_text: Maybe<Scalars['String']['output']>;
  /** URL of the primary link of the team */
  primary_link_url: Maybe<Scalars['String']['output']>;
  /** The URL of the team's privacy policy, if any. */
  privacy_policy: Maybe<Scalars['String']['output']>;
  /** Text of the secondary link of the team */
  secondary_link_text: Maybe<Scalars['String']['output']>;
  /** URL of the secondary link of the team */
  secondary_link_url: Maybe<Scalars['String']['output']>;
  /** Slug of the team */
  slug: Scalars['String']['output'];
  /** The SSO configuration for a team */
  ssoConnection: Maybe<SsoConnection>;
  /** Subtitle of the team */
  subtitle: Maybe<Scalars['String']['output']>;
  /** The tag groups for a team */
  tagGroups: Array<TagGroup>;
  /** The tags for a team */
  tags: Array<Tag>;
  /** The theme that is used to style the team page */
  theme: Maybe<TeamTheme>;
  /** Title of the team */
  title: Maybe<Scalars['String']['output']>;
  /** A list of tracks for this team */
  tracks: Array<Track>;
  /** The time the team's trial terminates. */
  trial_end_at: Maybe<Scalars['Time']['output']>;
  /** userDetails resolves all collected user details for the resolved team */
  userDetails: Array<UserDetails>;
  /** userReportPage retrieves a page users with related statistics */
  userReportPage: UserReportPage;
  /** List of users */
  users: Maybe<Array<TeamUserEdge>>;
  /** The one time use URL for the Svix dashboard to configure webhook endpoints. */
  webhook_dashboard_url: Scalars['String']['output'];
};


/** A team has members, and owns topics and tracks */
export type TeamUserReportPageArgs = {
  input: UserReportInput;
};

/** TeamFeatures define what features are enabled for a team */
export type TeamFeatures = {
  __typename?: 'TeamFeatures';
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox: Scalars['Boolean']['output'];
  /** Whether Alicloud accounts can be used */
  alicloud_accounts: Scalars['Boolean']['output'];
  /** Whether arcades can be used */
  arcades: Scalars['Boolean']['output'];
  /** Whether AWS accounts can be used */
  aws_accounts: Scalars['Boolean']['output'];
  /** Whether Azure subscriptions can be used */
  azure_subscriptions: Scalars['Boolean']['output'];
  /** Whether containers can be used */
  containers: Scalars['Boolean']['output'];
  /** Where resource based virtual machines is enabled for this team */
  custom_machine_type: Scalars['Boolean']['output'];
  /** Whether tracks can be embedded in other pages */
  embedded: Scalars['Boolean']['output'];
  /** Whether GCP projects can be used */
  gcp_projects: Scalars['Boolean']['output'];
  /** Whether multi-region setup is enabled for this team */
  global_sandboxes: Scalars['Boolean']['output'];
  /** Whether hot start is enabled for this team */
  hot_start: Scalars['Boolean']['output'];
  /** Whether invites can be created */
  invites: Scalars['Boolean']['output'];
  /** Whether the LTI integration is enabled for this team */
  lti_enabled: Scalars['Boolean']['output'];
  /**
   * The maximum size of a hot start pool
   * @deprecated Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size: Scalars['Int']['output'];
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on: Scalars['Int']['output'];
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled: Scalars['Int']['output'];
  /** The maximum number of members in this team */
  max_members: Scalars['Int']['output'];
  /** The maximum timelimit for a single track */
  max_timelimit: Scalars['Int']['output'];
  /** The maximum number of tracks that can be created */
  max_tracks: Scalars['Int']['output'];
  /** Whether team members can skip to a challenge */
  members_skip_to_challenge: Scalars['Boolean']['output'];
  /** Whether private content is allowed */
  private_content: Scalars['Boolean']['output'];
  /** Whether SAAS tracks are enabled for this team */
  saas: Scalars['Boolean']['output'];
  /** Whether the new scripts over http is enabled for this team */
  scripts_over_http: Scalars['Boolean']['output'];
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay: Scalars['Boolean']['output'];
  /** Whether the new shared hotstart pools invite flow is enabled for this team */
  shared_hotstart_pools: Scalars['Boolean']['output'];
  /** Whether statistics are accessible */
  statistics: Scalars['Boolean']['output'];
  /** Whether the new study room is enabled for this team */
  study_room_v2: Scalars['Boolean']['output'];
  /** Whether students can leave a track review after finishing a track. */
  track_reviews: Scalars['Boolean']['output'];
  /** Whether we should replace the terminal iframe with xterm directly on the frontend */
  use_new_terminal: Scalars['Boolean']['output'];
  /** Whether virtual machines can be used */
  virtual_machines: Scalars['Boolean']['output'];
  /** Whether vm pooling can be used */
  vm_pooling: Scalars['Boolean']['output'];
  /** Whether webhooks are enabled for this team */
  webhooks: Scalars['Boolean']['output'];
};

/** TeamFeaturesInput defines the input for mutating features of a team. */
export type TeamFeaturesInput = {
  /** Whether the user has a custom invite with the terms of service */
  accept_terms_checkbox?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Alicloud accounts can be used */
  alicloud_accounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether arcades can be used */
  arcades?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether AWS accounts can be used */
  aws_accounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Azure subscriptions can be used */
  azure_subscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether containers can be used */
  containers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Where resource based virtual machines is enabled for this team */
  custom_machine_type?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether tracks can be embedded in other pages */
  embedded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether GCP projects can be used */
  gcp_projects?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether multi-region setup is enabled for this team */
  global_sandboxes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether hot start is enabled for this team */
  hot_start?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether invites can be created */
  invites?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the LTI integration is enabled for this team */
  lti_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The maximum size of a hot start pool.
   * Deprecated: Use `max_hot_start_pool_size_scheduled`.
   */
  max_hot_start_pool_size?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum size of an always on hot start pool */
  max_hot_start_pool_size_always_on?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum size of a scheduled hot start pool */
  max_hot_start_pool_size_scheduled?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of members in this team */
  max_members?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum timelimit for a single track */
  max_timelimit?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum number of tracks that can be created */
  max_tracks?: InputMaybe<Scalars['Int']['input']>;
  /** Whether team members can skip to a challenge */
  members_skip_to_challenge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether private content is allowed */
  private_content?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether SAAS tracks are enabled for this team */
  saas?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the new scripts over http is enabled for this team */
  scripts_over_http?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether an overlay if shown on the service tab when playing a challenge. */
  service_tab_focus_overlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the new shared hotstart pools invite flow is enabled for this team */
  shared_hotstart_pools?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether statistics are accessible */
  statistics?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the new study room is enabled for this team */
  study_room_v2?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether students can leave a track review after finishing a track. */
  track_reviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether we should replace the terminal iframe with xterm directly on the frontend */
  use_new_terminal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether virtual machines can be used */
  virtual_machines?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether vm pooling can be used */
  vm_pooling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether webhooks are enabled for this team */
  webhooks?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A team has members, and owns topics and tracks */
export type TeamInput = {
  /** time when the team became a customer */
  customer_since?: InputMaybe<Scalars['Time']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Logo of the team */
  logo?: InputMaybe<Scalars['String']['input']>;
  /** Name of the team */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Text of the primary link of the team */
  primary_link_text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the primary link of the team */
  primary_link_url?: InputMaybe<Scalars['String']['input']>;
  /** Text of the secondary link of the team */
  secondary_link_text?: InputMaybe<Scalars['String']['input']>;
  /** URL of the secondary link of the team */
  secondary_link_url?: InputMaybe<Scalars['String']['input']>;
  /** Slug of the team */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Subtitle of the team */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** The theme that is used to style the team page */
  theme?: InputMaybe<TeamThemeInput>;
  /** Title of the team */
  title?: InputMaybe<Scalars['String']['input']>;
  /** instant at which the team's ends / ended */
  trial_end_at?: InputMaybe<Scalars['Time']['input']>;
};

/** TeamInvite represents an outstanding invite for an email address to join the team */
export type TeamInvite = {
  __typename?: 'TeamInvite';
  /** The time the invite was accepted */
  accepted_at: Maybe<Scalars['Time']['output']>;
  /** The user the invite was created by */
  created_by: Maybe<User>;
  /** The email of the invite */
  email: Scalars['String']['output'];
  /** The role that the user will get when accepting the invite */
  role: RoleName;
  /** The team this invite belongs to */
  team: Maybe<Team>;
  /** Whether the token in the email invite has expired */
  token_expired: Scalars['Boolean']['output'];
};

/** Member of a team */
export type TeamMember = {
  __typename?: 'TeamMember';
  /**
   * The user's ID
   * @deprecated use field `user`
   */
  id: Scalars['ID']['output'];
  /**
   * The user's profile
   * @deprecated use field `user`
   */
  profile: Maybe<UserProfile>;
  /** The user's role in the organization */
  role: RoleName;
  /** The user */
  user: User;
};

export type TeamSeries = {
  __typename?: 'TeamSeries';
  completed: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  started: Scalars['Int']['output'];
};

export type TeamStatistics = {
  __typename?: 'TeamStatistics';
  completed_total: Maybe<Scalars['Int']['output']>;
  restarted_total: Maybe<Scalars['Int']['output']>;
  started_total: Maybe<Scalars['Int']['output']>;
  team_series: Array<TeamSeries>;
  track_statistics: Array<TrackStatistics>;
};

/** A TeamTeme defines the look and feel for a team */
export type TeamTheme = {
  __typename?: 'TeamTheme';
  /** The color used for the background of the header */
  background_color: Maybe<Scalars['String']['output']>;
  /** The image used for the background of the header */
  background_image: Maybe<Scalars['String']['output']>;
  /** The color used for the text in the header */
  foreground_color: Maybe<Scalars['String']['output']>;
  /** The image that is shown in the header */
  foreground_image: Maybe<Scalars['String']['output']>;
  /** The color used for the background of the primary button */
  primary_background_color: Maybe<Scalars['String']['output']>;
  /** The color used for the text of the primary button */
  primary_foreground_color: Maybe<Scalars['String']['output']>;
  /** The color used for the background of the secondary button */
  secondary_background_color: Maybe<Scalars['String']['output']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color: Maybe<Scalars['String']['output']>;
};

export type TeamThemeInput = {
  /** The color used for the background of the header */
  background_color?: InputMaybe<Scalars['String']['input']>;
  /** The image used for the background of the header */
  background_image?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the text in the header */
  foreground_color?: InputMaybe<Scalars['String']['input']>;
  /** The image that is shown in the header */
  foreground_image?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the background of the primary button */
  primary_background_color?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the text of the primary button */
  primary_foreground_color?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the background of the secondary button */
  secondary_background_color?: InputMaybe<Scalars['String']['input']>;
  /** The color used for the text of the secondary button */
  secondary_foreground_color?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the user's which are member of a team. */
export type TeamUserEdge = {
  __typename?: 'TeamUserEdge';
  /** ID of this edge; the compound of the team ID and the user ID. */
  id: Scalars['ID']['output'];
  /** The target user. */
  node: User;
  /** The user's role within this team. */
  role: RoleName;
};

export type TerraformModule = {
  __typename?: 'TerraformModule';
  availableVersions: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inputs: Array<TerraformModuleInput>;
  logo: Scalars['String']['output'];
  module: Scalars['String']['output'];
  name: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  outputs: Array<TerraformModuleOutput>;
  owner: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  publishedAt: Scalars['Time']['output'];
  source: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type TerraformModuleInput = {
  __typename?: 'TerraformModuleInput';
  default: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type TerraformModuleOutput = {
  __typename?: 'TerraformModuleOutput';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** The time series granularity */
export enum TimeSeriesGranularity {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type TimeSpentSeries = {
  __typename?: 'TimeSpentSeries';
  average: Scalars['Float']['output'];
  items: Array<TimeSpentSeriesItem>;
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
};

export type TimeSpentSeriesItem = {
  __typename?: 'TimeSpentSeriesItem';
  bucketStartTime: Scalars['Time']['output'];
  value: Scalars['Float']['output'];
};

/** A topic is a group of tracks, all centered around a certain topic */
export type Topic = {
  __typename?: 'Topic';
  /** Description of the topic */
  description: Scalars['String']['output'];
  /** Icon for the topic, must be a URL to an image */
  icon: Scalars['String']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Slug of the organization that owns the track */
  owner: Maybe<Scalars['String']['output']>;
  /** Permalink for this topic. Will be generated automatically, based on the slugs of the organization and topic */
  permalink: Maybe<Scalars['String']['output']>;
  /** If a topic is private, it is only visible for organization members */
  private: Scalars['Boolean']['output'];
  /** Slug for the topic. This will be visible in the address bar of the browser */
  slug: Scalars['String']['output'];
  /** List of tags of the topic */
  tags: Array<Scalars['String']['output']>;
  /** Teaser of the topic */
  teaser: Scalars['String']['output'];
  /** Title of the topic */
  title: Scalars['String']['output'];
  /** List of tracks that are part of this topic */
  tracks: Array<Track>;
};

/** A topic is a group of tracks, all centered around a certain topic */
export type TopicInput = {
  /** Description of the topic */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Icon for the topic, must be a URL to an image */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Slug of the organization that owns the track */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** If a topic is private, it is only visible for organization members */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** Slug for the topic. This will be visible in the address bar of the browser */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Teaser of the topic */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** Title of the topic */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** A track consists of a list of challenges */
export type Track = {
  __typename?: 'Track';
  /** Whether the current user can play this track. */
  accessible: Scalars['Boolean']['output'];
  /** Actual pool size repesents the amount of actual enviroments in the stand-by pool */
  actual_pool_size: Scalars['Int']['output'];
  /** Whether skipping is available or not, this is dependent on the presence of check & solve scripts */
  can_skip: Scalars['Boolean']['output'];
  /** List of challenges for this track */
  challenges: Array<Challenge>;
  /** Time when track was cleaned */
  cleaned: Scalars['Time']['output'];
  /** Time when track was completed */
  completed: Scalars['Time']['output'];
  /** The config for this track */
  config: TrackConfig;
  /** Time when track was created successfully */
  created: Scalars['Time']['output'];
  /** Timestamp of when track was created */
  createdAt: Scalars['Time']['output'];
  /** Time when track creation has started */
  creating: Scalars['Time']['output'];
  /** Description of the track */
  description: Scalars['String']['output'];
  /** List of developers for this track */
  developers: Array<User>;
  /** Embed token */
  embed_token: Scalars['String']['output'];
  /**
   * How many plays are left on this track. Only set when track is made available through an invite
   * @deprecated Should be resolved from the relevant track_library entry
   */
  expiry_count: Maybe<Scalars['Int']['output']>;
  /**
   * When the access to this track expires. Only set when track is made available through an invite
   * @deprecated Should be resolved from the relevant track_invite
   */
  expiry_date: Maybe<Scalars['Time']['output']>;
  /** Time when track failed to create */
  failed: Scalars['Time']['output'];
  /** Icon of the track */
  icon: Scalars['String']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** The timeout value in seconds before the underlying sandbox will be detroyed. */
  idle_timeout: Maybe<Scalars['Int']['output']>;
  /** The lab configuration for the track. */
  lab_config: Maybe<LabConfig>;
  /** Timestamp of when track has been last updated */
  last_update: Scalars['Time']['output'];
  /**
   * List of learning paths this track is part of
   * @deprecated No longer supported
   */
  learning_paths: Array<LearningPath>;
  /** Level defines the skill level the track is designed for */
  level: Maybe<Level>;
  /** Whether the track is in maintenance mode. If it is, a maintenance banner will be shown and the track will not be playable. */
  maintenance: Scalars['Boolean']['output'];
  /** Median starting time of the track and the first challenge */
  median_starttime: Maybe<Scalars['Int']['output']>;
  /**
   * Slug of the team that owns the track
   * @deprecated Use the team field
   */
  owner: Maybe<Scalars['String']['output']>;
  /** The latest play of the current user on this track if available */
  participant: Maybe<Play>;
  /** Permalink for this topic. Will be generated automatically, based on the slugs of the team and track */
  permalink: Maybe<Scalars['String']['output']>;
  /** Amount of public plays done */
  play_count: Maybe<Scalars['Int']['output']>;
  /** Amount of public plays allowed for this track */
  play_limit: Maybe<Scalars['Int']['output']>;
  /** Whether the track has pre start capabilities. */
  prestart: Scalars['Boolean']['output'];
  /**
   * If a track is private, it is only visible for team members
   * @deprecated No longer in use
   */
  private: Scalars['Boolean']['output'];
  /**
   * If a track is not published, it is only visible to track developers
   * @deprecated No longer in use
   */
  published: Scalars['Boolean']['output'];
  /** Revision of the track. Currently not used */
  revision: Scalars['Time']['output'];
  /** The sandbox config for the track */
  sandboxConfig: Maybe<SandboxConfigVersion>;
  /** Scripts that belong to the track */
  scripts: Array<TrackScript>;
  /** Show timer represents the track setting whether to show a timer or not. */
  show_timer: Scalars['Boolean']['output'];
  /** Whether skipping is enabled for the challenges in this track */
  skipping_enabled: Scalars['Boolean']['output'];
  /** Which challenge the track is currently skipping to. */
  skipping_to: Maybe<Challenge>;
  /** Slug of the track */
  slug: Scalars['String']['output'];
  /** The track the current track has been copied from. */
  sourceTrack: Maybe<Track>;
  /** Start time of this track */
  started: Scalars['Time']['output'];
  /** Track statistics */
  statistics: Maybe<TrackStatistics>;
  /** Status of the track */
  status: Maybe<TrackStatus>;
  /** Time when track was stopped */
  stopped: Scalars['Time']['output'];
  /** Track statistics for a specific live event. */
  studentStatistics: Maybe<StudentTrackStatistics>;
  /**
   * List of tags for this track
   * @deprecated Use the trackTags field
   */
  tags: Array<Scalars['String']['output']>;
  /** The team that owns the track */
  team: Maybe<Team>;
  /** Teaser of the track */
  teaser: Scalars['String']['output'];
  /** the time limit value in seconds that the sandbox will be available for the track as a whole. */
  timelimit: Maybe<Scalars['Int']['output']>;
  /** Title of the track */
  title: Scalars['String']['output'];
  /** The config for a track */
  trackConfig: Maybe<TrackConfig>;
  /** Get reviews for a specific track */
  trackReviews: Maybe<TrackReviewConnection>;
  /** List of tags for this track */
  trackTags: Array<Tag>;
  /** The TTL of the current active environment */
  ttl: Maybe<Scalars['Time']['output']>;
  /**
   * Type of the track. One of: track, sandbox. Defaults to track. When choosing sandbox, the 'check' button changes to 'next'.
   * @deprecated no longer used
   */
  type: Scalars['String']['output'];
  /** User that last updated the track */
  updated_by: Maybe<User>;
  /** Version of the track. Currently not used */
  version: Scalars['String']['output'];
  /**
   * Visibility status of the track
   * @deprecated Replaced by `private`, `published` and `maintenance`
   */
  visibility: VisibilityStatus;
};


/** A track consists of a list of challenges */
export type TrackStatisticsArgs = {
  end: InputMaybe<Scalars['Time']['input']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']['input']>;
  start: InputMaybe<Scalars['Time']['input']>;
};


/** A track consists of a list of challenges */
export type TrackStudentStatisticsArgs = {
  inviteID: Scalars['ID']['input'];
};


/** A track consists of a list of challenges */
export type TrackTrackReviewsArgs = {
  after: InputMaybe<Scalars['String']['input']>;
  first: InputMaybe<Scalars['Int']['input']>;
};

/** A track config contains the infrastructure needed for the challenges */
export type TrackConfig = {
  __typename?: 'TrackConfig';
  /** List of Alicloud accounts */
  alicloud_accounts: Array<AlicloudAccountConfig>;
  /** List of AWS accounts */
  aws_accounts: Array<AwsAccountConfig>;
  /** List of Azure subscriptions */
  azure_subscriptions: Array<AzureSubscriptionConfig>;
  /** List of containers */
  containers: Array<ContainerConfig>;
  /** List of custom resources */
  custom_resources: Array<CustomResourceConfig>;
  /** List of GCP projects */
  gcp_projects: Array<GcpProjectConfig>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** List of secrets */
  secrets: Array<SecretConfig>;
  /** Version of the config, latest version is "2" */
  version: Maybe<Scalars['String']['output']>;
  /** List of virtual browsers */
  virtualbrowsers: Array<VirtualBrowserConfig>;
  /** List of virtual machines */
  virtualmachines: Array<VirtualMachineConfig>;
};

/** A track config contains the infrastructure needed for the challenges */
export type TrackConfigInput = {
  /** List of Alicloud accounts */
  alicloud_accounts?: InputMaybe<Array<AlicloudAccountConfigInput>>;
  /** List of AWS accounts */
  aws_accounts?: InputMaybe<Array<AwsAccountConfigInput>>;
  /** List of Azure Subscriptions */
  azure_subscriptions?: InputMaybe<Array<AzureSubscriptionConfigInput>>;
  /** List of containers */
  containers?: InputMaybe<Array<ContainerConfigInput>>;
  /** List of GCP projects */
  gcp_projects?: InputMaybe<Array<GcpProjectConfigInput>>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** List of secret configs */
  secrets?: InputMaybe<Array<SecretConfigInput>>;
  /** Version of the config, latest version is "2" */
  version?: InputMaybe<Scalars['String']['input']>;
  /** List of virtual browsers */
  virtualbrowsers?: InputMaybe<Array<VirtualBrowserConfigInput>>;
  /** List of virtual machines */
  virtualmachines?: InputMaybe<Array<VirtualMachineConfigInput>>;
};

/** A track config presets contains presets for track configs */
export type TrackConfigPresets = {
  __typename?: 'TrackConfigPresets';
  /** List of container presets */
  containers: Array<ContainerConfigPreset>;
  /** List of all Google Cloud machine types */
  googlecloudmachinetypes: Array<GoogleCloudMachineTypePreset>;
  /** List of all Instruqt machine types */
  machinetypes: Array<MachineTypePreset>;
  /** List of virtual machine presets */
  virtualmachines: Array<VirtualMachineConfigPreset>;
};

/** A track consists of a list of challenges */
export type TrackInput = {
  /** List of challenges for this track */
  challenges?: InputMaybe<Array<ChallengeInput>>;
  /** The config for this track */
  config?: InputMaybe<TrackConfigInput>;
  /** Description of the track */
  description?: InputMaybe<Scalars['String']['input']>;
  /** List of developers for this track */
  developers?: InputMaybe<Array<UserInput>>;
  /** Icon of the track */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The timeout value in seconds before the underlying sandbox will be detroyed. */
  idle_timeout?: InputMaybe<Scalars['Int']['input']>;
  /** lab configuration for the track */
  lab_config?: InputMaybe<LabConfigInput>;
  /** Level defines the skill level the track is designed for */
  level?: InputMaybe<Level>;
  /** If a track is in maintenance, it can only be played by developers, but is visible to others */
  maintenance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Slug of the team that owns the track */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** If a track is private, it is only visible for team members */
  private?: InputMaybe<Scalars['Boolean']['input']>;
  /** If a track is not published, it is only visible to track developers */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /** Revision of the track. Currently not used */
  revision?: InputMaybe<Scalars['Time']['input']>;
  /** The slug of the sandbox config to use for the track */
  sandboxConfig?: InputMaybe<Scalars['String']['input']>;
  /** The scripts for this track */
  scripts?: InputMaybe<Array<TrackScriptInput>>;
  /** If the track should show a timer while playing the track */
  show_timer?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the end user is able to skip to a specific challenge */
  skipping_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Slug of the track */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** The track the current track has been copied from. */
  sourceTrackID?: InputMaybe<Scalars['ID']['input']>;
  /** List of tags for this track */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Teaser of the track */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** the time limit value in seconds that the sandbox will be available for the track as a whole. */
  timelimit?: InputMaybe<Scalars['Int']['input']>;
  /** Title of the track */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Version of the track. Currently not used */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type TrackInsight = {
  __typename?: 'TrackInsight';
  page: TrackInsightPage;
};


export type TrackInsightPageArgs = {
  input: TrackInsightPageInput;
};

export type TrackInsightItem = {
  __typename?: 'TrackInsightItem';
  currentPeriod: TrackInsightsItemPeriod;
  id: Scalars['ID']['output'];
  previousPeriod: TrackInsightsItemPeriod;
  track: Track;
};

export type TrackInsightPage = {
  __typename?: 'TrackInsightPage';
  items: Array<TrackInsightItem>;
  totalItems: Scalars['Int']['output'];
};

/** Input types for track */
export type TrackInsightPageInput = {
  /** Filter for custom parameters */
  customParameterFilters?: InputMaybe<Array<CustomParameterFilter>>;
  /** Date range filter for plays */
  dateRangeFilter?: InputMaybe<DateRangeFilter>;
  /** Sorting parameters */
  ordering?: InputMaybe<Ordering>;
  /** Pagination parameters */
  pagination?: InputMaybe<SkipTakePagination>;
  /** Filter for play type */
  playType: PlayType;
  /** IDs of content tags for context */
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of track authors as context */
  trackAuthorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of tracks for which we want to get plays */
  trackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** track invite IDs for context */
  trackInviteIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TrackInsightsItemPeriod = {
  __typename?: 'TrackInsightsItemPeriod';
  averageReviewScore: Scalars['Float']['output'];
  completionRate: Scalars['Float']['output'];
  learnersReached: Scalars['Int']['output'];
  plays: Scalars['Int']['output'];
  timeSpent: Scalars['Int']['output'];
};

/** An invite can be used to invite users outside of an organization to access private tracks */
export type TrackInvite = {
  __typename?: 'TrackInvite';
  /** The access setting of the invite */
  accessSetting: Maybe<AccessSetting>;
  /** List the currently active users */
  activeUsers: Array<UserActivity>;
  /** Whether anyone with the link is able to access the invite anonymously (`true`), or is asked to leave their details (`false`, default). */
  allowAnonymous: Scalars['Boolean']['output'];
  /** List of email addresses that are allowed to accept invite */
  allowedEmailAddresses: Array<Scalars['String']['output']>;
  /** Whether a specific email addresses must be used to accept invite */
  allowedEmailAddressesOnly: Scalars['Boolean']['output'];
  /** Can the current user claim the invite */
  canClaim: Scalars['Boolean']['output'];
  /** The number of times this invite has been claimed */
  claimCount: Maybe<Scalars['Int']['output']>;
  /** A list of claims for this invite */
  claims: Array<InviteClaim>;
  /** When this invite was created */
  created: Maybe<Scalars['Time']['output']>;
  /** Whether the currently logged in user is allowed to accept invite */
  currentUserAllowed: Scalars['Boolean']['output'];
  /** The invite claim for the current user, if this invite was claimed */
  currentUserClaim: Maybe<InviteClaim>;
  /** Whether the currently logged in user has claimed this invite */
  currentUserClaimed: Scalars['Boolean']['output'];
  /**
   * The number of days until the live event's start.
   * @deprecated This can be resolved from the startsAt field in the frontend
   */
  daysUntil: Maybe<Scalars['Int']['output']>;
  /** Whether learner sharing is enabled */
  enableLearnerSharing: Scalars['Boolean']['output'];
  /** The expiry date for this invite */
  expiresAt: Maybe<Scalars['Time']['output']>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /**
   * The number of times this invite has been used
   * @deprecated name is ambiguous, use 'claimCount' instead.
   */
  inviteCount: Maybe<Scalars['Int']['output']>;
  /** The number of times this invite can be used */
  inviteLimit: Maybe<Scalars['Int']['output']>;
  /**
   * The TTL until when this invite can be used
   * @deprecated name is ambiguous, use 'expiresAt' instead.
   */
  inviteTTL: Maybe<Scalars['Time']['output']>;
  /**
   * When the invite got claimed
   * @deprecated Can be obtained through TrackInvite.currentUserClaim or User.claims
   */
  last_updated: Maybe<Scalars['Time']['output']>;
  /**
   * The organization this invite belongs to
   * @deprecated No longer supported
   */
  organization: Organization;
  /** The number of plays the end user is allowed to do */
  playLimit: Maybe<Scalars['Int']['output']>;
  /** The amount of time the track is available to the end user */
  playTTL: Maybe<Scalars['Int']['output']>;
  /** List all the plays using this invite */
  plays: Array<InvitePlay>;
  /** The public description of the invite. This description will be shown to end users */
  publicDescription: Maybe<Scalars['String']['output']>;
  /** The public title of the invite. This title will be shown to end users */
  publicTitle: Maybe<Scalars['String']['output']>;
  /** The runtime parameters for the invite */
  runtimeParameters: Maybe<RuntimeParameters>;
  /** Describes the method used to share the invite */
  shareMethod: Maybe<TrackInviteShareMethod>;
  /** The start time for a `type:live_event` invite. Invites will get `status:active` 24 hours before. */
  startsAt: Maybe<Scalars['Time']['output']>;
  /** The status of the invite. */
  status: Maybe<TrackInviteStatus>;
  /** The team this invite belongs to */
  team: Team;
  /** The title of the invite. Will not be shown to end users, but is only for administration purposes */
  title: Scalars['String']['output'];
  /**
   * The track library of the invite for the current user
   * @deprecated No longer supported
   */
  trackLibrary: Maybe<TrackLibraryEntryConnection>;
  /** The tracks this invite applies to */
  tracks: Array<Track>;
  /** Type of invite */
  type: Maybe<TrackInviteType>;
};


/** An invite can be used to invite users outside of an organization to access private tracks */
export type TrackInviteTrackLibraryArgs = {
  paging: InputMaybe<Pagination>;
};

/** An invite can be used to invite users outside of an organization to access private tracks */
export type TrackInviteInput = {
  /** Whether anyone with the link should be able to access the invite anonymously. Set to `false` (default) to gate your content with a form asking for details. */
  allowAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of email addresses that are allowed to accept invite */
  allowedEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether learner sharing is enabled */
  enableLearnerSharing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The expiry date for this invite */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The number of times this invite can be used */
  inviteLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The TTL until when this invite can be used */
  inviteTTL?: InputMaybe<Scalars['Time']['input']>;
  /** The number of plays the end user is allowed to do */
  playLimit?: InputMaybe<Scalars['Int']['input']>;
  /** The amount of time the track is available to the end user */
  playTTL?: InputMaybe<Scalars['Int']['input']>;
  /** The public description of the invite. This description will be shown to end users */
  publicDescription?: InputMaybe<Scalars['String']['input']>;
  /** The public title of the invite. This title will be shown to end users */
  publicTitle?: InputMaybe<Scalars['String']['input']>;
  /** Runtime parameters for the invite */
  runtimeParameters?: InputMaybe<RuntimeParametersInput>;
  /** Describes the method used to share the invite */
  shareMethod?: InputMaybe<TrackInviteShareMethod>;
  /** The start time for a `type:live_event` invite. Invites will be accessible (`status:active`) for new users 24 hours before start. */
  startsAt?: InputMaybe<Scalars['Time']['input']>;
  /** The title of the invite. Will not be shown to end users, but is only for administration purposes */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the tracks this invite applies to */
  trackIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of invite */
  type?: InputMaybe<TrackInviteType>;
};

export enum TrackInviteShareMethod {
  /** Used for gated embedded track invites. */
  Embed = 'embed',
  /** Used for sharing a track invite with a link. */
  Link = 'link'
}

export enum TrackInviteStatus {
  /** Default status. Allows new users to acces the invite link. */
  Active = 'active',
  /** After `invite.expiresAt` has passed. No longer allows new users to access the invite link. */
  Expired = 'expired',
  /** If `invite.startsAt` > 24 hours from now (applies to `invite.type: live_event` only.) New users are not yet allowed to access the invite link. */
  Upcoming = 'upcoming'
}

export enum TrackInviteType {
  /** Used to deliver content for instructor-led workshops. */
  LiveEvent = 'live_event',
  /** Used to deliver content to users to complete in their own time. */
  SelfPaced = 'self_paced'
}

/** TrackLibraryEntry a track owned by a user by accepting a track invite. */
export type TrackLibraryEntry = {
  __typename?: 'TrackLibraryEntry';
  /** The number of times this track was played by the user */
  playCount: Maybe<Scalars['Int']['output']>;
  /** The track. */
  track: Track;
  /**
   * Instant this track was last viewed by the user, nil if not viewed.
   * @deprecated No longer supported
   */
  viewed_at: Maybe<Scalars['Time']['output']>;
};

export type TrackLibraryEntryConnection = {
  __typename?: 'TrackLibraryEntryConnection';
  /** A list of edges. */
  edges: Array<TrackLibraryEntryEdge>;
  /** A list of nodes. */
  nodes: Array<TrackLibraryEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge to a TackLibraryEntry with its cursor. */
export type TrackLibraryEntryEdge = {
  __typename?: 'TrackLibraryEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The entry at the end of this edge. */
  node: Maybe<TrackLibraryEntry>;
};

/** TrackOrder defines the order in which to return tracks */
export enum TrackOrder {
  LastUpdateAsc = 'last_update_ASC',
  LastUpdateDesc = 'last_update_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type TrackPlayLimit = {
  __typename?: 'TrackPlayLimit';
  /** The amount of times a track can be played for a calendar month */
  calendarMonth: Scalars['Int']['output'];
  /** The amount of times a track can be started per IP Address for a rolling hour period */
  rollingIPAddressPerHour: Scalars['Int']['output'];
  /** The amount of times a track can be started for a rolling month period */
  rollingMonth: Scalars['Int']['output'];
  /** The track the limits apply to, if configured for a track */
  track: Maybe<Track>;
};

/** Input values for track play limits */
export type TrackPlayLimitInput = {
  /** The amount of times a track can be played for a calendar month */
  calendarMonth?: InputMaybe<Scalars['Int']['input']>;
  /** The amount of times a track can be started per IP Address for a rolling hour period */
  rollingIPAddressPerHour?: InputMaybe<Scalars['Int']['input']>;
  /** The amount of times a track can be started for a rolling month period */
  rollingMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type TrackProgress = Progress & {
  __typename?: 'TrackProgress';
  /** The time when the track was completed. */
  completed_at: Maybe<Scalars['Time']['output']>;
  /** The amount of challenges completed. */
  completed_challenges: Scalars['Int']['output'];
  /** The last time this track was played. */
  last_played_at: Maybe<Scalars['Time']['output']>;
  /** The track. */
  track: Track;
};

/** A student's review of a track. */
export type TrackReview = {
  __typename?: 'TrackReview';
  /** Written feedback. */
  content: Scalars['String']['output'];
  /** The time the review was created. */
  created_at: Scalars['Time']['output'];
  /** The ID of this track review. */
  id: Scalars['ID']['output'];
  /** The play this review applies to. */
  play: Maybe<Play>;
  /** The score the user gave to this track; should be between 1-5. */
  score: Scalars['Int']['output'];
  /** The track this review applies to. */
  track: Track;
  /** The time the review was last updated. */
  updated_at: Scalars['Time']['output'];
  /** The user which supplied this review. */
  user: User;
};

export type TrackReviewConnection = {
  __typename?: 'TrackReviewConnection';
  /** A list of edges. */
  edges: Array<TrackReviewEdge>;
  /** A list of nodes. */
  nodes: Array<TrackReview>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge to a TrackReview with its cursor. */
export type TrackReviewEdge = {
  __typename?: 'TrackReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The entry at the end of this edge. */
  node: Maybe<TrackReview>;
};

/**
 * Track scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 2 actions: setup,cleanup
 */
export type TrackScript = {
  __typename?: 'TrackScript';
  /** One of: setup, cleanup */
  action: Scalars['String']['output'];
  /** The script contents */
  contents: Scalars['String']['output'];
  /** On which host the script is executed. Must reference a host in the track config */
  host: Scalars['String']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
};

/**
 * Track scripts provide the automation hooks for interacting with the infrastructure of the track.
 * There are 2 actions: setup, cleanup
 */
export type TrackScriptInput = {
  /** One of: setup, cleanup */
  action?: InputMaybe<Scalars['String']['input']>;
  /** The script contents */
  contents?: InputMaybe<Scalars['String']['input']>;
  /** On which host the script is executed. Must reference a host in the track config */
  host?: InputMaybe<Scalars['String']['input']>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the track this script belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
};

export type TrackSeries = {
  __typename?: 'TrackSeries';
  completed: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  started: Scalars['Int']['output'];
};

export type TrackStatistics = {
  __typename?: 'TrackStatistics';
  average_review_score: Maybe<Scalars['Float']['output']>;
  challenge_series: Array<ChallengeSeries>;
  challenges: Array<ChallengeStatistics>;
  completed_total: Maybe<Scalars['Int']['output']>;
  happiness: Array<HappinessCount>;
  /** @deprecated Replaced by `track` */
  id: Scalars['ID']['output'];
  restarted_total: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by `track` */
  slug: Maybe<Scalars['String']['output']>;
  started_total: Maybe<Scalars['Int']['output']>;
  /** @deprecated Replaced by `track` */
  title: Maybe<Scalars['String']['output']>;
  track: Maybe<Track>;
  track_series: Array<TrackSeries>;
};

/** TrackStatus enumerate all track statuses */
export enum TrackStatus {
  /** Track has been cleaned up */
  Cleaned = 'cleaned',
  /** Track is being cleaned up */
  Cleaning = 'cleaning',
  /** The infrastructure has been completed */
  Created = 'created',
  /** The infrastructure for the track is being created */
  Creating = 'creating',
  /** The track setup has failed */
  Failed = 'failed',
  /** The user has started the track */
  Started = 'started',
  /** Track was stopped by the user */
  Stopped = 'stopped'
}

export type UpdateCustomResourceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UrlCondition = {
  __typename?: 'UrlCondition';
  /** rule to use for staring matching */
  condition: ConditionType;
  /** The URL to match against */
  urlPart: Scalars['String']['output'];
};

/** User */
export type User = {
  __typename?: 'User';
  /** The user's invite claims. */
  claims: Array<InviteClaim>;
  /** The details last used to claim an invite */
  details: Maybe<UserDetails>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Whether the user's account is anonymous */
  is_anonymous: Scalars['Boolean']['output'];
  /** Whether the user has admin rights */
  is_global_admin: Maybe<Scalars['Boolean']['output']>;
  /**
   * The organizations this user is a member of
   * @deprecated Replace with teams
   */
  organizations: Array<UserOrganizationEdge>;
  /** The user's profile */
  profile: Maybe<UserProfile>;
  /** reportItem resolves statistics for the resolved user */
  reportItem: Maybe<UserReportItem>;
  /** The user's segments. */
  segments: Array<UserSegment>;
  /** The teams this user is a member of */
  teams: Array<UserTeamEdge>;
};


/** User */
export type UserDetailsArgs = {
  teamID: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
};


/** User */
export type UserReportItemArgs = {
  input: UserReportInput;
};

/** UserActivity the current track and challenge a user is playing. */
export type UserActivity = {
  __typename?: 'UserActivity';
  /** The challenge this user is currently playing. */
  challenge: Maybe<Challenge>;
  /** The last instant the user was active on this track. */
  last_activity: Maybe<Scalars['Time']['output']>;
  /** The current play of this user. */
  participant: Maybe<Play>;
  /** The track this user is currently playing. */
  track: Maybe<Track>;
  /** The user. */
  user: Maybe<User>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  companyName: Maybe<Scalars['String']['output']>;
  consent: Maybe<Scalars['Boolean']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobLevel: Maybe<Scalars['String']['output']>;
  jobTitle: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  team: Maybe<Team>;
  usState: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type UserDetailsInput = {
  /** Company name field value of submitted user details */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user has accepted the Consent Notice. */
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Country code field value of submitted user details */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** email field value of submitted user details */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name field value of submitted user details */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Job level name field value of submitted user details */
  jobLevel?: InputMaybe<Scalars['String']['input']>;
  /** Job title field value of submitted user details */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Last name field value of submitted user details */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number field value of submitted user details */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** US state field value of submitted user details */
  usState?: InputMaybe<Scalars['String']['input']>;
};

/** User */
export type UserInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The user's profile */
  profile?: InputMaybe<UserProfileInput>;
};

/** Represents a user's relationship to an organization */
export type UserOrganizationEdge = {
  __typename?: 'UserOrganizationEdge';
  /** ID of this edge; a compound of the user ID and org ID. */
  id: Scalars['ID']['output'];
  /** The organization */
  node: Maybe<Organization>;
  /** The user's role in this organization */
  role: Maybe<RoleName>;
};

/** User Profile */
export type UserProfile = {
  __typename?: 'UserProfile';
  /** Avatar for the user, will typically be fetched from a social login */
  avatar: Maybe<Scalars['String']['output']>;
  /** Display name of the user */
  display_name: Maybe<Scalars['String']['output']>;
  /** Email address of the user */
  email: Maybe<Scalars['String']['output']>;
  /** Slug or username of the user */
  slug: Maybe<Scalars['String']['output']>;
};

/** User Profile */
export type UserProfileInput = {
  /** Email address of the user */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type UserReportInput = {
  /** Date range filter for plays */
  dateRangeFilter?: InputMaybe<DateRangeFilter>;
  /** Show/Hide anonymous users in the report */
  includeAnonymousUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sorting parameters */
  ordering?: InputMaybe<Ordering>;
  /** Pagination parameters */
  pagination?: InputMaybe<SkipTakePagination>;
  /**
   * Slug of the team you're querying the report for.
   * Only required if not called from Team.
   */
  teamSlug?: InputMaybe<Scalars['String']['input']>;
  /** IDs of tracks for which we want to get plays */
  trackIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of track invites */
  trackInviteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of users */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** UserReportItem represents a row of a user report */
export type UserReportItem = {
  __typename?: 'UserReportItem';
  /** The average progress a user has made in their plays */
  averageProgressPercent: Scalars['Float']['output'];
  /** Number of challenges completed */
  completedChallenges: Scalars['Int']['output'];
  /** Completion rate of tracks */
  completionRate: Scalars['Float']['output'];
  /** Unique ID of the user */
  id: Scalars['ID']['output'];
  /** lastStartedAt represents the timestamp the last play was started. */
  lastStartedAt: Scalars['Time']['output'];
  /** The play report items for a user report item. */
  playReportItems: Array<PlayReportItem>;
  /** number of plays a user has started */
  plays: Scalars['Int']['output'];
  /** Sum of all queries plays time spent */
  timeSpent: Scalars['Int']['output'];
  /** Number of challenges started */
  totalChallenges: Scalars['Int']['output'];
  /** Number of tracks completed */
  tracksCompleted: Scalars['Int']['output'];
  /** Number of tracks started */
  tracksStarted: Scalars['Int']['output'];
  /** Unique user other fields relate to */
  user: User;
};


/** UserReportItem represents a row of a user report */
export type UserReportItemPlayReportItemsArgs = {
  input: PlayReportInput;
};

/** UserReportPage represents a page of a user report */
export type UserReportPage = {
  __typename?: 'UserReportPage';
  items: Array<UserReportItem>;
  totalItems: Scalars['Int']['output'];
};

/** A user can be in one or more of these user segments. */
export enum UserSegment {
  /** Users in this segment are allowed to create content. */
  ContentCreator = 'content_creator',
  /** Users in this segment have admin rights */
  InstruqtEmployee = 'instruqt_employee',
  /** Users in this segment are not part of any organization. */
  Learner = 'learner',
  /** Users in this segment are part of an organization but cannot create content. */
  Member = 'member'
}

/** Represents a user's relationship to a team */
export type UserTeamEdge = {
  __typename?: 'UserTeamEdge';
  /** ID of this edge; a compound of the user ID and org ID. */
  id: Scalars['ID']['output'];
  /** The team */
  node: Maybe<Team>;
  /** The user's role in this team */
  role: Maybe<RoleName>;
};

/** Virtual browser specififc check */
export type VirtualBrowserCheck = {
  __typename?: 'VirtualBrowserCheck';
  /**
   * The url inside the virtual browser must be on in order to pass the check
   * more than one url can be provided, in which case the check will pass if any of the urls are matching
   * The DOM element to check
   */
  browserLocation: Maybe<Location>;
  /** The challenge ID this check belongs to */
  challenge: Challenge;
  element: Array<HtmlElement>;
  /** On which host (name) the script is executed. Must reference a host in the track config. */
  host: Scalars['String']['output'];
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** The InnerText of an element to check */
  innerText: Array<HtmlElement>;
};

export type VirtualBrowserCheckInput = {
  browserLocation?: InputMaybe<LocationCheckInput>;
  challenge: Scalars['String']['input'];
  element?: InputMaybe<Array<HtmlElementInput>>;
  host: Scalars['String']['input'];
  innerText?: InputMaybe<Array<HtmlElementInput>>;
  track: Scalars['String']['input'];
};

/** A VirtualBrowserConfig stores the details of a virtual browser */
export type VirtualBrowserConfig = {
  __typename?: 'VirtualBrowserConfig';
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** Name of the virtual browser host */
  name: Scalars['String']['output'];
  /** URL of the virtual browser host */
  url: Scalars['String']['output'];
};

export type VirtualBrowserConfigInput = {
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the container, will be used as hostname */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
  /** URL which the virtual browser will point to */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A VirtualMachineConfig stores the details of a VM */
export type VirtualMachineConfig = {
  __typename?: 'VirtualMachineConfig';
  /** What port (ranges) to expose for external ingress */
  allow_external_ingress: Array<Scalars['String']['output']>;
  /** The number of CPUs the machine should have */
  cpus: Maybe<Scalars['Int']['output']>;
  /** List of key-value pairs that are injected as environment variables */
  environment: Maybe<Array<EnvironmentVariable>>;
  /** Unique ID */
  id: Scalars['ID']['output'];
  /** GCP Compute image to use */
  image: Scalars['String']['output'];
  /** Machine type to use. Must be a valid machine type according to https://cloud.google.com/compute/docs/machine-types */
  machine_type: Scalars['String']['output'];
  /** The amount of memory the machine should have */
  memory: Maybe<Scalars['Int']['output']>;
  /** Name of the vm, will be used as hostname */
  name: Scalars['String']['output'];
  /** Whether nested virtualization is enabled */
  nested_virtualization: Scalars['Boolean']['output'];
  /** The pool size of VMs that will be kept as warm standby. If this is 0, pooling is disabled */
  pool_size: Scalars['Int']['output'];
  /** Whether to use preemptible vms. Defaults to false */
  preemptible: Scalars['Boolean']['output'];
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell: Scalars['String']['output'];
};

/** A VirtualMachineConfig stores the details of a VM */
export type VirtualMachineConfigInput = {
  /** What port (ranges) to expose for external ingress */
  allow_external_ingress?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The number of CPUs the machine should have */
  cpus?: InputMaybe<Scalars['Int']['input']>;
  /** List of key-value pairs that are injected as environment variables */
  environment?: InputMaybe<Array<EnvironmentInput>>;
  /** Unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** GCP Compute image to use */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Machine type to use. Must be a valid machine type according to https://cloud.google.com/compute/docs/machine-types */
  machine_type?: InputMaybe<Scalars['String']['input']>;
  /** The amount of memory the machine should have */
  memory?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the vm, will be used as hostname */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether nested virtualization is enabled */
  nested_virtualization?: InputMaybe<Scalars['Boolean']['input']>;
  /** The pool size of VMs that will be kept as warm standby. If this is 0, pooling is disabled */
  pool_size?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to use preemptible vms. Defaults to false */
  preemptible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which shell to expose in the terminal. Defaults to /bin/sh */
  shell?: InputMaybe<Scalars['String']['input']>;
  /** ID of the track this config belongs to */
  track?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A VirtualMachineConfigPreset stores the config
 * for a virtual machine preset.
 */
export type VirtualMachineConfigPreset = {
  __typename?: 'VirtualMachineConfigPreset';
  /** The amount of cpus for the machine */
  cpus: Scalars['Int']['output'];
  /** Unique ID */
  image: Scalars['String']['output'];
  /** The label of the preset */
  label: Scalars['String']['output'];
  /** Machine type to use. */
  machine_type: Scalars['String']['output'];
  /** The amount of memory for the machine in MB */
  memory: Scalars['Int']['output'];
};

export enum VisibilityStatus {
  /** Track is in maintenance */
  Maintenance = 'maintenance',
  /** Track is private */
  Private = 'private',
  /** Track is public */
  Public = 'public',
  /** Track has not been published */
  Unpublished = 'unpublished'
}

/** Webhook represents an Instruqt Webhook */
export type Webhook = {
  __typename?: 'Webhook';
  /** The time the webhook was created */
  created_at: Scalars['Time']['output'];
  /** Custom header for the webhook */
  custom_headers: Array<CustomHeader>;
  /** The events which trigger the webhook */
  events: Array<Scalars['String']['output']>;
  /** The ID of the Webhook */
  id: Scalars['ID']['output'];
  /** Name of the webhook */
  name: Scalars['String']['output'];
  /** The time the webhook was updated */
  updated_at: Scalars['Time']['output'];
  /** URL of the webhook */
  url: Scalars['String']['output'];
};

/** Parameter used to create or update a webhook */
export type WebhookInput = {
  /** Custom header for the webhook */
  custom_headers?: InputMaybe<Array<CustomHeaderInput>>;
  /** The events which trigger the webhook */
  events?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of the webhook */
  name?: InputMaybe<Scalars['String']['input']>;
  /** URL of the webhook */
  url: Scalars['String']['input'];
};

/**
 * This type is required for schema validation to pass.
 * https://www.apollographql.com/docs/federation/v1/federation-spec/#type-_service
 */
export type _Service = {
  __typename?: '_Service';
  sdl: Scalars['String']['output'];
};

export type ArcadeIdleTimerStopTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type ArcadeIdleTimerStopTrackMutation = { __typename?: 'Mutation', stopTrack: { __typename?: 'Track', id: string, started: string, creating: string, created: string, failed: string, stopped: string, completed: string, cleaned: string } | null };

export type ArcadeAssignmentQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type ArcadeAssignmentQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', use_new_terminal: boolean } | null } | null, track: { __typename?: 'Track', id: string, status: TrackStatus | null } | null, challenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus, timelimit: number | null, started: number, assignment: string, tabs: Array<{ __typename?: 'ChallengeTab', type: ChallengeTabType, title: string, target: string | null, path: string | null, url: string | null, index: number }>, attempts: Array<{ __typename?: 'ChallengeAttempt', timestamp: string, message: string }>, notes: Array<{ __typename?: 'ChallengeNote', type: ChallengeNoteType, contents: string | null }> } | null };

export type ArcadeChallengeCheckMutationVariables = Exact<{
  playerID: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
}>;


export type ArcadeChallengeCheckMutation = { __typename?: 'Mutation', checkArcadeChallenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus, started: number, completed: number, attempts: Array<{ __typename?: 'ChallengeAttempt', timestamp: string, message: string }>, unlocks: { __typename?: 'Challenge', id: string } | null } | null };

export type ArcadeChallengeQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
}>;


export type ArcadeChallengeQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, challenges: Array<{ __typename?: 'Challenge', id: string }> } | null, challenge: { __typename?: 'Challenge', id: string, index: number, title: string, started: number, timelimit: number | null, assignment: string, tabs: Array<{ __typename?: 'ChallengeTab', type: ChallengeTabType, title: string, target: string | null }>, notes: Array<{ __typename?: 'ChallengeNote', type: ChallengeNoteType, contents: string | null, url: string | null }> } | null };

export type ArcadeStartStatusQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
}>;


export type ArcadeStartStatusQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, status: TrackStatus | null } | null, challenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus } | null };

export type ArcadeChallengeStartMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type ArcadeChallengeStartMutation = { __typename?: 'Mutation', startChallenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus, started: number, timelimit: number | null } | null };

export type ArcadeChallengeSetupMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type ArcadeChallengeSetupMutation = { __typename?: 'Mutation', setupChallenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus } | null };

export type ArcadeInputContainerQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type ArcadeInputContainerQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, status: TrackStatus | null } | null };

export type InputContainerRegisterScoreMutationVariables = Exact<{
  playerID: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
  handle: Scalars['String']['input'];
  difficulty: Scalars['String']['input'];
  teamSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type InputContainerRegisterScoreMutation = { __typename?: 'Mutation', registerScore: { __typename?: 'Ranking', id: string, handle: string, score: number, player: { __typename?: 'Player', id: string, lives: number }, track: { __typename?: 'Track', id: string, title: string } } | null };

export type InputContainerStopTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type InputContainerStopTrackMutation = { __typename?: 'Mutation', stopTrack: { __typename?: 'Track', id: string, started: string, creating: string, created: string, failed: string, stopped: string, completed: string, cleaned: string } | null };

export type ArcadeLeaderboardQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type ArcadeLeaderboardQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, title: string, teaser: string } | null, rankings: Array<{ __typename?: 'Ranking', id: string, difficulty: string, handle: string, score: number }> | null };

export type ArcadeLeaderboardsQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type ArcadeLeaderboardsQuery = { __typename?: 'Query', arcadetracks: Array<{ __typename?: 'Track', id: string, title: string, teaser: string }> | null };

export type ArcadeLeaderboardsRankingsQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type ArcadeLeaderboardsRankingsQuery = { __typename?: 'Query', rankings: Array<{ __typename?: 'Ranking', id: string, difficulty: string, handle: string, score: number }> | null };

export type ArcadeLoginQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ArcadeLoginQuery = { __typename?: 'Query', arcadeLogin: { __typename?: 'ArcadeLogin', token: string, alternative_url: string | null, organization: { __typename?: 'Organization', id: string, slug: string } } | null };

export type ArcadeDifficultyCreatePlayerMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  difficulty: Scalars['String']['input'];
}>;


export type ArcadeDifficultyCreatePlayerMutation = { __typename?: 'Mutation', createPlayer: { __typename?: 'Player', id: string, lives: number } | null };

export type ArcadeTracksQueryVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type ArcadeTracksQuery = { __typename?: 'Query', arcadetracks: Array<{ __typename?: 'Track', id: string, slug: string, title: string, teaser: string, icon: string }> | null };

export type ArcadeTracksStartTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  region: InputMaybe<Scalars['String']['input']>;
}>;


export type ArcadeTracksStartTrackMutation = { __typename?: 'Mutation', startTrack: { __typename?: 'Track', id: string, started: string, creating: string, created: string, failed: string, stopped: string, completed: string, cleaned: string, challenges: Array<{ __typename?: 'Challenge', id: string, title: string, teaser: string, status: ChallengeStatus }> } | null };

export type ArcadeTvLeaderboardsQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type ArcadeTvLeaderboardsQuery = { __typename?: 'Query', arcadetracks: Array<{ __typename?: 'Track', id: string, title: string, teaser: string }> | null, team: { __typename?: 'Team', id: string, name: string } | null };

export type ArcadeTvLeaderboardsRankingsQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type ArcadeTvLeaderboardsRankingsQuery = { __typename?: 'Query', rankings: Array<{ __typename?: 'Ranking', id: string, difficulty: string, handle: string, score: number }> | null };

export type AuthorBadgeUserFragment = { __typename?: 'User', profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null } | null };

export type EditorHeroTeamThemeFragment = { __typename?: 'TeamTheme', background_color: string | null, background_image: string | null, foreground_color: string | null };

export type TrackInviteListTrackFragment = { __typename?: 'Track', id: string, status: TrackStatus | null, title: string, teaser: string, icon: string, completed: string, maintenance: boolean, lab_config: { __typename?: 'LabConfig', hideStopButton: boolean } | null };

export type TrackInviteListItemTrackFragment = { __typename?: 'Track', id: string, title: string, teaser: string, icon: string, status: TrackStatus | null, completed: string, maintenance: boolean, lab_config: { __typename?: 'LabConfig', hideStopButton: boolean } | null };

export type TrackInviteListItemInviteFragment = { __typename?: 'TrackInvite', playLimit: number | null, currentUserClaim: { __typename?: 'InviteClaim', id: string, playTTL: string | null, trackLibrary: Array<{ __typename?: 'TrackLibraryEntry', playCount: number | null, track: { __typename?: 'Track', id: string } }> } | null };

export type StartMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
}>;


export type StartMutation = { __typename?: 'Mutation', startTrack: { __typename?: 'Track', id: string, status: TrackStatus | null, permalink: string | null, challenges: Array<{ __typename?: 'Challenge', id: string, index: number, slug: string, title: string, teaser: string, status: ChallengeStatus, started: number, completed: number, timelimit: number | null, failed: number, failMessage: string | null }> } | null };

export type GetChallengeToDuplicateQueryVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type GetChallengeToDuplicateQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', slug: string, title: string, teaser: string, started: number, timelimit: number | null, assignment: string, type: ChallengeType, difficulty: string, answers: Array<string>, solution: Array<number>, tabs: Array<{ __typename?: 'ChallengeTab', cmd: string | null, index: number, new_window: boolean, type: ChallengeTabType, title: string, target: string | null, hostname: string | null, path: string | null, port: number | null, url: string | null, workdir: string | null }>, notes: Array<{ __typename?: 'ChallengeNote', type: ChallengeNoteType, contents: string | null, url: string | null, index: number }>, scripts: Array<{ __typename?: 'ChallengeScript', action: string, contents: string, host: string }> } | null };

export type DuplicateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type DuplicateChallengeMutation = { __typename?: 'Mutation', createChallenge: { __typename?: 'Challenge', id: string } | null };

export type EditorLayoutQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type EditorLayoutQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, team: { __typename?: 'Team', id: string, theme: { __typename?: 'TeamTheme', background_color: string | null, background_image: string | null, foreground_color: string | null } | null, features: { __typename?: 'TeamFeatures', saas: boolean } | null } | null, track: { __typename?: 'Track', id: string, title: string } | null };

export type SkippingToQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type SkippingToQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, status: TrackStatus | null, skipping_to: { __typename?: 'Challenge', id: string } | null, challenges: Array<{ __typename?: 'Challenge', id: string, title: string, slug: string, index: number, status: ChallengeStatus, started: number, completed: number, failed: number, failMessage: string | null }> } | null };

export type SkipAChallengeQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type SkipAChallengeQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, userInTeam: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', members_skip_to_challenge: boolean } | null } | null, track: { __typename?: 'Track', id: string, status: TrackStatus | null, skipping_enabled: boolean, can_skip: boolean, skipping_to: { __typename?: 'Challenge', id: string } | null, challenges: Array<{ __typename?: 'Challenge', id: string, type: ChallengeType, title: string, index: number, status: ChallengeStatus, started: number, completed: number }> } | null, skippingEnabledTrack: { __typename?: 'Track', skipping_enabled: boolean, can_skip: boolean } | null };

export type Skip_StartTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
}>;


export type Skip_StartTrackMutation = { __typename?: 'Mutation', startTrack: { __typename?: 'Track', id: string, status: TrackStatus | null } | null };

export type StartingTrackModalQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type StartingTrackModalQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, status: TrackStatus | null, median_starttime: number | null, challenges: Array<{ __typename?: 'Challenge', id: string, index: number, status: ChallengeStatus }> } | null };

export type SkipChallengeMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
}>;


export type SkipChallengeMutation = { __typename?: 'Mutation', skipChallenge: boolean };

export type SkipToChallengeMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
  force: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SkipToChallengeMutation = { __typename?: 'Mutation', skipToChallenge: { __typename?: 'Track', id: string, status: TrackStatus | null } | null };

export type UpdateChallengeIndexesMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  challenges: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateChallengeIndexesMutation = { __typename?: 'Mutation', updateChallengeIndexes: Array<{ __typename?: 'Challenge', id: string, title: string, index: number }> | null };

export type SortableChallengesChallengeFragment = { __typename?: 'Challenge', id: string, title: string, teaser: string };

export type StartLearningStopTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type StartLearningStopTrackMutation = { __typename?: 'Mutation', stopTrack: { __typename?: 'Track', id: string, status: TrackStatus | null, challenges: Array<{ __typename?: 'Challenge', id: string, slug: string, title: string, teaser: string, status: ChallengeStatus }> } | null };

export type StudyRoomClaimFragment = { __typename?: 'InviteClaim', id: string, claimedAt: string | null, trackInvite: { __typename?: 'TrackInvite', id: string, publicTitle: string | null, publicDescription: string | null, tracks: Array<{ __typename?: 'Track', id: string, status: TrackStatus | null, completed: string }>, team: { __typename?: 'Team', id: string, slug: string, name: string, logo: string | null, theme: { __typename?: 'TeamTheme', background_image: string | null, background_color: string | null } | null } } | null };

export type FindUsersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type FindUsersQuery = { __typename?: 'Query', findUsers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null, slug: string | null } | null }> | null };

export type CreateTrackDeveloperMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
}>;


export type CreateTrackDeveloperMutation = { __typename?: 'Mutation', createTrackDeveloper: { __typename?: 'Track', id: string, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null } | null }> } | null };

export type RemoveTrackDeveloperMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
}>;


export type RemoveTrackDeveloperMutation = { __typename?: 'Mutation', removeTrackDeveloper: boolean };

export type GetDevelopersQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type GetDevelopersQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null } | null }> } | null };

export type TrackDetailsQueryVariables = Exact<{
  inviteID: InputMaybe<Scalars['String']['input']>;
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackDetailsQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, userInTeam: boolean, team: { __typename?: 'Team', id: string, name: string, logo: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', statistics: boolean, embedded: boolean, members_skip_to_challenge: boolean } | null } | null, track: { __typename?: 'Track', id: string, permalink: string | null, slug: string, icon: string, title: string, teaser: string, timelimit: number | null, description: string, level: Level | null, idle_timeout: number | null, status: TrackStatus | null, completed: string, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null, challenges: Array<{ __typename?: 'Challenge', id: string, permalink: string | null, slug: string, title: string, teaser: string, status: ChallengeStatus, index: number, type: ChallengeType, timelimit: number | null, started: number, completed: number, failed: number, failMessage: string | null }>, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null, email: string | null } | null }> } | null };

export type TrackDetailsTeamDataFragment = { __typename?: 'Team', id: string, name: string, logo: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', statistics: boolean, embedded: boolean, members_skip_to_challenge: boolean } | null };

export type TrackDetailsTrackDataFragment = { __typename?: 'Track', id: string, permalink: string | null, slug: string, icon: string, title: string, teaser: string, timelimit: number | null, description: string, level: Level | null, idle_timeout: number | null, status: TrackStatus | null, completed: string, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null, challenges: Array<{ __typename?: 'Challenge', id: string, permalink: string | null, slug: string, title: string, teaser: string, status: ChallengeStatus, index: number, type: ChallengeType, timelimit: number | null, started: number, completed: number, failed: number, failMessage: string | null }>, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null, email: string | null } | null }> };

export type TrackTagsGetTrackQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type TrackTagsGetTrackQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, permalink: string | null, slug: string, icon: string, title: string, teaser: string, timelimit: number | null, description: string, level: Level | null, idle_timeout: number | null, status: TrackStatus | null, completed: string, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null, challenges: Array<{ __typename?: 'Challenge', id: string, permalink: string | null, slug: string, title: string, teaser: string, status: ChallengeStatus, index: number, type: ChallengeType, timelimit: number | null, started: number, completed: number, failed: number, failMessage: string | null }>, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null, email: string | null } | null }> } | null };

export type UpdateTrackTagsMutationVariables = Exact<{
  track: TrackInput;
}>;


export type UpdateTrackTagsMutation = { __typename?: 'Mutation', updateTrack: { __typename?: 'Track', id: string, permalink: string | null, slug: string, icon: string, title: string, teaser: string, timelimit: number | null, description: string, level: Level | null, idle_timeout: number | null, status: TrackStatus | null, completed: string, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null, challenges: Array<{ __typename?: 'Challenge', id: string, permalink: string | null, slug: string, title: string, teaser: string, status: ChallengeStatus, index: number, type: ChallengeType, timelimit: number | null, started: number, completed: number, failed: number, failMessage: string | null }>, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null, email: string | null } | null }> } | null };

export type UpdateTrackOptionsMutationVariables = Exact<{
  track: TrackInput;
}>;


export type UpdateTrackOptionsMutation = { __typename?: 'Mutation', updateTrack: { __typename?: 'Track', id: string, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean } | null };

export type UpdateUserMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null } | null };

export type AuthClaimTeamInvitesMutationVariables = Exact<{
  token: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthClaimTeamInvitesMutation = { __typename?: 'Mutation', claimTeamInvites: { __typename?: 'User', id: string, segments: Array<UserSegment>, is_global_admin: boolean | null, profile: { __typename?: 'UserProfile', email: string | null, display_name: string | null, avatar: string | null, slug: string | null } | null, teams: Array<{ __typename?: 'UserTeamEdge', role: RoleName | null, node: { __typename?: 'Team', id: string, slug: string, name: string, features: { __typename?: 'TeamFeatures', hot_start: boolean, invites: boolean, statistics: boolean, arcades: boolean, webhooks: boolean, track_reviews: boolean, shared_hotstart_pools: boolean } | null } | null }> } | null };

export type SignupPageQueryVariables = Exact<{
  teamID: Scalars['String']['input'];
  skipTeam: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
  skipInvite: Scalars['Boolean']['input'];
}>;


export type SignupPageQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, name: string, privacy_policy: string | null } | null, teamInvite?: { __typename?: 'TeamInvite', email: string, token_expired: boolean, accepted_at: string | null, team: { __typename?: 'Team', id: string, name: string } | null, created_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', email: string | null, display_name: string | null } | null } | null } | null };

export type ConsentToTeamPrivacyPolicyMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  consent: Scalars['Boolean']['input'];
}>;


export type ConsentToTeamPrivacyPolicyMutation = { __typename?: 'Mutation', consentToTeamPrivacyPolicy: boolean };

export type MergeAnonymousUserMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type MergeAnonymousUserMutation = { __typename?: 'Mutation', mergeAnonymousUser: boolean };

export type GetSettingsVirtualBrowserChallengeChecksQueryVariables = Exact<{
  track: Scalars['String']['input'];
}>;


export type GetSettingsVirtualBrowserChallengeChecksQuery = { __typename?: 'Query', virtualBrowserChecks: Array<{ __typename?: 'VirtualBrowserCheck', id: string, host: string, challenge: { __typename?: 'Challenge', id: string, slug: string, permalink: string | null, title: string }, browserLocation: { __typename?: 'Location', conditions: Array<{ __typename?: 'UrlCondition', urlPart: string, condition: ConditionType }> } | null, element: Array<{ __typename?: 'HtmlElement', selector: string, value: string }>, innerText: Array<{ __typename?: 'HtmlElement', selector: string, value: string }> }> };

export type GetSettingsVirtualBrowserChallengeChecksTrackQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type GetSettingsVirtualBrowserChallengeChecksTrackQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, title: string, challenges: Array<{ __typename?: 'Challenge', id: string, slug: string, permalink: string | null, title: string }>, config: { __typename?: 'TrackConfig', id: string, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> }, sandboxConfig: { __typename?: 'SandboxConfigVersion', id: string, resources: { __typename?: 'SandboxResources', virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string }> } | null } | null } | null };

export type GetChallengeNotesListConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
}>;


export type GetChallengeNotesListConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, track: { __typename?: 'Track', lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean } | null } | null, challenge: { __typename?: 'Challenge', id: string, assignment: string, teaser: string, title: string, type: ChallengeType, notes: Array<{ __typename?: 'ChallengeNote', id: string, index: number, type: ChallengeNoteType, contents: string | null, url: string | null }>, tabs: Array<{ __typename?: 'ChallengeTab', id: string, type: ChallengeTabType, title: string, target: string | null, path: string | null, url: string | null, index: number, new_window: boolean, hostname: string | null }> } | null };

export type NotesListChallengeFragment = { __typename?: 'Challenge', id: string, assignment: string, teaser: string, title: string, type: ChallengeType, notes: Array<{ __typename?: 'ChallengeNote', id: string, index: number, type: ChallengeNoteType, contents: string | null, url: string | null }>, tabs: Array<{ __typename?: 'ChallengeTab', id: string, type: ChallengeTabType, title: string, target: string | null, path: string | null, url: string | null, index: number, new_window: boolean, hostname: string | null }> };

export type GetChallengeTabsListPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
}>;


export type GetChallengeTabsListPageConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, track: { __typename?: 'Track', lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean } | null } | null, challenge: { __typename?: 'Challenge', id: string, assignment: string, teaser: string, title: string, type: ChallengeType, tabs: Array<{ __typename?: 'ChallengeTab', id: string, type: ChallengeTabType, title: string, target: string | null, path: string | null, url: string | null, index: number, new_window: boolean, hostname: string | null, port: number | null, workdir: string | null, cmd: string | null }>, notes: Array<{ __typename?: 'ChallengeNote', id: string, index: number, type: ChallengeNoteType, contents: string | null, url: string | null }> } | null };

export type TabsListChallengeFragment = { __typename?: 'Challenge', id: string, assignment: string, teaser: string, title: string, type: ChallengeType, notes: Array<{ __typename?: 'ChallengeNote', id: string, index: number, type: ChallengeNoteType, contents: string | null, url: string | null }>, tabs: Array<{ __typename?: 'ChallengeTab', id: string, type: ChallengeTabType, title: string, target: string | null, path: string | null, url: string | null, index: number, new_window: boolean, hostname: string | null }> };

export type TabsListChallengeTabFragment = { __typename?: 'ChallengeTab', id: string, index: number, target: string | null, title: string, type: ChallengeTabType, url: string | null, hostname: string | null, path: string | null, port: number | null, new_window: boolean, workdir: string | null, cmd: string | null };

export type GetCreateChallengeNoteConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
}>;


export type GetCreateChallengeNoteConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string } | null, challenge: { __typename?: 'Challenge', id: string } | null };

export type CreateChallengeNotePageCreateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;


export type CreateChallengeNotePageCreateChallengeNoteMutation = { __typename?: 'Mutation', createChallengeNote: { __typename?: 'ChallengeNote', id: string, index: number, contents: string | null, type: ChallengeNoteType, url: string | null } | null };

export type GetCreateChallengeTabPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
}>;


export type GetCreateChallengeTabPageConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, challenge: { __typename?: 'Challenge', id: string } | null, track: { __typename?: 'Track', id: string, sandboxConfig: { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null, config: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } } | null, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', saas: boolean } | null } | null };

export type CreateChallengeTabPageCreateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;


export type CreateChallengeTabPageCreateChallengeTabMutation = { __typename?: 'Mutation', createChallengeTab: { __typename?: 'ChallengeTab', id: string, index: number, target: string | null, title: string, type: ChallengeTabType, hostname: string | null, url: string | null, port: number | null, path: string | null, workdir: string | null, cmd: string | null, new_window: boolean, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null } | null };

export type GetCreateTrackWizardPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  filter: SandboxConfigVersionsFilterInput;
}>;


export type GetCreateTrackWizardPageConfigQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', containers: boolean, virtual_machines: boolean, saas: boolean, gcp_projects: boolean, aws_accounts: boolean, azure_subscriptions: boolean, custom_machine_type: boolean, shared_hotstart_pools: boolean } | null } | null, teamSecrets: Array<{ __typename?: 'Secret', name: string, description: string }> | null, trackConfigPresets: { __typename?: 'TrackConfigPresets', containers: Array<{ __typename?: 'ContainerConfigPreset', label: string, image: string, memory: number }>, googlecloudmachinetypes: Array<{ __typename?: 'GoogleCloudMachineTypePreset', label: string, machine_type: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfigPreset', image: string, label: string, machine_type: string, cpus: number, memory: number }>, machinetypes: Array<{ __typename?: 'MachineTypePreset', cpus: number, label: string, memory: number }> } | null, sandboxConfigVersions: Array<{ __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', action: string, contents: string, host: string }> | null, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null }> | null };

export type GetTrackForWizardQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type GetTrackForWizardQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, permalink: string | null, slug: string, title: string } | null };

export type WizardCreateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type WizardCreateChallengeMutation = { __typename?: 'Mutation', createChallenge: { __typename?: 'Challenge', id: string } | null };

export type WizardUpdateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type WizardUpdateChallengeMutation = { __typename?: 'Mutation', updateChallenge: { __typename?: 'Challenge', id: string } | null };

export type WizardUpdateSandboxMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  config: SandboxConfigInput;
}>;


export type WizardUpdateSandboxMutation = { __typename?: 'Mutation', updateSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type WizardSetTrackSandboxConfigVersionMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  configVersionID: InputMaybe<Scalars['String']['input']>;
}>;


export type WizardSetTrackSandboxConfigVersionMutation = { __typename?: 'Mutation', setTrackSandboxConfigVersion: boolean };

export type WizardCreateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;


export type WizardCreateChallengeNoteMutation = { __typename?: 'Mutation', createChallengeNote: { __typename?: 'ChallengeNote', id: string } | null };

export type WizardUpdateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;


export type WizardUpdateChallengeNoteMutation = { __typename?: 'Mutation', updateChallengeNote: { __typename?: 'ChallengeNote', id: string } | null };

export type WizardCreateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;


export type WizardCreateChallengeTabMutation = { __typename?: 'Mutation', createChallengeTab: { __typename?: 'ChallengeTab', id: string } | null };

export type WizardUpdateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;


export type WizardUpdateChallengeTabMutation = { __typename?: 'Mutation', updateChallengeTab: { __typename?: 'ChallengeTab', id: string } | null };

export type WizardUpdateTrackMutationVariables = Exact<{
  track: TrackInput;
}>;


export type WizardUpdateTrackMutation = { __typename?: 'Mutation', updateTrack: { __typename?: 'Track', id: string, permalink: string | null, slug: string, title: string } | null };

export type UpdateDisplayNameMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;


export type UpdateDisplayNameMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null } | null };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type GetEmbedConfigurationQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type GetEmbedConfigurationQuery = { __typename?: 'Query', track: { __typename?: 'Track', embed_token: string } | null, team: { __typename?: 'Team', lti_credentials: { __typename?: 'LTICredentials', consumer_name: string, consumer_key: string } | null } | null };

export type GetTemplateQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type GetTemplateQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, permalink: string | null, slug: string, icon: string, title: string, teaser: string, description: string, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }> } | null };

export type InviteEntryPageQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type InviteEntryPageQuery = { __typename?: 'Query', invitePublic: { __typename?: 'TrackInvite', id: string, accessSetting: AccessSetting | null, currentUserAllowed: boolean, currentUserClaimed: boolean, startsAt: string | null, tracks: Array<{ __typename?: 'Track', id: string }>, team: { __typename?: 'Team', id: string, slug: string, name: string, logo: string | null, features: { __typename?: 'TeamFeatures', accept_terms_checkbox: boolean } | null, theme: { __typename?: 'TeamTheme', background_image: string | null, background_color: string | null } | null } } | null, invitePrivate: { __typename?: 'TrackInvite', id: string } | null };

export type GainAccessContainerQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type GainAccessContainerQuery = { __typename?: 'Query', invitePublic: { __typename?: 'TrackInvite', id: string, currentUserClaimed: boolean, team: { __typename?: 'Team', id: string, name: string, slug: string, logo: string | null, features: { __typename?: 'TeamFeatures', accept_terms_checkbox: boolean } | null, theme: { __typename?: 'TeamTheme', background_image: string | null, background_color: string | null } | null } } | null, invitePrivate: { __typename?: 'TrackInvite', id: string, allowAnonymous: boolean, allowedEmailAddressesOnly: boolean, currentUserAllowed: boolean, startsAt: string | null } | null };

export type ClaimTrackInviteMutationVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type ClaimTrackInviteMutation = { __typename?: 'Mutation', claimTrackInvite: { __typename?: 'InviteClaim', id: string, trackInvite: { __typename?: 'TrackInvite', id: string, currentUserClaimed: boolean } | null } | null };

export type TrackInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackInvitePageQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null } | null, trackInvite: { __typename?: 'TrackInvite', id: string, title: string, publicTitle: string | null, publicDescription: string | null, enableLearnerSharing: boolean, accessSetting: AccessSetting | null, canClaim: boolean, currentUserClaimed: boolean, playLimit: number | null, tracks: Array<{ __typename?: 'Track', id: string, permalink: string | null, slug: string, title: string, status: TrackStatus | null, teaser: string, icon: string, completed: string, maintenance: boolean, challenges: Array<{ __typename?: 'Challenge', completed: number, index: number, slug: string, started: number, status: ChallengeStatus }>, lab_config: { __typename?: 'LabConfig', hideStopButton: boolean } | null }>, team: { __typename?: 'Team', id: string, slug: string, name: string, logo: string | null, privacy_policy: string | null, form: { __typename?: 'Form', formTitle: string | null, consentNotice: string | null, validateWorkEmail: boolean | null, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, background_color: string | null, background_image: string | null } | null, features: { __typename?: 'TeamFeatures', accept_terms_checkbox: boolean } | null }, currentUserClaim: { __typename?: 'InviteClaim', id: string, playTTL: string | null, trackLibrary: Array<{ __typename?: 'TrackLibraryEntry', playCount: number | null, track: { __typename?: 'Track', id: string } }> } | null } | null };

export type TrackInviteOverviewClaimTrackInviteMutationVariables = Exact<{
  inviteID: Scalars['String']['input'];
  userDetails: InputMaybe<UserDetailsInput>;
  customParameters: InputMaybe<Array<CustomParametersInput> | CustomParametersInput>;
}>;


export type TrackInviteOverviewClaimTrackInviteMutation = { __typename?: 'Mutation', claimTrackInvite: { __typename?: 'InviteClaim', id: string, trackInvite: { __typename?: 'TrackInvite', id: string, currentUserClaimed: boolean, currentUserClaim: { __typename?: 'InviteClaim', id: string, playTTL: string | null } | null } | null } | null };

export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  consent: Scalars['Boolean']['input'];
}>;


export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutation = { __typename?: 'Mutation', consentToTeamPrivacyPolicy: boolean };

export type TrackInviteOverviewStopTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type TrackInviteOverviewStopTrackMutation = { __typename?: 'Mutation', stopTrack: { __typename?: 'Track', id: string, status: TrackStatus | null } | null };

export type GetManageChallengePageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type GetManageChallengePageConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string, lab_config: { __typename?: 'LabConfig', position: string, width: number, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null } | null };

export type ManageChallengePageCreateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type ManageChallengePageCreateChallengeMutation = { __typename?: 'Mutation', createChallenge: { __typename?: 'Challenge', id: string, title: string, slug: string, permalink: string | null } | null };

export type ManageChallengePageUpdateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type ManageChallengePageUpdateChallengeMutation = { __typename?: 'Mutation', updateChallenge: { __typename?: 'Challenge', id: string, index: number, difficulty: string, title: string, slug: string, type: ChallengeType, assignment: string, teaser: string, timelimit: number | null, answers: Array<string>, solution: Array<number> } | null };

export type ManageChallengePageDeleteChallengeMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type ManageChallengePageDeleteChallengeMutation = { __typename?: 'Mutation', deleteChallenge: boolean };

export type GetChallengeInitialDataFromChallengeQueryVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type GetChallengeInitialDataFromChallengeQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', title: string, slug: string, type: ChallengeType, assignment: string, teaser: string, timelimit: number | null, answers: Array<string>, solution: Array<number> } | null };

export type GetChallengeInitialDataEditChallengeQueryVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type GetChallengeInitialDataEditChallengeQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', id: string, index: number, difficulty: string, title: string, slug: string, type: ChallengeType, assignment: string, teaser: string, timelimit: number | null, answers: Array<string>, solution: Array<number> } | null };

export type ChallengeInitialStateEditChallengeFragment = { __typename?: 'Challenge', id: string, index: number, difficulty: string, title: string, slug: string, type: ChallengeType, assignment: string, teaser: string, timelimit: number | null, answers: Array<string>, solution: Array<number> };

export type GetManageCloudAccountPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type GetManageCloudAccountPageConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', aws_accounts: boolean, azure_subscriptions: boolean, gcp_projects: boolean } | null } | null, track: { __typename?: 'Track', id: string, config: { __typename?: 'TrackConfig', id: string, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> }, scripts: Array<{ __typename?: 'TrackScript', id: string, host: string, action: string, contents: string }> } | null };

export type UpdateCloudAccountsMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  config: SandboxConfigInput;
}>;


export type UpdateCloudAccountsMutation = { __typename?: 'Mutation', updateSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type GetManageHostPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type GetManageHostPageConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', containers: boolean, virtual_machines: boolean, saas: boolean, custom_machine_type: boolean } | null } | null, trackConfigPresets: { __typename?: 'TrackConfigPresets', containers: Array<{ __typename?: 'ContainerConfigPreset', label: string, image: string, memory: number }>, googlecloudmachinetypes: Array<{ __typename?: 'GoogleCloudMachineTypePreset', label: string, machine_type: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfigPreset', image: string, label: string, machine_type: string, cpus: number, memory: number }>, machinetypes: Array<{ __typename?: 'MachineTypePreset', cpus: number, label: string, memory: number }> } | null, track: { __typename?: 'Track', id: string, config: { __typename?: 'TrackConfig', id: string, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> }, scripts: Array<{ __typename?: 'TrackScript', id: string, host: string, action: string, contents: string }> } | null };

export type UpdateHostsMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  config: SandboxConfigInput;
}>;


export type UpdateHostsMutation = { __typename?: 'Mutation', updateSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type ManageHostPageRenameHostMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  hostName: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type ManageHostPageRenameHostMutation = { __typename?: 'Mutation', renameSandboxConfigHost: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type GetSandboxConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  filter: SandboxConfigVersionsFilterInput;
}>;


export type GetSandboxConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, userInTeam: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', containers: boolean, virtual_machines: boolean, gcp_projects: boolean, aws_accounts: boolean, azure_subscriptions: boolean, saas: boolean, shared_hotstart_pools: boolean } | null } | null, track: { __typename?: 'Track', id: string, sandboxConfig: { __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null } | null, config: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> }, scripts: Array<{ __typename?: 'TrackScript', id: string, host: string, action: string, contents: string }> } | null, teamSecrets: Array<{ __typename?: 'Secret', name: string, description: string }> | null, sandboxConfigVersions: Array<{ __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null }> | null };

export type GetSandboxPagePresetResourcesQueryVariables = Exact<{
  configVersionID: Scalars['String']['input'];
}>;


export type GetSandboxPagePresetResourcesQuery = { __typename?: 'Query', sandboxConfigVersion: { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', action: string, contents: string, host: string }> | null } | null };

export type SandboxConfigPageDeleteHostMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  hostName: Scalars['String']['input'];
}>;


export type SandboxConfigPageDeleteHostMutation = { __typename?: 'Mutation', deleteSandboxConfigHost: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type SandboxConfigPageRenameHostMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  hostName: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type SandboxConfigPageRenameHostMutation = { __typename?: 'Mutation', renameSandboxConfigHost: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type SandboxConfigPageSetPresetMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  configVersionID: InputMaybe<Scalars['String']['input']>;
}>;


export type SandboxConfigPageSetPresetMutation = { __typename?: 'Mutation', setTrackSandboxConfigVersion: boolean };

export type SandboxConfigPageUpdateSandboxConfigMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  config: SandboxConfigInput;
}>;


export type SandboxConfigPageUpdateSandboxConfigMutation = { __typename?: 'Mutation', updateSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type SandboxConfigPageSaveTrackScriptMutationVariables = Exact<{
  script: TrackScriptInput;
  base64Encoded: Scalars['Boolean']['input'];
}>;


export type SandboxConfigPageSaveTrackScriptMutation = { __typename?: 'Mutation', saveTrackScript: { __typename?: 'TrackScript', id: string, host: string, action: string, contents: string } | null };

export type SandboxConfigSecretFragment = { __typename?: 'SecretConfig', id: string, name: string };

export type TrackScriptDataFragment = { __typename?: 'TrackScript', id: string, host: string, action: string, contents: string };

export type StudyRoomLinkRedirectQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type StudyRoomLinkRedirectQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, team: { __typename?: 'Team', id: string, slug: string } } | null };

export type StudyRoomQueryVariables = Exact<{ [key: string]: never; }>;


export type StudyRoomQuery = { __typename?: 'Query', me: { __typename?: 'User', claims: Array<{ __typename?: 'InviteClaim', id: string, claimedAt: string | null, trackInvite: { __typename?: 'TrackInvite', id: string, publicTitle: string | null, publicDescription: string | null, tracks: Array<{ __typename?: 'Track', id: string, status: TrackStatus | null, completed: string }>, team: { __typename?: 'Team', id: string, slug: string, name: string, logo: string | null, theme: { __typename?: 'TeamTheme', background_image: string | null, background_color: string | null } | null } } | null }> } | null };

export type TeamLoginQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type TeamLoginQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, ssoConnection: { __typename?: 'SsoConnection', name: string, organizationID: string } | null } | null };

export type GetTemplateTracksQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetTemplateTracksQuery = { __typename?: 'Query', tracks: Array<{ __typename?: 'Track', id: string, version: string, slug: string, icon: string, title: string, teaser: string, description: string, level: Level | null, idle_timeout: number | null, timelimit: number | null, status: TrackStatus | null, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, developers: Array<{ __typename?: 'User', profile: { __typename?: 'UserProfile', email: string | null } | null }>, challenges: Array<{ __typename?: 'Challenge', id: string, type: ChallengeType, slug: string, title: string, teaser: string, difficulty: string, assignment: string, timelimit: number | null, answers: Array<string>, solution: Array<number>, notes: Array<{ __typename?: 'ChallengeNote', type: ChallengeNoteType, contents: string | null, url: string | null }>, tabs: Array<{ __typename?: 'ChallengeTab', cmd: string | null, type: ChallengeTabType, title: string, hostname: string | null, path: string | null, port: number | null, url: string | null, new_window: boolean }>, scripts: Array<{ __typename?: 'ChallengeScript', host: string, action: string, contents: string }> }>, sandboxConfig: { __typename?: 'SandboxConfigVersion', config: { __typename?: 'SandboxConfig', slug: string } | null } | null, config: { __typename?: 'TrackConfig', version: string | null, containers: Array<{ __typename?: 'ContainerConfig', name: string, image: string, entrypoint: string | null, cmd: string | null, shell: string, ports: Array<number> | null, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', name: string, services: Array<string> }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', name: string, user_only: boolean, roles: Array<string> }> }, scripts: Array<{ __typename?: 'TrackScript', id: string, action: string, contents: string, host: string }> }> | null };

export type TrackStatisticsQueryVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']['input']>;
  trackSlug: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['Time']['input']>;
  end: InputMaybe<Scalars['Time']['input']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TrackStatisticsQuery = { __typename?: 'Query', statistics: { __typename?: 'Statistics', track: { __typename?: 'TrackStatistics', started_total: number | null, completed_total: number | null, track_series: Array<{ __typename?: 'TrackSeries', date: string, started: number, completed: number }>, challenge_series: Array<{ __typename?: 'ChallengeSeries', date: string, unlocked: number, started: number, completed: number }>, happiness: Array<{ __typename?: 'HappinessCount', score: number, count: number }>, challenges: Array<{ __typename?: 'ChallengeStatistics', title: string | null, started_total: number | null, completed_total: number | null, attempts_total: number | null, attempts_min: number | null, attempts_avg: number | null, attempts_max: number | null, duration_min: number | null, duration_avg: number | null, duration_max: number | null }> } | null } | null };

export type GetUpdateChallengeNotePageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
  noteID: Scalars['String']['input'];
}>;


export type GetUpdateChallengeNotePageConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string } | null, challenge: { __typename?: 'Challenge', id: string } | null, note: { __typename?: 'ChallengeNote', id: string, index: number, contents: string | null, type: ChallengeNoteType, url: string | null } | null };

export type UpdateChallengeNotePageUpdateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;


export type UpdateChallengeNotePageUpdateChallengeNoteMutation = { __typename?: 'Mutation', updateChallengeNote: { __typename?: 'ChallengeNote', id: string, index: number, contents: string | null, type: ChallengeNoteType, url: string | null } | null };

export type GetUpdateChallengeTabPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
  tabID: Scalars['String']['input'];
}>;


export type GetUpdateChallengeTabPageConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, challenge: { __typename?: 'Challenge', id: string } | null, tab: { __typename?: 'ChallengeTab', id: string, index: number, target: string | null, title: string, type: ChallengeTabType, hostname: string | null, url: string | null, port: number | null, path: string | null, workdir: string | null, cmd: string | null, new_window: boolean, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null } | null, track: { __typename?: 'Track', id: string, sandboxConfig: { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null, config: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } } | null, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', saas: boolean } | null } | null };

export type UpdateChallengeTabPageUpdateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;


export type UpdateChallengeTabPageUpdateChallengeTabMutation = { __typename?: 'Mutation', updateChallengeTab: { __typename?: 'ChallengeTab', id: string, index: number, target: string | null, title: string, type: ChallengeTabType, hostname: string | null, url: string | null, port: number | null, path: string | null, workdir: string | null, cmd: string | null, new_window: boolean, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null } | null };

export type UpdateChallengeTabChallengeTabFragment = { __typename?: 'ChallengeTab', id: string, index: number, target: string | null, title: string, type: ChallengeTabType, hostname: string | null, url: string | null, port: number | null, path: string | null, workdir: string | null, cmd: string | null, new_window: boolean, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null };

export type UpdateTrackPageUpdateTrackMutationVariables = Exact<{
  track: TrackInput;
}>;


export type UpdateTrackPageUpdateTrackMutation = { __typename?: 'Mutation', updateTrack: { __typename?: 'Track', id: string, slug: string } | null };

export type TrackReviewsQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type TrackReviewsQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, trackReviews: { __typename?: 'TrackReviewConnection', nodes: Array<{ __typename?: 'TrackReview', id: string, score: number, created_at: string, content: string }> } | null, statistics: { __typename?: 'TrackStatistics', happiness: Array<{ __typename?: 'HappinessCount', score: number, count: number }> } | null } | null };

export type DeleteTrackButtonMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type DeleteTrackButtonMutation = { __typename?: 'Mutation', deleteTrack: boolean };

export type CustomResourceCardItemFragment = { __typename?: 'CustomResource', id: string, name: string, description: string, version: string, logo: string, createdAt: string, createdBy: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null } };

export type SandboxPresetPreviewTrackFragment = { __typename?: 'Track', id: string, title: string };

export type SandboxPresetPreviewHotStartPoolFragment = { __typename?: 'HotStartPool', id: string, name: string };

export type AuthorFilterListItemFragment = { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null };

export type InviteFilterListItemFragment = { __typename?: 'TrackInvite', id: string, publicTitle: string | null, title: string };

export type TrackFilterTrackFragment = { __typename?: 'Track', id: string, title: string, slug: string, maintenance: boolean };

export type UserFilterListItemFragment = { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, user: { __typename?: 'User', id: string } | null };

export type CheckUrlEmbeddableQueryVariables = Exact<{
  url: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckUrlEmbeddableQuery = { __typename?: 'Query', isURLEmbeddable: boolean };

export type InsightsContentTableItemFragment = { __typename?: 'TrackInsightItem', id: string, track: { __typename?: 'Track', id: string, title: string, slug: string }, currentPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number }, previousPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number } };

export type InviteEnvironmentVariableFragment = { __typename?: 'EnvironmentVariable', key: string, value: string };

export type InviteSecretFragment = { __typename?: 'RuntimeSecret', key: string, secret: string };

export type InviteTeamSecretsFragment = { __typename?: 'Secret', name: string, description: string };

export type PlayActivityLogActivityFragment = { __typename?: 'PlayActivity', message: string, time: string, challenge: { __typename?: 'Challenge', slug: string } | null };

export type PlayActivityReportsTableFragment = { __typename?: 'PlayReportItem', id: string, completionPercent: number, timeSpent: number, startedAt: string, track: { __typename?: 'Track', id: string, slug: string, title: string }, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null } };

export type ChallengeAttemptsChallengeStatisticsFragment = { __typename?: 'ChallengeStatistics', title: string | null, attempts_min: number | null, attempts_avg: number | null, attempts_max: number | null };

export type ChallengeDurationChallengeStatisticsFragment = { __typename?: 'ChallengeStatistics', title: string | null, duration_min: number | null, duration_avg: number | null, duration_max: number | null };

export type DailyTrackStartsChallengeSeriesFragment = { __typename?: 'ChallengeSeries', date: string, unlocked: number, started: number, completed: number };

export type DailyTrackStartsTrackSeriesFragment = { __typename?: 'TrackSeries', date: string, started: number, completed: number };

export type PlaysPerDayChartTeamSeriesFragment = { __typename?: 'TeamSeries', date: string, started: number, completed: number };

export type PlaysPerDayChartTeamStatisticsFragment = { __typename?: 'TeamStatistics', started_total: number | null, completed_total: number | null };

export type TotalChallengeStartsChallengeStatisticsFragment = { __typename?: 'ChallengeStatistics', title: string | null, started_total: number | null, completed_total: number | null, attempts_total: number | null };

export type TotalTrackStartsTrackStatisticsFragment = { __typename?: 'TrackStatistics', started_total: number | null, completed_total: number | null };

export type UserHappinessHappinessCountFragment = { __typename?: 'HappinessCount', score: number, count: number };

export type DashboardHeaderTrackFragment = { __typename?: 'Track', id: string, slug: string, title: string, description: string, icon: string, createdAt: string, last_update: string, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null, slug: string | null } | null }>, team: { __typename?: 'Team', id: string, name: string, logo: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', statistics: boolean, embedded: boolean, members_skip_to_challenge: boolean } | null } | null };

export type DashboardHeaderDeveloperFragment = { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null, slug: string | null } | null };

export type UserActivityLogEventsQueryVariables = Exact<{
  claimID: Scalars['String']['input'];
}>;


export type UserActivityLogEventsQuery = { __typename?: 'Query', trackInviteClaim: { __typename?: 'InviteClaim', events: Array<{ __typename?: 'InviteEvent', time: string, message: string, participantID: string | null, track: { __typename?: 'Track', id: string, slug: string } | null, challenge: { __typename?: 'Challenge', id: string, slug: string } | null }> } | null };

export type UserPlayCardItemFragment = { __typename?: 'PlayReportItem', id: string, timeSpent: number, completionPercent: number, completedChallenges: number, totalChallenges: number, mode: Mode | null, trackInvite: { __typename?: 'TrackInvite', id: string, title: string, publicTitle: string | null } | null, track: { __typename?: 'Track', id: string, title: string, slug: string }, activity: Array<{ __typename?: 'PlayActivity', time: string }>, playReview: { __typename?: 'TrackReview', id: string, score: number, content: string } | null };

export type UserReportTableItemFragment = { __typename?: 'UserReportItem', plays: number, tracksStarted: number, tracksCompleted: number, completionRate: number, averageProgressPercent: number, timeSpent: number, lastStartedAt: string, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null } };

export type UserDetailsCollectedTableDetailsFragment = { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null };

export type AddTrackToArcadeMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type AddTrackToArcadeMutation = { __typename?: 'Mutation', addTrackToArcade: boolean };

export type RemoveTrackFromArcadeMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type RemoveTrackFromArcadeMutation = { __typename?: 'Mutation', removeTrackFromArcade: boolean };

export type ArcadeUpdateMachineUpdateArcadeMutationVariables = Exact<{
  arcade: ArcadeInput;
}>;


export type ArcadeUpdateMachineUpdateArcadeMutation = { __typename?: 'Mutation', updateArcade: { __typename?: 'Arcade', id: string, alternative_url: string | null } | null };

export type CreateChallengeFormQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type CreateChallengeFormQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string } | null };

export type CreateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type CreateChallengeMutation = { __typename?: 'Mutation', createChallenge: { __typename?: 'Challenge', id: string, slug: string, title: string, type: ChallengeType, teaser: string, assignment: string, timelimit: number | null, answers: Array<string>, solution: Array<number> } | null };

export type ChallengeFormDataFragment = { __typename?: 'Challenge', id: string, slug: string, title: string, type: ChallengeType, teaser: string, assignment: string, timelimit: number | null, answers: Array<string>, solution: Array<number> };

export type ChallengeFormChallengeFragment = { __typename?: 'Challenge', title: string, slug: string, type: ChallengeType, assignment: string, teaser: string, timelimit: number | null, answers: Array<string>, solution: Array<number> };

export type DashboardChallengeItemFragment = { __typename?: 'Challenge', id: string, slug: string, type: ChallengeType, title: string, teaser: string, index: number, status: ChallengeStatus };

export type DashboardChallengeItemTrackFragment = { __typename?: 'Track', id: string, status: TrackStatus | null, permalink: string | null, slug: string, maintenance: boolean };

export type ChallengeNoteDrawerQueryVariables = Exact<{
  noteID: Scalars['String']['input'];
}>;


export type ChallengeNoteDrawerQuery = { __typename?: 'Query', note: { __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null, index: number } | null };

export type UpdateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;


export type UpdateChallengeNoteMutation = { __typename?: 'Mutation', updateChallengeNote: { __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null, index: number } | null };

export type CreateChallengeNoteMutationVariables = Exact<{
  note: ChallengeNoteInput;
}>;


export type CreateChallengeNoteMutation = { __typename?: 'Mutation', createChallengeNote: { __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null, index: number } | null };

export type ChallengeNoteItemFragment = { __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null, index: number };

export type ChallengeNoteFormNoteFragment = { __typename?: 'ChallengeNote', contents: string | null, type: ChallengeNoteType, url: string | null };

export type ChallengeNoteListSortNotesMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
  notes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ChallengeNoteListSortNotesMutation = { __typename?: 'Mutation', updateChallengeNoteIndexes: Array<{ __typename?: 'ChallengeNote', id: string, index: number }> | null };

export type ChallengeNoteListDeleteNoteMutationVariables = Exact<{
  noteID: Scalars['String']['input'];
}>;


export type ChallengeNoteListDeleteNoteMutation = { __typename?: 'Mutation', deleteChallengeNote: boolean };

export type ChallengeNoteListNoteFragment = { __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null };

export type ChallengeTabCustomHeaderFragment = { __typename?: 'CustomHeader', key: string, value: string };

export type UpdateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;


export type UpdateChallengeTabMutation = { __typename?: 'Mutation', result: { __typename?: 'ChallengeTab', cmd: string | null, hostname: string | null, id: string, index: number, new_window: boolean, path: string | null, port: number | null, target: string | null, type: ChallengeTabType, title: string, url: string | null, workdir: string | null, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null } | null };

export type CreateChallengeTabMutationVariables = Exact<{
  tab: ChallengeTabInput;
}>;


export type CreateChallengeTabMutation = { __typename?: 'Mutation', result: { __typename?: 'ChallengeTab', cmd: string | null, hostname: string | null, id: string, index: number, new_window: boolean, path: string | null, port: number | null, target: string | null, type: ChallengeTabType, title: string, url: string | null, workdir: string | null, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null } | null };

export type ChallengeTabFormTabFragment = { __typename?: 'ChallengeTab', title: string, type: ChallengeTabType, hostname: string | null, url: string | null, port: number | null, path: string | null, workdir: string | null, cmd: string | null, new_window: boolean, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null };

export type ChallengeTabListSortTabsMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
  tabs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ChallengeTabListSortTabsMutation = { __typename?: 'Mutation', updateChallengeTabIndexes: Array<{ __typename?: 'ChallengeTab', id: string, title: string, index: number }> | null };

export type ChallengeTabListDeleteTabMutationVariables = Exact<{
  tabID: Scalars['String']['input'];
}>;


export type ChallengeTabListDeleteTabMutation = { __typename?: 'Mutation', deleteChallengeTab: boolean };

export type UpdateSettingsVirtualBrowserChallengeCheckMutationVariables = Exact<{
  check: VirtualBrowserCheckInput;
}>;


export type UpdateSettingsVirtualBrowserChallengeCheckMutation = { __typename?: 'Mutation', upsertVirtualBrowserCheck: { __typename?: 'VirtualBrowserCheck', id: string, browserLocation: { __typename?: 'Location', conditions: Array<{ __typename?: 'UrlCondition', urlPart: string, condition: ConditionType }> } | null, element: Array<{ __typename?: 'HtmlElement', selector: string, value: string }>, innerText: Array<{ __typename?: 'HtmlElement', selector: string, value: string }> } };

export type DeleteSettingsVirtualBrowserChallengeCheckMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSettingsVirtualBrowserChallengeCheckMutation = { __typename?: 'Mutation', deleteVirtualBrowserCheck: boolean };

export type VirtualBrowserCheckItemFragment = { __typename?: 'VirtualBrowserCheck', id: string, host: string, challenge: { __typename?: 'Challenge', id: string, slug: string, permalink: string | null, title: string }, browserLocation: { __typename?: 'Location', conditions: Array<{ __typename?: 'UrlCondition', urlPart: string, condition: ConditionType }> } | null, element: Array<{ __typename?: 'HtmlElement', selector: string, value: string }>, innerText: Array<{ __typename?: 'HtmlElement', selector: string, value: string }> };

export type CopyTrackModalQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type CopyTrackModalQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, version: string, slug: string, icon: string, title: string, teaser: string, description: string, level: Level | null, idle_timeout: number | null, timelimit: number | null, status: TrackStatus | null, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, developers: Array<{ __typename?: 'User', profile: { __typename?: 'UserProfile', email: string | null } | null }>, challenges: Array<{ __typename?: 'Challenge', id: string, type: ChallengeType, slug: string, title: string, teaser: string, difficulty: string, assignment: string, timelimit: number | null, answers: Array<string>, solution: Array<number>, notes: Array<{ __typename?: 'ChallengeNote', type: ChallengeNoteType, contents: string | null, url: string | null }>, tabs: Array<{ __typename?: 'ChallengeTab', cmd: string | null, type: ChallengeTabType, title: string, hostname: string | null, path: string | null, port: number | null, url: string | null, new_window: boolean }>, scripts: Array<{ __typename?: 'ChallengeScript', host: string, action: string, contents: string }> }>, sandboxConfig: { __typename?: 'SandboxConfigVersion', config: { __typename?: 'SandboxConfig', slug: string } | null } | null, config: { __typename?: 'TrackConfig', version: string | null, containers: Array<{ __typename?: 'ContainerConfig', name: string, image: string, entrypoint: string | null, cmd: string | null, shell: string, ports: Array<number> | null, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', name: string, services: Array<string> }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', name: string, user_only: boolean, roles: Array<string> }> }, scripts: Array<{ __typename?: 'TrackScript', id: string, action: string, contents: string, host: string }> } | null };

export type TrackExistsQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackExistsQuery = { __typename?: 'Query', trackExists: boolean };

export type CopyTrackModalUpdateCompleteTrackMutationVariables = Exact<{
  track: TrackInput;
}>;


export type CopyTrackModalUpdateCompleteTrackMutation = { __typename?: 'Mutation', updateCompleteTrack: { __typename?: 'Track', id: string, slug: string, icon: string, last_update: string, createdAt: string, permalink: string | null, teaser: string, title: string, description: string, maintenance: boolean, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, updated_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null }> } | null };

export type CreateTrackFromModalMutationVariables = Exact<{
  track: TrackInput;
}>;


export type CreateTrackFromModalMutation = { __typename?: 'Mutation', createTrack: { __typename?: 'Track', id: string, slug: string, icon: string, last_update: string, createdAt: string, permalink: string | null, teaser: string, title: string, description: string, maintenance: boolean, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, updated_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null }> } | null };

export type CreateTrackSandboxPresetsFragment = { __typename?: 'TrackConfigPresets', containers: Array<{ __typename?: 'ContainerConfigPreset', label: string, image: string, memory: number }>, googlecloudmachinetypes: Array<{ __typename?: 'GoogleCloudMachineTypePreset', label: string, machine_type: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfigPreset', image: string, label: string, machine_type: string, cpus: number, memory: number }>, machinetypes: Array<{ __typename?: 'MachineTypePreset', cpus: number, label: string, memory: number }> };

export type CustomResourcesListResourceFragment = { __typename?: 'CustomResource', id: string, name: string, description: string, version: string, logo: string, createdAt: string, createdBy: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null } };

export type TeamExistsQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type TeamExistsQuery = { __typename?: 'Query', teamExists: boolean };

export type UpdateLocalTeamMutationVariables = Exact<{
  id: Scalars['String']['input'];
  team: TeamInput;
}>;


export type UpdateLocalTeamMutation = { __typename?: 'Mutation', updateLocalTeam: { __typename?: 'Team', id: string, name: string, logo: string | null, title: string | null, subtitle: string | null, slug: string, primary_link_text: string | null, primary_link_url: string | null, secondary_link_text: string | null, secondary_link_url: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null, secondary_foreground_color: string | null, secondary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', hot_start: boolean, invites: boolean, statistics: boolean, webhooks: boolean } | null } | null };

export type UpdateRemoteTeamMutationVariables = Exact<{
  team: TeamInput;
}>;


export type UpdateRemoteTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name: string, logo: string | null, title: string | null, subtitle: string | null, slug: string, primary_link_text: string | null, primary_link_url: string | null, secondary_link_text: string | null, secondary_link_url: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null, secondary_foreground_color: string | null, secondary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', hot_start: boolean, invites: boolean, statistics: boolean, webhooks: boolean } | null } | null };

export type EditSidebarQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type EditSidebarQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string, logo: string | null, title: string | null, subtitle: string | null, slug: string, primary_link_text: string | null, primary_link_url: string | null, secondary_link_text: string | null, secondary_link_url: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null, secondary_foreground_color: string | null, secondary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', hot_start: boolean, invites: boolean, statistics: boolean, webhooks: boolean } | null } | null };

export type EditBrandingTeamFragment = { __typename?: 'Team', id: string, name: string, logo: string | null, title: string | null, subtitle: string | null, slug: string, primary_link_text: string | null, primary_link_url: string | null, secondary_link_text: string | null, secondary_link_url: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null, secondary_foreground_color: string | null, secondary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', hot_start: boolean, invites: boolean, statistics: boolean, webhooks: boolean } | null };

export type EmbedDrawerConfigurationQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type EmbedDrawerConfigurationQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, embed_token: string } | null };

export type FormConfigurationFragmentFragment = { __typename?: 'Form', id: string, formTitle: string | null, consentNotice: string | null, validateWorkEmail: boolean | null, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> };

export type GetFormConfigurationQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetFormConfigurationQuery = { __typename?: 'Query', team: { __typename?: 'Team', name: string, form: { __typename?: 'Form', id: string, formTitle: string | null, consentNotice: string | null, validateWorkEmail: boolean | null, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null } | null };

export type UpdateFormConfigurationMutationVariables = Exact<{
  form: FormInput;
}>;


export type UpdateFormConfigurationMutation = { __typename?: 'Mutation', updateForm: { __typename?: 'Form', id: string, formTitle: string | null, consentNotice: string | null, validateWorkEmail: boolean | null, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null };

export type HotStartFormTrackFragment = { __typename?: 'Track', id: string, title: string, permalink: string | null, maintenance: boolean };

export type HotStartSandboxPresetFragment = { __typename?: 'SandboxConfigVersion', id: string, version: number, published_at: string | null, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null };

export type HotStartPagePoolFragment = { __typename?: 'HotStartPool', id: string, type: HotStartPoolType, name: string, created: string | null, status: HotStartStatus, starts_at: string | null, ends_at: string | null };

export type InsightsFilterFormTrackFragment = { __typename?: 'Track', id: string, title: string, permalink: string | null, maintenance: boolean };

export type InsightsOverviewSeriesFragment = { __typename?: 'PlayInsightSeries', plays: { __typename?: 'PlaySeries', sum: number, items: Array<{ __typename?: 'PlaySeriesItem', bucketStartTime: string, value: number }> }, learnersReached: { __typename?: 'LearnersReachedSeries', sum: number, items: Array<{ __typename?: 'LearnersReachedSeriesItem', bucketStartTime: string, value: number }> }, timeSpent: { __typename?: 'TimeSpentSeries', average: number, items: Array<{ __typename?: 'TimeSpentSeriesItem', bucketStartTime: string, value: number }> }, completionRate: { __typename?: 'CompletionRateSeries', sum: number, items: Array<{ __typename?: 'CompletionRateSeriesItem', bucketStartTime: string, value: number }> } };

export type InsightsStatisticsFragment = { __typename?: 'TeamStatistics', started_total: number | null, completed_total: number | null, team_series: Array<{ __typename?: 'TeamSeries', date: string, started: number, completed: number }>, track_statistics: Array<{ __typename?: 'TrackStatistics', average_review_score: number | null, started_total: number | null, completed_total: number | null, track: { __typename?: 'Track', title: string, slug: string, developers: Array<{ __typename?: 'User', profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null } | null }> } | null }> };

export type InviteFormTrackInviteFragment = { __typename?: 'TrackInvite', id: string, shareMethod: TrackInviteShareMethod | null, type: TrackInviteType | null, publicTitle: string | null, publicDescription: string | null, title: string, inviteLimit: number | null, playLimit: number | null, playTTL: number | null, allowedEmailAddresses: Array<string>, allowAnonymous: boolean, expiresAt: string | null, startsAt: string | null, enableLearnerSharing: boolean, tracks: Array<{ __typename?: 'Track', id: string }>, runtimeParameters: { __typename?: 'RuntimeParameters', secrets: Array<{ __typename?: 'RuntimeSecret', key: string, secret: string }>, environmentVariables: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> } | null };

export type InviteFormTrackFragment = { __typename?: 'Track', id: string, title: string, maintenance: boolean, slug: string };

export type InviteFormTeamFragment = { __typename?: 'Team', id: string, form: { __typename?: 'Form', id: string, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null };

export type GetManageCloudAccountDrawerConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
}>;


export type GetManageCloudAccountDrawerConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', aws_accounts: boolean, azure_subscriptions: boolean, gcp_projects: boolean } | null } | null, trackConfig: { __typename?: 'TrackConfig', id: string, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, trackScripts: Array<{ __typename?: 'TrackScript', id: string, host: string, action: string, contents: string }> | null };

export type ManageCloudAccsResourcesFragment = { __typename?: 'SandboxResources', aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> };

export type ManageTrackCloudAccsResourcesFragment = { __typename?: 'TrackConfig', aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> };

export type GetManageHostDrawerConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackID: Scalars['String']['input'];
}>;


export type GetManageHostDrawerConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', containers: boolean, virtual_machines: boolean, saas: boolean, custom_machine_type: boolean } | null } | null, trackConfigPresets: { __typename?: 'TrackConfigPresets', containers: Array<{ __typename?: 'ContainerConfigPreset', label: string, image: string, memory: number }>, googlecloudmachinetypes: Array<{ __typename?: 'GoogleCloudMachineTypePreset', label: string, machine_type: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfigPreset', image: string, label: string, machine_type: string, cpus: number, memory: number }>, machinetypes: Array<{ __typename?: 'MachineTypePreset', cpus: number, label: string, memory: number }> } | null, trackConfig: { __typename?: 'TrackConfig', id: string, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, trackScripts: Array<{ __typename?: 'TrackScript', id: string, host: string, action: string, contents: string }> | null };

export type ManageHostDrawerRenameHostMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  hostName: Scalars['String']['input'];
  newName: Scalars['String']['input'];
}>;


export type ManageHostDrawerRenameHostMutation = { __typename?: 'Mutation', renameSandboxConfigHost: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type ManageHostResourcesFragment = { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }> };

export type ManageTrackHostResourcesFragment = { __typename?: 'TrackConfig', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }> };

export type ManageNewTrackSandboxConfigVersionFragment = { __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', action: string, contents: string, host: string }> | null, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null };

export type ManageSandboxPresetVersionFragment = { __typename?: 'SandboxConfigVersion', id: string, description: string, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', host: string, action: string, contents: string }> | null };

export type AddTeamMemberSlugCheckQueryVariables = Exact<{
  slug: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type AddTeamMemberSlugCheckQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null } | null } | null };

export type AddTeamMemberMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  role: InputMaybe<RoleName>;
}>;


export type AddTeamMemberMutation = { __typename?: 'Mutation', inviteTeamUser: { __typename?: 'Team', id: string, name: string, slug: string, members: Array<{ __typename?: 'TeamMember', role: RoleName, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null, slug: string | null } | null } }>, invites: Array<{ __typename?: 'TeamInvite', email: string, role: RoleName }> | null } | null };

export type DeleteTeamInviteMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type DeleteTeamInviteMutation = { __typename?: 'Mutation', deleteTeamInvite: { __typename?: 'Team', id: string, invites: Array<{ __typename?: 'TeamInvite', email: string, role: RoleName }> | null } | null };

export type InvitesTeamFragment = { __typename?: 'Team', id: string, invites: Array<{ __typename?: 'TeamInvite', email: string, role: RoleName }> | null };

export type RemoveTeamUserMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
}>;


export type RemoveTeamUserMutation = { __typename?: 'Mutation', removeTeamUser: { __typename?: 'Team', id: string, members: Array<{ __typename?: 'TeamMember', role: RoleName, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null, slug: string | null } | null } }> } | null };

export type ChangeTeamUserRoleMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
  role: RoleName;
}>;


export type ChangeTeamUserRoleMutation = { __typename?: 'Mutation', changeTeamUserRole: { __typename?: 'Team', id: string, members: Array<{ __typename?: 'TeamMember', role: RoleName, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null, slug: string | null } | null } }> } | null };

export type MembersTeamFragment = { __typename?: 'Team', id: string, members: Array<{ __typename?: 'TeamMember', role: RoleName, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null, slug: string | null } | null } }> };

export type ManageTrackSandboxConfigVersionFragment = { __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null };

export type PlayActivityDrawerPlayReportItemFragment = { __typename?: 'PlayReportItem', id: string, mode: Mode | null, stoppedReason: string | null, completionPercent: number, timeSpent: number, startedAt: string, hotStartPool: { __typename?: 'HotStartPool', id: string } | null, customParameters: Array<{ __typename?: 'CustomParameter', key: string, value: string }>, track: { __typename?: 'Track', id: string, title: string, slug: string, developers: Array<{ __typename?: 'User', id: string }> }, trackInvite: { __typename?: 'TrackInvite', id: string, publicTitle: string | null } | null, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null }, activity: Array<{ __typename?: 'PlayActivity', message: string, time: string, challenge: { __typename?: 'Challenge', slug: string } | null }>, playReview: { __typename?: 'TrackReview', id: string, score: number, content: string } | null };

export type PlayActivityDrawerQueryVariables = Exact<{
  playReportInput: PlayReportInput;
  playID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type PlayActivityDrawerQuery = { __typename?: 'Query', playReportItem: { __typename?: 'PlayReportItem', id: string, mode: Mode | null, stoppedReason: string | null, completionPercent: number, timeSpent: number, startedAt: string, hotStartPool: { __typename?: 'HotStartPool', id: string } | null, customParameters: Array<{ __typename?: 'CustomParameter', key: string, value: string }>, track: { __typename?: 'Track', id: string, title: string, slug: string, developers: Array<{ __typename?: 'User', id: string }> }, trackInvite: { __typename?: 'TrackInvite', id: string, publicTitle: string | null } | null, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null }, activity: Array<{ __typename?: 'PlayActivity', message: string, time: string, challenge: { __typename?: 'Challenge', slug: string } | null }>, playReview: { __typename?: 'TrackReview', id: string, score: number, content: string } | null } | null };

export type PreviewResourceSandboxResourcesFragment = { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> };

export type PreviewSandboxPresetVersionFragment = { __typename?: 'SandboxConfigVersion', change_log_entry: string, id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', action: string, contents: string, host: string }> | null, tracks: Array<{ __typename?: 'Track', id: string, title: string } | null>, hot_start_pools: Array<{ __typename?: 'HotStartPool', id: string, name: string } | null>, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null };

export type PreviewSandboxHistoryPresetVersionFragment = { __typename?: 'SandboxConfigVersion', change_log_entry: string, id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null };

export type AwsAccountFormAwsAccountFragment = { __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null };

export type AzureSubscriptionFormAzureSubscriptionFragment = { __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> };

export type ContainerFormContainerPresetFragment = { __typename?: 'ContainerConfigPreset', label: string, image: string, memory: number };

export type ContainerFormContainerFragment = { __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null };

export type GoogleCloudFormGcpProjectFragment = { __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> };

export type SandboxPresetCardInfoFragment = { __typename?: 'SandboxConfigVersion', id: string, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', action: string, contents: string, host: string }> | null };

export type SandboxPresetDiffModalGetDiffQueryVariables = Exact<{
  sourceConfigVersionID: InputMaybe<Scalars['String']['input']>;
  sourceConfigVersion: InputMaybe<SandboxConfigInput>;
  targetConfigVersionID: Scalars['String']['input'];
}>;


export type SandboxPresetDiffModalGetDiffQuery = { __typename?: 'Query', sandboxConfigVersionDiff: { __typename?: 'SandboxConfigVersionDiff', diff: string } | null };

export type GetSandboxPresetListCardInfoQueryVariables = Exact<{
  configVersionID: Scalars['String']['input'];
}>;


export type GetSandboxPresetListCardInfoQuery = { __typename?: 'Query', sandboxConfigVersion: { __typename?: 'SandboxConfigVersion', id: string, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', action: string, contents: string, host: string }> | null } | null };

export type SandboxPresetListCardFragment = { __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null };

export type VirtualBrowserFormVirtualBrowserFragment = { __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string };

export type VirtualMachineFormMachineTypePresetFragment = { __typename?: 'MachineTypePreset', cpus: number, label: string, memory: number };

export type VirtualMachineFormGoogleCloudMachineTypePresetFragment = { __typename?: 'GoogleCloudMachineTypePreset', label: string, machine_type: string };

export type VirtualMachineFormVirtualMachinePresetFragment = { __typename?: 'VirtualMachineConfigPreset', image: string, label: string, machine_type: string, cpus: number, memory: number };

export type VirtualMachineFormVirtualMachineFragment = { __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null };

export type SelectPresetSandboxConfigVersionFragment = { __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null };

export type SsoConfigDefaultFormOptionsFragment = { __typename?: 'DefaultSsoConnectionOptions', clientID: string, domain: string };

type SsoConfigDrawerOptions_DefaultSsoConnectionOptions_Fragment = { __typename?: 'DefaultSsoConnectionOptions', clientID: string, domain: string };

type SsoConfigDrawerOptions_SamlSsoConnectionOptions_Fragment = { __typename?: 'SamlSsoConnectionOptions', signingCert: string, signingEndpoint: string, entityID: string };

export type SsoConfigDrawerOptionsFragment = SsoConfigDrawerOptions_DefaultSsoConnectionOptions_Fragment | SsoConfigDrawerOptions_SamlSsoConnectionOptions_Fragment;

export type SsoConfigSamlFormOptionsFragment = { __typename?: 'SamlSsoConnectionOptions', signingCert: string, signingEndpoint: string, entityID: string };

export type TagGroupFormTagFragment = { __typename?: 'Tag', id: string, value: string };

export type TagGroupInfoDrawerGroupFragment = { __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> }> };

export type TagGroupInfoDrawerTrackFragment = { __typename?: 'Track', id: string, title: string, slug: string };

export type TagGroupsTableGroupFragment = { __typename?: 'TagGroup', id: string, name: string, createdAt: string, tags: Array<{ __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> }> };

export type TagGroupsTableTagFragment = { __typename?: 'Tag', id: string, value: string };

export type TagTracksDrawerTrackFragment = { __typename?: 'Track', id: string, title: string, slug: string };

export type TagsTableTagFragment = { __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> };

export type CreateTrackFromScrachMutationVariables = Exact<{
  track: TrackInput;
}>;


export type CreateTrackFromScrachMutation = { __typename?: 'Mutation', createTrack: { __typename?: 'Track', id: string, slug: string, icon: string, last_update: string, createdAt: string, permalink: string | null, teaser: string, title: string, description: string, maintenance: boolean, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, updated_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null }> } | null };

export type TeamContentTrackFragment = { __typename?: 'Track', id: string, icon: string, last_update: string, createdAt: string, permalink: string | null, slug: string, teaser: string, title: string, description: string, maintenance: boolean, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, updated_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null }> };

export type TeamContentTagFragment = { __typename?: 'Tag', id: string, value: string };

export type TerraformModuleListEntryFragment = { __typename?: 'TerraformModule', description: string, id: string, logo: string, name: string, provider: string, publishedAt: string };

export type DashboardChallengesItemFragment = { __typename?: 'Challenge', id: string, slug: string, type: ChallengeType, title: string, teaser: string, index: number, status: ChallengeStatus, assignment: string, tabs: Array<{ __typename?: 'ChallengeTab', id: string, hostname: string | null, index: number, type: ChallengeTabType, title: string, target: string | null, new_window: boolean, path: string | null }> };

export type DashboardChallengesTrackFragment = { __typename?: 'Track', id: string, status: TrackStatus | null, permalink: string | null, slug: string, maintenance: boolean };

export type UpdateTrackChallengesOrderMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  challenges: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateTrackChallengesOrderMutation = { __typename?: 'Mutation', updateChallengeIndexes: Array<{ __typename?: 'Challenge', id: string, index: number }> | null };

export type DashboardApplicationsTrackFragment = { __typename?: 'Track', sandboxConfig: { __typename?: 'SandboxConfigVersion', id: string, description: string, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> } | null } | null, trackConfig: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> } | null };

export type DashboardApplicationSandboxResourcesFragment = { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> };

export type DashboardApplicationTrackConfigResourcesFragment = { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> };

export type GetWidgetVirtualBrowserChallengeChecksQueryVariables = Exact<{
  track: Scalars['String']['input'];
}>;


export type GetWidgetVirtualBrowserChallengeChecksQuery = { __typename?: 'Query', virtualBrowserChecks: Array<{ __typename?: 'VirtualBrowserCheck', id: string, host: string, challenge: { __typename?: 'Challenge', id: string, slug: string, permalink: string | null, title: string }, browserLocation: { __typename?: 'Location', conditions: Array<{ __typename?: 'UrlCondition', urlPart: string, condition: ConditionType }> } | null, element: Array<{ __typename?: 'HtmlElement', selector: string, value: string }>, innerText: Array<{ __typename?: 'HtmlElement', selector: string, value: string }> }> };

export type ChecksWidgetChallengeFragment = { __typename?: 'Challenge', id: string, title: string, permalink: string | null, scripts: Array<{ __typename?: 'ChallengeScript', id: string, action: string }> };

export type UpdateTrackDashboardOptionsMutationVariables = Exact<{
  track: TrackInput;
}>;


export type UpdateTrackDashboardOptionsMutation = { __typename?: 'Mutation', updateTrack: { __typename?: 'Track', id: string, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, lab_config: { __typename?: 'LabConfig', hideStopButton: boolean } | null } | null };

export type DashboardSettingsTrackFragment = { __typename?: 'Track', id: string, timelimit: number | null, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, permalink: string | null, slug: string, icon: string, title: string, teaser: string, description: string, level: Level | null, idle_timeout: number | null, status: TrackStatus | null, completed: string, challenges: Array<{ __typename?: 'Challenge', id: string, timelimit: number | null, permalink: string | null, slug: string, title: string, teaser: string, status: ChallengeStatus, index: number, type: ChallengeType, started: number, completed: number, failed: number, failMessage: string | null }>, lab_config: { __typename?: 'LabConfig', hideStopButton: boolean, width: number, position: string, overlay: boolean, extendTTL: number | null } | null, team: { __typename?: 'Team', id: string, slug: string } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null, email: string | null } | null }> };

export type DashboardSourceTrackFragment = { __typename?: 'Track', sourceTrack: { __typename?: 'Track', id: string, slug: string, title: string, team: { __typename?: 'Team', id: string, slug: string } | null } | null };

export type DashboardTrackStatisticsFragment = { __typename?: 'TrackStatistics', started_total: number | null, happiness: Array<{ __typename?: 'HappinessCount', score: number, count: number }> };

export type TrackDetailsAddTagFormTagGroupFragment = { __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }> };

export type TrackDetailsAddTagFormTagFragment = { __typename?: 'Tag', id: string, value: string };

export type TrackDetailsFormQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackDetailsFormQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, slug: string, title: string, timelimit: number | null, description: string, idle_timeout: number | null, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, icon: string, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null } | null }>, team: { __typename?: 'Team', id: string, slug: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }>, tagGroups: Array<{ __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }> }> } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null } | null };

export type UpdateTrackDetailsMutationVariables = Exact<{
  track: TrackInput;
}>;


export type UpdateTrackDetailsMutation = { __typename?: 'Mutation', updateTrack: { __typename?: 'Track', id: string, slug: string, title: string, timelimit: number | null, description: string, idle_timeout: number | null, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, icon: string, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null } | null }>, team: { __typename?: 'Team', id: string, slug: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }>, tagGroups: Array<{ __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }> }> } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null } | null };

export type TrackDetailsFormDataFragment = { __typename?: 'Track', id: string, slug: string, title: string, timelimit: number | null, description: string, idle_timeout: number | null, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, icon: string, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null } | null }>, team: { __typename?: 'Team', id: string, slug: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }>, tagGroups: Array<{ __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }> }> } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, lab_config: { __typename?: 'LabConfig', width: number, position: string, overlay: boolean, extendTTL: number | null, hideStopButton: boolean } | null };

export type TrackInviteDetailsTrackInviteFragment = { __typename?: 'TrackInvite', id: string, shareMethod: TrackInviteShareMethod | null, title: string, publicTitle: string | null, publicDescription: string | null, inviteLimit: number | null, claimCount: number | null, startsAt: string | null, expiresAt: string | null, playLimit: number | null, playTTL: number | null, allowAnonymous: boolean, allowedEmailAddressesOnly: boolean, status: TrackInviteStatus | null, type: TrackInviteType | null, enableLearnerSharing: boolean, canClaim: boolean, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }>, team: { __typename?: 'Team', name: string } };

export type TrackInvitesTableInvitesQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  filters: InviteFilters;
}>;


export type TrackInvitesTableInvitesQuery = { __typename?: 'Query', trackInvites: Array<{ __typename?: 'TrackInvite', id: string, shareMethod: TrackInviteShareMethod | null, publicTitle: string | null, title: string, inviteLimit: number | null, claimCount: number | null, expiresAt: string | null, created: string | null, playLimit: number | null, type: TrackInviteType | null, status: TrackInviteStatus | null, startsAt: string | null, tracks: Array<{ __typename?: 'Track', id: string, title: string }> }> | null, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', hot_start: boolean } | null } | null };

export type TrackInvitesTableInviteQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackInvitesTableInviteQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, publicTitle: string | null, claims: Array<{ __typename?: 'InviteClaim', id: string, claimedAt: string | null, playLimit: number | null, playTTL: string | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null, details: { __typename?: 'UserDetails', firstName: string | null, lastName: string | null, email: string | null, id: string, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null } }>, team: { __typename?: 'Team', id: string, slug: string, form: { __typename?: 'Form', id: string, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName }> } | null }, plays: Array<{ __typename?: 'InvitePlay', last_activity: string, time_spent: number, track_started_at: string, track_completed_at: string | null, completed_challenges: number, total_challenges: number, failed_challenge_attempts: number, track: { __typename?: 'Track', id: string, slug: string }, participant: { __typename?: 'Play', id: string }, user: { __typename?: 'User', id: string, is_anonymous: boolean, profile: { __typename?: 'UserProfile', email: string | null, display_name: string | null } | null } }> } | null };

export type DeleteTrackInviteMutationVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type DeleteTrackInviteMutation = { __typename?: 'Mutation', deleteTrackInvite: boolean };

export type TrackLimitsTableTrackFragment = { __typename?: 'Track', id: string, title: string, slug: string, maintenance: boolean, play_count: number | null };

export type TrackLimitsTableTrackLimitsFragment = { __typename?: 'TrackPlayLimit', rollingMonth: number, rollingIPAddressPerHour: number, calendarMonth: number, track: { __typename?: 'Track', id: string } | null };

export type TrackLtiDrawerQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type TrackLtiDrawerQuery = { __typename?: 'Query', team: { __typename?: 'Team', lti_credentials: { __typename?: 'LTICredentials', consumer_name: string, consumer_key: string } | null } | null };

export type TrackStatisticsTableTrackStatisticsFragment = { __typename?: 'TrackStatistics', average_review_score: number | null, started_total: number | null, completed_total: number | null, track: { __typename?: 'Track', title: string, slug: string, developers: Array<{ __typename?: 'User', profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null } | null }> } | null };

export type UserReportDrawerQueryVariables = Exact<{
  userID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  userReportInput: UserReportInput;
  playReportInput: PlayReportInput;
}>;


export type UserReportDrawerQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null, reportItem: { __typename?: 'UserReportItem', tracksStarted: number, tracksCompleted: number, averageProgressPercent: number, timeSpent: number, lastStartedAt: string, playReportItems: Array<{ __typename?: 'PlayReportItem', id: string, timeSpent: number, completionPercent: number, completedChallenges: number, totalChallenges: number, mode: Mode | null, trackInvite: { __typename?: 'TrackInvite', id: string, title: string, publicTitle: string | null } | null, track: { __typename?: 'Track', id: string, title: string, slug: string }, activity: Array<{ __typename?: 'PlayActivity', time: string }>, playReview: { __typename?: 'TrackReview', id: string, score: number, content: string } | null }> } | null } | null };

export type GetTeamSaasFeatureFlagQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetTeamSaasFeatureFlagQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', saas: boolean } | null } | null };

export type WizardTrackDetailsTrackExistsQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type WizardTrackDetailsTrackExistsQuery = { __typename?: 'Query', trackExists: boolean };

export type ApiKeysQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type ApiKeysQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, api_key: string | null, features: { __typename?: 'TeamFeatures', lti_enabled: boolean } | null, lti_credentials: { __typename?: 'LTICredentials', consumer_name: string, consumer_key: string } | null } | null };

export type ApiKeysGenerateTeamApiKeyMutationVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type ApiKeysGenerateTeamApiKeyMutation = { __typename?: 'Mutation', generateTeamAPIKey: string | null };

export type ApiKeysGenerateTeamLtiCredentialsMutationVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type ApiKeysGenerateTeamLtiCredentialsMutation = { __typename?: 'Mutation', generateTeamLTICredentials: { __typename?: 'LTICredentials', consumer_name: string, consumer_key: string } | null };

export type ArcadeEditPageQueryVariables = Exact<{
  arcadeID: Scalars['String']['input'];
}>;


export type ArcadeEditPageQuery = { __typename?: 'Query', arcade: { __typename?: 'Arcade', id: string, serial_number: string, alternative_url: string | null, active: boolean } | null };

export type ArcadeListPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type ArcadeListPageQuery = { __typename?: 'Query', arcades: Array<{ __typename?: 'Arcade', id: string, serial_number: string, alternative_url: string | null, organization: string, active: boolean }> | null, tracks: Array<{ __typename?: 'Track', id: string, title: string }> | null, arcadetracks: Array<{ __typename?: 'Track', id: string, title: string, icon: string }> | null };

export type ChallengeAssignmentPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeAssignmentPageQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', answers: Array<string>, assignment: string, difficulty: string, id: string, index: number, slug: string, solution: Array<number>, teaser: string, timelimit: number | null, title: string, type: ChallengeType } | null, track: { __typename?: 'Track', id: string } | null };

export type UpdateChallengeAssignmentPageMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type UpdateChallengeAssignmentPageMutation = { __typename?: 'Mutation', updateChallenge: { __typename?: 'Challenge', assignment: string, id: string } | null };

export type ChallengeDetailsPageQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeDetailsPageQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string } | null, challenge: { __typename?: 'Challenge', id: string, slug: string, title: string, type: ChallengeType, teaser: string, assignment: string, timelimit: number | null, answers: Array<string>, solution: Array<number> } | null };

export type ChallengeDetailsPageUpdateChallengeMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type ChallengeDetailsPageUpdateChallengeMutation = { __typename?: 'Mutation', updateChallenge: { __typename?: 'Challenge', id: string, slug: string, title: string, type: ChallengeType, teaser: string, assignment: string, timelimit: number | null, answers: Array<string>, solution: Array<number> } | null };

export type ChallengeGuardrailsPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeGuardrailsPageQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', id: string, type: ChallengeType, title: string, slug: string } | null };

export type ChallengeNotesPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeNotesPageQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string } | null, challenge: { __typename?: 'Challenge', id: string, type: ChallengeType, title: string, slug: string, notes: Array<{ __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null, index: number }> } | null };

export type UpdateChallengeNotesOrderMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
  notes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateChallengeNotesOrderMutation = { __typename?: 'Mutation', updateChallengeNoteIndexes: Array<{ __typename?: 'ChallengeNote', id: string, index: number }> | null };

export type ChallengeQuizPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeQuizPageQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', answers: Array<string>, assignment: string, difficulty: string, id: string, index: number, slug: string, solution: Array<number>, teaser: string, timelimit: number | null, title: string, type: ChallengeType } | null, track: { __typename?: 'Track', id: string } | null };

export type UpdateChallengeQuizPageMutationVariables = Exact<{
  challenge: ChallengeInput;
}>;


export type UpdateChallengeQuizPageMutation = { __typename?: 'Mutation', updateChallenge: { __typename?: 'Challenge', id: string, assignment: string, answers: Array<string>, solution: Array<number> } | null };

export type ChallengeScriptsPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeScriptsPageQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, sandboxConfig: { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null, trackConfig: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null, challenge: { __typename?: 'Challenge', id: string, type: ChallengeType, title: string, slug: string, scripts: Array<{ __typename?: 'ChallengeScript', action: string, contents: string, host: string, id: string }> } | null };

export type ChallengeTabsPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeTabsPageQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', id: string, type: ChallengeType, title: string, slug: string, tabs: Array<{ __typename?: 'ChallengeTab', cmd: string | null, hostname: string | null, id: string, index: number, new_window: boolean, path: string | null, port: number | null, target: string | null, type: ChallengeTabType, title: string, url: string | null, workdir: string | null, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null }>, track: { __typename?: 'Track', id: string, sandboxConfig: { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null, trackConfig: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } } | null, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', saas: boolean } | null } | null };

export type TabsConfigVersionFragment = { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null };

export type TabsTrackConfigFragment = { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> };

export type ChallengeTabListSortMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
  tabs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ChallengeTabListSortMutation = { __typename?: 'Mutation', updateChallengeTabIndexes: Array<{ __typename?: 'ChallengeTab', id: string, index: number }> | null };

export type ChallengeTabItemFragment = { __typename?: 'ChallengeTab', cmd: string | null, hostname: string | null, id: string, index: number, new_window: boolean, path: string | null, port: number | null, target: string | null, type: ChallengeTabType, title: string, url: string | null, workdir: string | null, custom_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null, custom_response_headers: Array<{ __typename?: 'CustomHeader', key: string, value: string }> | null };

export type GetCustomResourcesListPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetCustomResourcesListPageConfigQuery = { __typename?: 'Query', customResources: Array<{ __typename?: 'CustomResource', id: string, name: string, description: string, version: string, logo: string, createdAt: string, createdBy: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null } }> };

export type GetHotStartPoolDetailsConfigQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetHotStartPoolDetailsConfigQuery = { __typename?: 'Query', hotStartPool: { __typename?: 'HotStartPool', id: string, size: number, created: string | null, name: string, auto_refill: boolean, starts_at: string | null, ends_at: string | null, status: HotStartStatus, type: HotStartPoolType, region: string | null, created_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null } | null, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', shared_hotstart_pools: boolean, global_sandboxes: boolean } | null }, tracks: Array<{ __typename?: 'HotStartPoolTrackEdge', claimed: number, available: number, creating: number, node: { __typename?: 'Track', id: string, title: string, slug: string } }>, configs: Array<{ __typename?: 'HotStartConfigTrackEdge', claimed: number, available: number, creating: number, node: { __typename?: 'SandboxConfig', id: string, name: string } }> } };

export type GetHotStartPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetHotStartPageConfigQuery = { __typename?: 'Query', team: { __typename?: 'Team', features: { __typename?: 'TeamFeatures', shared_hotstart_pools: boolean } | null } | null, hotStartPools: { __typename?: 'HotStartPoolConnection', edges: Array<{ __typename?: 'HotStartPoolEdge', node: { __typename?: 'HotStartPool', id: string, type: HotStartPoolType, name: string, created: string | null, status: HotStartStatus, starts_at: string | null, ends_at: string | null } | null }> } | null };

export type HotStartPageDeleteHotStartPoolMutationVariables = Exact<{
  poolID: Scalars['ID']['input'];
}>;


export type HotStartPageDeleteHotStartPoolMutation = { __typename?: 'Mutation', deleteHotStartPool: boolean };

export type InsightsFiltersQueryVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type InsightsFiltersQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string, maintenance: boolean, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null }> }>, tags: Array<{ __typename?: 'Tag', id: string, value: string }>, tagGroups: Array<{ __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }> }> } | null, trackInvites: Array<{ __typename?: 'TrackInvite', id: string, publicTitle: string | null, title: string }> | null };

export type InsightsOverviewQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  previousPlayInsightSeriesInput: PlayInsightSeriesInput;
  currentPlayInsightSeriesInput: PlayInsightSeriesInput;
}>;


export type InsightsOverviewQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, insights: { __typename?: 'Insights', play: { __typename?: 'PlayInsight', previous: { __typename?: 'PlayInsightSeries', granularity: TimeSeriesGranularity, plays: { __typename?: 'PlaySeries', sum: number, items: Array<{ __typename?: 'PlaySeriesItem', bucketStartTime: string, value: number }> }, learnersReached: { __typename?: 'LearnersReachedSeries', sum: number, items: Array<{ __typename?: 'LearnersReachedSeriesItem', bucketStartTime: string, value: number }> }, timeSpent: { __typename?: 'TimeSpentSeries', average: number, items: Array<{ __typename?: 'TimeSpentSeriesItem', bucketStartTime: string, value: number }> }, completionRate: { __typename?: 'CompletionRateSeries', sum: number, items: Array<{ __typename?: 'CompletionRateSeriesItem', bucketStartTime: string, value: number }> } }, current: { __typename?: 'PlayInsightSeries', granularity: TimeSeriesGranularity, plays: { __typename?: 'PlaySeries', sum: number, items: Array<{ __typename?: 'PlaySeriesItem', bucketStartTime: string, value: number }> }, learnersReached: { __typename?: 'LearnersReachedSeries', sum: number, items: Array<{ __typename?: 'LearnersReachedSeriesItem', bucketStartTime: string, value: number }> }, timeSpent: { __typename?: 'TimeSpentSeries', average: number, items: Array<{ __typename?: 'TimeSpentSeriesItem', bucketStartTime: string, value: number }> }, completionRate: { __typename?: 'CompletionRateSeries', sum: number, items: Array<{ __typename?: 'CompletionRateSeriesItem', bucketStartTime: string, value: number }> } } } } } | null };

export type InsightsContentTableQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackInsightPageInput: TrackInsightPageInput;
}>;


export type InsightsContentTableQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, insights: { __typename?: 'Insights', track: { __typename?: 'TrackInsight', page: { __typename?: 'TrackInsightPage', totalItems: number, items: Array<{ __typename?: 'TrackInsightItem', id: string, track: { __typename?: 'Track', id: string, title: string, slug: string }, currentPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number }, previousPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number } }> } } } } | null };

export type InsightsOverviewCsvQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  playInsightSeriesInput: PlayInsightSeriesInput;
}>;


export type InsightsOverviewCsvQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, insights: { __typename?: 'Insights', play: { __typename?: 'PlayInsight', series: { __typename?: 'PlayInsightSeries', plays: { __typename?: 'PlaySeries', items: Array<{ __typename?: 'PlaySeriesItem', bucketStartTime: string, value: number }> }, learnersReached: { __typename?: 'LearnersReachedSeries', items: Array<{ __typename?: 'LearnersReachedSeriesItem', bucketStartTime: string, value: number }> }, timeSpent: { __typename?: 'TimeSpentSeries', items: Array<{ __typename?: 'TimeSpentSeriesItem', bucketStartTime: string, value: number }> }, completionRate: { __typename?: 'CompletionRateSeries', items: Array<{ __typename?: 'CompletionRateSeriesItem', bucketStartTime: string, value: number }> } } } } } | null };

export type InsightsAllContentCsvQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackInsightPageInput: TrackInsightPageInput;
}>;


export type InsightsAllContentCsvQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, insights: { __typename?: 'Insights', track: { __typename?: 'TrackInsight', page: { __typename?: 'TrackInsightPage', items: Array<{ __typename?: 'TrackInsightItem', id: string, track: { __typename?: 'Track', id: string, slug: string }, currentPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number }, previousPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number } }> } } } } | null };

export type InsightsAllContentCsvFragment = { __typename?: 'TrackInsightItem', id: string, track: { __typename?: 'Track', id: string, slug: string }, currentPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number }, previousPeriod: { __typename?: 'TrackInsightsItemPeriod', plays: number, learnersReached: number, timeSpent: number, completionRate: number, averageReviewScore: number } };

export type InsightsOverviewCsvFragment = { __typename?: 'PlayInsightSeries', plays: { __typename?: 'PlaySeries', items: Array<{ __typename?: 'PlaySeriesItem', bucketStartTime: string, value: number }> }, learnersReached: { __typename?: 'LearnersReachedSeries', items: Array<{ __typename?: 'LearnersReachedSeriesItem', bucketStartTime: string, value: number }> }, timeSpent: { __typename?: 'TimeSpentSeries', items: Array<{ __typename?: 'TimeSpentSeriesItem', bucketStartTime: string, value: number }> }, completionRate: { __typename?: 'CompletionRateSeries', items: Array<{ __typename?: 'CompletionRateSeriesItem', bucketStartTime: string, value: number }> } };

export type InspirationLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type InspirationLibraryQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Track', icon: string, id: string, maintenance: boolean, slug: string, teaser: string, title: string, challenges: Array<{ __typename?: 'Challenge', permalink: string | null }> }> | null, examples: Array<{ __typename?: 'Track', icon: string, id: string, maintenance: boolean, slug: string, teaser: string, title: string, challenges: Array<{ __typename?: 'Challenge', permalink: string | null }> }> | null, tutorials: Array<{ __typename?: 'Track', icon: string, id: string, maintenance: boolean, slug: string, teaser: string, title: string, challenges: Array<{ __typename?: 'Challenge', permalink: string | null }> }> | null };

export type GetManageHotStartPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  filter: SandboxConfigVersionsFilterInput;
}>;


export type GetManageHotStartPageConfigQuery = { __typename?: 'Query', team: { __typename?: 'Team', features: { __typename?: 'TeamFeatures', max_hot_start_pool_size_always_on: number, max_hot_start_pool_size_scheduled: number, shared_hotstart_pools: boolean, global_sandboxes: boolean } | null } | null, tracks: Array<{ __typename?: 'Track', id: string, title: string, permalink: string | null, maintenance: boolean }> | null, sandboxConfigVersions: Array<{ __typename?: 'SandboxConfigVersion', id: string, version: number, published_at: string | null, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null }> | null };

export type CreateHotStartPoolMutationVariables = Exact<{
  input: HotStartPoolInput;
}>;


export type CreateHotStartPoolMutation = { __typename?: 'Mutation', createHotStartPool: { __typename?: 'HotStartPool', id: string } | null };

export type UpdateHotStartPoolMutationVariables = Exact<{
  poolID: Scalars['ID']['input'];
  input: HotStartPoolInput;
}>;


export type UpdateHotStartPoolMutation = { __typename?: 'Mutation', updateHotStartPool: { __typename?: 'HotStartPool', id: string } | null };

export type GetHotStartPoolToDuplicateQueryVariables = Exact<{
  poolID: Scalars['String']['input'];
}>;


export type GetHotStartPoolToDuplicateQuery = { __typename?: 'Query', hotStartPool: { __typename?: 'HotStartPool', id: string, type: HotStartPoolType, size: number, name: string, starts_at: string | null, ends_at: string | null, status: HotStartStatus, region: string | null, tracks: Array<{ __typename?: 'HotStartPoolTrackEdge', node: { __typename?: 'Track', id: string } }>, configs: Array<{ __typename?: 'HotStartConfigTrackEdge', node: { __typename?: 'SandboxConfig', id: string } }> } };

export type GetHotStartInviteQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type GetHotStartInviteQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', expiresAt: string | null, publicTitle: string | null, status: TrackInviteStatus | null, startsAt: string | null, tracks: Array<{ __typename?: 'Track', id: string }> } | null };

export type GetHotStartPoolExistingPoolQueryVariables = Exact<{
  poolID: Scalars['String']['input'];
}>;


export type GetHotStartPoolExistingPoolQuery = { __typename?: 'Query', hotStartPool: { __typename?: 'HotStartPool', id: string, type: HotStartPoolType, size: number, name: string, starts_at: string | null, ends_at: string | null, status: HotStartStatus, region: string | null, tracks: Array<{ __typename?: 'HotStartPoolTrackEdge', node: { __typename?: 'Track', id: string } }>, configs: Array<{ __typename?: 'HotStartConfigTrackEdge', node: { __typename?: 'SandboxConfig', id: string } }> } };

export type HotStartPoolExistingPoolFragment = { __typename?: 'HotStartPool', id: string, type: HotStartPoolType, size: number, name: string, starts_at: string | null, ends_at: string | null, status: HotStartStatus, region: string | null, tracks: Array<{ __typename?: 'HotStartPoolTrackEdge', node: { __typename?: 'Track', id: string } }>, configs: Array<{ __typename?: 'HotStartConfigTrackEdge', node: { __typename?: 'SandboxConfig', id: string } }> };

export type HotStartInviteFragment = { __typename?: 'TrackInvite', expiresAt: string | null, publicTitle: string | null, status: TrackInviteStatus | null, startsAt: string | null, tracks: Array<{ __typename?: 'Track', id: string }> };

export type GetManageSandboxPresetConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetManageSandboxPresetConfigQuery = { __typename?: 'Query', userInTeam: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', containers: boolean, virtual_machines: boolean, saas: boolean, custom_machine_type: boolean, aws_accounts: boolean, azure_subscriptions: boolean, gcp_projects: boolean, shared_hotstart_pools: boolean } | null } | null, trackConfigPresets: { __typename?: 'TrackConfigPresets', containers: Array<{ __typename?: 'ContainerConfigPreset', label: string, image: string, memory: number }>, googlecloudmachinetypes: Array<{ __typename?: 'GoogleCloudMachineTypePreset', label: string, machine_type: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfigPreset', image: string, label: string, machine_type: string, cpus: number, memory: number }>, machinetypes: Array<{ __typename?: 'MachineTypePreset', cpus: number, label: string, memory: number }> } | null, teamSecrets: Array<{ __typename?: 'Secret', name: string, description: string }> | null };

export type ManageSandboxPresetCreatePresetMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  config: SandboxConfigInput;
}>;


export type ManageSandboxPresetCreatePresetMutation = { __typename?: 'Mutation', createSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string, config: { __typename?: 'SandboxConfig', id: string } | null } | null };

export type ManageSandboxPresetUpdatePresetMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  config: SandboxConfigInput;
}>;


export type ManageSandboxPresetUpdatePresetMutation = { __typename?: 'Mutation', updateSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string, config: { __typename?: 'SandboxConfig', id: string } | null } | null };

export type ManageSandboxPresetPublishConfigMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  changeLogEntry: Scalars['String']['input'];
}>;


export type ManageSandboxPresetPublishConfigMutation = { __typename?: 'Mutation', publishSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type ManageSandboxPresetRenameSandboxMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type ManageSandboxPresetRenameSandboxMutation = { __typename?: 'Mutation', renameSandboxConfig: { __typename?: 'SandboxConfig', id: string } | null };

export type GetManageSandboxPresetVersionQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  filter: SandboxConfigVersionsFilterInput;
}>;


export type GetManageSandboxPresetVersionQuery = { __typename?: 'Query', sandboxConfigVersions: Array<{ __typename?: 'SandboxConfigVersion', id: string, description: string, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', host: string, action: string, contents: string }> | null }> | null };

export type GetManageSandboxPresetTrackQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type GetManageSandboxPresetTrackQuery = { __typename?: 'Query', trackConfig: { __typename?: 'TrackConfig', secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, trackScripts: Array<{ __typename?: 'TrackScript', host: string, action: string, contents: string }> | null };

export type ManageTagsPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type ManageTagsPageConfigQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, tags: Array<{ __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> }>, tagGroups: Array<{ __typename?: 'TagGroup', id: string, name: string, createdAt: string, tags: Array<{ __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> }> }> } | null };

export type ManageTagsPageCreateTagMutationVariables = Exact<{
  teamID: Scalars['ID']['input'];
  input: TagInput;
}>;


export type ManageTagsPageCreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> } };

export type ManageTagsPageUpdateTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TagInput;
}>;


export type ManageTagsPageUpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> } };

export type ManageTagsPageDeleteTagMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ManageTagsPageDeleteTagMutation = { __typename?: 'Mutation', deleteTag: boolean };

export type ManageTagsPageCreateTagGroupMutationVariables = Exact<{
  teamID: Scalars['ID']['input'];
  input: TagGroupInput;
  tagIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ManageTagsPageCreateTagGroupMutation = { __typename?: 'Mutation', createTagGroup: { __typename?: 'TagGroup', id: string, name: string, createdAt: string, tags: Array<{ __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> }> } };

export type ManageTagsPageUpdateTagGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TagGroupInput;
  tagIDs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ManageTagsPageUpdateTagGroupMutation = { __typename?: 'Mutation', updateTagGroup: { __typename?: 'TagGroup', id: string, name: string, createdAt: string, tags: Array<{ __typename?: 'Tag', id: string, value: string, createdAt: string, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }> }> } };

export type ManageTagsPageDeleteTagGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ManageTagsPageDeleteTagGroupMutation = { __typename?: 'Mutation', deleteTagGroup: boolean };

export type MembersPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type MembersPageQuery = { __typename?: 'Query', userInTeam: boolean, team: { __typename?: 'Team', id: string, members: Array<{ __typename?: 'TeamMember', role: RoleName, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null, slug: string | null } | null } }>, invites: Array<{ __typename?: 'TeamInvite', email: string, role: RoleName }> | null } | null };

export type PlayActivityReportPageQueryVariables = Exact<{
  playReportInput: PlayReportInput;
  teamSlug: Scalars['String']['input'];
}>;


export type PlayActivityReportPageQuery = { __typename?: 'Query', playReports: { __typename?: 'PlayReportPage', totalItems: number, items: Array<{ __typename?: 'PlayReportItem', id: string, completionPercent: number, timeSpent: number, startedAt: string, track: { __typename?: 'Track', id: string, slug: string, title: string }, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null } }> } };

export type PlayActivityReportFiltersQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type PlayActivityReportFiltersQuery = { __typename?: 'Query', tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string, maintenance: boolean }> | null, team: { __typename?: 'Team', userDetails: Array<{ __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, user: { __typename?: 'User', id: string } | null }> } | null, trackInvites: Array<{ __typename?: 'TrackInvite', id: string, publicTitle: string | null, title: string }> | null };

export type PlayActivityReportCsvQueryVariables = Exact<{
  playReportInput: PlayReportInput;
  teamSlug: Scalars['String']['input'];
}>;


export type PlayActivityReportCsvQuery = { __typename?: 'Query', playReports: { __typename?: 'PlayReportPage', items: Array<{ __typename?: 'PlayReportItem', id: string, startedAt: string, completionPercent: number, totalChallenges: number, completedChallenges: number, timeSpent: number, playReview: { __typename?: 'TrackReview', score: number, content: string } | null, activity: Array<{ __typename?: 'PlayActivity', time: string }>, track: { __typename?: 'Track', id: string, slug: string }, trackInvite: { __typename?: 'TrackInvite', id: string } | null, customParameters: Array<{ __typename?: 'CustomParameter', key: string, value: string }>, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null } }> } };

export type DownloadPlayActivityReportCsvFragment = { __typename?: 'PlayReportItem', id: string, startedAt: string, completionPercent: number, totalChallenges: number, completedChallenges: number, timeSpent: number, playReview: { __typename?: 'TrackReview', score: number, content: string } | null, activity: Array<{ __typename?: 'PlayActivity', time: string }>, track: { __typename?: 'Track', id: string, slug: string }, trackInvite: { __typename?: 'TrackInvite', id: string } | null, customParameters: Array<{ __typename?: 'CustomParameter', key: string, value: string }>, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null } };

export type GetPreviewSandboxPresetPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  filter: SandboxConfigVersionsFilterInput;
}>;


export type GetPreviewSandboxPresetPageConfigQuery = { __typename?: 'Query', userInTeam: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', containers: boolean, virtual_machines: boolean, saas: boolean, custom_machine_type: boolean, aws_accounts: boolean, azure_subscriptions: boolean, gcp_projects: boolean, shared_hotstart_pools: boolean } | null } | null, sandboxConfigVersions: Array<{ __typename?: 'SandboxConfigVersion', change_log_entry: string, id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, resources: { __typename?: 'SandboxResources', secrets: Array<{ __typename?: 'SecretConfig', name: string }>, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }> } | null, scripts: Array<{ __typename?: 'SandboxScript', action: string, contents: string, host: string }> | null, tracks: Array<{ __typename?: 'Track', id: string, title: string } | null>, hot_start_pools: Array<{ __typename?: 'HotStartPool', id: string, name: string } | null>, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null }> | null };

export type PreviewSandboxPresetDeleteSandboxConfigMutationVariables = Exact<{
  configVersionID: Scalars['String']['input'];
}>;


export type PreviewSandboxPresetDeleteSandboxConfigMutation = { __typename?: 'Mutation', deleteSandboxConfig: boolean };

export type GetSandboxPresetsListPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  filter: SandboxConfigVersionsFilterInput;
}>;


export type GetSandboxPresetsListPageConfigQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', shared_hotstart_pools: boolean } | null } | null, sandboxConfigVersions: Array<{ __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null }> | null };

export type SandboxPresetsListPagePublishConfigMutationVariables = Exact<{
  configID: Scalars['String']['input'];
  changeLogEntry: Scalars['String']['input'];
}>;


export type SandboxPresetsListPagePublishConfigMutation = { __typename?: 'Mutation', publishSandboxConfig: { __typename?: 'SandboxConfigVersion', id: string } | null };

export type SandboxPresetsListDeleteSandboxConfigMutationVariables = Exact<{
  configVersionID: Scalars['String']['input'];
}>;


export type SandboxPresetsListDeleteSandboxConfigMutation = { __typename?: 'Mutation', deleteSandboxConfig: boolean };

export type SandboxesFormDataQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type SandboxesFormDataQuery = { __typename?: 'Query', tracks: Array<{ __typename?: 'Track', id: string, title: string }> | null, trackInvites: Array<{ __typename?: 'TrackInvite', id: string, title: string, publicTitle: string | null }> | null, hotStartPools: { __typename?: 'HotStartPoolConnection', edges: Array<{ __typename?: 'HotStartPoolEdge', node: { __typename?: 'HotStartPool', id: string, name: string } | null }> } | null };

export type SandboxesQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  filter: SandboxFilterInput;
  paging: Pagination;
  ordering: Ordering;
}>;


export type SandboxesQuery = { __typename?: 'Query', sandboxes: { __typename?: 'SandboxConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string | null, endCursor: string | null }, edges: Array<{ __typename?: 'SandboxEdge', node: { __typename?: 'Sandbox', created: string | null, ttl: string | null, state: SandboxState, id: string, hot_start_pool: { __typename?: 'HotStartPool', id: string, name: string } | null, invite: { __typename?: 'TrackInvite', id: string, title: string, publicTitle: string | null } | null, track: { __typename?: 'Track', id: string, slug: string, title: string } | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null } | null } | null }> } | null };

export type UpdateSandboxTtlMutationVariables = Exact<{
  sandboxID: Scalars['String']['input'];
  until: Scalars['Time']['input'];
}>;


export type UpdateSandboxTtlMutation = { __typename?: 'Mutation', updateSandboxTTL: { __typename?: 'Sandbox', id: string } | null };

export type StopSandboxMutationVariables = Exact<{
  sandboxID: Scalars['String']['input'];
}>;


export type StopSandboxMutation = { __typename?: 'Mutation', stopSandbox: { __typename?: 'Sandbox', id: string } | null };

export type SsoManagementQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type SsoManagementQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, ssoConnection: { __typename?: 'SsoConnection', name: string, strategy: Strategy, organizationID: string, options: { __typename?: 'DefaultSsoConnectionOptions', clientID: string, domain: string } | { __typename?: 'SamlSsoConnectionOptions', signingCert: string, signingEndpoint: string, entityID: string } } | null } | null };

export type CreateSamlSsoConnectionMutationVariables = Exact<{
  teamID: Scalars['ID']['input'];
  ssoConnection: SsoSamlConnectionInput;
}>;


export type CreateSamlSsoConnectionMutation = { __typename?: 'Mutation', createSamlSsoConnection: { __typename?: 'SsoConnection', name: string, strategy: Strategy, organizationID: string, options: { __typename?: 'DefaultSsoConnectionOptions', clientID: string, domain: string } | { __typename?: 'SamlSsoConnectionOptions', signingCert: string, signingEndpoint: string, entityID: string } } | null };

export type UpdateSamlSsoConnectionMutationVariables = Exact<{
  teamID: Scalars['ID']['input'];
  ssoConnection: SsoSamlConnectionInput;
  connectionName: Scalars['String']['input'];
}>;


export type UpdateSamlSsoConnectionMutation = { __typename?: 'Mutation', updateSamlSsoConnection: { __typename?: 'SsoConnection', name: string, strategy: Strategy, organizationID: string, options: { __typename?: 'DefaultSsoConnectionOptions', clientID: string, domain: string } | { __typename?: 'SamlSsoConnectionOptions', signingCert: string, signingEndpoint: string, entityID: string } } | null };

export type CreateSsoConnectionMutationVariables = Exact<{
  teamID: Scalars['ID']['input'];
  ssoConnection: SsoConnectionInput;
}>;


export type CreateSsoConnectionMutation = { __typename?: 'Mutation', createSsoConnection: { __typename?: 'SsoConnection', name: string, strategy: Strategy, organizationID: string, options: { __typename?: 'DefaultSsoConnectionOptions', clientID: string, domain: string } | { __typename?: 'SamlSsoConnectionOptions', signingCert: string, signingEndpoint: string, entityID: string } } | null };

export type UpdateSsoConnectionMutationVariables = Exact<{
  teamID: Scalars['ID']['input'];
  ssoConnection: SsoConnectionInput;
  connectionName: Scalars['String']['input'];
}>;


export type UpdateSsoConnectionMutation = { __typename?: 'Mutation', updateSsoConnection: { __typename?: 'SsoConnection', name: string, strategy: Strategy, organizationID: string, options: { __typename?: 'DefaultSsoConnectionOptions', clientID: string, domain: string } | { __typename?: 'SamlSsoConnectionOptions', signingCert: string, signingEndpoint: string, entityID: string } } | null };

export type DeleteSsoConnectionMutationVariables = Exact<{
  teamID: Scalars['ID']['input'];
  connectionName: Scalars['String']['input'];
}>;


export type DeleteSsoConnectionMutation = { __typename?: 'Mutation', deleteSsoConnection: boolean };

export type TeamPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type TeamPageQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string, logo: string | null, title: string | null, subtitle: string | null, slug: string, primary_link_text: string | null, primary_link_url: string | null, secondary_link_text: string | null, secondary_link_url: string | null, tracks: Array<{ __typename?: 'Track', id: string, icon: string, last_update: string, createdAt: string, permalink: string | null, slug: string, teaser: string, title: string, description: string, maintenance: boolean, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }>, updated_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null }> }>, tags: Array<{ __typename?: 'Tag', id: string, value: string }>, tagGroups: Array<{ __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }> }>, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null, secondary_foreground_color: string | null, secondary_background_color: string | null } | null } | null };

export type TeamPageTagGroupFragment = { __typename?: 'TagGroup', id: string, name: string, tags: Array<{ __typename?: 'Tag', id: string, value: string }> };

export type TeamPageDeleteTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type TeamPageDeleteTrackMutation = { __typename?: 'Mutation', deleteTrack: boolean };

export type TeamSecretsUpsertTeamSecretMutationVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  secret: Scalars['String']['input'];
}>;


export type TeamSecretsUpsertTeamSecretMutation = { __typename?: 'Mutation', upsertTeamSecret: { __typename?: 'Secret', name: string } | null };

export type TeamSecretsDeleteTeamSecretMutationVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type TeamSecretsDeleteTeamSecretMutation = { __typename?: 'Mutation', deleteTeamSecret: boolean };

export type TeamSecretsGetTeamSecretsQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type TeamSecretsGetTeamSecretsQuery = { __typename?: 'Query', teamSecrets: Array<{ __typename?: 'Secret', teamID: string, name: string, description: string, updated_at: string | null, created_at: string, created_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null }, updated_by: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null }> | null };

export type GetInsightsStatisticsQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackIDs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  start: InputMaybe<Scalars['Time']['input']>;
  end: InputMaybe<Scalars['Time']['input']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInsightsStatisticsQuery = { __typename?: 'Query', teamStatistics: { __typename?: 'TeamStatistics', started_total: number | null, completed_total: number | null, team_series: Array<{ __typename?: 'TeamSeries', date: string, started: number, completed: number }>, track_statistics: Array<{ __typename?: 'TrackStatistics', average_review_score: number | null, started_total: number | null, completed_total: number | null, track: { __typename?: 'Track', title: string, slug: string, developers: Array<{ __typename?: 'User', profile: { __typename?: 'UserProfile', display_name: string | null, avatar: string | null } | null }> } | null }> } | null };

export type GetInsightsTracksQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetInsightsTracksQuery = { __typename?: 'Query', tracks: Array<{ __typename?: 'Track', id: string, title: string, permalink: string | null, maintenance: boolean }> | null };

export type TerraformRegistryPageSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type TerraformRegistryPageSearchQuery = { __typename?: 'Query', searchTerraformModules: { __typename?: 'SearchTerraformModuleResults', modules: Array<{ __typename?: 'TerraformModule', description: string, id: string, logo: string, name: string, provider: string, publishedAt: string }> } | null };

export type TrackDashboardHappinessQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackDashboardHappinessQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string, trackReviews: { __typename?: 'TrackReviewConnection', nodes: Array<{ __typename?: 'TrackReview', id: string, score: number, created_at: string, content: string }> } | null, statistics: { __typename?: 'TrackStatistics', happiness: Array<{ __typename?: 'HappinessCount', score: number, count: number }> } | null } | null };

export type TrackDashboardLogsConfigQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackDashboardLogsConfigQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean };

export type TrackDashboardStatisticsQueryVariables = Exact<{
  trackSlug: InputMaybe<Scalars['String']['input']>;
  teamSlug: InputMaybe<Scalars['String']['input']>;
  start: InputMaybe<Scalars['Time']['input']>;
  end: InputMaybe<Scalars['Time']['input']>;
  filterDevelopers: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TrackDashboardStatisticsQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, statistics: { __typename?: 'Statistics', track: { __typename?: 'TrackStatistics', started_total: number | null, completed_total: number | null, track_series: Array<{ __typename?: 'TrackSeries', date: string, started: number, completed: number }>, challenge_series: Array<{ __typename?: 'ChallengeSeries', date: string, unlocked: number, started: number, completed: number }>, happiness: Array<{ __typename?: 'HappinessCount', score: number, count: number }>, challenges: Array<{ __typename?: 'ChallengeStatistics', title: string | null, started_total: number | null, completed_total: number | null, attempts_total: number | null, attempts_min: number | null, attempts_avg: number | null, attempts_max: number | null, duration_min: number | null, duration_avg: number | null, duration_max: number | null }> } | null } | null };

export type TrackDashboardQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackDashboardQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, userInTeam: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', members_skip_to_challenge: boolean } | null } | null, track: { __typename?: 'Track', id: string, status: TrackStatus | null, slug: string, title: string, description: string, icon: string, createdAt: string, last_update: string, timelimit: number | null, maintenance: boolean, show_timer: boolean, skipping_enabled: boolean, can_skip: boolean, permalink: string | null, teaser: string, level: Level | null, idle_timeout: number | null, completed: string, challenges: Array<{ __typename?: 'Challenge', id: string, timelimit: number | null, permalink: string | null, slug: string, title: string, teaser: string, status: ChallengeStatus, index: number, type: ChallengeType, started: number, completed: number, failed: number, failMessage: string | null, assignment: string, scripts: Array<{ __typename?: 'ChallengeScript', id: string, action: string }>, tabs: Array<{ __typename?: 'ChallengeTab', id: string, hostname: string | null, index: number, type: ChallengeTabType, title: string, target: string | null, new_window: boolean, path: string | null }> }>, statistics: { __typename?: 'TrackStatistics', started_total: number | null, happiness: Array<{ __typename?: 'HappinessCount', score: number, count: number }> } | null, developers: Array<{ __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', slug: string | null, avatar: string | null, display_name: string | null, email: string | null } | null }>, team: { __typename?: 'Team', id: string, slug: string, name: string, logo: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null } | null, features: { __typename?: 'TeamFeatures', statistics: boolean, embedded: boolean, members_skip_to_challenge: boolean } | null } | null, sandboxConfig: { __typename?: 'SandboxConfigVersion', id: string, description: string, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> } | null } | null, trackConfig: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> } | null, lab_config: { __typename?: 'LabConfig', hideStopButton: boolean, width: number, position: string, overlay: boolean, extendTTL: number | null } | null, sourceTrack: { __typename?: 'Track', id: string, slug: string, title: string, team: { __typename?: 'Team', id: string, slug: string } | null } | null, trackTags: Array<{ __typename?: 'Tag', id: string, value: string }> } | null };

export type TrackDashboardDeleteChallengeMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type TrackDashboardDeleteChallengeMutation = { __typename?: 'Mutation', deleteChallenge: boolean };

export type TrackDashboardStopTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type TrackDashboardStopTrackMutation = { __typename?: 'Mutation', stopTrack: { __typename?: 'Track', id: string, status: TrackStatus | null } | null };

export type GetActivityPageQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  inviteIDLegacy: Scalars['String']['input'];
  userID: Scalars['ID']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type GetActivityPageQuery = { __typename?: 'Query', student: { __typename?: 'Student', activeSandboxesTotal: number | null, inspectable: boolean | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null } | null } | null } | null, trackInvite: { __typename?: 'TrackInvite', expiresAt: string | null, publicDescription: string | null, publicTitle: string | null, startsAt: string | null, status: TrackInviteStatus | null, type: TrackInviteType | null } | null, students: Array<{ __typename?: 'Student', user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null } | null } | null }> | null };

export type GetActivityLogAndSandboxesQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  inviteID: Scalars['String']['input'];
  userID: Scalars['String']['input'];
  filter: SandboxFilterInput;
}>;


export type GetActivityLogAndSandboxesQuery = { __typename?: 'Query', trackInviteClaim: { __typename?: 'InviteClaim', events: Array<{ __typename?: 'InviteEvent', message: string, participantID: string | null, time: string, challenge: { __typename?: 'Challenge', slug: string } | null, track: { __typename?: 'Track', slug: string } | null }>, user: { __typename?: 'User', profile: { __typename?: 'UserProfile', display_name: string | null } | null } } | null, sandboxes: { __typename?: 'SandboxConnection', totalCount: number, edges: Array<{ __typename?: 'SandboxEdge', node: { __typename?: 'Sandbox', created: string | null, last_activity_at: string | null, ttl: string | null, state: SandboxState, id: string, track: { __typename?: 'Track', title: string } | null } | null }> } | null };

export type SandboxFragment = { __typename?: 'Sandbox', created: string | null, last_activity_at: string | null, ttl: string | null, state: SandboxState, id: string, track: { __typename?: 'Track', title: string } | null };

export type ActivityReportPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  inviteID: Scalars['String']['input'];
}>;


export type ActivityReportPageQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, type: TrackInviteType | null, allowAnonymous: boolean, allowedEmailAddressesOnly: boolean, title: string, publicTitle: string | null, tracks: Array<{ __typename?: 'Track', id: string }>, claims: Array<{ __typename?: 'InviteClaim', id: string, claimedAt: string | null, playLimit: number | null, playTTL: string | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null, details: { __typename?: 'UserDetails', firstName: string | null, lastName: string | null, email: string | null, id: string, companyName: string | null, phoneNumber: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, consent: boolean | null } | null } }>, team: { __typename?: 'Team', id: string, slug: string, form: { __typename?: 'Form', id: string, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName }> } | null }, plays: Array<{ __typename?: 'InvitePlay', last_activity: string, time_spent: number, track_started_at: string, track_completed_at: string | null, completed_challenges: number, total_challenges: number, failed_challenge_attempts: number, track: { __typename?: 'Track', id: string, slug: string }, participant: { __typename?: 'Play', id: string }, user: { __typename?: 'User', id: string, is_anonymous: boolean, profile: { __typename?: 'UserProfile', email: string | null, display_name: string | null } | null } }> } | null };

export type GetClassroomPageQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  inviteIDLegacy: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type GetClassroomPageQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', hot_start: boolean } | null } | null, studentStatistics: { __typename?: 'StudentStatistics', inProgressTotal: number | null, completedTotal: number | null } | null, trackInvite: { __typename?: 'TrackInvite', id: string, inviteLimit: number | null, expiresAt: string | null, publicDescription: string | null, publicTitle: string | null, startsAt: string | null, type: TrackInviteType | null, status: TrackInviteStatus | null, tracks: Array<{ __typename?: 'Track', icon: string, id: string, title: string, studentStatistics: { __typename?: 'StudentTrackStatistics', inProgressTotal: number | null, completedTotal: number | null } | null }> } | null };

export type GetStudentsQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type GetStudentsQuery = { __typename?: 'Query', students: Array<{ __typename?: 'Student', completed_at: string | null, activeSandboxesTotal: number | null, inspectable: boolean | null, last_activity_at: string | null, accessed_at: string | null, challenge: { __typename?: 'Challenge', index: number, started: number, title: string } | null, claim: { __typename?: 'InviteClaim', id: string } | null, track: { __typename?: 'Track', id: string, title: string, challenges: Array<{ __typename?: 'Challenge', id: string }> } | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null } | null } | null }> | null };

export type DeleteTrackInviteClaimMutationVariables = Exact<{
  claimID: Scalars['String']['input'];
}>;


export type DeleteTrackInviteClaimMutation = { __typename?: 'Mutation', deleteTrackInviteClaim: boolean };

export type CreateInvitePageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type CreateInvitePageQuery = { __typename?: 'Query', tracks: Array<{ __typename?: 'Track', id: string, title: string, maintenance: boolean, slug: string }> | null, team: { __typename?: 'Team', id: string, form: { __typename?: 'Form', id: string, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null } | null, teamSecrets: Array<{ __typename?: 'Secret', name: string, description: string }> | null };

export type CreateInviteCreateTrackInviteMutationVariables = Exact<{
  invite: TrackInviteInput;
}>;


export type CreateInviteCreateTrackInviteMutation = { __typename?: 'Mutation', createTrackInvite: { __typename?: 'TrackInvite', id: string } | null };

export type DuplicateInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type DuplicateInvitePageQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, shareMethod: TrackInviteShareMethod | null, type: TrackInviteType | null, publicTitle: string | null, publicDescription: string | null, title: string, inviteLimit: number | null, playLimit: number | null, playTTL: number | null, allowedEmailAddresses: Array<string>, allowAnonymous: boolean, expiresAt: string | null, startsAt: string | null, enableLearnerSharing: boolean, tracks: Array<{ __typename?: 'Track', id: string }>, runtimeParameters: { __typename?: 'RuntimeParameters', secrets: Array<{ __typename?: 'RuntimeSecret', key: string, secret: string }>, environmentVariables: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> } | null } | null, tracks: Array<{ __typename?: 'Track', id: string, title: string, maintenance: boolean, slug: string }> | null, team: { __typename?: 'Team', id: string, form: { __typename?: 'Form', id: string, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null } | null, teamSecrets: Array<{ __typename?: 'Secret', name: string, description: string }> | null };

export type DuplicateInviteCreateTrackInviteMutationVariables = Exact<{
  invite: TrackInviteInput;
}>;


export type DuplicateInviteCreateTrackInviteMutation = { __typename?: 'Mutation', createTrackInvite: { __typename?: 'TrackInvite', id: string } | null };

export type EditInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type EditInvitePageQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, shareMethod: TrackInviteShareMethod | null, type: TrackInviteType | null, publicTitle: string | null, publicDescription: string | null, title: string, inviteLimit: number | null, playLimit: number | null, playTTL: number | null, allowedEmailAddresses: Array<string>, allowAnonymous: boolean, expiresAt: string | null, startsAt: string | null, enableLearnerSharing: boolean, tracks: Array<{ __typename?: 'Track', id: string }>, runtimeParameters: { __typename?: 'RuntimeParameters', secrets: Array<{ __typename?: 'RuntimeSecret', key: string, secret: string }>, environmentVariables: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> } | null } | null, tracks: Array<{ __typename?: 'Track', id: string, title: string, maintenance: boolean, slug: string }> | null, team: { __typename?: 'Team', id: string, form: { __typename?: 'Form', id: string, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null } | null, teamSecrets: Array<{ __typename?: 'Secret', name: string, description: string }> | null };

export type EditInviteUpdateTrackInviteMutationVariables = Exact<{
  invite: TrackInviteInput;
}>;


export type EditInviteUpdateTrackInviteMutation = { __typename?: 'Mutation', updateTrackInvite: { __typename?: 'TrackInvite', id: string } | null };

export type GetInspectStudentPageQueryVariables = Exact<{
  inviteID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type GetInspectStudentPageQuery = { __typename?: 'Query', student: { __typename?: 'Student', inspectable: boolean | null, last_activity_at: string | null, challenge: { __typename?: 'Challenge', index: number, permalink: string | null } | null, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null } | null } | null } | null, students: Array<{ __typename?: 'Student', user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null } | null } | null }> | null };

export type ViewInvitePageQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type ViewInvitePageQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, shareMethod: TrackInviteShareMethod | null, title: string, publicTitle: string | null, publicDescription: string | null, inviteLimit: number | null, claimCount: number | null, startsAt: string | null, expiresAt: string | null, playLimit: number | null, playTTL: number | null, allowAnonymous: boolean, allowedEmailAddressesOnly: boolean, status: TrackInviteStatus | null, type: TrackInviteType | null, enableLearnerSharing: boolean, canClaim: boolean, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string }>, team: { __typename?: 'Team', name: string } } | null };

export type DownloadTrackInviteCsvTrackInviteFragment = { __typename?: 'TrackInvite', id: string, publicTitle: string | null, team: { __typename?: 'Team', id: string, slug: string, form: { __typename?: 'Form', id: string, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName }> } | null }, plays: Array<{ __typename?: 'InvitePlay', last_activity: string, time_spent: number, track_started_at: string, track_completed_at: string | null, completed_challenges: number, total_challenges: number, failed_challenge_attempts: number, track: { __typename?: 'Track', id: string, slug: string }, participant: { __typename?: 'Play', id: string }, user: { __typename?: 'User', id: string, is_anonymous: boolean, profile: { __typename?: 'UserProfile', email: string | null, display_name: string | null } | null } }> };

export type GetTrackLimitsPageConfigQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;


export type GetTrackLimitsPageConfigQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string } | null, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string, maintenance: boolean, play_count: number | null }> | null, trackPlayLimits: Array<{ __typename?: 'TrackPlayLimit', rollingMonth: number, rollingIPAddressPerHour: number, calendarMonth: number, track: { __typename?: 'Track', id: string } | null }> };

export type LimitsPageSaveLimitsMutationVariables = Exact<{
  trackID: InputMaybe<Scalars['String']['input']>;
  teamSlug: Scalars['String']['input'];
  trackPlayLimits: TrackPlayLimitInput;
}>;


export type LimitsPageSaveLimitsMutation = { __typename?: 'Mutation', saveTrackPlayLimits: Array<{ __typename?: 'TrackPlayLimit', rollingMonth: number, rollingIPAddressPerHour: number, calendarMonth: number, track: { __typename?: 'Track', id: string } | null }> };

export type TrackDashboardSandboxesQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  filter: SandboxConfigVersionsFilterInput;
}>;


export type TrackDashboardSandboxesQuery = { __typename?: 'Query', userInTeam: boolean, userIsTrackDeveloper: boolean, team: { __typename?: 'Team', id: string, features: { __typename?: 'TeamFeatures', containers: boolean, virtual_machines: boolean, saas: boolean, gcp_projects: boolean, aws_accounts: boolean, azure_subscriptions: boolean, custom_machine_type: boolean, shared_hotstart_pools: boolean } | null } | null, teamSecrets: Array<{ __typename?: 'Secret', name: string, description: string }> | null, track: { __typename?: 'Track', id: string, sandboxConfig: { __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null } | null, trackConfig: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string, image: string, entrypoint: string | null, cmd: string | null, ports: Array<number> | null, shell: string, memory: number, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string, image: string, machine_type: string, allow_external_ingress: Array<string>, shell: string, memory: number | null, cpus: number | null, nested_virtualization: boolean, environment: Array<{ __typename?: 'EnvironmentVariable', key: string, value: string }> | null }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string, url: string }>, gcp_projects: Array<{ __typename?: 'GcpProjectConfig', id: string, name: string, services: Array<string>, roles: Array<string> }>, aws_accounts: Array<{ __typename?: 'AwsAccountConfig', id: string, name: string, iam_policy: string | null, managed_policies: Array<string>, scp_policy: string | null }>, azure_subscriptions: Array<{ __typename?: 'AzureSubscriptionConfig', id: string, name: string, user_only: boolean, roles: Array<string> }>, secrets: Array<{ __typename?: 'SecretConfig', id: string, name: string }> } | null, scripts: Array<{ __typename?: 'TrackScript', id: string, host: string, action: string, contents: string }> } | null, sandboxConfigVersions: Array<{ __typename?: 'SandboxConfigVersion', id: string, description: string, published_at: string | null, status: SandboxConfigVersionStatus, version: number, config: { __typename?: 'SandboxConfig', id: string, name: string, slug: string } | null, published_by: { __typename?: 'User', profile: { __typename?: 'UserProfile', avatar: string | null, display_name: string | null } | null } | null }> | null };

export type TrackSandboxSetPresetMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  configVersionID: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackSandboxSetPresetMutation = { __typename?: 'Mutation', setTrackSandboxConfigVersion: boolean };

export type GetUpdateScriptsPageQueryQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type GetUpdateScriptsPageQueryQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string, scripts: Array<{ __typename?: 'TrackScript', action: string, contents: string, host: string, id: string }>, sandboxConfig: { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null, challenges: Array<{ __typename?: 'Challenge', id: string, title: string, scripts: Array<{ __typename?: 'ChallengeScript', action: string, contents: string, host: string, id: string }> }>, trackConfig: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null };

export type UpdateTrackScriptsFragment = { __typename?: 'Track', id: string, scripts: Array<{ __typename?: 'TrackScript', action: string, contents: string, host: string, id: string }>, sandboxConfig: { __typename?: 'SandboxConfigVersion', resources: { __typename?: 'SandboxResources', containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null } | null, challenges: Array<{ __typename?: 'Challenge', id: string, title: string, scripts: Array<{ __typename?: 'ChallengeScript', action: string, contents: string, host: string, id: string }> }>, trackConfig: { __typename?: 'TrackConfig', id: string, containers: Array<{ __typename?: 'ContainerConfig', id: string, name: string }>, virtualmachines: Array<{ __typename?: 'VirtualMachineConfig', id: string, name: string }>, virtualbrowsers: Array<{ __typename?: 'VirtualBrowserConfig', id: string, name: string }> } | null };

export type UpdateChallengeScriptsFragment = { __typename?: 'Challenge', id: string, title: string, scripts: Array<{ __typename?: 'ChallengeScript', action: string, contents: string, host: string, id: string }> };

export type UpdateTrackScriptMutationVariables = Exact<{
  script: TrackScriptInput;
  base64Encoded: Scalars['Boolean']['input'];
}>;


export type UpdateTrackScriptMutation = { __typename?: 'Mutation', saveTrackScript: { __typename?: 'TrackScript', id: string, host: string, action: string, contents: string } | null };

export type UpdateChallengeScriptMutationVariables = Exact<{
  script: ChallengeScriptInput;
  base64Encoded: Scalars['Boolean']['input'];
}>;


export type UpdateChallengeScriptMutation = { __typename?: 'Mutation', saveChallengeScript: { __typename?: 'ChallengeScript', id: string, host: string, action: string, contents: string } | null };

export type DeleteChallengeScriptMutationVariables = Exact<{
  challengeScriptID: Scalars['String']['input'];
}>;


export type DeleteChallengeScriptMutation = { __typename?: 'Mutation', deleteChallengeScript: boolean };

export type UpdateChallengeScriptResultFragment = { __typename?: 'ChallengeScript', id: string, host: string, action: string, contents: string };

export type UpdateTrackScriptResultFragment = { __typename?: 'TrackScript', id: string, host: string, action: string, contents: string };

export type UserReportPageQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  userReportInput: UserReportInput;
}>;


export type UserReportPageQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, userReportPage: { __typename?: 'UserReportPage', totalItems: number, items: Array<{ __typename?: 'UserReportItem', plays: number, tracksStarted: number, tracksCompleted: number, completionRate: number, averageProgressPercent: number, timeSpent: number, lastStartedAt: string, user: { __typename?: 'User', id: string, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null } | null, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null } }> } } | null };

export type UserReportFiltersQueryVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type UserReportFiltersQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, userDetails: Array<{ __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, user: { __typename?: 'User', id: string } | null }>, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string, maintenance: boolean }> } | null, trackInvites: Array<{ __typename?: 'TrackInvite', id: string, publicTitle: string | null, title: string }> | null };

export type UserReportCsvQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  userReportInput: UserReportInput;
}>;


export type UserReportCsvQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, userReportPage: { __typename?: 'UserReportPage', items: Array<{ __typename?: 'UserReportItem', id: string, plays: number, tracksStarted: number, tracksCompleted: number, averageProgressPercent: number, timeSpent: number, lastStartedAt: string, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null, details: { __typename?: 'UserDetails', firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, phoneNumber: string | null, consent: boolean | null } | null } }> } } | null };

export type UserReportCsvFragment = { __typename?: 'UserReportItem', id: string, plays: number, tracksStarted: number, tracksCompleted: number, averageProgressPercent: number, timeSpent: number, lastStartedAt: string, user: { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null, email: string | null } | null, details: { __typename?: 'UserDetails', firstName: string | null, lastName: string | null, email: string | null, companyName: string | null, jobTitle: string | null, jobLevel: string | null, countryCode: string | null, usState: string | null, phoneNumber: string | null, consent: boolean | null } | null } };

export type GetTeamSvixUrlQueryVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTeamSvixUrlQuery = { __typename?: 'Query', team: { __typename?: 'Team', webhook_dashboard_url: string } | null };

export type StudentNameFragment = { __typename?: 'User', id: string, profile: { __typename?: 'UserProfile', display_name: string | null } | null, details: { __typename?: 'UserDetails', id: string, firstName: string | null, lastName: string | null } | null };

export type PreviewChallengeFragment = { __typename?: 'Challenge', type: ChallengeType, title: string, teaser: string, assignment: string, tabs: Array<{ __typename?: 'ChallengeTab', id: string, hostname: string | null, index: number, type: ChallengeTabType, title: string, target: string | null, new_window: boolean, path: string | null }> };

export type ChallengeTemplateQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
}>;


export type ChallengeTemplateQuery = { __typename?: 'Query', userIsTrackDeveloper: boolean, challenge: { __typename?: 'Challenge', id: string, slug: string, type: ChallengeType, title: string, teaser: string, assignment: string, tabs: Array<{ __typename?: 'ChallengeTab', id: string, hostname: string | null, index: number, type: ChallengeTabType, title: string, target: string | null, new_window: boolean, path: string | null }> } | null };

export type PlayAppContainerQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
}>;


export type PlayAppContainerQuery = { __typename?: 'Query', userInTeam: boolean, userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string, median_starttime: number | null, idle_timeout: number | null, timelimit: number | null, challenges: Array<{ __typename?: 'Challenge', id: string, timelimit: number | null }>, participant: { __typename?: 'Play', id: string, hotStartPool: { __typename?: 'HotStartPool', id: string } | null } | null } | null, team: { __typename?: 'Team', features: { __typename?: 'TeamFeatures', members_skip_to_challenge: boolean } | null } | null, skippingEnabledTrack: { __typename?: 'Track', skipping_enabled: boolean, can_skip: boolean } | null };

export type GetVirtualBrowserChecksForAutoChecksQueryVariables = Exact<{
  challenge: Scalars['String']['input'];
  host: Scalars['String']['input'];
}>;


export type GetVirtualBrowserChecksForAutoChecksQuery = { __typename?: 'Query', virtualBrowserCheck: { __typename?: 'VirtualBrowserCheck', id: string, host: string, browserLocation: { __typename?: 'Location', errorMsg: string | null, conditions: Array<{ __typename?: 'UrlCondition', urlPart: string, condition: ConditionType }> } | null, element: Array<{ __typename?: 'HtmlElement', selector: string, value: string, errorMsg: string | null }>, innerText: Array<{ __typename?: 'HtmlElement', selector: string, value: string, errorMsg: string | null }> } };

export type GetAssignmentVirtualBrowserChallengeCheckQueryVariables = Exact<{
  challenge: Scalars['String']['input'];
  host: Scalars['String']['input'];
}>;


export type GetAssignmentVirtualBrowserChallengeCheckQuery = { __typename?: 'Query', virtualBrowserCheck: { __typename?: 'VirtualBrowserCheck', id: string, host: string, browserLocation: { __typename?: 'Location', errorMsg: string | null, conditions: Array<{ __typename?: 'UrlCondition', urlPart: string, condition: ConditionType }> } | null, element: Array<{ __typename?: 'HtmlElement', selector: string, value: string, errorMsg: string | null }>, innerText: Array<{ __typename?: 'HtmlElement', selector: string, value: string, errorMsg: string | null }> } };

export type UpdateAssignmentVirtualBrowserChallengeCheckMutationVariables = Exact<{
  check: VirtualBrowserCheckInput;
}>;


export type UpdateAssignmentVirtualBrowserChallengeCheckMutation = { __typename?: 'Mutation', upsertVirtualBrowserCheck: { __typename?: 'VirtualBrowserCheck', id: string, browserLocation: { __typename?: 'Location', errorMsg: string | null, conditions: Array<{ __typename?: 'UrlCondition', urlPart: string, condition: ConditionType }> } | null, element: Array<{ __typename?: 'HtmlElement', selector: string, value: string, errorMsg: string | null }>, innerText: Array<{ __typename?: 'HtmlElement', selector: string, value: string, errorMsg: string | null }> } };

export type DeleteAssignmentVirtualBrowserChallengeCheckMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAssignmentVirtualBrowserChallengeCheckMutation = { __typename?: 'Mutation', deleteVirtualBrowserCheck: boolean };

export type ExpiredScreenTrackFragment = { __typename?: 'Track', slug: string, permalink: string | null, challenges: Array<{ __typename?: 'Challenge', permalink: string | null }> };

export type ProgressModalChallengeFragment = { __typename?: 'Challenge', id: string, status: ChallengeStatus, slug: string, title: string, permalink: string | null, failed: number, type: ChallengeType, index: number };

export type ProgressModalTrackFragment = { __typename?: 'Track', id: string, slug: string, status: TrackStatus | null, median_starttime: number | null };

export type StopTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type StopTrackMutation = { __typename?: 'Mutation', stopTrack: { __typename?: 'Track', id: string, status: TrackStatus | null, challenges: Array<{ __typename?: 'Challenge', id: string, slug: string, title: string, teaser: string, status: ChallengeStatus }> } | null };

export type ProgressChallengeFragment = { __typename?: 'Challenge', id: string, status: ChallengeStatus, slug: string, title: string, permalink: string | null, failed: number, type: ChallengeType, index: number };

export type ProgressTrackFragment = { __typename?: 'Track', id: string, slug: string, status: TrackStatus | null, median_starttime: number | null };

export type UpdateTrackReviewMutationVariables = Exact<{
  id: Scalars['String']['input'];
  content: Scalars['String']['input'];
}>;


export type UpdateTrackReviewMutation = { __typename?: 'Mutation', updateTrackReview: { __typename?: 'TrackReview', id: string } | null };

export type TrackReviewSaveRatingMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  participantID: Scalars['String']['input'];
  score: Scalars['Int']['input'];
}>;


export type TrackReviewSaveRatingMutation = { __typename?: 'Mutation', createTrackReview: { __typename?: 'TrackReview', id: string } | null };

export type TrackReviewRatingGetTrackQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
}>;


export type TrackReviewRatingGetTrackQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, slug: string, participant: { __typename?: 'Play', id: string } | null } | null };

export type TrackAndChallengeStatusQueryVariables = Exact<{
  trackID: Scalars['String']['input'];
  challengeID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackAndChallengeStatusQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, slug: string, status: TrackStatus | null, creating: string } | null, challenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus, failMessage: string | null } | null };

export type SetupChallengeMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type SetupChallengeMutation = { __typename?: 'Mutation', setupChallenge: { __typename?: 'Challenge', id: string } | null };

export type AttemptsChallengeAttemptFragment = { __typename?: 'ChallengeAttempt', message: string };

export type TabContentChallengeTabFragment = { __typename?: 'ChallengeTab', id: string, type: ChallengeTabType, target: string | null, path: string | null, new_window: boolean };

export type TabContentChallengeChallengeTabFragment = { __typename?: 'ChallengeTab', id: string, type: ChallengeTabType, target: string | null, path: string | null, new_window: boolean };

export type WorkspaceChallengeFragment = { __typename?: 'Challenge', type: ChallengeType, answers: Array<string>, hasSingleAnswer: boolean, attempts: Array<{ __typename?: 'ChallengeAttempt', timestamp: string, message: string }>, tabs: Array<{ __typename?: 'ChallengeTab', id: string, index: number, type: ChallengeTabType, title: string, target: string | null, new_window: boolean, path: string | null }> };

export type ClaimGatedEmbedTrackInviteMutationVariables = Exact<{
  inviteID: Scalars['String']['input'];
  userDetails: InputMaybe<UserDetailsInput>;
  customParameters: InputMaybe<Array<CustomParametersInput> | CustomParametersInput>;
}>;


export type ClaimGatedEmbedTrackInviteMutation = { __typename?: 'Mutation', claimTrackInvite: { __typename?: 'InviteClaim', id: string, trackInvite: { __typename?: 'TrackInvite', id: string, currentUserClaim: { __typename?: 'InviteClaim', id: string, playTTL: string | null } | null } | null } | null };

export type ConsentToTeamPrivacyPolicyGatedEmbedMutationVariables = Exact<{
  teamID: Scalars['String']['input'];
  consent: Scalars['Boolean']['input'];
}>;


export type ConsentToTeamPrivacyPolicyGatedEmbedMutation = { __typename?: 'Mutation', consentToTeamPrivacyPolicy: boolean };

export type GatedEmbedPageQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type GatedEmbedPageQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, title: string, publicTitle: string | null, publicDescription: string | null, tracks: Array<{ __typename?: 'Track', id: string, title: string, slug: string, challenges: Array<{ __typename?: 'Challenge', id: string, slug: string }> }>, team: { __typename?: 'Team', id: string, name: string, logo: string | null, privacy_policy: string | null, slug: string, form: { __typename?: 'Form', formTitle: string | null, consentNotice: string | null, validateWorkEmail: boolean | null, fields: Array<{ __typename?: 'FormField', id: string, fieldName: FormFieldName, isRequired: boolean }> } | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, background_color: string | null, background_image: string | null } | null, features: { __typename?: 'TeamFeatures', accept_terms_checkbox: boolean } | null }, currentUserClaim: { __typename?: 'InviteClaim', id: string, playTTL: string | null } | null } | null };

export type CheckChallengeMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckChallengeMutation = { __typename?: 'Mutation', checkChallenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus, attempts: Array<{ __typename?: 'ChallengeAttempt', timestamp: string, message: string }>, unlocks: { __typename?: 'Challenge', id: string, permalink: string | null } | null } | null };

export type CheckQuizMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
  solution: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CheckQuizMutation = { __typename?: 'Mutation', checkQuiz: { __typename?: 'Challenge', id: string, status: ChallengeStatus, attempts: Array<{ __typename?: 'ChallengeAttempt', timestamp: string, message: string }>, unlocks: { __typename?: 'Challenge', id: string, permalink: string | null } | null } | null };

export type LearnEnvironmentKeepAliveMutationVariables = Exact<{
  trackId: Scalars['ID']['input'];
}>;


export type LearnEnvironmentKeepAliveMutation = { __typename?: 'Mutation', keepAlive: boolean };

export type LearnEnvironmentQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  challengeSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
}>;


export type LearnEnvironmentQuery = { __typename?: 'Query', userInTeam: boolean, userIsTrackDeveloper: boolean, team: { __typename?: 'Team', id: string, slug: string, name: string, features: { __typename?: 'TeamFeatures', track_reviews: boolean, service_tab_focus_overlay: boolean, members_skip_to_challenge: boolean, use_new_terminal: boolean } | null } | null, track: { __typename?: 'Track', id: string, title: string, permalink: string | null, slug: string, status: TrackStatus | null, started: string, creating: string, created: string, failed: string, stopped: string, completed: string, cleaned: string, show_timer: boolean, ttl: string | null, idle_timeout: number | null, median_starttime: number | null, challenges: Array<{ __typename?: 'Challenge', id: string, status: ChallengeStatus, index: number, permalink: string | null, slug: string, title: string, failed: number, type: ChallengeType }>, participant: { __typename?: 'Play', id: string, ttlExtendedByUser: boolean } | null, lab_config: { __typename?: 'LabConfig', overlay: boolean, position: string, width: number, extendTTL: number | null } | null } | null, challenge: { __typename?: 'Challenge', id: string, type: ChallengeType, index: number, teaser: string, permalink: string | null, title: string, slug: string, status: ChallengeStatus, assignment: string, answers: Array<string>, can_check: boolean | null, failed: number, hasSingleAnswer: boolean, notes: Array<{ __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null }>, attempts: Array<{ __typename?: 'ChallengeAttempt', timestamp: string, message: string }>, tabs: Array<{ __typename?: 'ChallengeTab', hostname: string | null, id: string, index: number, type: ChallengeTabType, title: string, target: string | null, new_window: boolean, path: string | null }> } | null, skippingEnabledTrack: { __typename?: 'Track', skipping_enabled: boolean, can_skip: boolean } | null };

export type ExtendSandboxTtlMutationVariables = Exact<{
  sandboxID: Scalars['String']['input'];
  until: Scalars['Time']['input'];
}>;


export type ExtendSandboxTtlMutation = { __typename?: 'Mutation', updateSandboxTTL: { __typename?: 'Sandbox', id: string, track: { __typename?: 'Track', id: string, ttl: string | null, participant: { __typename?: 'Play', id: string, ttlExtendedByUser: boolean } | null } | null } | null };

export type LearnEnvironmentStopTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
}>;


export type LearnEnvironmentStopTrackMutation = { __typename?: 'Mutation', stopTrack: { __typename?: 'Track', id: string } | null };

export type LearnEnvironmentInviteQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type LearnEnvironmentInviteQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, canClaim: boolean, enableLearnerSharing: boolean, allowAnonymous: boolean, allowedEmailAddresses: Array<string> } | null };

export type NotesContainerStartTrackMutationVariables = Exact<{
  trackID: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
  mode: InputMaybe<Mode>;
  customParameters: InputMaybe<Array<CustomParametersInput> | CustomParametersInput>;
  runtimeParameters: InputMaybe<RuntimeParametersInput>;
  forceStart: InputMaybe<Scalars['Boolean']['input']>;
  region: InputMaybe<Scalars['String']['input']>;
}>;


export type NotesContainerStartTrackMutation = { __typename?: 'Mutation', startTrack: { __typename?: 'Track', id: string, status: TrackStatus | null, permalink: string | null, challenges: Array<{ __typename?: 'Challenge', id: string, slug: string, status: ChallengeStatus }> } | null };

export type NotesContainerStartChallengeMutationVariables = Exact<{
  challengeID: Scalars['String']['input'];
}>;


export type NotesContainerStartChallengeMutation = { __typename?: 'Mutation', startChallenge: { __typename?: 'Challenge', id: string, status: ChallengeStatus, assignment: string, tabs: Array<{ __typename?: 'ChallengeTab', type: ChallengeTabType, title: string, target: string | null }> } | null };

export type NotesContainerQueryVariables = Exact<{
  trackSlug: InputMaybe<Scalars['String']['input']>;
  challengeSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  inviteID: InputMaybe<Scalars['String']['input']>;
  userID: InputMaybe<Scalars['String']['input']>;
}>;


export type NotesContainerQuery = { __typename?: 'Query', userInTeam: boolean, userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string, permalink: string | null, slug: string, status: TrackStatus | null, creating: string, completed: string, median_starttime: number | null, participant: { __typename?: 'Play', id: string } | null, challenges: Array<{ __typename?: 'Challenge', id: string, title: string, status: ChallengeStatus, permalink: string | null, slug: string, failed: number, type: ChallengeType, index: number }>, team: { __typename?: 'Team', id: string, name: string } | null } | null, challenge: { __typename?: 'Challenge', id: string, index: number, title: string, permalink: string | null, slug: string, status: ChallengeStatus, teaser: string, type: ChallengeType, failed: number, notes: Array<{ __typename?: 'ChallengeNote', id: string, type: ChallengeNoteType, contents: string | null, url: string | null }> } | null, team: { __typename?: 'Team', features: { __typename?: 'TeamFeatures', members_skip_to_challenge: boolean } | null } | null, skippingEnabledTrack: { __typename?: 'Track', skipping_enabled: boolean, can_skip: boolean } | null };

export type NotesContainerInviteQueryVariables = Exact<{
  inviteID: Scalars['String']['input'];
}>;


export type NotesContainerInviteQuery = { __typename?: 'Query', trackInvite: { __typename?: 'TrackInvite', id: string, canClaim: boolean, enableLearnerSharing: boolean, allowAnonymous: boolean, allowedEmailAddresses: Array<string> } | null };

export type RecapQueryVariables = Exact<{
  trackSlug: Scalars['String']['input'];
  teamSlug: Scalars['String']['input'];
  inviteID: Scalars['String']['input'];
  skipInvite: Scalars['Boolean']['input'];
}>;


export type RecapQuery = { __typename?: 'Query', userInTeam: boolean, userIsTrackDeveloper: boolean, track: { __typename?: 'Track', id: string, title: string, permalink: string | null, slug: string, status: TrackStatus | null, median_starttime: number | null, challenges: Array<{ __typename?: 'Challenge', permalink: string | null, id: string, status: ChallengeStatus, slug: string, title: string, failed: number, type: ChallengeType, index: number }>, participant: { __typename?: 'Play', id: string } | null } | null, trackInvite?: { __typename?: 'TrackInvite', id: string, canClaim: boolean, enableLearnerSharing: boolean, allowAnonymous: boolean, allowedEmailAddresses: Array<string> } | null, team: { __typename?: 'Team', features: { __typename?: 'TeamFeatures', members_skip_to_challenge: boolean } | null } | null, skippingEnabledTrack: { __typename?: 'Track', skipping_enabled: boolean, can_skip: boolean } | null };

export type SplashScreenQueryVariables = Exact<{
  teamSlug: Scalars['String']['input'];
  trackSlug: Scalars['String']['input'];
}>;


export type SplashScreenQuery = { __typename?: 'Query', track: { __typename?: 'Track', id: string, title: string, teaser: string, status: TrackStatus | null, challenges: Array<{ __typename?: 'Challenge', status: ChallengeStatus, slug: string, started: number, permalink: string | null, completed: number, title: string }>, participant: { __typename?: 'Play', id: string } | null } | null };

export type IsSkippingEnabledQueryFragment = { __typename?: 'Query', userInTeam: boolean, userIsTrackDeveloper: boolean, team: { __typename?: 'Team', features: { __typename?: 'TeamFeatures', members_skip_to_challenge: boolean } | null } | null, skippingEnabledTrack: { __typename?: 'Track', skipping_enabled: boolean, can_skip: boolean } | null };

export type ChallengeStatusQueryVariables = Exact<{
  challengeID: Scalars['String']['input'];
  userID: InputMaybe<Scalars['String']['input']>;
  inviteID: InputMaybe<Scalars['String']['input']>;
}>;


export type ChallengeStatusQuery = { __typename?: 'Query', challenge: { __typename?: 'Challenge', status: ChallengeStatus, failed: number, failMessage: string | null } | null };

export type BrandedTeamFragment = { __typename?: 'Team', name: string, logo: string | null, title: string | null, subtitle: string | null, slug: string, primary_link_text: string | null, primary_link_url: string | null, secondary_link_text: string | null, secondary_link_url: string | null, theme: { __typename?: 'TeamTheme', foreground_color: string | null, foreground_image: string | null, background_color: string | null, background_image: string | null, primary_foreground_color: string | null, primary_background_color: string | null, secondary_foreground_color: string | null, secondary_background_color: string | null } | null };

export type AmplitudeUserFragment = { __typename?: 'User', id: string, segments: Array<UserSegment>, teams: Array<{ __typename?: 'UserTeamEdge', node: { __typename?: 'Team', slug: string } | null }> };

export type GetInstruqtUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstruqtUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, segments: Array<UserSegment>, is_global_admin: boolean | null, profile: { __typename?: 'UserProfile', email: string | null, display_name: string | null, avatar: string | null, slug: string | null } | null, teams: Array<{ __typename?: 'UserTeamEdge', role: RoleName | null, node: { __typename?: 'Team', id: string, slug: string, name: string, features: { __typename?: 'TeamFeatures', hot_start: boolean, invites: boolean, statistics: boolean, arcades: boolean, webhooks: boolean, track_reviews: boolean, shared_hotstart_pools: boolean } | null } | null }> } | null };

export type AuthenticationUserFragment = { __typename?: 'User', id: string, segments: Array<UserSegment>, is_global_admin: boolean | null, profile: { __typename?: 'UserProfile', email: string | null, display_name: string | null, avatar: string | null, slug: string | null } | null, teams: Array<{ __typename?: 'UserTeamEdge', role: RoleName | null, node: { __typename?: 'Team', id: string, slug: string, name: string, features: { __typename?: 'TeamFeatures', hot_start: boolean, invites: boolean, statistics: boolean, arcades: boolean, webhooks: boolean, track_reviews: boolean, shared_hotstart_pools: boolean } | null } | null }> };

export const EditorHeroTeamThemeFragmentDoc = gql`
    fragment EditorHeroTeamTheme on TeamTheme {
  background_color
  background_image
  foreground_color
}
    `;
export const TrackInviteListItemTrackFragmentDoc = gql`
    fragment TrackInviteListItemTrack on Track {
  id
  title
  teaser
  icon
  status
  completed
  maintenance
  lab_config {
    hideStopButton
  }
}
    `;
export const TrackInviteListTrackFragmentDoc = gql`
    fragment TrackInviteListTrack on Track {
  id
  status
  lab_config {
    hideStopButton
  }
  ...TrackInviteListItemTrack
}
    ${TrackInviteListItemTrackFragmentDoc}`;
export const TrackInviteListItemInviteFragmentDoc = gql`
    fragment TrackInviteListItemInvite on TrackInvite {
  playLimit
  currentUserClaim {
    id
    playTTL
    trackLibrary {
      playCount
      track {
        id
      }
    }
  }
}
    `;
export const SortableChallengesChallengeFragmentDoc = gql`
    fragment SortableChallengesChallenge on Challenge {
  id
  title
  teaser
}
    `;
export const StudyRoomClaimFragmentDoc = gql`
    fragment StudyRoomClaim on InviteClaim {
  id
  claimedAt
  trackInvite {
    id
    publicTitle
    publicDescription
    tracks {
      id
      status
      completed
    }
    team {
      id
      slug
      name
      logo
      theme {
        background_image
        background_color
      }
    }
  }
}
    `;
export const NotesListChallengeFragmentDoc = gql`
    fragment NotesListChallenge on Challenge {
  id
  assignment
  teaser
  title
  type
  notes {
    id
    index
    type
    contents
    url
  }
  tabs {
    id
    type
    title
    target
    path
    url
    index
    new_window
    hostname
  }
}
    `;
export const TabsListChallengeFragmentDoc = gql`
    fragment TabsListChallenge on Challenge {
  id
  assignment
  teaser
  title
  type
  notes {
    id
    index
    type
    contents
    url
  }
  tabs {
    id
    type
    title
    target
    path
    url
    index
    new_window
    hostname
  }
}
    `;
export const TabsListChallengeTabFragmentDoc = gql`
    fragment TabsListChallengeTab on ChallengeTab {
  id
  index
  target
  title
  type
  url
  hostname
  path
  port
  new_window
  workdir
  cmd
}
    `;
export const ChallengeFormChallengeFragmentDoc = gql`
    fragment ChallengeFormChallenge on Challenge {
  title
  slug
  type
  assignment
  teaser
  timelimit
  answers
  solution
}
    `;
export const ChallengeInitialStateEditChallengeFragmentDoc = gql`
    fragment ChallengeInitialStateEditChallenge on Challenge {
  id
  index
  difficulty
  ...ChallengeFormChallenge
}
    ${ChallengeFormChallengeFragmentDoc}`;
export const TrackScriptDataFragmentDoc = gql`
    fragment TrackScriptData on TrackScript {
  id
  host
  action
  contents
}
    `;
export const ChallengeTabCustomHeaderFragmentDoc = gql`
    fragment ChallengeTabCustomHeader on CustomHeader {
  key
  value
}
    `;
export const ChallengeTabFormTabFragmentDoc = gql`
    fragment ChallengeTabFormTab on ChallengeTab {
  title
  type
  hostname
  url
  port
  path
  workdir
  cmd
  new_window
  custom_headers {
    ...ChallengeTabCustomHeader
  }
  custom_response_headers {
    ...ChallengeTabCustomHeader
  }
}
    ${ChallengeTabCustomHeaderFragmentDoc}`;
export const UpdateChallengeTabChallengeTabFragmentDoc = gql`
    fragment UpdateChallengeTabChallengeTab on ChallengeTab {
  id
  index
  target
  ...ChallengeTabFormTab
}
    ${ChallengeTabFormTabFragmentDoc}`;
export const InviteFilterListItemFragmentDoc = gql`
    fragment InviteFilterListItem on TrackInvite {
  id
  publicTitle
  title
}
    `;
export const TrackFilterTrackFragmentDoc = gql`
    fragment TrackFilterTrack on Track {
  id
  title
  slug
  maintenance
}
    `;
export const UserFilterListItemFragmentDoc = gql`
    fragment UserFilterListItem on UserDetails {
  id
  user {
    id
  }
  firstName
  lastName
  email
  companyName
}
    `;
export const InsightsContentTableItemFragmentDoc = gql`
    fragment InsightsContentTableItem on TrackInsightItem {
  id
  track {
    id
    title
    slug
  }
  currentPeriod {
    plays
    learnersReached
    timeSpent
    completionRate
    averageReviewScore
  }
  previousPeriod {
    plays
    learnersReached
    timeSpent
    completionRate
    averageReviewScore
  }
}
    `;
export const InviteTeamSecretsFragmentDoc = gql`
    fragment InviteTeamSecrets on Secret {
  name
  description
}
    `;
export const PlayActivityReportsTableFragmentDoc = gql`
    fragment PlayActivityReportsTable on PlayReportItem {
  id
  completionPercent
  timeSpent
  track {
    id
    slug
    title
  }
  user {
    id
    details(teamSlug: $teamSlug) {
      id
      firstName
      lastName
      email
    }
    profile {
      display_name
      email
    }
  }
  startedAt
}
    `;
export const ChallengeAttemptsChallengeStatisticsFragmentDoc = gql`
    fragment ChallengeAttemptsChallengeStatistics on ChallengeStatistics {
  title
  attempts_min
  attempts_avg
  attempts_max
}
    `;
export const ChallengeDurationChallengeStatisticsFragmentDoc = gql`
    fragment ChallengeDurationChallengeStatistics on ChallengeStatistics {
  title
  duration_min
  duration_avg
  duration_max
}
    `;
export const DailyTrackStartsChallengeSeriesFragmentDoc = gql`
    fragment DailyTrackStartsChallengeSeries on ChallengeSeries {
  date
  unlocked
  started
  completed
}
    `;
export const DailyTrackStartsTrackSeriesFragmentDoc = gql`
    fragment DailyTrackStartsTrackSeries on TrackSeries {
  date
  started
  completed
}
    `;
export const TotalChallengeStartsChallengeStatisticsFragmentDoc = gql`
    fragment TotalChallengeStartsChallengeStatistics on ChallengeStatistics {
  title
  started_total
  completed_total
  attempts_total
}
    `;
export const TotalTrackStartsTrackStatisticsFragmentDoc = gql`
    fragment TotalTrackStartsTrackStatistics on TrackStatistics {
  started_total
  completed_total
}
    `;
export const UserHappinessHappinessCountFragmentDoc = gql`
    fragment UserHappinessHappinessCount on HappinessCount {
  score
  count
}
    `;
export const DashboardHeaderDeveloperFragmentDoc = gql`
    fragment DashboardHeaderDeveloper on User {
  id
  profile {
    display_name
    avatar
    slug
  }
}
    `;
export const TrackDetailsTeamDataFragmentDoc = gql`
    fragment TrackDetailsTeamData on Team {
  id
  name
  logo
  theme {
    foreground_color
    foreground_image
    background_color
    background_image
    primary_foreground_color
    primary_background_color
  }
  features {
    statistics
    embedded
    members_skip_to_challenge
  }
}
    `;
export const DashboardHeaderTrackFragmentDoc = gql`
    fragment DashboardHeaderTrack on Track {
  id
  slug
  title
  description
  icon
  createdAt
  last_update
  developers {
    ...DashboardHeaderDeveloper
  }
  team {
    ...TrackDetailsTeamData
  }
}
    ${DashboardHeaderDeveloperFragmentDoc}
${TrackDetailsTeamDataFragmentDoc}`;
export const UserPlayCardItemFragmentDoc = gql`
    fragment UserPlayCardItem on PlayReportItem {
  id
  timeSpent
  completionPercent
  completedChallenges
  totalChallenges
  mode
  trackInvite {
    id
    title
    publicTitle
  }
  track {
    id
    title
    slug
  }
  activity {
    time
  }
  playReview {
    id
    score
    content
  }
}
    `;
export const UserReportTableItemFragmentDoc = gql`
    fragment UserReportTableItem on UserReportItem {
  plays
  tracksStarted
  tracksCompleted
  completionRate
  averageProgressPercent
  timeSpent
  lastStartedAt
  user {
    id
    details(teamSlug: $teamSlug) {
      id
      firstName
      lastName
      email
      companyName
    }
    profile {
      display_name
      email
    }
  }
}
    `;
export const UserDetailsCollectedTableDetailsFragmentDoc = gql`
    fragment UserDetailsCollectedTableDetails on UserDetails {
  id
  firstName
  lastName
  email
  companyName
  phoneNumber
  jobTitle
  jobLevel
  countryCode
  usState
  consent
}
    `;
export const ChallengeFormDataFragmentDoc = gql`
    fragment ChallengeFormData on Challenge {
  id
  slug
  title
  type
  teaser
  assignment
  timelimit
  answers
  solution
}
    `;
export const ChallengeNoteItemFragmentDoc = gql`
    fragment ChallengeNoteItem on ChallengeNote {
  id
  type
  contents
  url
  index
}
    `;
export const ChallengeNoteFormNoteFragmentDoc = gql`
    fragment ChallengeNoteFormNote on ChallengeNote {
  contents
  type
  url
}
    `;
export const ChallengeNoteListNoteFragmentDoc = gql`
    fragment ChallengeNoteListNote on ChallengeNote {
  id
  type
  contents
  url
}
    `;
export const VirtualBrowserCheckItemFragmentDoc = gql`
    fragment VirtualBrowserCheckItem on VirtualBrowserCheck {
  id
  challenge {
    id
    slug
    permalink
    title
  }
  host
  browserLocation {
    conditions {
      urlPart
      condition
    }
  }
  element {
    selector
    value
  }
  innerText {
    selector
    value
  }
}
    `;
export const ContainerFormContainerPresetFragmentDoc = gql`
    fragment ContainerFormContainerPreset on ContainerConfigPreset {
  label
  image
  memory
}
    `;
export const VirtualMachineFormGoogleCloudMachineTypePresetFragmentDoc = gql`
    fragment VirtualMachineFormGoogleCloudMachineTypePreset on GoogleCloudMachineTypePreset {
  label
  machine_type
}
    `;
export const VirtualMachineFormVirtualMachinePresetFragmentDoc = gql`
    fragment VirtualMachineFormVirtualMachinePreset on VirtualMachineConfigPreset {
  image
  label
  machine_type
  cpus
  memory
}
    `;
export const VirtualMachineFormMachineTypePresetFragmentDoc = gql`
    fragment VirtualMachineFormMachineTypePreset on MachineTypePreset {
  cpus
  label
  memory
}
    `;
export const CreateTrackSandboxPresetsFragmentDoc = gql`
    fragment CreateTrackSandboxPresets on TrackConfigPresets {
  containers {
    ...ContainerFormContainerPreset
  }
  googlecloudmachinetypes {
    ...VirtualMachineFormGoogleCloudMachineTypePreset
  }
  virtualmachines {
    ...VirtualMachineFormVirtualMachinePreset
  }
  machinetypes {
    ...VirtualMachineFormMachineTypePreset
  }
}
    ${ContainerFormContainerPresetFragmentDoc}
${VirtualMachineFormGoogleCloudMachineTypePresetFragmentDoc}
${VirtualMachineFormVirtualMachinePresetFragmentDoc}
${VirtualMachineFormMachineTypePresetFragmentDoc}`;
export const CustomResourceCardItemFragmentDoc = gql`
    fragment CustomResourceCardItem on CustomResource {
  id
  name
  description
  version
  logo
  createdAt
  createdBy {
    id
    profile {
      display_name
    }
  }
}
    `;
export const CustomResourcesListResourceFragmentDoc = gql`
    fragment CustomResourcesListResource on CustomResource {
  ...CustomResourceCardItem
}
    ${CustomResourceCardItemFragmentDoc}`;
export const EditBrandingTeamFragmentDoc = gql`
    fragment EditBrandingTeam on Team {
  id
  name
  logo
  title
  subtitle
  slug
  primary_link_text
  primary_link_url
  secondary_link_text
  secondary_link_url
  theme {
    foreground_color
    foreground_image
    background_color
    background_image
    primary_foreground_color
    primary_background_color
    secondary_foreground_color
    secondary_background_color
  }
  features {
    hot_start
    invites
    statistics
    webhooks
  }
}
    `;
export const FormConfigurationFragmentFragmentDoc = gql`
    fragment FormConfigurationFragment on Form {
  id
  formTitle
  consentNotice
  validateWorkEmail
  fields {
    id
    fieldName
    isRequired
  }
}
    `;
export const HotStartFormTrackFragmentDoc = gql`
    fragment HotStartFormTrack on Track {
  id
  title
  permalink
  maintenance
}
    `;
export const HotStartSandboxPresetFragmentDoc = gql`
    fragment HotStartSandboxPreset on SandboxConfigVersion {
  id
  config {
    id
    name
    slug
  }
  version
  published_at
}
    `;
export const HotStartPagePoolFragmentDoc = gql`
    fragment HotStartPagePool on HotStartPool {
  id
  type
  name
  created
  status
  starts_at
  ends_at
}
    `;
export const InsightsFilterFormTrackFragmentDoc = gql`
    fragment InsightsFilterFormTrack on Track {
  id
  title
  permalink
  maintenance
}
    `;
export const InsightsOverviewSeriesFragmentDoc = gql`
    fragment InsightsOverviewSeries on PlayInsightSeries {
  plays {
    sum
    items {
      bucketStartTime
      value
    }
  }
  learnersReached {
    sum
    items {
      bucketStartTime
      value
    }
  }
  timeSpent {
    average
    items {
      bucketStartTime
      value
    }
  }
  completionRate {
    sum
    items: Items {
      bucketStartTime
      value
    }
  }
}
    `;
export const PlaysPerDayChartTeamStatisticsFragmentDoc = gql`
    fragment PlaysPerDayChartTeamStatistics on TeamStatistics {
  started_total
  completed_total
}
    `;
export const PlaysPerDayChartTeamSeriesFragmentDoc = gql`
    fragment PlaysPerDayChartTeamSeries on TeamSeries {
  date
  started
  completed
}
    `;
export const TrackStatisticsTableTrackStatisticsFragmentDoc = gql`
    fragment TrackStatisticsTableTrackStatistics on TrackStatistics {
  average_review_score
  started_total
  completed_total
  track {
    title
    slug
    developers {
      profile {
        display_name
        avatar
      }
    }
  }
}
    `;
export const InsightsStatisticsFragmentDoc = gql`
    fragment InsightsStatistics on TeamStatistics {
  ...PlaysPerDayChartTeamStatistics
  team_series {
    ...PlaysPerDayChartTeamSeries
  }
  track_statistics {
    ...TrackStatisticsTableTrackStatistics
  }
}
    ${PlaysPerDayChartTeamStatisticsFragmentDoc}
${PlaysPerDayChartTeamSeriesFragmentDoc}
${TrackStatisticsTableTrackStatisticsFragmentDoc}`;
export const InviteSecretFragmentDoc = gql`
    fragment InviteSecret on RuntimeSecret {
  key
  secret
}
    `;
export const InviteEnvironmentVariableFragmentDoc = gql`
    fragment InviteEnvironmentVariable on EnvironmentVariable {
  key
  value
}
    `;
export const InviteFormTrackInviteFragmentDoc = gql`
    fragment InviteFormTrackInvite on TrackInvite {
  id
  shareMethod
  type
  publicTitle
  publicDescription
  title
  inviteLimit
  playLimit
  playTTL
  allowedEmailAddresses
  allowAnonymous
  expiresAt
  startsAt
  enableLearnerSharing
  tracks {
    id
  }
  runtimeParameters {
    secrets {
      ...InviteSecret
    }
    environmentVariables {
      ...InviteEnvironmentVariable
    }
  }
}
    ${InviteSecretFragmentDoc}
${InviteEnvironmentVariableFragmentDoc}`;
export const InviteFormTrackFragmentDoc = gql`
    fragment InviteFormTrack on Track {
  id
  title
  maintenance
  slug
}
    `;
export const InviteFormTeamFragmentDoc = gql`
    fragment InviteFormTeam on Team {
  id
  form {
    id
    fields {
      id
      fieldName
      isRequired
    }
  }
}
    `;
export const AwsAccountFormAwsAccountFragmentDoc = gql`
    fragment AwsAccountFormAwsAccount on AwsAccountConfig {
  id
  name
  iam_policy
  managed_policies
  scp_policy
}
    `;
export const AzureSubscriptionFormAzureSubscriptionFragmentDoc = gql`
    fragment AzureSubscriptionFormAzureSubscription on AzureSubscriptionConfig {
  id
  name
  user_only
  roles
}
    `;
export const GoogleCloudFormGcpProjectFragmentDoc = gql`
    fragment GoogleCloudFormGcpProject on GcpProjectConfig {
  id
  name
  services
  roles
}
    `;
export const ManageTrackCloudAccsResourcesFragmentDoc = gql`
    fragment ManageTrackCloudAccsResources on TrackConfig {
  aws_accounts {
    ...AwsAccountFormAwsAccount
  }
  azure_subscriptions {
    ...AzureSubscriptionFormAzureSubscription
  }
  gcp_projects {
    ...GoogleCloudFormGcpProject
  }
}
    ${AwsAccountFormAwsAccountFragmentDoc}
${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
${GoogleCloudFormGcpProjectFragmentDoc}`;
export const ContainerFormContainerFragmentDoc = gql`
    fragment ContainerFormContainer on ContainerConfig {
  id
  name
  image
  entrypoint
  cmd
  ports
  shell
  environment {
    key
    value
  }
  memory
}
    `;
export const VirtualMachineFormVirtualMachineFragmentDoc = gql`
    fragment VirtualMachineFormVirtualMachine on VirtualMachineConfig {
  id
  name
  image
  machine_type
  allow_external_ingress
  shell
  environment {
    key
    value
  }
  memory
  cpus
  nested_virtualization
}
    `;
export const VirtualBrowserFormVirtualBrowserFragmentDoc = gql`
    fragment VirtualBrowserFormVirtualBrowser on VirtualBrowserConfig {
  id
  name
  url
}
    `;
export const ManageTrackHostResourcesFragmentDoc = gql`
    fragment ManageTrackHostResources on TrackConfig {
  containers {
    ...ContainerFormContainer
  }
  virtualmachines {
    ...VirtualMachineFormVirtualMachine
  }
  virtualbrowsers {
    ...VirtualBrowserFormVirtualBrowser
  }
}
    ${ContainerFormContainerFragmentDoc}
${VirtualMachineFormVirtualMachineFragmentDoc}
${VirtualBrowserFormVirtualBrowserFragmentDoc}`;
export const SandboxPresetListCardFragmentDoc = gql`
    fragment SandboxPresetListCard on SandboxConfigVersion {
  id
  config {
    id
    name
    slug
  }
  description
  published_at
  published_by {
    profile {
      avatar
      display_name
    }
  }
  status
  version
}
    `;
export const SelectPresetSandboxConfigVersionFragmentDoc = gql`
    fragment SelectPresetSandboxConfigVersion on SandboxConfigVersion {
  ...SandboxPresetListCard
}
    ${SandboxPresetListCardFragmentDoc}`;
export const ManageHostResourcesFragmentDoc = gql`
    fragment ManageHostResources on SandboxResources {
  containers {
    ...ContainerFormContainer
  }
  virtualmachines {
    ...VirtualMachineFormVirtualMachine
  }
  virtualbrowsers {
    ...VirtualBrowserFormVirtualBrowser
  }
}
    ${ContainerFormContainerFragmentDoc}
${VirtualMachineFormVirtualMachineFragmentDoc}
${VirtualBrowserFormVirtualBrowserFragmentDoc}`;
export const ManageCloudAccsResourcesFragmentDoc = gql`
    fragment ManageCloudAccsResources on SandboxResources {
  aws_accounts {
    ...AwsAccountFormAwsAccount
  }
  azure_subscriptions {
    ...AzureSubscriptionFormAzureSubscription
  }
  gcp_projects {
    ...GoogleCloudFormGcpProject
  }
}
    ${AwsAccountFormAwsAccountFragmentDoc}
${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
${GoogleCloudFormGcpProjectFragmentDoc}`;
export const SandboxConfigSecretFragmentDoc = gql`
    fragment SandboxConfigSecret on SecretConfig {
  id
  name
}
    `;
export const ManageNewTrackSandboxConfigVersionFragmentDoc = gql`
    fragment ManageNewTrackSandboxConfigVersion on SandboxConfigVersion {
  ...SelectPresetSandboxConfigVersion
  resources {
    ...ManageHostResources
    ...ManageCloudAccsResources
    secrets {
      ...SandboxConfigSecret
    }
  }
  scripts {
    action
    contents
    host
  }
}
    ${SelectPresetSandboxConfigVersionFragmentDoc}
${ManageHostResourcesFragmentDoc}
${ManageCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;
export const ManageSandboxPresetVersionFragmentDoc = gql`
    fragment ManageSandboxPresetVersion on SandboxConfigVersion {
  id
  config {
    id
    name
    slug
  }
  description
  status
  version
  resources {
    ...ManageHostResources
    ...ManageCloudAccsResources
    secrets {
      ...SandboxConfigSecret
    }
  }
  scripts {
    host
    action
    contents
  }
}
    ${ManageHostResourcesFragmentDoc}
${ManageCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;
export const InvitesTeamFragmentDoc = gql`
    fragment InvitesTeam on Team {
  id
  invites {
    email
    role
  }
}
    `;
export const MembersTeamFragmentDoc = gql`
    fragment MembersTeam on Team {
  id
  members {
    role
    user {
      id
      profile {
        display_name
        avatar
        slug
      }
    }
  }
}
    `;
export const ManageTrackSandboxConfigVersionFragmentDoc = gql`
    fragment ManageTrackSandboxConfigVersion on SandboxConfigVersion {
  ...SelectPresetSandboxConfigVersion
}
    ${SelectPresetSandboxConfigVersionFragmentDoc}`;
export const PlayActivityLogActivityFragmentDoc = gql`
    fragment PlayActivityLogActivity on PlayActivity {
  message
  time
  challenge {
    slug
  }
}
    `;
export const PlayActivityDrawerPlayReportItemFragmentDoc = gql`
    fragment PlayActivityDrawerPlayReportItem on PlayReportItem {
  id
  mode
  stoppedReason
  completionPercent
  timeSpent
  startedAt
  hotStartPool {
    id
  }
  customParameters {
    key
    value
  }
  track {
    id
    title
    slug
    developers {
      id
    }
  }
  trackInvite {
    id
    publicTitle
  }
  user {
    id
    details(teamSlug: $teamSlug) {
      id
      firstName
      lastName
      email
      companyName
      phoneNumber
      jobTitle
      jobLevel
      countryCode
      usState
      consent
    }
    profile {
      display_name
      email
    }
  }
  activity {
    ...PlayActivityLogActivity
  }
  playReview {
    id
    score
    content
  }
}
    ${PlayActivityLogActivityFragmentDoc}`;
export const PreviewResourceSandboxResourcesFragmentDoc = gql`
    fragment PreviewResourceSandboxResources on SandboxResources {
  containers {
    ...ContainerFormContainer
  }
  virtualmachines {
    ...VirtualMachineFormVirtualMachine
  }
  virtualbrowsers {
    ...VirtualBrowserFormVirtualBrowser
  }
  aws_accounts {
    ...AwsAccountFormAwsAccount
  }
  azure_subscriptions {
    ...AzureSubscriptionFormAzureSubscription
  }
  gcp_projects {
    ...GoogleCloudFormGcpProject
  }
}
    ${ContainerFormContainerFragmentDoc}
${VirtualMachineFormVirtualMachineFragmentDoc}
${VirtualBrowserFormVirtualBrowserFragmentDoc}
${AwsAccountFormAwsAccountFragmentDoc}
${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
${GoogleCloudFormGcpProjectFragmentDoc}`;
export const SandboxPresetPreviewTrackFragmentDoc = gql`
    fragment SandboxPresetPreviewTrack on Track {
  id
  title
}
    `;
export const SandboxPresetPreviewHotStartPoolFragmentDoc = gql`
    fragment SandboxPresetPreviewHotStartPool on HotStartPool {
  id
  name
}
    `;
export const PreviewSandboxPresetVersionFragmentDoc = gql`
    fragment PreviewSandboxPresetVersion on SandboxConfigVersion {
  ...SandboxPresetListCard
  change_log_entry
  resources {
    ...PreviewResourceSandboxResources
    secrets {
      name
    }
  }
  scripts {
    action
    contents
    host
  }
  tracks {
    ...SandboxPresetPreviewTrack
  }
  hot_start_pools {
    ...SandboxPresetPreviewHotStartPool
  }
}
    ${SandboxPresetListCardFragmentDoc}
${PreviewResourceSandboxResourcesFragmentDoc}
${SandboxPresetPreviewTrackFragmentDoc}
${SandboxPresetPreviewHotStartPoolFragmentDoc}`;
export const PreviewSandboxHistoryPresetVersionFragmentDoc = gql`
    fragment PreviewSandboxHistoryPresetVersion on SandboxConfigVersion {
  ...SandboxPresetListCard
  change_log_entry
}
    ${SandboxPresetListCardFragmentDoc}`;
export const SandboxPresetCardInfoFragmentDoc = gql`
    fragment SandboxPresetCardInfo on SandboxConfigVersion {
  id
  resources {
    ...PreviewResourceSandboxResources
    secrets {
      name
    }
  }
  scripts {
    action
    contents
    host
  }
}
    ${PreviewResourceSandboxResourcesFragmentDoc}`;
export const SsoConfigDefaultFormOptionsFragmentDoc = gql`
    fragment SSOConfigDefaultFormOptions on DefaultSsoConnectionOptions {
  clientID
  domain
}
    `;
export const SsoConfigSamlFormOptionsFragmentDoc = gql`
    fragment SSOConfigSamlFormOptions on SamlSsoConnectionOptions {
  signingCert
  signingEndpoint
  entityID
}
    `;
export const SsoConfigDrawerOptionsFragmentDoc = gql`
    fragment SSOConfigDrawerOptions on SsoConnectionOptions {
  ...SSOConfigDefaultFormOptions
  ...SSOConfigSamlFormOptions
}
    ${SsoConfigDefaultFormOptionsFragmentDoc}
${SsoConfigSamlFormOptionsFragmentDoc}`;
export const TagGroupInfoDrawerTrackFragmentDoc = gql`
    fragment TagGroupInfoDrawerTrack on Track {
  id
  title
  slug
}
    `;
export const TagGroupInfoDrawerGroupFragmentDoc = gql`
    fragment TagGroupInfoDrawerGroup on TagGroup {
  id
  name
  tags {
    id
    value
    tracks {
      ...TagGroupInfoDrawerTrack
    }
  }
}
    ${TagGroupInfoDrawerTrackFragmentDoc}`;
export const TagGroupsTableGroupFragmentDoc = gql`
    fragment TagGroupsTableGroup on TagGroup {
  id
  name
  createdAt
  tags {
    id
    value
    createdAt
    tracks {
      id
    }
  }
  ...TagGroupInfoDrawerGroup
}
    ${TagGroupInfoDrawerGroupFragmentDoc}`;
export const TagGroupFormTagFragmentDoc = gql`
    fragment TagGroupFormTag on Tag {
  id
  value
}
    `;
export const TagGroupsTableTagFragmentDoc = gql`
    fragment TagGroupsTableTag on Tag {
  ...TagGroupFormTag
}
    ${TagGroupFormTagFragmentDoc}`;
export const TagTracksDrawerTrackFragmentDoc = gql`
    fragment TagTracksDrawerTrack on Track {
  id
  title
  slug
}
    `;
export const TagsTableTagFragmentDoc = gql`
    fragment TagsTableTag on Tag {
  id
  value
  createdAt
  tracks {
    ...TagTracksDrawerTrack
  }
}
    ${TagTracksDrawerTrackFragmentDoc}`;
export const AuthorFilterListItemFragmentDoc = gql`
    fragment AuthorFilterListItem on User {
  id
  profile {
    display_name
  }
}
    `;
export const TeamContentTrackFragmentDoc = gql`
    fragment TeamContentTrack on Track {
  id
  icon
  last_update
  createdAt
  permalink
  slug
  teaser
  title
  description
  maintenance
  trackTags {
    id
    value
  }
  updated_by {
    id
    profile {
      avatar
      display_name
    }
  }
  developers {
    id
    profile {
      avatar
      display_name
    }
    ...AuthorFilterListItem
  }
}
    ${AuthorFilterListItemFragmentDoc}`;
export const TerraformModuleListEntryFragmentDoc = gql`
    fragment TerraformModuleListEntry on TerraformModule {
  description
  id
  logo
  name
  provider
  publishedAt
}
    `;
export const DashboardChallengeItemFragmentDoc = gql`
    fragment DashboardChallengeItem on Challenge {
  id
  slug
  type
  title
  teaser
  index
  status
}
    `;
export const PreviewChallengeFragmentDoc = gql`
    fragment PreviewChallenge on Challenge {
  type
  title
  teaser
  assignment
  tabs {
    id
    hostname
    index
    type
    title
    target
    new_window
    path
  }
}
    `;
export const DashboardChallengesItemFragmentDoc = gql`
    fragment DashboardChallengesItem on Challenge {
  ...DashboardChallengeItem
  ...PreviewChallenge
}
    ${DashboardChallengeItemFragmentDoc}
${PreviewChallengeFragmentDoc}`;
export const DashboardChallengeItemTrackFragmentDoc = gql`
    fragment DashboardChallengeItemTrack on Track {
  id
  status
  permalink
  slug
  maintenance
}
    `;
export const DashboardChallengesTrackFragmentDoc = gql`
    fragment DashboardChallengesTrack on Track {
  ...DashboardChallengeItemTrack
}
    ${DashboardChallengeItemTrackFragmentDoc}`;
export const DashboardApplicationSandboxResourcesFragmentDoc = gql`
    fragment DashboardApplicationSandboxResources on SandboxResources {
  containers {
    id
    name
    image
  }
  virtualmachines {
    id
    name
    image
  }
  virtualbrowsers {
    id
    name
    url
  }
  gcp_projects {
    id
    name
  }
  aws_accounts {
    id
    name
  }
  azure_subscriptions {
    id
    name
  }
  secrets {
    id
    name
  }
}
    `;
export const DashboardApplicationTrackConfigResourcesFragmentDoc = gql`
    fragment DashboardApplicationTrackConfigResources on TrackConfig {
  id
  containers {
    id
    name
    image
  }
  virtualmachines {
    id
    name
    image
  }
  virtualbrowsers {
    id
    name
    url
  }
  gcp_projects {
    id
    name
  }
  aws_accounts {
    id
    name
  }
  azure_subscriptions {
    id
    name
  }
  secrets {
    id
    name
  }
}
    `;
export const DashboardApplicationsTrackFragmentDoc = gql`
    fragment DashboardApplicationsTrack on Track {
  sandboxConfig {
    id
    description
    config {
      id
      name
      slug
    }
    resources {
      ...DashboardApplicationSandboxResources
    }
  }
  trackConfig {
    ...DashboardApplicationTrackConfigResources
  }
}
    ${DashboardApplicationSandboxResourcesFragmentDoc}
${DashboardApplicationTrackConfigResourcesFragmentDoc}`;
export const ChecksWidgetChallengeFragmentDoc = gql`
    fragment ChecksWidgetChallenge on Challenge {
  id
  title
  scripts {
    id
    action
  }
  permalink
}
    `;
export const TrackDetailsTrackDataFragmentDoc = gql`
    fragment TrackDetailsTrackData on Track {
  id
  permalink
  slug
  icon
  title
  teaser
  timelimit
  description
  level
  idle_timeout
  status
  completed
  maintenance
  show_timer
  skipping_enabled
  can_skip
  team {
    id
    slug
  }
  trackTags {
    id
    value
  }
  lab_config {
    width
    position
    overlay
    extendTTL
    hideStopButton
  }
  challenges {
    id
    permalink
    slug
    title
    teaser
    status
    index
    type
    timelimit
    started
    completed
    failed
    failMessage
  }
  developers {
    id
    profile {
      slug
      avatar
      display_name
      email
    }
  }
}
    `;
export const DashboardSettingsTrackFragmentDoc = gql`
    fragment DashboardSettingsTrack on Track {
  id
  timelimit
  maintenance
  show_timer
  skipping_enabled
  can_skip
  challenges {
    id
    timelimit
  }
  lab_config {
    hideStopButton
  }
  ...TrackDetailsTrackData
}
    ${TrackDetailsTrackDataFragmentDoc}`;
export const DashboardSourceTrackFragmentDoc = gql`
    fragment DashboardSourceTrack on Track {
  sourceTrack {
    id
    slug
    title
    team {
      id
      slug
    }
  }
}
    `;
export const DashboardTrackStatisticsFragmentDoc = gql`
    fragment DashboardTrackStatistics on TrackStatistics {
  started_total
  happiness {
    score
    count
  }
}
    `;
export const AuthorBadgeUserFragmentDoc = gql`
    fragment AuthorBadgeUser on User {
  profile {
    display_name
    avatar
  }
}
    `;
export const TrackDetailsAddTagFormTagFragmentDoc = gql`
    fragment TrackDetailsAddTagFormTag on Tag {
  id
  value
}
    `;
export const TrackDetailsAddTagFormTagGroupFragmentDoc = gql`
    fragment TrackDetailsAddTagFormTagGroup on TagGroup {
  id
  name
  tags {
    ...TrackDetailsAddTagFormTag
  }
}
    ${TrackDetailsAddTagFormTagFragmentDoc}`;
export const TrackDetailsFormDataFragmentDoc = gql`
    fragment TrackDetailsFormData on Track {
  id
  slug
  title
  timelimit
  description
  idle_timeout
  maintenance
  show_timer
  skipping_enabled
  can_skip
  icon
  developers {
    id
    ...AuthorBadgeUser
  }
  team {
    id
    slug
    tags {
      ...TrackDetailsAddTagFormTag
    }
    tagGroups {
      ...TrackDetailsAddTagFormTagGroup
    }
  }
  trackTags {
    id
    value
  }
  lab_config {
    width
    position
    overlay
    extendTTL
    hideStopButton
  }
}
    ${AuthorBadgeUserFragmentDoc}
${TrackDetailsAddTagFormTagFragmentDoc}
${TrackDetailsAddTagFormTagGroupFragmentDoc}`;
export const TrackInviteDetailsTrackInviteFragmentDoc = gql`
    fragment TrackInviteDetailsTrackInvite on TrackInvite {
  id
  shareMethod
  title
  publicTitle
  publicDescription
  inviteLimit
  claimCount
  startsAt
  expiresAt
  playLimit
  playTTL
  allowAnonymous
  allowedEmailAddressesOnly
  status
  type
  enableLearnerSharing
  canClaim
  tracks {
    id
    title
    slug
  }
  team {
    name
  }
}
    `;
export const TrackLimitsTableTrackFragmentDoc = gql`
    fragment TrackLimitsTableTrack on Track {
  id
  title
  slug
  maintenance
  play_count
}
    `;
export const TrackLimitsTableTrackLimitsFragmentDoc = gql`
    fragment TrackLimitsTableTrackLimits on TrackPlayLimit {
  track {
    id
  }
  rollingMonth
  rollingIPAddressPerHour
  calendarMonth
}
    `;
export const TabsConfigVersionFragmentDoc = gql`
    fragment TabsConfigVersion on SandboxConfigVersion {
  resources {
    containers {
      id
      name
    }
    virtualmachines {
      id
      name
    }
    virtualbrowsers {
      id
      name
    }
  }
}
    `;
export const TabsTrackConfigFragmentDoc = gql`
    fragment TabsTrackConfig on TrackConfig {
  id
  containers {
    id
    name
  }
  virtualmachines {
    id
    name
  }
  virtualbrowsers {
    id
    name
  }
}
    `;
export const ChallengeTabItemFragmentDoc = gql`
    fragment ChallengeTabItem on ChallengeTab {
  cmd
  hostname
  id
  index
  new_window
  path
  port
  target
  type
  title
  url
  workdir
  custom_headers {
    ...ChallengeTabCustomHeader
  }
  custom_response_headers {
    ...ChallengeTabCustomHeader
  }
  index
}
    ${ChallengeTabCustomHeaderFragmentDoc}`;
export const InsightsAllContentCsvFragmentDoc = gql`
    fragment InsightsAllContentCSV on TrackInsightItem {
  id
  track {
    id
    slug
  }
  currentPeriod {
    plays
    learnersReached
    timeSpent
    completionRate
    averageReviewScore
  }
  previousPeriod {
    plays
    learnersReached
    timeSpent
    completionRate
    averageReviewScore
  }
}
    `;
export const InsightsOverviewCsvFragmentDoc = gql`
    fragment InsightsOverviewCSV on PlayInsightSeries {
  plays {
    items {
      bucketStartTime
      value
    }
  }
  learnersReached {
    items {
      bucketStartTime
      value
    }
  }
  timeSpent {
    items {
      bucketStartTime
      value
    }
  }
  completionRate {
    items: Items {
      bucketStartTime
      value
    }
  }
}
    `;
export const HotStartPoolExistingPoolFragmentDoc = gql`
    fragment HotStartPoolExistingPool on HotStartPool {
  id
  type
  size
  name
  starts_at
  ends_at
  status
  region
  tracks {
    node {
      id
    }
  }
  configs {
    node {
      id
    }
  }
}
    `;
export const HotStartInviteFragmentDoc = gql`
    fragment HotStartInvite on TrackInvite {
  expiresAt
  publicTitle
  status
  startsAt
  tracks {
    id
  }
}
    `;
export const DownloadPlayActivityReportCsvFragmentDoc = gql`
    fragment DownloadPlayActivityReportCSV on PlayReportItem {
  id
  startedAt
  completionPercent
  totalChallenges
  completedChallenges
  timeSpent
  playReview {
    score
    content
  }
  activity {
    time
  }
  track {
    id
    slug
  }
  trackInvite {
    id
  }
  customParameters {
    key
    value
  }
  user {
    id
    details(teamSlug: $teamSlug) {
      firstName
      lastName
      email
      companyName
      phoneNumber
      jobTitle
      jobLevel
      countryCode
      usState
      consent
    }
    profile {
      display_name
      email
    }
  }
}
    `;
export const TeamContentTagFragmentDoc = gql`
    fragment TeamContentTag on Tag {
  id
  value
}
    `;
export const TeamPageTagGroupFragmentDoc = gql`
    fragment TeamPageTagGroup on TagGroup {
  id
  name
  tags {
    ...TeamContentTag
  }
}
    ${TeamContentTagFragmentDoc}`;
export const SandboxFragmentDoc = gql`
    fragment Sandbox on Sandbox {
  created
  last_activity_at
  ttl
  state
  id
  track {
    title
  }
}
    `;
export const DownloadTrackInviteCsvTrackInviteFragmentDoc = gql`
    fragment DownloadTrackInviteCsvTrackInvite on TrackInvite {
  id
  publicTitle
  team {
    id
    slug
    form {
      id
      fields {
        id
        fieldName
      }
    }
  }
  plays {
    last_activity
    time_spent
    track_started_at
    track_completed_at
    completed_challenges
    total_challenges
    failed_challenge_attempts
    track {
      id
      slug
    }
    participant {
      id
    }
    user {
      id
      is_anonymous
      profile {
        email
        display_name
      }
    }
  }
}
    `;
export const UpdateChallengeScriptsFragmentDoc = gql`
    fragment UpdateChallengeScripts on Challenge {
  id
  title
  scripts {
    action
    contents
    host
    id
  }
}
    `;
export const UpdateTrackScriptsFragmentDoc = gql`
    fragment UpdateTrackScripts on Track {
  id
  scripts {
    action
    contents
    host
    id
  }
  sandboxConfig {
    resources {
      containers {
        id
        name
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
  }
  challenges {
    ...UpdateChallengeScripts
  }
  trackConfig {
    id
    containers {
      id
      name
    }
    virtualmachines {
      id
      name
    }
    virtualbrowsers {
      id
      name
    }
  }
}
    ${UpdateChallengeScriptsFragmentDoc}`;
export const UpdateChallengeScriptResultFragmentDoc = gql`
    fragment UpdateChallengeScriptResult on ChallengeScript {
  id
  host
  action
  contents
}
    `;
export const UpdateTrackScriptResultFragmentDoc = gql`
    fragment UpdateTrackScriptResult on TrackScript {
  id
  host
  action
  contents
}
    `;
export const UserReportCsvFragmentDoc = gql`
    fragment UserReportCSV on UserReportItem {
  id
  plays
  tracksStarted
  tracksCompleted
  averageProgressPercent
  timeSpent
  lastStartedAt
  user {
    id
    profile {
      display_name
      email
    }
    details(teamSlug: $teamSlug) {
      firstName
      lastName
      email
      companyName
      jobTitle
      jobLevel
      countryCode
      usState
      phoneNumber
      consent
    }
  }
}
    `;
export const StudentNameFragmentDoc = gql`
    fragment StudentName on User {
  id
  profile {
    display_name
  }
  details(teamSlug: $teamSlug) {
    id
    firstName
    lastName
  }
}
    `;
export const ExpiredScreenTrackFragmentDoc = gql`
    fragment ExpiredScreenTrack on Track {
  slug
  permalink
  challenges {
    permalink
  }
}
    `;
export const ProgressModalChallengeFragmentDoc = gql`
    fragment ProgressModalChallenge on Challenge {
  id
  status
  slug
  title
  permalink
  failed
  type
  index
}
    `;
export const ProgressChallengeFragmentDoc = gql`
    fragment ProgressChallenge on Challenge {
  id
  status
  ...ProgressModalChallenge
}
    ${ProgressModalChallengeFragmentDoc}`;
export const ProgressModalTrackFragmentDoc = gql`
    fragment ProgressModalTrack on Track {
  id
  slug
  status
  median_starttime
}
    `;
export const ProgressTrackFragmentDoc = gql`
    fragment ProgressTrack on Track {
  ...ProgressModalTrack
}
    ${ProgressModalTrackFragmentDoc}`;
export const AttemptsChallengeAttemptFragmentDoc = gql`
    fragment AttemptsChallengeAttempt on ChallengeAttempt {
  message
}
    `;
export const TabContentChallengeChallengeTabFragmentDoc = gql`
    fragment TabContentChallengeChallengeTab on ChallengeTab {
  id
  type
  target
  path
  new_window
}
    `;
export const TabContentChallengeTabFragmentDoc = gql`
    fragment TabContentChallengeTab on ChallengeTab {
  id
  ...TabContentChallengeChallengeTab
}
    ${TabContentChallengeChallengeTabFragmentDoc}`;
export const WorkspaceChallengeFragmentDoc = gql`
    fragment WorkspaceChallenge on Challenge {
  type
  answers
  hasSingleAnswer
  attempts {
    timestamp
    ...AttemptsChallengeAttempt
  }
  tabs {
    id
    index
    type
    title
    target
    new_window
    ...TabContentChallengeTab
  }
}
    ${AttemptsChallengeAttemptFragmentDoc}
${TabContentChallengeTabFragmentDoc}`;
export const IsSkippingEnabledQueryFragmentDoc = gql`
    fragment IsSkippingEnabledQuery on Query {
  userInTeam(teamSlug: $teamSlug)
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  team(teamSlug: $teamSlug) {
    features {
      members_skip_to_challenge
    }
  }
  skippingEnabledTrack: track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    skipping_enabled
    can_skip
  }
}
    `;
export const BrandedTeamFragmentDoc = gql`
    fragment BrandedTeam on Team {
  name
  logo
  title
  subtitle
  slug
  primary_link_text
  primary_link_url
  secondary_link_text
  secondary_link_url
  theme {
    foreground_color
    foreground_image
    background_color
    background_image
    primary_foreground_color
    primary_background_color
    secondary_foreground_color
    secondary_background_color
  }
}
    `;
export const AmplitudeUserFragmentDoc = gql`
    fragment AmplitudeUser on User {
  id
  segments
  teams {
    node {
      slug
    }
  }
}
    `;
export const AuthenticationUserFragmentDoc = gql`
    fragment AuthenticationUser on User {
  id
  segments
  is_global_admin
  profile {
    email
    display_name
    avatar
    slug
  }
  teams {
    role
    node {
      id
      slug
      name
      features {
        hot_start
        invites
        statistics
        arcades
        webhooks
        track_reviews
        shared_hotstart_pools
      }
    }
  }
  ...AmplitudeUser
}
    ${AmplitudeUserFragmentDoc}`;
export const ArcadeIdleTimerStopTrackDocument = gql`
    mutation ArcadeIdleTimerStopTrack($trackID: String!) {
  stopTrack(trackID: $trackID) {
    id
    started
    creating
    created
    failed
    stopped
    completed
    cleaned
  }
}
    `;
export type ArcadeIdleTimerStopTrackMutationFn = Apollo.MutationFunction<ArcadeIdleTimerStopTrackMutation, ArcadeIdleTimerStopTrackMutationVariables>;

/**
 * __useArcadeIdleTimerStopTrackMutation__
 *
 * To run a mutation, you first call `useArcadeIdleTimerStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeIdleTimerStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeIdleTimerStopTrackMutation, { data, loading, error }] = useArcadeIdleTimerStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeIdleTimerStopTrackMutation(baseOptions?: Apollo.MutationHookOptions<ArcadeIdleTimerStopTrackMutation, ArcadeIdleTimerStopTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArcadeIdleTimerStopTrackMutation, ArcadeIdleTimerStopTrackMutationVariables>(ArcadeIdleTimerStopTrackDocument, options);
      }
export type ArcadeIdleTimerStopTrackMutationHookResult = ReturnType<typeof useArcadeIdleTimerStopTrackMutation>;
export type ArcadeIdleTimerStopTrackMutationResult = Apollo.MutationResult<ArcadeIdleTimerStopTrackMutation>;
export type ArcadeIdleTimerStopTrackMutationOptions = Apollo.BaseMutationOptions<ArcadeIdleTimerStopTrackMutation, ArcadeIdleTimerStopTrackMutationVariables>;
export const ArcadeAssignmentDocument = gql`
    query ArcadeAssignment($trackID: String!, $challengeID: String!, $teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    features {
      use_new_terminal
    }
  }
  track(trackID: $trackID) {
    id
    status
  }
  challenge(challengeID: $challengeID) {
    id
    status
    timelimit
    started
    assignment
    tabs {
      type
      title
      target
      path
      url
      index
    }
    attempts {
      timestamp
      message
    }
    notes {
      type
      contents
    }
  }
}
    `;

/**
 * __useArcadeAssignmentQuery__
 *
 * To run a query within a React component, call `useArcadeAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeAssignmentQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeAssignmentQuery(baseOptions: Apollo.QueryHookOptions<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>(ArcadeAssignmentDocument, options);
      }
export function useArcadeAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>(ArcadeAssignmentDocument, options);
        }
export type ArcadeAssignmentQueryHookResult = ReturnType<typeof useArcadeAssignmentQuery>;
export type ArcadeAssignmentLazyQueryHookResult = ReturnType<typeof useArcadeAssignmentLazyQuery>;
export type ArcadeAssignmentQueryResult = Apollo.QueryResult<ArcadeAssignmentQuery, ArcadeAssignmentQueryVariables>;
export const ArcadeChallengeCheckDocument = gql`
    mutation ArcadeChallengeCheck($playerID: String!, $challengeID: String!) {
  checkArcadeChallenge(playerID: $playerID, challengeID: $challengeID) {
    id
    status
    started
    completed
    attempts {
      timestamp
      message
    }
    unlocks {
      id
    }
  }
}
    `;
export type ArcadeChallengeCheckMutationFn = Apollo.MutationFunction<ArcadeChallengeCheckMutation, ArcadeChallengeCheckMutationVariables>;

/**
 * __useArcadeChallengeCheckMutation__
 *
 * To run a mutation, you first call `useArcadeChallengeCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeChallengeCheckMutation, { data, loading, error }] = useArcadeChallengeCheckMutation({
 *   variables: {
 *      playerID: // value for 'playerID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeCheckMutation(baseOptions?: Apollo.MutationHookOptions<ArcadeChallengeCheckMutation, ArcadeChallengeCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArcadeChallengeCheckMutation, ArcadeChallengeCheckMutationVariables>(ArcadeChallengeCheckDocument, options);
      }
export type ArcadeChallengeCheckMutationHookResult = ReturnType<typeof useArcadeChallengeCheckMutation>;
export type ArcadeChallengeCheckMutationResult = Apollo.MutationResult<ArcadeChallengeCheckMutation>;
export type ArcadeChallengeCheckMutationOptions = Apollo.BaseMutationOptions<ArcadeChallengeCheckMutation, ArcadeChallengeCheckMutationVariables>;
export const ArcadeChallengeDocument = gql`
    query ArcadeChallenge($trackID: String!, $challengeID: String!) {
  track(trackID: $trackID) {
    id
    challenges {
      id
    }
  }
  challenge(challengeID: $challengeID) {
    id
    index
    title
    started
    timelimit
    assignment
    tabs {
      type
      title
      target
    }
    notes {
      type
      contents
      url
    }
  }
}
    `;

/**
 * __useArcadeChallengeQuery__
 *
 * To run a query within a React component, call `useArcadeChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeChallengeQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeQuery(baseOptions: Apollo.QueryHookOptions<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>(ArcadeChallengeDocument, options);
      }
export function useArcadeChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>(ArcadeChallengeDocument, options);
        }
export type ArcadeChallengeQueryHookResult = ReturnType<typeof useArcadeChallengeQuery>;
export type ArcadeChallengeLazyQueryHookResult = ReturnType<typeof useArcadeChallengeLazyQuery>;
export type ArcadeChallengeQueryResult = Apollo.QueryResult<ArcadeChallengeQuery, ArcadeChallengeQueryVariables>;
export const ArcadeStartStatusDocument = gql`
    query ArcadeStartStatus($trackID: String!, $challengeID: String!) {
  track(trackID: $trackID) {
    id
    status
  }
  challenge(challengeID: $challengeID) {
    id
    status
  }
}
    `;

/**
 * __useArcadeStartStatusQuery__
 *
 * To run a query within a React component, call `useArcadeStartStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeStartStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeStartStatusQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeStartStatusQuery(baseOptions: Apollo.QueryHookOptions<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>(ArcadeStartStatusDocument, options);
      }
export function useArcadeStartStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>(ArcadeStartStatusDocument, options);
        }
export type ArcadeStartStatusQueryHookResult = ReturnType<typeof useArcadeStartStatusQuery>;
export type ArcadeStartStatusLazyQueryHookResult = ReturnType<typeof useArcadeStartStatusLazyQuery>;
export type ArcadeStartStatusQueryResult = Apollo.QueryResult<ArcadeStartStatusQuery, ArcadeStartStatusQueryVariables>;
export const ArcadeChallengeStartDocument = gql`
    mutation ArcadeChallengeStart($challengeID: String!) {
  startChallenge(challengeID: $challengeID) {
    id
    status
    started
    timelimit
  }
}
    `;
export type ArcadeChallengeStartMutationFn = Apollo.MutationFunction<ArcadeChallengeStartMutation, ArcadeChallengeStartMutationVariables>;

/**
 * __useArcadeChallengeStartMutation__
 *
 * To run a mutation, you first call `useArcadeChallengeStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeChallengeStartMutation, { data, loading, error }] = useArcadeChallengeStartMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeStartMutation(baseOptions?: Apollo.MutationHookOptions<ArcadeChallengeStartMutation, ArcadeChallengeStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArcadeChallengeStartMutation, ArcadeChallengeStartMutationVariables>(ArcadeChallengeStartDocument, options);
      }
export type ArcadeChallengeStartMutationHookResult = ReturnType<typeof useArcadeChallengeStartMutation>;
export type ArcadeChallengeStartMutationResult = Apollo.MutationResult<ArcadeChallengeStartMutation>;
export type ArcadeChallengeStartMutationOptions = Apollo.BaseMutationOptions<ArcadeChallengeStartMutation, ArcadeChallengeStartMutationVariables>;
export const ArcadeChallengeSetupDocument = gql`
    mutation ArcadeChallengeSetup($challengeID: String!) {
  setupChallenge(challengeID: $challengeID) {
    id
    status
  }
}
    `;
export type ArcadeChallengeSetupMutationFn = Apollo.MutationFunction<ArcadeChallengeSetupMutation, ArcadeChallengeSetupMutationVariables>;

/**
 * __useArcadeChallengeSetupMutation__
 *
 * To run a mutation, you first call `useArcadeChallengeSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeChallengeSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeChallengeSetupMutation, { data, loading, error }] = useArcadeChallengeSetupMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useArcadeChallengeSetupMutation(baseOptions?: Apollo.MutationHookOptions<ArcadeChallengeSetupMutation, ArcadeChallengeSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArcadeChallengeSetupMutation, ArcadeChallengeSetupMutationVariables>(ArcadeChallengeSetupDocument, options);
      }
export type ArcadeChallengeSetupMutationHookResult = ReturnType<typeof useArcadeChallengeSetupMutation>;
export type ArcadeChallengeSetupMutationResult = Apollo.MutationResult<ArcadeChallengeSetupMutation>;
export type ArcadeChallengeSetupMutationOptions = Apollo.BaseMutationOptions<ArcadeChallengeSetupMutation, ArcadeChallengeSetupMutationVariables>;
export const ArcadeInputContainerDocument = gql`
    query ArcadeInputContainer($trackID: String!) {
  track(trackID: $trackID) {
    id
    status
  }
}
    `;

/**
 * __useArcadeInputContainerQuery__
 *
 * To run a query within a React component, call `useArcadeInputContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeInputContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeInputContainerQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeInputContainerQuery(baseOptions: Apollo.QueryHookOptions<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>(ArcadeInputContainerDocument, options);
      }
export function useArcadeInputContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>(ArcadeInputContainerDocument, options);
        }
export type ArcadeInputContainerQueryHookResult = ReturnType<typeof useArcadeInputContainerQuery>;
export type ArcadeInputContainerLazyQueryHookResult = ReturnType<typeof useArcadeInputContainerLazyQuery>;
export type ArcadeInputContainerQueryResult = Apollo.QueryResult<ArcadeInputContainerQuery, ArcadeInputContainerQueryVariables>;
export const InputContainerRegisterScoreDocument = gql`
    mutation InputContainerRegisterScore($playerID: String!, $trackID: String!, $handle: String!, $difficulty: String!, $teamSlug: String) {
  registerScore(
    playerID: $playerID
    trackID: $trackID
    handle: $handle
    difficulty: $difficulty
    organizationSlug: $teamSlug
  ) {
    id
    player {
      id
      lives
    }
    track {
      id
      title
    }
    handle
    score
  }
}
    `;
export type InputContainerRegisterScoreMutationFn = Apollo.MutationFunction<InputContainerRegisterScoreMutation, InputContainerRegisterScoreMutationVariables>;

/**
 * __useInputContainerRegisterScoreMutation__
 *
 * To run a mutation, you first call `useInputContainerRegisterScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInputContainerRegisterScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inputContainerRegisterScoreMutation, { data, loading, error }] = useInputContainerRegisterScoreMutation({
 *   variables: {
 *      playerID: // value for 'playerID'
 *      trackID: // value for 'trackID'
 *      handle: // value for 'handle'
 *      difficulty: // value for 'difficulty'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useInputContainerRegisterScoreMutation(baseOptions?: Apollo.MutationHookOptions<InputContainerRegisterScoreMutation, InputContainerRegisterScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InputContainerRegisterScoreMutation, InputContainerRegisterScoreMutationVariables>(InputContainerRegisterScoreDocument, options);
      }
export type InputContainerRegisterScoreMutationHookResult = ReturnType<typeof useInputContainerRegisterScoreMutation>;
export type InputContainerRegisterScoreMutationResult = Apollo.MutationResult<InputContainerRegisterScoreMutation>;
export type InputContainerRegisterScoreMutationOptions = Apollo.BaseMutationOptions<InputContainerRegisterScoreMutation, InputContainerRegisterScoreMutationVariables>;
export const InputContainerStopTrackDocument = gql`
    mutation InputContainerStopTrack($trackID: String!) {
  stopTrack(trackID: $trackID) {
    id
    started
    creating
    created
    failed
    stopped
    completed
    cleaned
  }
}
    `;
export type InputContainerStopTrackMutationFn = Apollo.MutationFunction<InputContainerStopTrackMutation, InputContainerStopTrackMutationVariables>;

/**
 * __useInputContainerStopTrackMutation__
 *
 * To run a mutation, you first call `useInputContainerStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInputContainerStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inputContainerStopTrackMutation, { data, loading, error }] = useInputContainerStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useInputContainerStopTrackMutation(baseOptions?: Apollo.MutationHookOptions<InputContainerStopTrackMutation, InputContainerStopTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InputContainerStopTrackMutation, InputContainerStopTrackMutationVariables>(InputContainerStopTrackDocument, options);
      }
export type InputContainerStopTrackMutationHookResult = ReturnType<typeof useInputContainerStopTrackMutation>;
export type InputContainerStopTrackMutationResult = Apollo.MutationResult<InputContainerStopTrackMutation>;
export type InputContainerStopTrackMutationOptions = Apollo.BaseMutationOptions<InputContainerStopTrackMutation, InputContainerStopTrackMutationVariables>;
export const ArcadeLeaderboardDocument = gql`
    query ArcadeLeaderboard($trackID: String!) {
  track(trackID: $trackID) {
    id
    title
    teaser
  }
  rankings(trackID: $trackID) {
    id
    difficulty
    handle
    score
  }
}
    `;

/**
 * __useArcadeLeaderboardQuery__
 *
 * To run a query within a React component, call `useArcadeLeaderboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLeaderboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLeaderboardQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeLeaderboardQuery(baseOptions: Apollo.QueryHookOptions<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>(ArcadeLeaderboardDocument, options);
      }
export function useArcadeLeaderboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>(ArcadeLeaderboardDocument, options);
        }
export type ArcadeLeaderboardQueryHookResult = ReturnType<typeof useArcadeLeaderboardQuery>;
export type ArcadeLeaderboardLazyQueryHookResult = ReturnType<typeof useArcadeLeaderboardLazyQuery>;
export type ArcadeLeaderboardQueryResult = Apollo.QueryResult<ArcadeLeaderboardQuery, ArcadeLeaderboardQueryVariables>;
export const ArcadeLeaderboardsDocument = gql`
    query ArcadeLeaderboards($teamSlug: String!) {
  arcadetracks(organizationSlug: $teamSlug) {
    id
    title
    teaser
  }
}
    `;

/**
 * __useArcadeLeaderboardsQuery__
 *
 * To run a query within a React component, call `useArcadeLeaderboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLeaderboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLeaderboardsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeLeaderboardsQuery(baseOptions: Apollo.QueryHookOptions<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>(ArcadeLeaderboardsDocument, options);
      }
export function useArcadeLeaderboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>(ArcadeLeaderboardsDocument, options);
        }
export type ArcadeLeaderboardsQueryHookResult = ReturnType<typeof useArcadeLeaderboardsQuery>;
export type ArcadeLeaderboardsLazyQueryHookResult = ReturnType<typeof useArcadeLeaderboardsLazyQuery>;
export type ArcadeLeaderboardsQueryResult = Apollo.QueryResult<ArcadeLeaderboardsQuery, ArcadeLeaderboardsQueryVariables>;
export const ArcadeLeaderboardsRankingsDocument = gql`
    query ArcadeLeaderboardsRankings($trackID: String!) {
  rankings(trackID: $trackID) {
    id
    difficulty
    handle
    score
  }
}
    `;

/**
 * __useArcadeLeaderboardsRankingsQuery__
 *
 * To run a query within a React component, call `useArcadeLeaderboardsRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLeaderboardsRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLeaderboardsRankingsQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeLeaderboardsRankingsQuery(baseOptions: Apollo.QueryHookOptions<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>(ArcadeLeaderboardsRankingsDocument, options);
      }
export function useArcadeLeaderboardsRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>(ArcadeLeaderboardsRankingsDocument, options);
        }
export type ArcadeLeaderboardsRankingsQueryHookResult = ReturnType<typeof useArcadeLeaderboardsRankingsQuery>;
export type ArcadeLeaderboardsRankingsLazyQueryHookResult = ReturnType<typeof useArcadeLeaderboardsRankingsLazyQuery>;
export type ArcadeLeaderboardsRankingsQueryResult = Apollo.QueryResult<ArcadeLeaderboardsRankingsQuery, ArcadeLeaderboardsRankingsQueryVariables>;
export const ArcadeLoginDocument = gql`
    query ArcadeLogin($token: String!) {
  arcadeLogin(token: $token) {
    token
    alternative_url
    organization {
      id
      slug
    }
  }
}
    `;

/**
 * __useArcadeLoginQuery__
 *
 * To run a query within a React component, call `useArcadeLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeLoginQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useArcadeLoginQuery(baseOptions: Apollo.QueryHookOptions<ArcadeLoginQuery, ArcadeLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeLoginQuery, ArcadeLoginQueryVariables>(ArcadeLoginDocument, options);
      }
export function useArcadeLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeLoginQuery, ArcadeLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeLoginQuery, ArcadeLoginQueryVariables>(ArcadeLoginDocument, options);
        }
export type ArcadeLoginQueryHookResult = ReturnType<typeof useArcadeLoginQuery>;
export type ArcadeLoginLazyQueryHookResult = ReturnType<typeof useArcadeLoginLazyQuery>;
export type ArcadeLoginQueryResult = Apollo.QueryResult<ArcadeLoginQuery, ArcadeLoginQueryVariables>;
export const ArcadeDifficultyCreatePlayerDocument = gql`
    mutation ArcadeDifficultyCreatePlayer($trackID: String!, $difficulty: String!) {
  createPlayer(trackID: $trackID, difficulty: $difficulty) {
    id
    lives
  }
}
    `;
export type ArcadeDifficultyCreatePlayerMutationFn = Apollo.MutationFunction<ArcadeDifficultyCreatePlayerMutation, ArcadeDifficultyCreatePlayerMutationVariables>;

/**
 * __useArcadeDifficultyCreatePlayerMutation__
 *
 * To run a mutation, you first call `useArcadeDifficultyCreatePlayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeDifficultyCreatePlayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeDifficultyCreatePlayerMutation, { data, loading, error }] = useArcadeDifficultyCreatePlayerMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      difficulty: // value for 'difficulty'
 *   },
 * });
 */
export function useArcadeDifficultyCreatePlayerMutation(baseOptions?: Apollo.MutationHookOptions<ArcadeDifficultyCreatePlayerMutation, ArcadeDifficultyCreatePlayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArcadeDifficultyCreatePlayerMutation, ArcadeDifficultyCreatePlayerMutationVariables>(ArcadeDifficultyCreatePlayerDocument, options);
      }
export type ArcadeDifficultyCreatePlayerMutationHookResult = ReturnType<typeof useArcadeDifficultyCreatePlayerMutation>;
export type ArcadeDifficultyCreatePlayerMutationResult = Apollo.MutationResult<ArcadeDifficultyCreatePlayerMutation>;
export type ArcadeDifficultyCreatePlayerMutationOptions = Apollo.BaseMutationOptions<ArcadeDifficultyCreatePlayerMutation, ArcadeDifficultyCreatePlayerMutationVariables>;
export const ArcadeTracksDocument = gql`
    query ArcadeTracks($teamSlug: String) {
  arcadetracks(organizationSlug: $teamSlug) {
    id
    slug
    title
    teaser
    icon
  }
}
    `;

/**
 * __useArcadeTracksQuery__
 *
 * To run a query within a React component, call `useArcadeTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeTracksQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeTracksQuery(baseOptions?: Apollo.QueryHookOptions<ArcadeTracksQuery, ArcadeTracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeTracksQuery, ArcadeTracksQueryVariables>(ArcadeTracksDocument, options);
      }
export function useArcadeTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeTracksQuery, ArcadeTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeTracksQuery, ArcadeTracksQueryVariables>(ArcadeTracksDocument, options);
        }
export type ArcadeTracksQueryHookResult = ReturnType<typeof useArcadeTracksQuery>;
export type ArcadeTracksLazyQueryHookResult = ReturnType<typeof useArcadeTracksLazyQuery>;
export type ArcadeTracksQueryResult = Apollo.QueryResult<ArcadeTracksQuery, ArcadeTracksQueryVariables>;
export const ArcadeTracksStartTrackDocument = gql`
    mutation ArcadeTracksStartTrack($trackID: String!, $region: String) {
  startTrack(trackID: $trackID, region: $region, force: true) {
    id
    started
    creating
    created
    failed
    stopped
    completed
    cleaned
    challenges {
      id
      title
      teaser
      status
    }
  }
}
    `;
export type ArcadeTracksStartTrackMutationFn = Apollo.MutationFunction<ArcadeTracksStartTrackMutation, ArcadeTracksStartTrackMutationVariables>;

/**
 * __useArcadeTracksStartTrackMutation__
 *
 * To run a mutation, you first call `useArcadeTracksStartTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeTracksStartTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeTracksStartTrackMutation, { data, loading, error }] = useArcadeTracksStartTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useArcadeTracksStartTrackMutation(baseOptions?: Apollo.MutationHookOptions<ArcadeTracksStartTrackMutation, ArcadeTracksStartTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArcadeTracksStartTrackMutation, ArcadeTracksStartTrackMutationVariables>(ArcadeTracksStartTrackDocument, options);
      }
export type ArcadeTracksStartTrackMutationHookResult = ReturnType<typeof useArcadeTracksStartTrackMutation>;
export type ArcadeTracksStartTrackMutationResult = Apollo.MutationResult<ArcadeTracksStartTrackMutation>;
export type ArcadeTracksStartTrackMutationOptions = Apollo.BaseMutationOptions<ArcadeTracksStartTrackMutation, ArcadeTracksStartTrackMutationVariables>;
export const ArcadeTvLeaderboardsDocument = gql`
    query ArcadeTVLeaderboards($teamSlug: String!) {
  arcadetracks(organizationSlug: $teamSlug) {
    id
    title
    teaser
  }
  team(teamSlug: $teamSlug) {
    id
    name
  }
}
    `;

/**
 * __useArcadeTvLeaderboardsQuery__
 *
 * To run a query within a React component, call `useArcadeTvLeaderboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeTvLeaderboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeTvLeaderboardsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeTvLeaderboardsQuery(baseOptions: Apollo.QueryHookOptions<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>(ArcadeTvLeaderboardsDocument, options);
      }
export function useArcadeTvLeaderboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>(ArcadeTvLeaderboardsDocument, options);
        }
export type ArcadeTvLeaderboardsQueryHookResult = ReturnType<typeof useArcadeTvLeaderboardsQuery>;
export type ArcadeTvLeaderboardsLazyQueryHookResult = ReturnType<typeof useArcadeTvLeaderboardsLazyQuery>;
export type ArcadeTvLeaderboardsQueryResult = Apollo.QueryResult<ArcadeTvLeaderboardsQuery, ArcadeTvLeaderboardsQueryVariables>;
export const ArcadeTvLeaderboardsRankingsDocument = gql`
    query ArcadeTVLeaderboardsRankings($trackID: String!) {
  rankings(trackID: $trackID) {
    id
    difficulty
    handle
    score
  }
}
    `;

/**
 * __useArcadeTvLeaderboardsRankingsQuery__
 *
 * To run a query within a React component, call `useArcadeTvLeaderboardsRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeTvLeaderboardsRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeTvLeaderboardsRankingsQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useArcadeTvLeaderboardsRankingsQuery(baseOptions: Apollo.QueryHookOptions<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>(ArcadeTvLeaderboardsRankingsDocument, options);
      }
export function useArcadeTvLeaderboardsRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>(ArcadeTvLeaderboardsRankingsDocument, options);
        }
export type ArcadeTvLeaderboardsRankingsQueryHookResult = ReturnType<typeof useArcadeTvLeaderboardsRankingsQuery>;
export type ArcadeTvLeaderboardsRankingsLazyQueryHookResult = ReturnType<typeof useArcadeTvLeaderboardsRankingsLazyQuery>;
export type ArcadeTvLeaderboardsRankingsQueryResult = Apollo.QueryResult<ArcadeTvLeaderboardsRankingsQuery, ArcadeTvLeaderboardsRankingsQueryVariables>;
export const StartDocument = gql`
    mutation start($trackID: String!, $inviteID: String) {
  startTrack(trackID: $trackID, inviteID: $inviteID, recaptchaToken: "") {
    id
    status
    permalink
    challenges {
      id
      index
      slug
      title
      teaser
      status
      started
      completed
      timelimit
      failed
      failMessage
    }
  }
}
    `;
export type StartMutationFn = Apollo.MutationFunction<StartMutation, StartMutationVariables>;

/**
 * __useStartMutation__
 *
 * To run a mutation, you first call `useStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMutation, { data, loading, error }] = useStartMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useStartMutation(baseOptions?: Apollo.MutationHookOptions<StartMutation, StartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMutation, StartMutationVariables>(StartDocument, options);
      }
export type StartMutationHookResult = ReturnType<typeof useStartMutation>;
export type StartMutationResult = Apollo.MutationResult<StartMutation>;
export type StartMutationOptions = Apollo.BaseMutationOptions<StartMutation, StartMutationVariables>;
export const GetChallengeToDuplicateDocument = gql`
    query GetChallengeToDuplicate($challengeID: String!) {
  challenge(challengeID: $challengeID) {
    slug
    title
    teaser
    started
    timelimit
    assignment
    type
    difficulty
    tabs {
      cmd
      index
      new_window
      type
      title
      target
      hostname
      path
      port
      url
      workdir
    }
    notes {
      type
      contents
      url
      index
    }
    scripts {
      action
      contents
      host
    }
    answers
    solution
  }
}
    `;

/**
 * __useGetChallengeToDuplicateQuery__
 *
 * To run a query within a React component, call `useGetChallengeToDuplicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeToDuplicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeToDuplicateQuery({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeToDuplicateQuery(baseOptions: Apollo.QueryHookOptions<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>(GetChallengeToDuplicateDocument, options);
      }
export function useGetChallengeToDuplicateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>(GetChallengeToDuplicateDocument, options);
        }
export type GetChallengeToDuplicateQueryHookResult = ReturnType<typeof useGetChallengeToDuplicateQuery>;
export type GetChallengeToDuplicateLazyQueryHookResult = ReturnType<typeof useGetChallengeToDuplicateLazyQuery>;
export type GetChallengeToDuplicateQueryResult = Apollo.QueryResult<GetChallengeToDuplicateQuery, GetChallengeToDuplicateQueryVariables>;
export const DuplicateChallengeDocument = gql`
    mutation DuplicateChallenge($challenge: ChallengeInput!) {
  createChallenge(challenge: $challenge) {
    id
  }
}
    `;
export type DuplicateChallengeMutationFn = Apollo.MutationFunction<DuplicateChallengeMutation, DuplicateChallengeMutationVariables>;

/**
 * __useDuplicateChallengeMutation__
 *
 * To run a mutation, you first call `useDuplicateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateChallengeMutation, { data, loading, error }] = useDuplicateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useDuplicateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateChallengeMutation, DuplicateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateChallengeMutation, DuplicateChallengeMutationVariables>(DuplicateChallengeDocument, options);
      }
export type DuplicateChallengeMutationHookResult = ReturnType<typeof useDuplicateChallengeMutation>;
export type DuplicateChallengeMutationResult = Apollo.MutationResult<DuplicateChallengeMutation>;
export type DuplicateChallengeMutationOptions = Apollo.BaseMutationOptions<DuplicateChallengeMutation, DuplicateChallengeMutationVariables>;
export const EditorLayoutDocument = gql`
    query EditorLayout($teamSlug: String!, $trackSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    theme {
      ...EditorHeroTeamTheme
    }
    features {
      saas
    }
  }
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    title
  }
}
    ${EditorHeroTeamThemeFragmentDoc}`;

/**
 * __useEditorLayoutQuery__
 *
 * To run a query within a React component, call `useEditorLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorLayoutQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useEditorLayoutQuery(baseOptions: Apollo.QueryHookOptions<EditorLayoutQuery, EditorLayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditorLayoutQuery, EditorLayoutQueryVariables>(EditorLayoutDocument, options);
      }
export function useEditorLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditorLayoutQuery, EditorLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditorLayoutQuery, EditorLayoutQueryVariables>(EditorLayoutDocument, options);
        }
export type EditorLayoutQueryHookResult = ReturnType<typeof useEditorLayoutQuery>;
export type EditorLayoutLazyQueryHookResult = ReturnType<typeof useEditorLayoutLazyQuery>;
export type EditorLayoutQueryResult = Apollo.QueryResult<EditorLayoutQuery, EditorLayoutQueryVariables>;
export const SkippingToDocument = gql`
    query SkippingTo($trackSlug: String!, $teamSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    status
    skipping_to {
      id
    }
    challenges {
      id
      title
      slug
      index
      status
      started
      completed
      failed
      failMessage
    }
  }
}
    `;

/**
 * __useSkippingToQuery__
 *
 * To run a query within a React component, call `useSkippingToQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkippingToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkippingToQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useSkippingToQuery(baseOptions: Apollo.QueryHookOptions<SkippingToQuery, SkippingToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkippingToQuery, SkippingToQueryVariables>(SkippingToDocument, options);
      }
export function useSkippingToLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkippingToQuery, SkippingToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkippingToQuery, SkippingToQueryVariables>(SkippingToDocument, options);
        }
export type SkippingToQueryHookResult = ReturnType<typeof useSkippingToQuery>;
export type SkippingToLazyQueryHookResult = ReturnType<typeof useSkippingToLazyQuery>;
export type SkippingToQueryResult = Apollo.QueryResult<SkippingToQuery, SkippingToQueryVariables>;
export const SkipAChallengeDocument = gql`
    query SkipAChallenge($trackSlug: String!, $teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    features {
      members_skip_to_challenge
    }
  }
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  userInTeam(teamSlug: $teamSlug)
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    status
    skipping_to {
      id
    }
    skipping_enabled
    can_skip
    challenges {
      id
      type
      title
      index
      status
      started
      completed
    }
  }
  ...IsSkippingEnabledQuery
}
    ${IsSkippingEnabledQueryFragmentDoc}`;

/**
 * __useSkipAChallengeQuery__
 *
 * To run a query within a React component, call `useSkipAChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkipAChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkipAChallengeQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useSkipAChallengeQuery(baseOptions: Apollo.QueryHookOptions<SkipAChallengeQuery, SkipAChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkipAChallengeQuery, SkipAChallengeQueryVariables>(SkipAChallengeDocument, options);
      }
export function useSkipAChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkipAChallengeQuery, SkipAChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkipAChallengeQuery, SkipAChallengeQueryVariables>(SkipAChallengeDocument, options);
        }
export type SkipAChallengeQueryHookResult = ReturnType<typeof useSkipAChallengeQuery>;
export type SkipAChallengeLazyQueryHookResult = ReturnType<typeof useSkipAChallengeLazyQuery>;
export type SkipAChallengeQueryResult = Apollo.QueryResult<SkipAChallengeQuery, SkipAChallengeQueryVariables>;
export const Skip_StartTrackDocument = gql`
    mutation Skip_StartTrack($trackID: String!, $inviteID: String) {
  startTrack(trackID: $trackID, inviteID: $inviteID) {
    id
    status
  }
}
    `;
export type Skip_StartTrackMutationFn = Apollo.MutationFunction<Skip_StartTrackMutation, Skip_StartTrackMutationVariables>;

/**
 * __useSkip_StartTrackMutation__
 *
 * To run a mutation, you first call `useSkip_StartTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkip_StartTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipStartTrackMutation, { data, loading, error }] = useSkip_StartTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useSkip_StartTrackMutation(baseOptions?: Apollo.MutationHookOptions<Skip_StartTrackMutation, Skip_StartTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Skip_StartTrackMutation, Skip_StartTrackMutationVariables>(Skip_StartTrackDocument, options);
      }
export type Skip_StartTrackMutationHookResult = ReturnType<typeof useSkip_StartTrackMutation>;
export type Skip_StartTrackMutationResult = Apollo.MutationResult<Skip_StartTrackMutation>;
export type Skip_StartTrackMutationOptions = Apollo.BaseMutationOptions<Skip_StartTrackMutation, Skip_StartTrackMutationVariables>;
export const StartingTrackModalDocument = gql`
    query StartingTrackModal($trackSlug: String!, $teamSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    status
    median_starttime
    challenges {
      id
      index
      status
    }
  }
}
    `;

/**
 * __useStartingTrackModalQuery__
 *
 * To run a query within a React component, call `useStartingTrackModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartingTrackModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartingTrackModalQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useStartingTrackModalQuery(baseOptions: Apollo.QueryHookOptions<StartingTrackModalQuery, StartingTrackModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartingTrackModalQuery, StartingTrackModalQueryVariables>(StartingTrackModalDocument, options);
      }
export function useStartingTrackModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartingTrackModalQuery, StartingTrackModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartingTrackModalQuery, StartingTrackModalQueryVariables>(StartingTrackModalDocument, options);
        }
export type StartingTrackModalQueryHookResult = ReturnType<typeof useStartingTrackModalQuery>;
export type StartingTrackModalLazyQueryHookResult = ReturnType<typeof useStartingTrackModalLazyQuery>;
export type StartingTrackModalQueryResult = Apollo.QueryResult<StartingTrackModalQuery, StartingTrackModalQueryVariables>;
export const SkipChallengeDocument = gql`
    mutation SkipChallenge($trackID: String!, $challengeID: String!, $userID: String, $inviteID: String) {
  skipChallenge(
    trackID: $trackID
    challengeID: $challengeID
    userID: $userID
    inviteID: $inviteID
  )
}
    `;
export type SkipChallengeMutationFn = Apollo.MutationFunction<SkipChallengeMutation, SkipChallengeMutationVariables>;

/**
 * __useSkipChallengeMutation__
 *
 * To run a mutation, you first call `useSkipChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipChallengeMutation, { data, loading, error }] = useSkipChallengeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useSkipChallengeMutation(baseOptions?: Apollo.MutationHookOptions<SkipChallengeMutation, SkipChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipChallengeMutation, SkipChallengeMutationVariables>(SkipChallengeDocument, options);
      }
export type SkipChallengeMutationHookResult = ReturnType<typeof useSkipChallengeMutation>;
export type SkipChallengeMutationResult = Apollo.MutationResult<SkipChallengeMutation>;
export type SkipChallengeMutationOptions = Apollo.BaseMutationOptions<SkipChallengeMutation, SkipChallengeMutationVariables>;
export const SkipToChallengeDocument = gql`
    mutation SkipToChallenge($trackID: String!, $challengeID: String!, $userID: String, $inviteID: String, $force: Boolean) {
  skipToChallenge(
    trackID: $trackID
    challengeID: $challengeID
    userID: $userID
    inviteID: $inviteID
    force: $force
  ) {
    id
    status
  }
}
    `;
export type SkipToChallengeMutationFn = Apollo.MutationFunction<SkipToChallengeMutation, SkipToChallengeMutationVariables>;

/**
 * __useSkipToChallengeMutation__
 *
 * To run a mutation, you first call `useSkipToChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipToChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipToChallengeMutation, { data, loading, error }] = useSkipToChallengeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useSkipToChallengeMutation(baseOptions?: Apollo.MutationHookOptions<SkipToChallengeMutation, SkipToChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipToChallengeMutation, SkipToChallengeMutationVariables>(SkipToChallengeDocument, options);
      }
export type SkipToChallengeMutationHookResult = ReturnType<typeof useSkipToChallengeMutation>;
export type SkipToChallengeMutationResult = Apollo.MutationResult<SkipToChallengeMutation>;
export type SkipToChallengeMutationOptions = Apollo.BaseMutationOptions<SkipToChallengeMutation, SkipToChallengeMutationVariables>;
export const UpdateChallengeIndexesDocument = gql`
    mutation UpdateChallengeIndexes($trackID: String!, $challenges: [String!]!) {
  updateChallengeIndexes(trackID: $trackID, challenges: $challenges) {
    id
    title
    index
  }
}
    `;
export type UpdateChallengeIndexesMutationFn = Apollo.MutationFunction<UpdateChallengeIndexesMutation, UpdateChallengeIndexesMutationVariables>;

/**
 * __useUpdateChallengeIndexesMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeIndexesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeIndexesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeIndexesMutation, { data, loading, error }] = useUpdateChallengeIndexesMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challenges: // value for 'challenges'
 *   },
 * });
 */
export function useUpdateChallengeIndexesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeIndexesMutation, UpdateChallengeIndexesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeIndexesMutation, UpdateChallengeIndexesMutationVariables>(UpdateChallengeIndexesDocument, options);
      }
export type UpdateChallengeIndexesMutationHookResult = ReturnType<typeof useUpdateChallengeIndexesMutation>;
export type UpdateChallengeIndexesMutationResult = Apollo.MutationResult<UpdateChallengeIndexesMutation>;
export type UpdateChallengeIndexesMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeIndexesMutation, UpdateChallengeIndexesMutationVariables>;
export const StartLearningStopTrackDocument = gql`
    mutation StartLearningStopTrack($trackID: String!) {
  stopTrack(trackID: $trackID) {
    id
    status
    challenges {
      id
      slug
      title
      teaser
      status
    }
  }
}
    `;
export type StartLearningStopTrackMutationFn = Apollo.MutationFunction<StartLearningStopTrackMutation, StartLearningStopTrackMutationVariables>;

/**
 * __useStartLearningStopTrackMutation__
 *
 * To run a mutation, you first call `useStartLearningStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLearningStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLearningStopTrackMutation, { data, loading, error }] = useStartLearningStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useStartLearningStopTrackMutation(baseOptions?: Apollo.MutationHookOptions<StartLearningStopTrackMutation, StartLearningStopTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartLearningStopTrackMutation, StartLearningStopTrackMutationVariables>(StartLearningStopTrackDocument, options);
      }
export type StartLearningStopTrackMutationHookResult = ReturnType<typeof useStartLearningStopTrackMutation>;
export type StartLearningStopTrackMutationResult = Apollo.MutationResult<StartLearningStopTrackMutation>;
export type StartLearningStopTrackMutationOptions = Apollo.BaseMutationOptions<StartLearningStopTrackMutation, StartLearningStopTrackMutationVariables>;
export const FindUsersDocument = gql`
    query FindUsers($searchTerm: String!, $teamSlug: String!) {
  findUsers(searchTerm: $searchTerm, teamSlug: $teamSlug) {
    id
    profile {
      avatar
      display_name
      slug
    }
  }
}
    `;

/**
 * __useFindUsersQuery__
 *
 * To run a query within a React component, call `useFindUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useFindUsersQuery(baseOptions: Apollo.QueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
      }
export function useFindUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
        }
export type FindUsersQueryHookResult = ReturnType<typeof useFindUsersQuery>;
export type FindUsersLazyQueryHookResult = ReturnType<typeof useFindUsersLazyQuery>;
export type FindUsersQueryResult = Apollo.QueryResult<FindUsersQuery, FindUsersQueryVariables>;
export const CreateTrackDeveloperDocument = gql`
    mutation createTrackDeveloper($trackID: String!, $userID: String!) {
  createTrackDeveloper(trackID: $trackID, userID: $userID) {
    id
    developers {
      id
      profile {
        slug
        avatar
        display_name
      }
    }
  }
}
    `;
export type CreateTrackDeveloperMutationFn = Apollo.MutationFunction<CreateTrackDeveloperMutation, CreateTrackDeveloperMutationVariables>;

/**
 * __useCreateTrackDeveloperMutation__
 *
 * To run a mutation, you first call `useCreateTrackDeveloperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackDeveloperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackDeveloperMutation, { data, loading, error }] = useCreateTrackDeveloperMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useCreateTrackDeveloperMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackDeveloperMutation, CreateTrackDeveloperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackDeveloperMutation, CreateTrackDeveloperMutationVariables>(CreateTrackDeveloperDocument, options);
      }
export type CreateTrackDeveloperMutationHookResult = ReturnType<typeof useCreateTrackDeveloperMutation>;
export type CreateTrackDeveloperMutationResult = Apollo.MutationResult<CreateTrackDeveloperMutation>;
export type CreateTrackDeveloperMutationOptions = Apollo.BaseMutationOptions<CreateTrackDeveloperMutation, CreateTrackDeveloperMutationVariables>;
export const RemoveTrackDeveloperDocument = gql`
    mutation removeTrackDeveloper($trackID: String!, $userID: String!) {
  removeTrackDeveloper(trackID: $trackID, userID: $userID)
}
    `;
export type RemoveTrackDeveloperMutationFn = Apollo.MutationFunction<RemoveTrackDeveloperMutation, RemoveTrackDeveloperMutationVariables>;

/**
 * __useRemoveTrackDeveloperMutation__
 *
 * To run a mutation, you first call `useRemoveTrackDeveloperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTrackDeveloperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTrackDeveloperMutation, { data, loading, error }] = useRemoveTrackDeveloperMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useRemoveTrackDeveloperMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTrackDeveloperMutation, RemoveTrackDeveloperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTrackDeveloperMutation, RemoveTrackDeveloperMutationVariables>(RemoveTrackDeveloperDocument, options);
      }
export type RemoveTrackDeveloperMutationHookResult = ReturnType<typeof useRemoveTrackDeveloperMutation>;
export type RemoveTrackDeveloperMutationResult = Apollo.MutationResult<RemoveTrackDeveloperMutation>;
export type RemoveTrackDeveloperMutationOptions = Apollo.BaseMutationOptions<RemoveTrackDeveloperMutation, RemoveTrackDeveloperMutationVariables>;
export const GetDevelopersDocument = gql`
    query getDevelopers($trackID: String!) {
  track(trackID: $trackID) {
    id
    developers {
      id
      profile {
        slug
        avatar
        display_name
      }
    }
  }
}
    `;

/**
 * __useGetDevelopersQuery__
 *
 * To run a query within a React component, call `useGetDevelopersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevelopersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevelopersQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetDevelopersQuery(baseOptions: Apollo.QueryHookOptions<GetDevelopersQuery, GetDevelopersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDevelopersQuery, GetDevelopersQueryVariables>(GetDevelopersDocument, options);
      }
export function useGetDevelopersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDevelopersQuery, GetDevelopersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDevelopersQuery, GetDevelopersQueryVariables>(GetDevelopersDocument, options);
        }
export type GetDevelopersQueryHookResult = ReturnType<typeof useGetDevelopersQuery>;
export type GetDevelopersLazyQueryHookResult = ReturnType<typeof useGetDevelopersLazyQuery>;
export type GetDevelopersQueryResult = Apollo.QueryResult<GetDevelopersQuery, GetDevelopersQueryVariables>;
export const TrackDetailsDocument = gql`
    query TrackDetails($inviteID: String, $trackSlug: String!, $teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    ...TrackDetailsTeamData
  }
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  userInTeam(teamSlug: $teamSlug)
  track(inviteID: $inviteID, trackSlug: $trackSlug, teamSlug: $teamSlug) {
    ...TrackDetailsTrackData
  }
}
    ${TrackDetailsTeamDataFragmentDoc}
${TrackDetailsTrackDataFragmentDoc}`;

/**
 * __useTrackDetailsQuery__
 *
 * To run a query within a React component, call `useTrackDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDetailsQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDetailsQuery(baseOptions: Apollo.QueryHookOptions<TrackDetailsQuery, TrackDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackDetailsQuery, TrackDetailsQueryVariables>(TrackDetailsDocument, options);
      }
export function useTrackDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackDetailsQuery, TrackDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackDetailsQuery, TrackDetailsQueryVariables>(TrackDetailsDocument, options);
        }
export type TrackDetailsQueryHookResult = ReturnType<typeof useTrackDetailsQuery>;
export type TrackDetailsLazyQueryHookResult = ReturnType<typeof useTrackDetailsLazyQuery>;
export type TrackDetailsQueryResult = Apollo.QueryResult<TrackDetailsQuery, TrackDetailsQueryVariables>;
export const TrackTagsGetTrackDocument = gql`
    query TrackTagsGetTrack($trackID: String!) {
  track(trackID: $trackID) {
    ...TrackDetailsTrackData
  }
}
    ${TrackDetailsTrackDataFragmentDoc}`;

/**
 * __useTrackTagsGetTrackQuery__
 *
 * To run a query within a React component, call `useTrackTagsGetTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackTagsGetTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackTagsGetTrackQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useTrackTagsGetTrackQuery(baseOptions: Apollo.QueryHookOptions<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>(TrackTagsGetTrackDocument, options);
      }
export function useTrackTagsGetTrackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>(TrackTagsGetTrackDocument, options);
        }
export type TrackTagsGetTrackQueryHookResult = ReturnType<typeof useTrackTagsGetTrackQuery>;
export type TrackTagsGetTrackLazyQueryHookResult = ReturnType<typeof useTrackTagsGetTrackLazyQuery>;
export type TrackTagsGetTrackQueryResult = Apollo.QueryResult<TrackTagsGetTrackQuery, TrackTagsGetTrackQueryVariables>;
export const UpdateTrackTagsDocument = gql`
    mutation UpdateTrackTags($track: TrackInput!) {
  updateTrack(track: $track) {
    ...TrackDetailsTrackData
  }
}
    ${TrackDetailsTrackDataFragmentDoc}`;
export type UpdateTrackTagsMutationFn = Apollo.MutationFunction<UpdateTrackTagsMutation, UpdateTrackTagsMutationVariables>;

/**
 * __useUpdateTrackTagsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackTagsMutation, { data, loading, error }] = useUpdateTrackTagsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackTagsMutation, UpdateTrackTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackTagsMutation, UpdateTrackTagsMutationVariables>(UpdateTrackTagsDocument, options);
      }
export type UpdateTrackTagsMutationHookResult = ReturnType<typeof useUpdateTrackTagsMutation>;
export type UpdateTrackTagsMutationResult = Apollo.MutationResult<UpdateTrackTagsMutation>;
export type UpdateTrackTagsMutationOptions = Apollo.BaseMutationOptions<UpdateTrackTagsMutation, UpdateTrackTagsMutationVariables>;
export const UpdateTrackOptionsDocument = gql`
    mutation UpdateTrackOptions($track: TrackInput!) {
  updateTrack(track: $track) {
    id
    maintenance
    show_timer
    skipping_enabled
  }
}
    `;
export type UpdateTrackOptionsMutationFn = Apollo.MutationFunction<UpdateTrackOptionsMutation, UpdateTrackOptionsMutationVariables>;

/**
 * __useUpdateTrackOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackOptionsMutation, { data, loading, error }] = useUpdateTrackOptionsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackOptionsMutation, UpdateTrackOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackOptionsMutation, UpdateTrackOptionsMutationVariables>(UpdateTrackOptionsDocument, options);
      }
export type UpdateTrackOptionsMutationHookResult = ReturnType<typeof useUpdateTrackOptionsMutation>;
export type UpdateTrackOptionsMutationResult = Apollo.MutationResult<UpdateTrackOptionsMutation>;
export type UpdateTrackOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateTrackOptionsMutation, UpdateTrackOptionsMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($displayName: String!) {
  updateUser(displayName: $displayName) {
    id
    profile {
      display_name
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const AuthClaimTeamInvitesDocument = gql`
    mutation AuthClaimTeamInvites($token: String) {
  claimTeamInvites(token: $token) {
    ...AuthenticationUser
  }
}
    ${AuthenticationUserFragmentDoc}`;
export type AuthClaimTeamInvitesMutationFn = Apollo.MutationFunction<AuthClaimTeamInvitesMutation, AuthClaimTeamInvitesMutationVariables>;

/**
 * __useAuthClaimTeamInvitesMutation__
 *
 * To run a mutation, you first call `useAuthClaimTeamInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthClaimTeamInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authClaimTeamInvitesMutation, { data, loading, error }] = useAuthClaimTeamInvitesMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthClaimTeamInvitesMutation(baseOptions?: Apollo.MutationHookOptions<AuthClaimTeamInvitesMutation, AuthClaimTeamInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthClaimTeamInvitesMutation, AuthClaimTeamInvitesMutationVariables>(AuthClaimTeamInvitesDocument, options);
      }
export type AuthClaimTeamInvitesMutationHookResult = ReturnType<typeof useAuthClaimTeamInvitesMutation>;
export type AuthClaimTeamInvitesMutationResult = Apollo.MutationResult<AuthClaimTeamInvitesMutation>;
export type AuthClaimTeamInvitesMutationOptions = Apollo.BaseMutationOptions<AuthClaimTeamInvitesMutation, AuthClaimTeamInvitesMutationVariables>;
export const SignupPageDocument = gql`
    query SignupPage($teamID: String!, $skipTeam: Boolean!, $token: String!, $skipInvite: Boolean!) {
  team(teamID: $teamID) @skip(if: $skipTeam) {
    id
    name
    privacy_policy
  }
  teamInvite(token: $token) @skip(if: $skipInvite) {
    email
    token_expired
    team {
      id
      name
    }
    accepted_at
    created_by {
      id
      profile {
        email
        display_name
      }
    }
  }
}
    `;

/**
 * __useSignupPageQuery__
 *
 * To run a query within a React component, call `useSignupPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignupPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignupPageQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      skipTeam: // value for 'skipTeam'
 *      token: // value for 'token'
 *      skipInvite: // value for 'skipInvite'
 *   },
 * });
 */
export function useSignupPageQuery(baseOptions: Apollo.QueryHookOptions<SignupPageQuery, SignupPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignupPageQuery, SignupPageQueryVariables>(SignupPageDocument, options);
      }
export function useSignupPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignupPageQuery, SignupPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignupPageQuery, SignupPageQueryVariables>(SignupPageDocument, options);
        }
export type SignupPageQueryHookResult = ReturnType<typeof useSignupPageQuery>;
export type SignupPageLazyQueryHookResult = ReturnType<typeof useSignupPageLazyQuery>;
export type SignupPageQueryResult = Apollo.QueryResult<SignupPageQuery, SignupPageQueryVariables>;
export const ConsentToTeamPrivacyPolicyDocument = gql`
    mutation ConsentToTeamPrivacyPolicy($teamID: String!, $consent: Boolean!) {
  consentToTeamPrivacyPolicy(teamID: $teamID, consent: $consent)
}
    `;
export type ConsentToTeamPrivacyPolicyMutationFn = Apollo.MutationFunction<ConsentToTeamPrivacyPolicyMutation, ConsentToTeamPrivacyPolicyMutationVariables>;

/**
 * __useConsentToTeamPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useConsentToTeamPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsentToTeamPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consentToTeamPrivacyPolicyMutation, { data, loading, error }] = useConsentToTeamPrivacyPolicyMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useConsentToTeamPrivacyPolicyMutation(baseOptions?: Apollo.MutationHookOptions<ConsentToTeamPrivacyPolicyMutation, ConsentToTeamPrivacyPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsentToTeamPrivacyPolicyMutation, ConsentToTeamPrivacyPolicyMutationVariables>(ConsentToTeamPrivacyPolicyDocument, options);
      }
export type ConsentToTeamPrivacyPolicyMutationHookResult = ReturnType<typeof useConsentToTeamPrivacyPolicyMutation>;
export type ConsentToTeamPrivacyPolicyMutationResult = Apollo.MutationResult<ConsentToTeamPrivacyPolicyMutation>;
export type ConsentToTeamPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<ConsentToTeamPrivacyPolicyMutation, ConsentToTeamPrivacyPolicyMutationVariables>;
export const MergeAnonymousUserDocument = gql`
    mutation MergeAnonymousUser($token: String!) {
  mergeAnonymousUser(token: $token)
}
    `;
export type MergeAnonymousUserMutationFn = Apollo.MutationFunction<MergeAnonymousUserMutation, MergeAnonymousUserMutationVariables>;

/**
 * __useMergeAnonymousUserMutation__
 *
 * To run a mutation, you first call `useMergeAnonymousUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeAnonymousUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeAnonymousUserMutation, { data, loading, error }] = useMergeAnonymousUserMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useMergeAnonymousUserMutation(baseOptions?: Apollo.MutationHookOptions<MergeAnonymousUserMutation, MergeAnonymousUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeAnonymousUserMutation, MergeAnonymousUserMutationVariables>(MergeAnonymousUserDocument, options);
      }
export type MergeAnonymousUserMutationHookResult = ReturnType<typeof useMergeAnonymousUserMutation>;
export type MergeAnonymousUserMutationResult = Apollo.MutationResult<MergeAnonymousUserMutation>;
export type MergeAnonymousUserMutationOptions = Apollo.BaseMutationOptions<MergeAnonymousUserMutation, MergeAnonymousUserMutationVariables>;
export const GetSettingsVirtualBrowserChallengeChecksDocument = gql`
    query getSettingsVirtualBrowserChallengeChecks($track: String!) {
  virtualBrowserChecks(track: $track) {
    ...VirtualBrowserCheckItem
  }
}
    ${VirtualBrowserCheckItemFragmentDoc}`;

/**
 * __useGetSettingsVirtualBrowserChallengeChecksQuery__
 *
 * To run a query within a React component, call `useGetSettingsVirtualBrowserChallengeChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsVirtualBrowserChallengeChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsVirtualBrowserChallengeChecksQuery({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useGetSettingsVirtualBrowserChallengeChecksQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsVirtualBrowserChallengeChecksQuery, GetSettingsVirtualBrowserChallengeChecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsVirtualBrowserChallengeChecksQuery, GetSettingsVirtualBrowserChallengeChecksQueryVariables>(GetSettingsVirtualBrowserChallengeChecksDocument, options);
      }
export function useGetSettingsVirtualBrowserChallengeChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsVirtualBrowserChallengeChecksQuery, GetSettingsVirtualBrowserChallengeChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsVirtualBrowserChallengeChecksQuery, GetSettingsVirtualBrowserChallengeChecksQueryVariables>(GetSettingsVirtualBrowserChallengeChecksDocument, options);
        }
export type GetSettingsVirtualBrowserChallengeChecksQueryHookResult = ReturnType<typeof useGetSettingsVirtualBrowserChallengeChecksQuery>;
export type GetSettingsVirtualBrowserChallengeChecksLazyQueryHookResult = ReturnType<typeof useGetSettingsVirtualBrowserChallengeChecksLazyQuery>;
export type GetSettingsVirtualBrowserChallengeChecksQueryResult = Apollo.QueryResult<GetSettingsVirtualBrowserChallengeChecksQuery, GetSettingsVirtualBrowserChallengeChecksQueryVariables>;
export const GetSettingsVirtualBrowserChallengeChecksTrackDocument = gql`
    query getSettingsVirtualBrowserChallengeChecksTrack($teamSlug: String!, $trackSlug: String!) {
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    title
    challenges {
      id
      slug
      permalink
      title
    }
    config {
      id
      virtualbrowsers {
        id
        name
      }
    }
    sandboxConfig {
      id
      resources {
        virtualbrowsers {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetSettingsVirtualBrowserChallengeChecksTrackQuery__
 *
 * To run a query within a React component, call `useGetSettingsVirtualBrowserChallengeChecksTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsVirtualBrowserChallengeChecksTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsVirtualBrowserChallengeChecksTrackQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useGetSettingsVirtualBrowserChallengeChecksTrackQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsVirtualBrowserChallengeChecksTrackQuery, GetSettingsVirtualBrowserChallengeChecksTrackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsVirtualBrowserChallengeChecksTrackQuery, GetSettingsVirtualBrowserChallengeChecksTrackQueryVariables>(GetSettingsVirtualBrowserChallengeChecksTrackDocument, options);
      }
export function useGetSettingsVirtualBrowserChallengeChecksTrackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsVirtualBrowserChallengeChecksTrackQuery, GetSettingsVirtualBrowserChallengeChecksTrackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsVirtualBrowserChallengeChecksTrackQuery, GetSettingsVirtualBrowserChallengeChecksTrackQueryVariables>(GetSettingsVirtualBrowserChallengeChecksTrackDocument, options);
        }
export type GetSettingsVirtualBrowserChallengeChecksTrackQueryHookResult = ReturnType<typeof useGetSettingsVirtualBrowserChallengeChecksTrackQuery>;
export type GetSettingsVirtualBrowserChallengeChecksTrackLazyQueryHookResult = ReturnType<typeof useGetSettingsVirtualBrowserChallengeChecksTrackLazyQuery>;
export type GetSettingsVirtualBrowserChallengeChecksTrackQueryResult = Apollo.QueryResult<GetSettingsVirtualBrowserChallengeChecksTrackQuery, GetSettingsVirtualBrowserChallengeChecksTrackQueryVariables>;
export const GetChallengeNotesListConfigDocument = gql`
    query getChallengeNotesListConfig($teamSlug: String!, $trackSlug: String!, $challengeID: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    lab_config {
      width
      position
      overlay
    }
  }
  challenge(challengeID: $challengeID) {
    ...NotesListChallenge
  }
}
    ${NotesListChallengeFragmentDoc}`;

/**
 * __useGetChallengeNotesListConfigQuery__
 *
 * To run a query within a React component, call `useGetChallengeNotesListConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeNotesListConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeNotesListConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeNotesListConfigQuery(baseOptions: Apollo.QueryHookOptions<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>(GetChallengeNotesListConfigDocument, options);
      }
export function useGetChallengeNotesListConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>(GetChallengeNotesListConfigDocument, options);
        }
export type GetChallengeNotesListConfigQueryHookResult = ReturnType<typeof useGetChallengeNotesListConfigQuery>;
export type GetChallengeNotesListConfigLazyQueryHookResult = ReturnType<typeof useGetChallengeNotesListConfigLazyQuery>;
export type GetChallengeNotesListConfigQueryResult = Apollo.QueryResult<GetChallengeNotesListConfigQuery, GetChallengeNotesListConfigQueryVariables>;
export const GetChallengeTabsListPageConfigDocument = gql`
    query getChallengeTabsListPageConfig($teamSlug: String!, $trackSlug: String!, $challengeID: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    lab_config {
      width
      position
      overlay
    }
  }
  challenge(challengeID: $challengeID) {
    ...TabsListChallenge
    tabs {
      ...TabsListChallengeTab
    }
  }
}
    ${TabsListChallengeFragmentDoc}
${TabsListChallengeTabFragmentDoc}`;

/**
 * __useGetChallengeTabsListPageConfigQuery__
 *
 * To run a query within a React component, call `useGetChallengeTabsListPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeTabsListPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeTabsListPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeTabsListPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetChallengeTabsListPageConfigQuery, GetChallengeTabsListPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeTabsListPageConfigQuery, GetChallengeTabsListPageConfigQueryVariables>(GetChallengeTabsListPageConfigDocument, options);
      }
export function useGetChallengeTabsListPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeTabsListPageConfigQuery, GetChallengeTabsListPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeTabsListPageConfigQuery, GetChallengeTabsListPageConfigQueryVariables>(GetChallengeTabsListPageConfigDocument, options);
        }
export type GetChallengeTabsListPageConfigQueryHookResult = ReturnType<typeof useGetChallengeTabsListPageConfigQuery>;
export type GetChallengeTabsListPageConfigLazyQueryHookResult = ReturnType<typeof useGetChallengeTabsListPageConfigLazyQuery>;
export type GetChallengeTabsListPageConfigQueryResult = Apollo.QueryResult<GetChallengeTabsListPageConfigQuery, GetChallengeTabsListPageConfigQueryVariables>;
export const GetCreateChallengeNoteConfigDocument = gql`
    query getCreateChallengeNoteConfig($teamSlug: String!, $trackSlug: String!, $challengeID: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
  }
  challenge(challengeID: $challengeID) {
    id
  }
}
    `;

/**
 * __useGetCreateChallengeNoteConfigQuery__
 *
 * To run a query within a React component, call `useGetCreateChallengeNoteConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateChallengeNoteConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateChallengeNoteConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetCreateChallengeNoteConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>(GetCreateChallengeNoteConfigDocument, options);
      }
export function useGetCreateChallengeNoteConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>(GetCreateChallengeNoteConfigDocument, options);
        }
export type GetCreateChallengeNoteConfigQueryHookResult = ReturnType<typeof useGetCreateChallengeNoteConfigQuery>;
export type GetCreateChallengeNoteConfigLazyQueryHookResult = ReturnType<typeof useGetCreateChallengeNoteConfigLazyQuery>;
export type GetCreateChallengeNoteConfigQueryResult = Apollo.QueryResult<GetCreateChallengeNoteConfigQuery, GetCreateChallengeNoteConfigQueryVariables>;
export const CreateChallengeNotePageCreateChallengeNoteDocument = gql`
    mutation createChallengeNotePageCreateChallengeNote($note: ChallengeNoteInput!) {
  createChallengeNote(note: $note) {
    id
    index
    ...ChallengeNoteFormNote
  }
}
    ${ChallengeNoteFormNoteFragmentDoc}`;
export type CreateChallengeNotePageCreateChallengeNoteMutationFn = Apollo.MutationFunction<CreateChallengeNotePageCreateChallengeNoteMutation, CreateChallengeNotePageCreateChallengeNoteMutationVariables>;

/**
 * __useCreateChallengeNotePageCreateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useCreateChallengeNotePageCreateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeNotePageCreateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeNotePageCreateChallengeNoteMutation, { data, loading, error }] = useCreateChallengeNotePageCreateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateChallengeNotePageCreateChallengeNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateChallengeNotePageCreateChallengeNoteMutation, CreateChallengeNotePageCreateChallengeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChallengeNotePageCreateChallengeNoteMutation, CreateChallengeNotePageCreateChallengeNoteMutationVariables>(CreateChallengeNotePageCreateChallengeNoteDocument, options);
      }
export type CreateChallengeNotePageCreateChallengeNoteMutationHookResult = ReturnType<typeof useCreateChallengeNotePageCreateChallengeNoteMutation>;
export type CreateChallengeNotePageCreateChallengeNoteMutationResult = Apollo.MutationResult<CreateChallengeNotePageCreateChallengeNoteMutation>;
export type CreateChallengeNotePageCreateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<CreateChallengeNotePageCreateChallengeNoteMutation, CreateChallengeNotePageCreateChallengeNoteMutationVariables>;
export const GetCreateChallengeTabPageConfigDocument = gql`
    query getCreateChallengeTabPageConfig($teamSlug: String!, $trackSlug: String!, $challengeID: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  challenge(challengeID: $challengeID) {
    id
  }
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    sandboxConfig {
      resources {
        containers {
          id
          name
        }
        virtualmachines {
          id
          name
        }
        virtualbrowsers {
          id
          name
        }
      }
    }
    config {
      id
      containers {
        id
        name
        image
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
  }
  team(teamSlug: $teamSlug) {
    id
    features {
      saas
    }
  }
}
    `;

/**
 * __useGetCreateChallengeTabPageConfigQuery__
 *
 * To run a query within a React component, call `useGetCreateChallengeTabPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateChallengeTabPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateChallengeTabPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetCreateChallengeTabPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCreateChallengeTabPageConfigQuery, GetCreateChallengeTabPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateChallengeTabPageConfigQuery, GetCreateChallengeTabPageConfigQueryVariables>(GetCreateChallengeTabPageConfigDocument, options);
      }
export function useGetCreateChallengeTabPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateChallengeTabPageConfigQuery, GetCreateChallengeTabPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateChallengeTabPageConfigQuery, GetCreateChallengeTabPageConfigQueryVariables>(GetCreateChallengeTabPageConfigDocument, options);
        }
export type GetCreateChallengeTabPageConfigQueryHookResult = ReturnType<typeof useGetCreateChallengeTabPageConfigQuery>;
export type GetCreateChallengeTabPageConfigLazyQueryHookResult = ReturnType<typeof useGetCreateChallengeTabPageConfigLazyQuery>;
export type GetCreateChallengeTabPageConfigQueryResult = Apollo.QueryResult<GetCreateChallengeTabPageConfigQuery, GetCreateChallengeTabPageConfigQueryVariables>;
export const CreateChallengeTabPageCreateChallengeTabDocument = gql`
    mutation createChallengeTabPageCreateChallengeTab($tab: ChallengeTabInput!) {
  createChallengeTab(tab: $tab) {
    id
    index
    target
    ...ChallengeTabFormTab
  }
}
    ${ChallengeTabFormTabFragmentDoc}`;
export type CreateChallengeTabPageCreateChallengeTabMutationFn = Apollo.MutationFunction<CreateChallengeTabPageCreateChallengeTabMutation, CreateChallengeTabPageCreateChallengeTabMutationVariables>;

/**
 * __useCreateChallengeTabPageCreateChallengeTabMutation__
 *
 * To run a mutation, you first call `useCreateChallengeTabPageCreateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeTabPageCreateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeTabPageCreateChallengeTabMutation, { data, loading, error }] = useCreateChallengeTabPageCreateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useCreateChallengeTabPageCreateChallengeTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateChallengeTabPageCreateChallengeTabMutation, CreateChallengeTabPageCreateChallengeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChallengeTabPageCreateChallengeTabMutation, CreateChallengeTabPageCreateChallengeTabMutationVariables>(CreateChallengeTabPageCreateChallengeTabDocument, options);
      }
export type CreateChallengeTabPageCreateChallengeTabMutationHookResult = ReturnType<typeof useCreateChallengeTabPageCreateChallengeTabMutation>;
export type CreateChallengeTabPageCreateChallengeTabMutationResult = Apollo.MutationResult<CreateChallengeTabPageCreateChallengeTabMutation>;
export type CreateChallengeTabPageCreateChallengeTabMutationOptions = Apollo.BaseMutationOptions<CreateChallengeTabPageCreateChallengeTabMutation, CreateChallengeTabPageCreateChallengeTabMutationVariables>;
export const GetCreateTrackWizardPageConfigDocument = gql`
    query getCreateTrackWizardPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
  team(teamSlug: $teamSlug) {
    id
    features {
      containers
      virtual_machines
      saas
      gcp_projects
      aws_accounts
      azure_subscriptions
      custom_machine_type
      shared_hotstart_pools
    }
  }
  teamSecrets(teamSlug: $teamSlug) {
    name
    description
  }
  trackConfigPresets {
    ...CreateTrackSandboxPresets
  }
  sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
    ...ManageNewTrackSandboxConfigVersion
  }
}
    ${CreateTrackSandboxPresetsFragmentDoc}
${ManageNewTrackSandboxConfigVersionFragmentDoc}`;

/**
 * __useGetCreateTrackWizardPageConfigQuery__
 *
 * To run a query within a React component, call `useGetCreateTrackWizardPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreateTrackWizardPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreateTrackWizardPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCreateTrackWizardPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCreateTrackWizardPageConfigQuery, GetCreateTrackWizardPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreateTrackWizardPageConfigQuery, GetCreateTrackWizardPageConfigQueryVariables>(GetCreateTrackWizardPageConfigDocument, options);
      }
export function useGetCreateTrackWizardPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreateTrackWizardPageConfigQuery, GetCreateTrackWizardPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreateTrackWizardPageConfigQuery, GetCreateTrackWizardPageConfigQueryVariables>(GetCreateTrackWizardPageConfigDocument, options);
        }
export type GetCreateTrackWizardPageConfigQueryHookResult = ReturnType<typeof useGetCreateTrackWizardPageConfigQuery>;
export type GetCreateTrackWizardPageConfigLazyQueryHookResult = ReturnType<typeof useGetCreateTrackWizardPageConfigLazyQuery>;
export type GetCreateTrackWizardPageConfigQueryResult = Apollo.QueryResult<GetCreateTrackWizardPageConfigQuery, GetCreateTrackWizardPageConfigQueryVariables>;
export const GetTrackForWizardDocument = gql`
    query GetTrackForWizard($teamSlug: String!, $trackSlug: String!) {
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    permalink
    slug
    title
  }
}
    `;

/**
 * __useGetTrackForWizardQuery__
 *
 * To run a query within a React component, call `useGetTrackForWizardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackForWizardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackForWizardQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useGetTrackForWizardQuery(baseOptions: Apollo.QueryHookOptions<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>(GetTrackForWizardDocument, options);
      }
export function useGetTrackForWizardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>(GetTrackForWizardDocument, options);
        }
export type GetTrackForWizardQueryHookResult = ReturnType<typeof useGetTrackForWizardQuery>;
export type GetTrackForWizardLazyQueryHookResult = ReturnType<typeof useGetTrackForWizardLazyQuery>;
export type GetTrackForWizardQueryResult = Apollo.QueryResult<GetTrackForWizardQuery, GetTrackForWizardQueryVariables>;
export const WizardCreateChallengeDocument = gql`
    mutation wizardCreateChallenge($challenge: ChallengeInput!) {
  createChallenge(challenge: $challenge) {
    id
  }
}
    `;
export type WizardCreateChallengeMutationFn = Apollo.MutationFunction<WizardCreateChallengeMutation, WizardCreateChallengeMutationVariables>;

/**
 * __useWizardCreateChallengeMutation__
 *
 * To run a mutation, you first call `useWizardCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardCreateChallengeMutation, { data, loading, error }] = useWizardCreateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useWizardCreateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<WizardCreateChallengeMutation, WizardCreateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardCreateChallengeMutation, WizardCreateChallengeMutationVariables>(WizardCreateChallengeDocument, options);
      }
export type WizardCreateChallengeMutationHookResult = ReturnType<typeof useWizardCreateChallengeMutation>;
export type WizardCreateChallengeMutationResult = Apollo.MutationResult<WizardCreateChallengeMutation>;
export type WizardCreateChallengeMutationOptions = Apollo.BaseMutationOptions<WizardCreateChallengeMutation, WizardCreateChallengeMutationVariables>;
export const WizardUpdateChallengeDocument = gql`
    mutation wizardUpdateChallenge($challenge: ChallengeInput!) {
  updateChallenge(challenge: $challenge) {
    id
  }
}
    `;
export type WizardUpdateChallengeMutationFn = Apollo.MutationFunction<WizardUpdateChallengeMutation, WizardUpdateChallengeMutationVariables>;

/**
 * __useWizardUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useWizardUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateChallengeMutation, { data, loading, error }] = useWizardUpdateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useWizardUpdateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<WizardUpdateChallengeMutation, WizardUpdateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardUpdateChallengeMutation, WizardUpdateChallengeMutationVariables>(WizardUpdateChallengeDocument, options);
      }
export type WizardUpdateChallengeMutationHookResult = ReturnType<typeof useWizardUpdateChallengeMutation>;
export type WizardUpdateChallengeMutationResult = Apollo.MutationResult<WizardUpdateChallengeMutation>;
export type WizardUpdateChallengeMutationOptions = Apollo.BaseMutationOptions<WizardUpdateChallengeMutation, WizardUpdateChallengeMutationVariables>;
export const WizardUpdateSandboxDocument = gql`
    mutation wizardUpdateSandbox($configID: String!, $config: SandboxConfigInput!) {
  updateSandboxConfig(configID: $configID, config: $config) {
    id
  }
}
    `;
export type WizardUpdateSandboxMutationFn = Apollo.MutationFunction<WizardUpdateSandboxMutation, WizardUpdateSandboxMutationVariables>;

/**
 * __useWizardUpdateSandboxMutation__
 *
 * To run a mutation, you first call `useWizardUpdateSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateSandboxMutation, { data, loading, error }] = useWizardUpdateSandboxMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useWizardUpdateSandboxMutation(baseOptions?: Apollo.MutationHookOptions<WizardUpdateSandboxMutation, WizardUpdateSandboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardUpdateSandboxMutation, WizardUpdateSandboxMutationVariables>(WizardUpdateSandboxDocument, options);
      }
export type WizardUpdateSandboxMutationHookResult = ReturnType<typeof useWizardUpdateSandboxMutation>;
export type WizardUpdateSandboxMutationResult = Apollo.MutationResult<WizardUpdateSandboxMutation>;
export type WizardUpdateSandboxMutationOptions = Apollo.BaseMutationOptions<WizardUpdateSandboxMutation, WizardUpdateSandboxMutationVariables>;
export const WizardSetTrackSandboxConfigVersionDocument = gql`
    mutation wizardSetTrackSandboxConfigVersion($trackID: String!, $configVersionID: String) {
  setTrackSandboxConfigVersion(
    trackID: $trackID
    configVersionID: $configVersionID
  )
}
    `;
export type WizardSetTrackSandboxConfigVersionMutationFn = Apollo.MutationFunction<WizardSetTrackSandboxConfigVersionMutation, WizardSetTrackSandboxConfigVersionMutationVariables>;

/**
 * __useWizardSetTrackSandboxConfigVersionMutation__
 *
 * To run a mutation, you first call `useWizardSetTrackSandboxConfigVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardSetTrackSandboxConfigVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardSetTrackSandboxConfigVersionMutation, { data, loading, error }] = useWizardSetTrackSandboxConfigVersionMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useWizardSetTrackSandboxConfigVersionMutation(baseOptions?: Apollo.MutationHookOptions<WizardSetTrackSandboxConfigVersionMutation, WizardSetTrackSandboxConfigVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardSetTrackSandboxConfigVersionMutation, WizardSetTrackSandboxConfigVersionMutationVariables>(WizardSetTrackSandboxConfigVersionDocument, options);
      }
export type WizardSetTrackSandboxConfigVersionMutationHookResult = ReturnType<typeof useWizardSetTrackSandboxConfigVersionMutation>;
export type WizardSetTrackSandboxConfigVersionMutationResult = Apollo.MutationResult<WizardSetTrackSandboxConfigVersionMutation>;
export type WizardSetTrackSandboxConfigVersionMutationOptions = Apollo.BaseMutationOptions<WizardSetTrackSandboxConfigVersionMutation, WizardSetTrackSandboxConfigVersionMutationVariables>;
export const WizardCreateChallengeNoteDocument = gql`
    mutation wizardCreateChallengeNote($note: ChallengeNoteInput!) {
  createChallengeNote(note: $note) {
    id
  }
}
    `;
export type WizardCreateChallengeNoteMutationFn = Apollo.MutationFunction<WizardCreateChallengeNoteMutation, WizardCreateChallengeNoteMutationVariables>;

/**
 * __useWizardCreateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useWizardCreateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardCreateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardCreateChallengeNoteMutation, { data, loading, error }] = useWizardCreateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useWizardCreateChallengeNoteMutation(baseOptions?: Apollo.MutationHookOptions<WizardCreateChallengeNoteMutation, WizardCreateChallengeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardCreateChallengeNoteMutation, WizardCreateChallengeNoteMutationVariables>(WizardCreateChallengeNoteDocument, options);
      }
export type WizardCreateChallengeNoteMutationHookResult = ReturnType<typeof useWizardCreateChallengeNoteMutation>;
export type WizardCreateChallengeNoteMutationResult = Apollo.MutationResult<WizardCreateChallengeNoteMutation>;
export type WizardCreateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<WizardCreateChallengeNoteMutation, WizardCreateChallengeNoteMutationVariables>;
export const WizardUpdateChallengeNoteDocument = gql`
    mutation wizardUpdateChallengeNote($note: ChallengeNoteInput!) {
  updateChallengeNote(note: $note) {
    id
  }
}
    `;
export type WizardUpdateChallengeNoteMutationFn = Apollo.MutationFunction<WizardUpdateChallengeNoteMutation, WizardUpdateChallengeNoteMutationVariables>;

/**
 * __useWizardUpdateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useWizardUpdateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateChallengeNoteMutation, { data, loading, error }] = useWizardUpdateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useWizardUpdateChallengeNoteMutation(baseOptions?: Apollo.MutationHookOptions<WizardUpdateChallengeNoteMutation, WizardUpdateChallengeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardUpdateChallengeNoteMutation, WizardUpdateChallengeNoteMutationVariables>(WizardUpdateChallengeNoteDocument, options);
      }
export type WizardUpdateChallengeNoteMutationHookResult = ReturnType<typeof useWizardUpdateChallengeNoteMutation>;
export type WizardUpdateChallengeNoteMutationResult = Apollo.MutationResult<WizardUpdateChallengeNoteMutation>;
export type WizardUpdateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<WizardUpdateChallengeNoteMutation, WizardUpdateChallengeNoteMutationVariables>;
export const WizardCreateChallengeTabDocument = gql`
    mutation wizardCreateChallengeTab($tab: ChallengeTabInput!) {
  createChallengeTab(tab: $tab) {
    id
  }
}
    `;
export type WizardCreateChallengeTabMutationFn = Apollo.MutationFunction<WizardCreateChallengeTabMutation, WizardCreateChallengeTabMutationVariables>;

/**
 * __useWizardCreateChallengeTabMutation__
 *
 * To run a mutation, you first call `useWizardCreateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardCreateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardCreateChallengeTabMutation, { data, loading, error }] = useWizardCreateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useWizardCreateChallengeTabMutation(baseOptions?: Apollo.MutationHookOptions<WizardCreateChallengeTabMutation, WizardCreateChallengeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardCreateChallengeTabMutation, WizardCreateChallengeTabMutationVariables>(WizardCreateChallengeTabDocument, options);
      }
export type WizardCreateChallengeTabMutationHookResult = ReturnType<typeof useWizardCreateChallengeTabMutation>;
export type WizardCreateChallengeTabMutationResult = Apollo.MutationResult<WizardCreateChallengeTabMutation>;
export type WizardCreateChallengeTabMutationOptions = Apollo.BaseMutationOptions<WizardCreateChallengeTabMutation, WizardCreateChallengeTabMutationVariables>;
export const WizardUpdateChallengeTabDocument = gql`
    mutation wizardUpdateChallengeTab($tab: ChallengeTabInput!) {
  updateChallengeTab(tab: $tab) {
    id
  }
}
    `;
export type WizardUpdateChallengeTabMutationFn = Apollo.MutationFunction<WizardUpdateChallengeTabMutation, WizardUpdateChallengeTabMutationVariables>;

/**
 * __useWizardUpdateChallengeTabMutation__
 *
 * To run a mutation, you first call `useWizardUpdateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateChallengeTabMutation, { data, loading, error }] = useWizardUpdateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useWizardUpdateChallengeTabMutation(baseOptions?: Apollo.MutationHookOptions<WizardUpdateChallengeTabMutation, WizardUpdateChallengeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardUpdateChallengeTabMutation, WizardUpdateChallengeTabMutationVariables>(WizardUpdateChallengeTabDocument, options);
      }
export type WizardUpdateChallengeTabMutationHookResult = ReturnType<typeof useWizardUpdateChallengeTabMutation>;
export type WizardUpdateChallengeTabMutationResult = Apollo.MutationResult<WizardUpdateChallengeTabMutation>;
export type WizardUpdateChallengeTabMutationOptions = Apollo.BaseMutationOptions<WizardUpdateChallengeTabMutation, WizardUpdateChallengeTabMutationVariables>;
export const WizardUpdateTrackDocument = gql`
    mutation wizardUpdateTrack($track: TrackInput!) {
  updateTrack(track: $track) {
    id
    permalink
    slug
    title
  }
}
    `;
export type WizardUpdateTrackMutationFn = Apollo.MutationFunction<WizardUpdateTrackMutation, WizardUpdateTrackMutationVariables>;

/**
 * __useWizardUpdateTrackMutation__
 *
 * To run a mutation, you first call `useWizardUpdateTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWizardUpdateTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wizardUpdateTrackMutation, { data, loading, error }] = useWizardUpdateTrackMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useWizardUpdateTrackMutation(baseOptions?: Apollo.MutationHookOptions<WizardUpdateTrackMutation, WizardUpdateTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WizardUpdateTrackMutation, WizardUpdateTrackMutationVariables>(WizardUpdateTrackDocument, options);
      }
export type WizardUpdateTrackMutationHookResult = ReturnType<typeof useWizardUpdateTrackMutation>;
export type WizardUpdateTrackMutationResult = Apollo.MutationResult<WizardUpdateTrackMutation>;
export type WizardUpdateTrackMutationOptions = Apollo.BaseMutationOptions<WizardUpdateTrackMutation, WizardUpdateTrackMutationVariables>;
export const UpdateDisplayNameDocument = gql`
    mutation UpdateDisplayName($displayName: String!) {
  updateUser(displayName: $displayName) {
    id
    profile {
      display_name
    }
  }
}
    `;
export type UpdateDisplayNameMutationFn = Apollo.MutationFunction<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>;

/**
 * __useUpdateDisplayNameMutation__
 *
 * To run a mutation, you first call `useUpdateDisplayNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDisplayNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDisplayNameMutation, { data, loading, error }] = useUpdateDisplayNameMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useUpdateDisplayNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>(UpdateDisplayNameDocument, options);
      }
export type UpdateDisplayNameMutationHookResult = ReturnType<typeof useUpdateDisplayNameMutation>;
export type UpdateDisplayNameMutationResult = Apollo.MutationResult<UpdateDisplayNameMutation>;
export type UpdateDisplayNameMutationOptions = Apollo.BaseMutationOptions<UpdateDisplayNameMutation, UpdateDisplayNameMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser {
  deleteUser
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetEmbedConfigurationDocument = gql`
    query getEmbedConfiguration($trackSlug: String!, $teamSlug: String!) {
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    embed_token
  }
  team(teamSlug: $teamSlug) {
    lti_credentials {
      consumer_name
      consumer_key
    }
  }
}
    `;

/**
 * __useGetEmbedConfigurationQuery__
 *
 * To run a query within a React component, call `useGetEmbedConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbedConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbedConfigurationQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetEmbedConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>(GetEmbedConfigurationDocument, options);
      }
export function useGetEmbedConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>(GetEmbedConfigurationDocument, options);
        }
export type GetEmbedConfigurationQueryHookResult = ReturnType<typeof useGetEmbedConfigurationQuery>;
export type GetEmbedConfigurationLazyQueryHookResult = ReturnType<typeof useGetEmbedConfigurationLazyQuery>;
export type GetEmbedConfigurationQueryResult = Apollo.QueryResult<GetEmbedConfigurationQuery, GetEmbedConfigurationQueryVariables>;
export const GetTemplateDocument = gql`
    query GetTemplate($trackSlug: String!, $teamSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    permalink
    slug
    icon
    title
    teaser
    description
    trackTags {
      id
      value
    }
  }
}
    `;

/**
 * __useGetTemplateQuery__
 *
 * To run a query within a React component, call `useGetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateQuery, GetTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateQuery, GetTemplateQueryVariables>(GetTemplateDocument, options);
      }
export function useGetTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateQuery, GetTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateQuery, GetTemplateQueryVariables>(GetTemplateDocument, options);
        }
export type GetTemplateQueryHookResult = ReturnType<typeof useGetTemplateQuery>;
export type GetTemplateLazyQueryHookResult = ReturnType<typeof useGetTemplateLazyQuery>;
export type GetTemplateQueryResult = Apollo.QueryResult<GetTemplateQuery, GetTemplateQueryVariables>;
export const InviteEntryPageDocument = gql`
    query InviteEntryPage($inviteID: String!) {
  invitePublic: trackInvite(inviteID: $inviteID) {
    id
    accessSetting
    currentUserAllowed
    currentUserClaimed
    startsAt
    tracks {
      id
    }
    team {
      id
      slug
      name
      logo
      features {
        accept_terms_checkbox
      }
      theme {
        background_image
        background_color
      }
    }
  }
  invitePrivate: viewInvite(inviteID: $inviteID) {
    id
  }
}
    `;

/**
 * __useInviteEntryPageQuery__
 *
 * To run a query within a React component, call `useInviteEntryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteEntryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteEntryPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useInviteEntryPageQuery(baseOptions: Apollo.QueryHookOptions<InviteEntryPageQuery, InviteEntryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InviteEntryPageQuery, InviteEntryPageQueryVariables>(InviteEntryPageDocument, options);
      }
export function useInviteEntryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InviteEntryPageQuery, InviteEntryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InviteEntryPageQuery, InviteEntryPageQueryVariables>(InviteEntryPageDocument, options);
        }
export type InviteEntryPageQueryHookResult = ReturnType<typeof useInviteEntryPageQuery>;
export type InviteEntryPageLazyQueryHookResult = ReturnType<typeof useInviteEntryPageLazyQuery>;
export type InviteEntryPageQueryResult = Apollo.QueryResult<InviteEntryPageQuery, InviteEntryPageQueryVariables>;
export const GainAccessContainerDocument = gql`
    query GainAccessContainer($inviteID: String!) {
  invitePublic: trackInvite(inviteID: $inviteID) {
    id
    currentUserClaimed
    team {
      id
      name
      slug
      logo
      features {
        accept_terms_checkbox
      }
      theme {
        background_image
        background_color
      }
    }
  }
  invitePrivate: viewInvite(inviteID: $inviteID) {
    id
    allowAnonymous
    allowedEmailAddressesOnly
    currentUserAllowed
    startsAt
  }
}
    `;

/**
 * __useGainAccessContainerQuery__
 *
 * To run a query within a React component, call `useGainAccessContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGainAccessContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGainAccessContainerQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useGainAccessContainerQuery(baseOptions: Apollo.QueryHookOptions<GainAccessContainerQuery, GainAccessContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GainAccessContainerQuery, GainAccessContainerQueryVariables>(GainAccessContainerDocument, options);
      }
export function useGainAccessContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GainAccessContainerQuery, GainAccessContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GainAccessContainerQuery, GainAccessContainerQueryVariables>(GainAccessContainerDocument, options);
        }
export type GainAccessContainerQueryHookResult = ReturnType<typeof useGainAccessContainerQuery>;
export type GainAccessContainerLazyQueryHookResult = ReturnType<typeof useGainAccessContainerLazyQuery>;
export type GainAccessContainerQueryResult = Apollo.QueryResult<GainAccessContainerQuery, GainAccessContainerQueryVariables>;
export const ClaimTrackInviteDocument = gql`
    mutation ClaimTrackInvite($inviteID: String!) {
  claimTrackInvite(inviteID: $inviteID) {
    id
    trackInvite {
      id
      currentUserClaimed
    }
  }
}
    `;
export type ClaimTrackInviteMutationFn = Apollo.MutationFunction<ClaimTrackInviteMutation, ClaimTrackInviteMutationVariables>;

/**
 * __useClaimTrackInviteMutation__
 *
 * To run a mutation, you first call `useClaimTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimTrackInviteMutation, { data, loading, error }] = useClaimTrackInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useClaimTrackInviteMutation(baseOptions?: Apollo.MutationHookOptions<ClaimTrackInviteMutation, ClaimTrackInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimTrackInviteMutation, ClaimTrackInviteMutationVariables>(ClaimTrackInviteDocument, options);
      }
export type ClaimTrackInviteMutationHookResult = ReturnType<typeof useClaimTrackInviteMutation>;
export type ClaimTrackInviteMutationResult = Apollo.MutationResult<ClaimTrackInviteMutation>;
export type ClaimTrackInviteMutationOptions = Apollo.BaseMutationOptions<ClaimTrackInviteMutation, ClaimTrackInviteMutationVariables>;
export const TrackInvitePageDocument = gql`
    query TrackInvitePage($inviteID: String!, $teamSlug: String!) {
  me {
    id
    details(teamSlug: $teamSlug) {
      id
      firstName
      lastName
      email
      companyName
      phoneNumber
      jobTitle
      jobLevel
      countryCode
      usState
      consent
    }
  }
  trackInvite(inviteID: $inviteID) {
    id
    title
    publicTitle
    publicDescription
    enableLearnerSharing
    accessSetting
    canClaim
    currentUserClaimed
    ...TrackInviteListItemInvite
    tracks {
      id
      permalink
      slug
      title
      challenges {
        completed
        index
        slug
        started
        status
      }
      ...TrackInviteListTrack
    }
    team {
      id
      slug
      name
      logo
      privacy_policy
      form {
        formTitle
        consentNotice
        validateWorkEmail
        fields {
          id
          fieldName
          isRequired
        }
      }
      theme {
        foreground_color
        background_color
        background_image
      }
      features {
        accept_terms_checkbox
      }
    }
  }
}
    ${TrackInviteListItemInviteFragmentDoc}
${TrackInviteListTrackFragmentDoc}`;

/**
 * __useTrackInvitePageQuery__
 *
 * To run a query within a React component, call `useTrackInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackInvitePageQuery(baseOptions: Apollo.QueryHookOptions<TrackInvitePageQuery, TrackInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackInvitePageQuery, TrackInvitePageQueryVariables>(TrackInvitePageDocument, options);
      }
export function useTrackInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackInvitePageQuery, TrackInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackInvitePageQuery, TrackInvitePageQueryVariables>(TrackInvitePageDocument, options);
        }
export type TrackInvitePageQueryHookResult = ReturnType<typeof useTrackInvitePageQuery>;
export type TrackInvitePageLazyQueryHookResult = ReturnType<typeof useTrackInvitePageLazyQuery>;
export type TrackInvitePageQueryResult = Apollo.QueryResult<TrackInvitePageQuery, TrackInvitePageQueryVariables>;
export const TrackInviteOverviewClaimTrackInviteDocument = gql`
    mutation TrackInviteOverviewClaimTrackInvite($inviteID: String!, $userDetails: UserDetailsInput, $customParameters: [CustomParametersInput!]) {
  claimTrackInvite(
    inviteID: $inviteID
    userDetails: $userDetails
    customParameters: $customParameters
  ) {
    id
    trackInvite {
      id
      currentUserClaimed
      currentUserClaim {
        id
        playTTL
      }
    }
  }
}
    `;
export type TrackInviteOverviewClaimTrackInviteMutationFn = Apollo.MutationFunction<TrackInviteOverviewClaimTrackInviteMutation, TrackInviteOverviewClaimTrackInviteMutationVariables>;

/**
 * __useTrackInviteOverviewClaimTrackInviteMutation__
 *
 * To run a mutation, you first call `useTrackInviteOverviewClaimTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInviteOverviewClaimTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInviteOverviewClaimTrackInviteMutation, { data, loading, error }] = useTrackInviteOverviewClaimTrackInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      userDetails: // value for 'userDetails'
 *      customParameters: // value for 'customParameters'
 *   },
 * });
 */
export function useTrackInviteOverviewClaimTrackInviteMutation(baseOptions?: Apollo.MutationHookOptions<TrackInviteOverviewClaimTrackInviteMutation, TrackInviteOverviewClaimTrackInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackInviteOverviewClaimTrackInviteMutation, TrackInviteOverviewClaimTrackInviteMutationVariables>(TrackInviteOverviewClaimTrackInviteDocument, options);
      }
export type TrackInviteOverviewClaimTrackInviteMutationHookResult = ReturnType<typeof useTrackInviteOverviewClaimTrackInviteMutation>;
export type TrackInviteOverviewClaimTrackInviteMutationResult = Apollo.MutationResult<TrackInviteOverviewClaimTrackInviteMutation>;
export type TrackInviteOverviewClaimTrackInviteMutationOptions = Apollo.BaseMutationOptions<TrackInviteOverviewClaimTrackInviteMutation, TrackInviteOverviewClaimTrackInviteMutationVariables>;
export const TrackInviteOverviewConsentToTeamPrivacyPolicyDocument = gql`
    mutation TrackInviteOverviewConsentToTeamPrivacyPolicy($teamID: String!, $consent: Boolean!) {
  consentToTeamPrivacyPolicy(teamID: $teamID, consent: $consent)
}
    `;
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationFn = Apollo.MutationFunction<TrackInviteOverviewConsentToTeamPrivacyPolicyMutation, TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables>;

/**
 * __useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation__
 *
 * To run a mutation, you first call `useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInviteOverviewConsentToTeamPrivacyPolicyMutation, { data, loading, error }] = useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation(baseOptions?: Apollo.MutationHookOptions<TrackInviteOverviewConsentToTeamPrivacyPolicyMutation, TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackInviteOverviewConsentToTeamPrivacyPolicyMutation, TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables>(TrackInviteOverviewConsentToTeamPrivacyPolicyDocument, options);
      }
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationHookResult = ReturnType<typeof useTrackInviteOverviewConsentToTeamPrivacyPolicyMutation>;
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationResult = Apollo.MutationResult<TrackInviteOverviewConsentToTeamPrivacyPolicyMutation>;
export type TrackInviteOverviewConsentToTeamPrivacyPolicyMutationOptions = Apollo.BaseMutationOptions<TrackInviteOverviewConsentToTeamPrivacyPolicyMutation, TrackInviteOverviewConsentToTeamPrivacyPolicyMutationVariables>;
export const TrackInviteOverviewStopTrackDocument = gql`
    mutation TrackInviteOverviewStopTrack($trackID: String!) {
  stopTrack(trackID: $trackID) {
    id
    status
  }
}
    `;
export type TrackInviteOverviewStopTrackMutationFn = Apollo.MutationFunction<TrackInviteOverviewStopTrackMutation, TrackInviteOverviewStopTrackMutationVariables>;

/**
 * __useTrackInviteOverviewStopTrackMutation__
 *
 * To run a mutation, you first call `useTrackInviteOverviewStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackInviteOverviewStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackInviteOverviewStopTrackMutation, { data, loading, error }] = useTrackInviteOverviewStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useTrackInviteOverviewStopTrackMutation(baseOptions?: Apollo.MutationHookOptions<TrackInviteOverviewStopTrackMutation, TrackInviteOverviewStopTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackInviteOverviewStopTrackMutation, TrackInviteOverviewStopTrackMutationVariables>(TrackInviteOverviewStopTrackDocument, options);
      }
export type TrackInviteOverviewStopTrackMutationHookResult = ReturnType<typeof useTrackInviteOverviewStopTrackMutation>;
export type TrackInviteOverviewStopTrackMutationResult = Apollo.MutationResult<TrackInviteOverviewStopTrackMutation>;
export type TrackInviteOverviewStopTrackMutationOptions = Apollo.BaseMutationOptions<TrackInviteOverviewStopTrackMutation, TrackInviteOverviewStopTrackMutationVariables>;
export const GetManageChallengePageConfigDocument = gql`
    query getManageChallengePageConfig($teamSlug: String!, $trackSlug: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    lab_config {
      position
      width
      overlay
      extendTTL
      hideStopButton
    }
  }
}
    `;

/**
 * __useGetManageChallengePageConfigQuery__
 *
 * To run a query within a React component, call `useGetManageChallengePageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageChallengePageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageChallengePageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useGetManageChallengePageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetManageChallengePageConfigQuery, GetManageChallengePageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageChallengePageConfigQuery, GetManageChallengePageConfigQueryVariables>(GetManageChallengePageConfigDocument, options);
      }
export function useGetManageChallengePageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageChallengePageConfigQuery, GetManageChallengePageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageChallengePageConfigQuery, GetManageChallengePageConfigQueryVariables>(GetManageChallengePageConfigDocument, options);
        }
export type GetManageChallengePageConfigQueryHookResult = ReturnType<typeof useGetManageChallengePageConfigQuery>;
export type GetManageChallengePageConfigLazyQueryHookResult = ReturnType<typeof useGetManageChallengePageConfigLazyQuery>;
export type GetManageChallengePageConfigQueryResult = Apollo.QueryResult<GetManageChallengePageConfigQuery, GetManageChallengePageConfigQueryVariables>;
export const ManageChallengePageCreateChallengeDocument = gql`
    mutation manageChallengePageCreateChallenge($challenge: ChallengeInput!) {
  createChallenge(challenge: $challenge) {
    id
    title
    slug
    permalink
  }
}
    `;
export type ManageChallengePageCreateChallengeMutationFn = Apollo.MutationFunction<ManageChallengePageCreateChallengeMutation, ManageChallengePageCreateChallengeMutationVariables>;

/**
 * __useManageChallengePageCreateChallengeMutation__
 *
 * To run a mutation, you first call `useManageChallengePageCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageChallengePageCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageChallengePageCreateChallengeMutation, { data, loading, error }] = useManageChallengePageCreateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useManageChallengePageCreateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<ManageChallengePageCreateChallengeMutation, ManageChallengePageCreateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageChallengePageCreateChallengeMutation, ManageChallengePageCreateChallengeMutationVariables>(ManageChallengePageCreateChallengeDocument, options);
      }
export type ManageChallengePageCreateChallengeMutationHookResult = ReturnType<typeof useManageChallengePageCreateChallengeMutation>;
export type ManageChallengePageCreateChallengeMutationResult = Apollo.MutationResult<ManageChallengePageCreateChallengeMutation>;
export type ManageChallengePageCreateChallengeMutationOptions = Apollo.BaseMutationOptions<ManageChallengePageCreateChallengeMutation, ManageChallengePageCreateChallengeMutationVariables>;
export const ManageChallengePageUpdateChallengeDocument = gql`
    mutation manageChallengePageUpdateChallenge($challenge: ChallengeInput!) {
  updateChallenge(challenge: $challenge) {
    id
    index
    difficulty
    ...ChallengeInitialStateEditChallenge
  }
}
    ${ChallengeInitialStateEditChallengeFragmentDoc}`;
export type ManageChallengePageUpdateChallengeMutationFn = Apollo.MutationFunction<ManageChallengePageUpdateChallengeMutation, ManageChallengePageUpdateChallengeMutationVariables>;

/**
 * __useManageChallengePageUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useManageChallengePageUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageChallengePageUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageChallengePageUpdateChallengeMutation, { data, loading, error }] = useManageChallengePageUpdateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useManageChallengePageUpdateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<ManageChallengePageUpdateChallengeMutation, ManageChallengePageUpdateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageChallengePageUpdateChallengeMutation, ManageChallengePageUpdateChallengeMutationVariables>(ManageChallengePageUpdateChallengeDocument, options);
      }
export type ManageChallengePageUpdateChallengeMutationHookResult = ReturnType<typeof useManageChallengePageUpdateChallengeMutation>;
export type ManageChallengePageUpdateChallengeMutationResult = Apollo.MutationResult<ManageChallengePageUpdateChallengeMutation>;
export type ManageChallengePageUpdateChallengeMutationOptions = Apollo.BaseMutationOptions<ManageChallengePageUpdateChallengeMutation, ManageChallengePageUpdateChallengeMutationVariables>;
export const ManageChallengePageDeleteChallengeDocument = gql`
    mutation manageChallengePageDeleteChallenge($challengeID: String!) {
  deleteChallenge(challengeID: $challengeID)
}
    `;
export type ManageChallengePageDeleteChallengeMutationFn = Apollo.MutationFunction<ManageChallengePageDeleteChallengeMutation, ManageChallengePageDeleteChallengeMutationVariables>;

/**
 * __useManageChallengePageDeleteChallengeMutation__
 *
 * To run a mutation, you first call `useManageChallengePageDeleteChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageChallengePageDeleteChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageChallengePageDeleteChallengeMutation, { data, loading, error }] = useManageChallengePageDeleteChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useManageChallengePageDeleteChallengeMutation(baseOptions?: Apollo.MutationHookOptions<ManageChallengePageDeleteChallengeMutation, ManageChallengePageDeleteChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageChallengePageDeleteChallengeMutation, ManageChallengePageDeleteChallengeMutationVariables>(ManageChallengePageDeleteChallengeDocument, options);
      }
export type ManageChallengePageDeleteChallengeMutationHookResult = ReturnType<typeof useManageChallengePageDeleteChallengeMutation>;
export type ManageChallengePageDeleteChallengeMutationResult = Apollo.MutationResult<ManageChallengePageDeleteChallengeMutation>;
export type ManageChallengePageDeleteChallengeMutationOptions = Apollo.BaseMutationOptions<ManageChallengePageDeleteChallengeMutation, ManageChallengePageDeleteChallengeMutationVariables>;
export const GetChallengeInitialDataFromChallengeDocument = gql`
    query GetChallengeInitialDataFromChallenge($challengeID: String!) {
  challenge(challengeID: $challengeID) {
    ...ChallengeFormChallenge
  }
}
    ${ChallengeFormChallengeFragmentDoc}`;

/**
 * __useGetChallengeInitialDataFromChallengeQuery__
 *
 * To run a query within a React component, call `useGetChallengeInitialDataFromChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeInitialDataFromChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeInitialDataFromChallengeQuery({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeInitialDataFromChallengeQuery(baseOptions: Apollo.QueryHookOptions<GetChallengeInitialDataFromChallengeQuery, GetChallengeInitialDataFromChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeInitialDataFromChallengeQuery, GetChallengeInitialDataFromChallengeQueryVariables>(GetChallengeInitialDataFromChallengeDocument, options);
      }
export function useGetChallengeInitialDataFromChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeInitialDataFromChallengeQuery, GetChallengeInitialDataFromChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeInitialDataFromChallengeQuery, GetChallengeInitialDataFromChallengeQueryVariables>(GetChallengeInitialDataFromChallengeDocument, options);
        }
export type GetChallengeInitialDataFromChallengeQueryHookResult = ReturnType<typeof useGetChallengeInitialDataFromChallengeQuery>;
export type GetChallengeInitialDataFromChallengeLazyQueryHookResult = ReturnType<typeof useGetChallengeInitialDataFromChallengeLazyQuery>;
export type GetChallengeInitialDataFromChallengeQueryResult = Apollo.QueryResult<GetChallengeInitialDataFromChallengeQuery, GetChallengeInitialDataFromChallengeQueryVariables>;
export const GetChallengeInitialDataEditChallengeDocument = gql`
    query GetChallengeInitialDataEditChallenge($challengeID: String!) {
  challenge(challengeID: $challengeID) {
    ...ChallengeInitialStateEditChallenge
  }
}
    ${ChallengeInitialStateEditChallengeFragmentDoc}`;

/**
 * __useGetChallengeInitialDataEditChallengeQuery__
 *
 * To run a query within a React component, call `useGetChallengeInitialDataEditChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChallengeInitialDataEditChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChallengeInitialDataEditChallengeQuery({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useGetChallengeInitialDataEditChallengeQuery(baseOptions: Apollo.QueryHookOptions<GetChallengeInitialDataEditChallengeQuery, GetChallengeInitialDataEditChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChallengeInitialDataEditChallengeQuery, GetChallengeInitialDataEditChallengeQueryVariables>(GetChallengeInitialDataEditChallengeDocument, options);
      }
export function useGetChallengeInitialDataEditChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChallengeInitialDataEditChallengeQuery, GetChallengeInitialDataEditChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChallengeInitialDataEditChallengeQuery, GetChallengeInitialDataEditChallengeQueryVariables>(GetChallengeInitialDataEditChallengeDocument, options);
        }
export type GetChallengeInitialDataEditChallengeQueryHookResult = ReturnType<typeof useGetChallengeInitialDataEditChallengeQuery>;
export type GetChallengeInitialDataEditChallengeLazyQueryHookResult = ReturnType<typeof useGetChallengeInitialDataEditChallengeLazyQuery>;
export type GetChallengeInitialDataEditChallengeQueryResult = Apollo.QueryResult<GetChallengeInitialDataEditChallengeQuery, GetChallengeInitialDataEditChallengeQueryVariables>;
export const GetManageCloudAccountPageConfigDocument = gql`
    query getManageCloudAccountPageConfig($teamSlug: String!, $trackSlug: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  team(teamSlug: $teamSlug) {
    id
    features {
      aws_accounts
      azure_subscriptions
      gcp_projects
    }
  }
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    config {
      id
      ...ManageTrackHostResources
      ...ManageTrackCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    scripts {
      id
      host
      action
      contents
    }
  }
}
    ${ManageTrackHostResourcesFragmentDoc}
${ManageTrackCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;

/**
 * __useGetManageCloudAccountPageConfigQuery__
 *
 * To run a query within a React component, call `useGetManageCloudAccountPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageCloudAccountPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageCloudAccountPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useGetManageCloudAccountPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetManageCloudAccountPageConfigQuery, GetManageCloudAccountPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageCloudAccountPageConfigQuery, GetManageCloudAccountPageConfigQueryVariables>(GetManageCloudAccountPageConfigDocument, options);
      }
export function useGetManageCloudAccountPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageCloudAccountPageConfigQuery, GetManageCloudAccountPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageCloudAccountPageConfigQuery, GetManageCloudAccountPageConfigQueryVariables>(GetManageCloudAccountPageConfigDocument, options);
        }
export type GetManageCloudAccountPageConfigQueryHookResult = ReturnType<typeof useGetManageCloudAccountPageConfigQuery>;
export type GetManageCloudAccountPageConfigLazyQueryHookResult = ReturnType<typeof useGetManageCloudAccountPageConfigLazyQuery>;
export type GetManageCloudAccountPageConfigQueryResult = Apollo.QueryResult<GetManageCloudAccountPageConfigQuery, GetManageCloudAccountPageConfigQueryVariables>;
export const UpdateCloudAccountsDocument = gql`
    mutation updateCloudAccounts($configID: String!, $config: SandboxConfigInput!) {
  updateSandboxConfig(configID: $configID, config: $config) {
    id
  }
}
    `;
export type UpdateCloudAccountsMutationFn = Apollo.MutationFunction<UpdateCloudAccountsMutation, UpdateCloudAccountsMutationVariables>;

/**
 * __useUpdateCloudAccountsMutation__
 *
 * To run a mutation, you first call `useUpdateCloudAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCloudAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCloudAccountsMutation, { data, loading, error }] = useUpdateCloudAccountsMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateCloudAccountsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCloudAccountsMutation, UpdateCloudAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCloudAccountsMutation, UpdateCloudAccountsMutationVariables>(UpdateCloudAccountsDocument, options);
      }
export type UpdateCloudAccountsMutationHookResult = ReturnType<typeof useUpdateCloudAccountsMutation>;
export type UpdateCloudAccountsMutationResult = Apollo.MutationResult<UpdateCloudAccountsMutation>;
export type UpdateCloudAccountsMutationOptions = Apollo.BaseMutationOptions<UpdateCloudAccountsMutation, UpdateCloudAccountsMutationVariables>;
export const GetManageHostPageConfigDocument = gql`
    query getManageHostPageConfig($teamSlug: String!, $trackSlug: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  team(teamSlug: $teamSlug) {
    id
    features {
      containers
      virtual_machines
      saas
      custom_machine_type
    }
  }
  trackConfigPresets {
    ...CreateTrackSandboxPresets
  }
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    config {
      id
      ...ManageTrackHostResources
      ...ManageTrackCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    scripts {
      id
      host
      action
      contents
    }
  }
}
    ${CreateTrackSandboxPresetsFragmentDoc}
${ManageTrackHostResourcesFragmentDoc}
${ManageTrackCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;

/**
 * __useGetManageHostPageConfigQuery__
 *
 * To run a query within a React component, call `useGetManageHostPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageHostPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageHostPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useGetManageHostPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>(GetManageHostPageConfigDocument, options);
      }
export function useGetManageHostPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>(GetManageHostPageConfigDocument, options);
        }
export type GetManageHostPageConfigQueryHookResult = ReturnType<typeof useGetManageHostPageConfigQuery>;
export type GetManageHostPageConfigLazyQueryHookResult = ReturnType<typeof useGetManageHostPageConfigLazyQuery>;
export type GetManageHostPageConfigQueryResult = Apollo.QueryResult<GetManageHostPageConfigQuery, GetManageHostPageConfigQueryVariables>;
export const UpdateHostsDocument = gql`
    mutation updateHosts($configID: String!, $config: SandboxConfigInput!) {
  updateSandboxConfig(configID: $configID, config: $config) {
    id
  }
}
    `;
export type UpdateHostsMutationFn = Apollo.MutationFunction<UpdateHostsMutation, UpdateHostsMutationVariables>;

/**
 * __useUpdateHostsMutation__
 *
 * To run a mutation, you first call `useUpdateHostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHostsMutation, { data, loading, error }] = useUpdateHostsMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateHostsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHostsMutation, UpdateHostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHostsMutation, UpdateHostsMutationVariables>(UpdateHostsDocument, options);
      }
export type UpdateHostsMutationHookResult = ReturnType<typeof useUpdateHostsMutation>;
export type UpdateHostsMutationResult = Apollo.MutationResult<UpdateHostsMutation>;
export type UpdateHostsMutationOptions = Apollo.BaseMutationOptions<UpdateHostsMutation, UpdateHostsMutationVariables>;
export const ManageHostPageRenameHostDocument = gql`
    mutation manageHostPageRenameHost($configID: String!, $hostName: String!, $newName: String!) {
  renameSandboxConfigHost(
    configID: $configID
    hostName: $hostName
    newName: $newName
  ) {
    id
  }
}
    `;
export type ManageHostPageRenameHostMutationFn = Apollo.MutationFunction<ManageHostPageRenameHostMutation, ManageHostPageRenameHostMutationVariables>;

/**
 * __useManageHostPageRenameHostMutation__
 *
 * To run a mutation, you first call `useManageHostPageRenameHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageHostPageRenameHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageHostPageRenameHostMutation, { data, loading, error }] = useManageHostPageRenameHostMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      hostName: // value for 'hostName'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useManageHostPageRenameHostMutation(baseOptions?: Apollo.MutationHookOptions<ManageHostPageRenameHostMutation, ManageHostPageRenameHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageHostPageRenameHostMutation, ManageHostPageRenameHostMutationVariables>(ManageHostPageRenameHostDocument, options);
      }
export type ManageHostPageRenameHostMutationHookResult = ReturnType<typeof useManageHostPageRenameHostMutation>;
export type ManageHostPageRenameHostMutationResult = Apollo.MutationResult<ManageHostPageRenameHostMutation>;
export type ManageHostPageRenameHostMutationOptions = Apollo.BaseMutationOptions<ManageHostPageRenameHostMutation, ManageHostPageRenameHostMutationVariables>;
export const GetSandboxConfigDocument = gql`
    query getSandboxConfig($teamSlug: String!, $trackSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  userInTeam(teamSlug: $teamSlug)
  team(teamSlug: $teamSlug) {
    id
    features {
      containers
      virtual_machines
      gcp_projects
      aws_accounts
      azure_subscriptions
      saas
      shared_hotstart_pools
    }
  }
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    sandboxConfig {
      ...ManageTrackSandboxConfigVersion
    }
    config {
      id
      containers {
        ...ContainerFormContainer
      }
      virtualmachines {
        ...VirtualMachineFormVirtualMachine
      }
      virtualbrowsers {
        ...VirtualBrowserFormVirtualBrowser
      }
      gcp_projects {
        ...GoogleCloudFormGcpProject
      }
      aws_accounts {
        ...AwsAccountFormAwsAccount
      }
      azure_subscriptions {
        ...AzureSubscriptionFormAzureSubscription
      }
      secrets {
        ...SandboxConfigSecret
      }
    }
    scripts {
      ...TrackScriptData
    }
  }
  teamSecrets(teamSlug: $teamSlug) {
    name
    description
  }
  sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
    ...ManageTrackSandboxConfigVersion
  }
}
    ${ManageTrackSandboxConfigVersionFragmentDoc}
${ContainerFormContainerFragmentDoc}
${VirtualMachineFormVirtualMachineFragmentDoc}
${VirtualBrowserFormVirtualBrowserFragmentDoc}
${GoogleCloudFormGcpProjectFragmentDoc}
${AwsAccountFormAwsAccountFragmentDoc}
${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
${SandboxConfigSecretFragmentDoc}
${TrackScriptDataFragmentDoc}`;

/**
 * __useGetSandboxConfigQuery__
 *
 * To run a query within a React component, call `useGetSandboxConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSandboxConfigQuery(baseOptions: Apollo.QueryHookOptions<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>(GetSandboxConfigDocument, options);
      }
export function useGetSandboxConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>(GetSandboxConfigDocument, options);
        }
export type GetSandboxConfigQueryHookResult = ReturnType<typeof useGetSandboxConfigQuery>;
export type GetSandboxConfigLazyQueryHookResult = ReturnType<typeof useGetSandboxConfigLazyQuery>;
export type GetSandboxConfigQueryResult = Apollo.QueryResult<GetSandboxConfigQuery, GetSandboxConfigQueryVariables>;
export const GetSandboxPagePresetResourcesDocument = gql`
    query getSandboxPagePresetResources($configVersionID: String!) {
  sandboxConfigVersion(configVersionID: $configVersionID) {
    resources {
      ...ManageHostResources
      ...ManageCloudAccsResources
      secrets {
        ...SandboxConfigSecret
      }
    }
    scripts {
      action
      contents
      host
    }
  }
}
    ${ManageHostResourcesFragmentDoc}
${ManageCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;

/**
 * __useGetSandboxPagePresetResourcesQuery__
 *
 * To run a query within a React component, call `useGetSandboxPagePresetResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxPagePresetResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxPagePresetResourcesQuery({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useGetSandboxPagePresetResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>(GetSandboxPagePresetResourcesDocument, options);
      }
export function useGetSandboxPagePresetResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>(GetSandboxPagePresetResourcesDocument, options);
        }
export type GetSandboxPagePresetResourcesQueryHookResult = ReturnType<typeof useGetSandboxPagePresetResourcesQuery>;
export type GetSandboxPagePresetResourcesLazyQueryHookResult = ReturnType<typeof useGetSandboxPagePresetResourcesLazyQuery>;
export type GetSandboxPagePresetResourcesQueryResult = Apollo.QueryResult<GetSandboxPagePresetResourcesQuery, GetSandboxPagePresetResourcesQueryVariables>;
export const SandboxConfigPageDeleteHostDocument = gql`
    mutation sandboxConfigPageDeleteHost($configID: String!, $hostName: String!) {
  deleteSandboxConfigHost(configID: $configID, hostName: $hostName) {
    id
  }
}
    `;
export type SandboxConfigPageDeleteHostMutationFn = Apollo.MutationFunction<SandboxConfigPageDeleteHostMutation, SandboxConfigPageDeleteHostMutationVariables>;

/**
 * __useSandboxConfigPageDeleteHostMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageDeleteHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageDeleteHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageDeleteHostMutation, { data, loading, error }] = useSandboxConfigPageDeleteHostMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      hostName: // value for 'hostName'
 *   },
 * });
 */
export function useSandboxConfigPageDeleteHostMutation(baseOptions?: Apollo.MutationHookOptions<SandboxConfigPageDeleteHostMutation, SandboxConfigPageDeleteHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxConfigPageDeleteHostMutation, SandboxConfigPageDeleteHostMutationVariables>(SandboxConfigPageDeleteHostDocument, options);
      }
export type SandboxConfigPageDeleteHostMutationHookResult = ReturnType<typeof useSandboxConfigPageDeleteHostMutation>;
export type SandboxConfigPageDeleteHostMutationResult = Apollo.MutationResult<SandboxConfigPageDeleteHostMutation>;
export type SandboxConfigPageDeleteHostMutationOptions = Apollo.BaseMutationOptions<SandboxConfigPageDeleteHostMutation, SandboxConfigPageDeleteHostMutationVariables>;
export const SandboxConfigPageRenameHostDocument = gql`
    mutation sandboxConfigPageRenameHost($configID: String!, $hostName: String!, $newName: String!) {
  renameSandboxConfigHost(
    configID: $configID
    hostName: $hostName
    newName: $newName
  ) {
    id
  }
}
    `;
export type SandboxConfigPageRenameHostMutationFn = Apollo.MutationFunction<SandboxConfigPageRenameHostMutation, SandboxConfigPageRenameHostMutationVariables>;

/**
 * __useSandboxConfigPageRenameHostMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageRenameHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageRenameHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageRenameHostMutation, { data, loading, error }] = useSandboxConfigPageRenameHostMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      hostName: // value for 'hostName'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useSandboxConfigPageRenameHostMutation(baseOptions?: Apollo.MutationHookOptions<SandboxConfigPageRenameHostMutation, SandboxConfigPageRenameHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxConfigPageRenameHostMutation, SandboxConfigPageRenameHostMutationVariables>(SandboxConfigPageRenameHostDocument, options);
      }
export type SandboxConfigPageRenameHostMutationHookResult = ReturnType<typeof useSandboxConfigPageRenameHostMutation>;
export type SandboxConfigPageRenameHostMutationResult = Apollo.MutationResult<SandboxConfigPageRenameHostMutation>;
export type SandboxConfigPageRenameHostMutationOptions = Apollo.BaseMutationOptions<SandboxConfigPageRenameHostMutation, SandboxConfigPageRenameHostMutationVariables>;
export const SandboxConfigPageSetPresetDocument = gql`
    mutation sandboxConfigPageSetPreset($trackID: String!, $configVersionID: String) {
  setTrackSandboxConfigVersion(
    trackID: $trackID
    configVersionID: $configVersionID
  )
}
    `;
export type SandboxConfigPageSetPresetMutationFn = Apollo.MutationFunction<SandboxConfigPageSetPresetMutation, SandboxConfigPageSetPresetMutationVariables>;

/**
 * __useSandboxConfigPageSetPresetMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageSetPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageSetPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageSetPresetMutation, { data, loading, error }] = useSandboxConfigPageSetPresetMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useSandboxConfigPageSetPresetMutation(baseOptions?: Apollo.MutationHookOptions<SandboxConfigPageSetPresetMutation, SandboxConfigPageSetPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxConfigPageSetPresetMutation, SandboxConfigPageSetPresetMutationVariables>(SandboxConfigPageSetPresetDocument, options);
      }
export type SandboxConfigPageSetPresetMutationHookResult = ReturnType<typeof useSandboxConfigPageSetPresetMutation>;
export type SandboxConfigPageSetPresetMutationResult = Apollo.MutationResult<SandboxConfigPageSetPresetMutation>;
export type SandboxConfigPageSetPresetMutationOptions = Apollo.BaseMutationOptions<SandboxConfigPageSetPresetMutation, SandboxConfigPageSetPresetMutationVariables>;
export const SandboxConfigPageUpdateSandboxConfigDocument = gql`
    mutation sandboxConfigPageUpdateSandboxConfig($configID: String!, $config: SandboxConfigInput!) {
  updateSandboxConfig(configID: $configID, config: $config) {
    id
  }
}
    `;
export type SandboxConfigPageUpdateSandboxConfigMutationFn = Apollo.MutationFunction<SandboxConfigPageUpdateSandboxConfigMutation, SandboxConfigPageUpdateSandboxConfigMutationVariables>;

/**
 * __useSandboxConfigPageUpdateSandboxConfigMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageUpdateSandboxConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageUpdateSandboxConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageUpdateSandboxConfigMutation, { data, loading, error }] = useSandboxConfigPageUpdateSandboxConfigMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useSandboxConfigPageUpdateSandboxConfigMutation(baseOptions?: Apollo.MutationHookOptions<SandboxConfigPageUpdateSandboxConfigMutation, SandboxConfigPageUpdateSandboxConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxConfigPageUpdateSandboxConfigMutation, SandboxConfigPageUpdateSandboxConfigMutationVariables>(SandboxConfigPageUpdateSandboxConfigDocument, options);
      }
export type SandboxConfigPageUpdateSandboxConfigMutationHookResult = ReturnType<typeof useSandboxConfigPageUpdateSandboxConfigMutation>;
export type SandboxConfigPageUpdateSandboxConfigMutationResult = Apollo.MutationResult<SandboxConfigPageUpdateSandboxConfigMutation>;
export type SandboxConfigPageUpdateSandboxConfigMutationOptions = Apollo.BaseMutationOptions<SandboxConfigPageUpdateSandboxConfigMutation, SandboxConfigPageUpdateSandboxConfigMutationVariables>;
export const SandboxConfigPageSaveTrackScriptDocument = gql`
    mutation sandboxConfigPageSaveTrackScript($script: TrackScriptInput!, $base64Encoded: Boolean!) {
  saveTrackScript(script: $script, base64Encoded: $base64Encoded) {
    ...TrackScriptData
  }
}
    ${TrackScriptDataFragmentDoc}`;
export type SandboxConfigPageSaveTrackScriptMutationFn = Apollo.MutationFunction<SandboxConfigPageSaveTrackScriptMutation, SandboxConfigPageSaveTrackScriptMutationVariables>;

/**
 * __useSandboxConfigPageSaveTrackScriptMutation__
 *
 * To run a mutation, you first call `useSandboxConfigPageSaveTrackScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxConfigPageSaveTrackScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxConfigPageSaveTrackScriptMutation, { data, loading, error }] = useSandboxConfigPageSaveTrackScriptMutation({
 *   variables: {
 *      script: // value for 'script'
 *      base64Encoded: // value for 'base64Encoded'
 *   },
 * });
 */
export function useSandboxConfigPageSaveTrackScriptMutation(baseOptions?: Apollo.MutationHookOptions<SandboxConfigPageSaveTrackScriptMutation, SandboxConfigPageSaveTrackScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxConfigPageSaveTrackScriptMutation, SandboxConfigPageSaveTrackScriptMutationVariables>(SandboxConfigPageSaveTrackScriptDocument, options);
      }
export type SandboxConfigPageSaveTrackScriptMutationHookResult = ReturnType<typeof useSandboxConfigPageSaveTrackScriptMutation>;
export type SandboxConfigPageSaveTrackScriptMutationResult = Apollo.MutationResult<SandboxConfigPageSaveTrackScriptMutation>;
export type SandboxConfigPageSaveTrackScriptMutationOptions = Apollo.BaseMutationOptions<SandboxConfigPageSaveTrackScriptMutation, SandboxConfigPageSaveTrackScriptMutationVariables>;
export const StudyRoomLinkRedirectDocument = gql`
    query StudyRoomLinkRedirect($inviteID: String!) {
  trackInvite(inviteID: $inviteID) {
    id
    team {
      id
      slug
    }
  }
}
    `;

/**
 * __useStudyRoomLinkRedirectQuery__
 *
 * To run a query within a React component, call `useStudyRoomLinkRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyRoomLinkRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyRoomLinkRedirectQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useStudyRoomLinkRedirectQuery(baseOptions: Apollo.QueryHookOptions<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>(StudyRoomLinkRedirectDocument, options);
      }
export function useStudyRoomLinkRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>(StudyRoomLinkRedirectDocument, options);
        }
export type StudyRoomLinkRedirectQueryHookResult = ReturnType<typeof useStudyRoomLinkRedirectQuery>;
export type StudyRoomLinkRedirectLazyQueryHookResult = ReturnType<typeof useStudyRoomLinkRedirectLazyQuery>;
export type StudyRoomLinkRedirectQueryResult = Apollo.QueryResult<StudyRoomLinkRedirectQuery, StudyRoomLinkRedirectQueryVariables>;
export const StudyRoomDocument = gql`
    query StudyRoom {
  me {
    claims {
      ...StudyRoomClaim
    }
  }
}
    ${StudyRoomClaimFragmentDoc}`;

/**
 * __useStudyRoomQuery__
 *
 * To run a query within a React component, call `useStudyRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudyRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudyRoomQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudyRoomQuery(baseOptions?: Apollo.QueryHookOptions<StudyRoomQuery, StudyRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudyRoomQuery, StudyRoomQueryVariables>(StudyRoomDocument, options);
      }
export function useStudyRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudyRoomQuery, StudyRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudyRoomQuery, StudyRoomQueryVariables>(StudyRoomDocument, options);
        }
export type StudyRoomQueryHookResult = ReturnType<typeof useStudyRoomQuery>;
export type StudyRoomLazyQueryHookResult = ReturnType<typeof useStudyRoomLazyQuery>;
export type StudyRoomQueryResult = Apollo.QueryResult<StudyRoomQuery, StudyRoomQueryVariables>;
export const TeamLoginDocument = gql`
    query TeamLogin($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    ssoConnection {
      name
      organizationID
    }
  }
}
    `;

/**
 * __useTeamLoginQuery__
 *
 * To run a query within a React component, call `useTeamLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamLoginQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTeamLoginQuery(baseOptions: Apollo.QueryHookOptions<TeamLoginQuery, TeamLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamLoginQuery, TeamLoginQueryVariables>(TeamLoginDocument, options);
      }
export function useTeamLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamLoginQuery, TeamLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamLoginQuery, TeamLoginQueryVariables>(TeamLoginDocument, options);
        }
export type TeamLoginQueryHookResult = ReturnType<typeof useTeamLoginQuery>;
export type TeamLoginLazyQueryHookResult = ReturnType<typeof useTeamLoginLazyQuery>;
export type TeamLoginQueryResult = Apollo.QueryResult<TeamLoginQuery, TeamLoginQueryVariables>;
export const GetTemplateTracksDocument = gql`
    query GetTemplateTracks($teamSlug: String!) {
  tracks(teamSlug: $teamSlug) {
    id
    version
    slug
    icon
    title
    teaser
    description
    level
    trackTags {
      id
      value
    }
    idle_timeout
    timelimit
    status
    developers {
      profile {
        email
      }
    }
    maintenance
    show_timer
    skipping_enabled
    challenges {
      id
      type
      slug
      title
      teaser
      notes {
        type
        contents
        url
      }
      difficulty
      assignment
      timelimit
      tabs {
        cmd
        type
        title
        hostname
        path
        port
        url
        new_window
      }
      scripts {
        host
        action
        contents
      }
      answers
      solution
    }
    sandboxConfig {
      config {
        slug
      }
    }
    config {
      version
      containers {
        name
        image
        entrypoint
        cmd
        shell
        ports
        environment {
          key
          value
        }
        memory
      }
      virtualmachines {
        name
        image
        machine_type
        allow_external_ingress
        shell
        environment {
          key
          value
        }
        memory
        cpus
      }
      virtualbrowsers {
        name
        url
      }
      gcp_projects {
        name
        services
      }
      aws_accounts {
        name
        iam_policy
        managed_policies
        scp_policy
      }
      azure_subscriptions {
        name
        user_only
        roles
      }
    }
    scripts {
      id
      action
      contents
      host
    }
  }
}
    `;

/**
 * __useGetTemplateTracksQuery__
 *
 * To run a query within a React component, call `useGetTemplateTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateTracksQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTemplateTracksQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>(GetTemplateTracksDocument, options);
      }
export function useGetTemplateTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>(GetTemplateTracksDocument, options);
        }
export type GetTemplateTracksQueryHookResult = ReturnType<typeof useGetTemplateTracksQuery>;
export type GetTemplateTracksLazyQueryHookResult = ReturnType<typeof useGetTemplateTracksLazyQuery>;
export type GetTemplateTracksQueryResult = Apollo.QueryResult<GetTemplateTracksQuery, GetTemplateTracksQueryVariables>;
export const TrackStatisticsDocument = gql`
    query TrackStatistics($teamSlug: String, $trackSlug: String, $start: Time, $end: Time, $filterDevelopers: Boolean) {
  statistics(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    start: $start
    end: $end
    filterDevelopers: $filterDevelopers
  ) {
    track {
      ...TotalTrackStartsTrackStatistics
      track_series {
        ...DailyTrackStartsTrackSeries
      }
      challenge_series {
        ...DailyTrackStartsChallengeSeries
      }
      happiness {
        ...UserHappinessHappinessCount
      }
      challenges {
        ...TotalChallengeStartsChallengeStatistics
        ...ChallengeAttemptsChallengeStatistics
        ...ChallengeDurationChallengeStatistics
      }
    }
  }
}
    ${TotalTrackStartsTrackStatisticsFragmentDoc}
${DailyTrackStartsTrackSeriesFragmentDoc}
${DailyTrackStartsChallengeSeriesFragmentDoc}
${UserHappinessHappinessCountFragmentDoc}
${TotalChallengeStartsChallengeStatisticsFragmentDoc}
${ChallengeAttemptsChallengeStatisticsFragmentDoc}
${ChallengeDurationChallengeStatisticsFragmentDoc}`;

/**
 * __useTrackStatisticsQuery__
 *
 * To run a query within a React component, call `useTrackStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackStatisticsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      filterDevelopers: // value for 'filterDevelopers'
 *   },
 * });
 */
export function useTrackStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<TrackStatisticsQuery, TrackStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackStatisticsQuery, TrackStatisticsQueryVariables>(TrackStatisticsDocument, options);
      }
export function useTrackStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackStatisticsQuery, TrackStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackStatisticsQuery, TrackStatisticsQueryVariables>(TrackStatisticsDocument, options);
        }
export type TrackStatisticsQueryHookResult = ReturnType<typeof useTrackStatisticsQuery>;
export type TrackStatisticsLazyQueryHookResult = ReturnType<typeof useTrackStatisticsLazyQuery>;
export type TrackStatisticsQueryResult = Apollo.QueryResult<TrackStatisticsQuery, TrackStatisticsQueryVariables>;
export const GetUpdateChallengeNotePageConfigDocument = gql`
    query getUpdateChallengeNotePageConfig($teamSlug: String!, $trackSlug: String!, $challengeID: String!, $noteID: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
  }
  challenge(challengeID: $challengeID) {
    id
  }
  note(noteID: $noteID) {
    id
    index
    ...ChallengeNoteFormNote
  }
}
    ${ChallengeNoteFormNoteFragmentDoc}`;

/**
 * __useGetUpdateChallengeNotePageConfigQuery__
 *
 * To run a query within a React component, call `useGetUpdateChallengeNotePageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateChallengeNotePageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateChallengeNotePageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeID: // value for 'challengeID'
 *      noteID: // value for 'noteID'
 *   },
 * });
 */
export function useGetUpdateChallengeNotePageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetUpdateChallengeNotePageConfigQuery, GetUpdateChallengeNotePageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpdateChallengeNotePageConfigQuery, GetUpdateChallengeNotePageConfigQueryVariables>(GetUpdateChallengeNotePageConfigDocument, options);
      }
export function useGetUpdateChallengeNotePageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpdateChallengeNotePageConfigQuery, GetUpdateChallengeNotePageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpdateChallengeNotePageConfigQuery, GetUpdateChallengeNotePageConfigQueryVariables>(GetUpdateChallengeNotePageConfigDocument, options);
        }
export type GetUpdateChallengeNotePageConfigQueryHookResult = ReturnType<typeof useGetUpdateChallengeNotePageConfigQuery>;
export type GetUpdateChallengeNotePageConfigLazyQueryHookResult = ReturnType<typeof useGetUpdateChallengeNotePageConfigLazyQuery>;
export type GetUpdateChallengeNotePageConfigQueryResult = Apollo.QueryResult<GetUpdateChallengeNotePageConfigQuery, GetUpdateChallengeNotePageConfigQueryVariables>;
export const UpdateChallengeNotePageUpdateChallengeNoteDocument = gql`
    mutation updateChallengeNotePageUpdateChallengeNote($note: ChallengeNoteInput!) {
  updateChallengeNote(note: $note) {
    id
    index
    ...ChallengeNoteFormNote
  }
}
    ${ChallengeNoteFormNoteFragmentDoc}`;
export type UpdateChallengeNotePageUpdateChallengeNoteMutationFn = Apollo.MutationFunction<UpdateChallengeNotePageUpdateChallengeNoteMutation, UpdateChallengeNotePageUpdateChallengeNoteMutationVariables>;

/**
 * __useUpdateChallengeNotePageUpdateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeNotePageUpdateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeNotePageUpdateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeNotePageUpdateChallengeNoteMutation, { data, loading, error }] = useUpdateChallengeNotePageUpdateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateChallengeNotePageUpdateChallengeNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeNotePageUpdateChallengeNoteMutation, UpdateChallengeNotePageUpdateChallengeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeNotePageUpdateChallengeNoteMutation, UpdateChallengeNotePageUpdateChallengeNoteMutationVariables>(UpdateChallengeNotePageUpdateChallengeNoteDocument, options);
      }
export type UpdateChallengeNotePageUpdateChallengeNoteMutationHookResult = ReturnType<typeof useUpdateChallengeNotePageUpdateChallengeNoteMutation>;
export type UpdateChallengeNotePageUpdateChallengeNoteMutationResult = Apollo.MutationResult<UpdateChallengeNotePageUpdateChallengeNoteMutation>;
export type UpdateChallengeNotePageUpdateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeNotePageUpdateChallengeNoteMutation, UpdateChallengeNotePageUpdateChallengeNoteMutationVariables>;
export const GetUpdateChallengeTabPageConfigDocument = gql`
    query getUpdateChallengeTabPageConfig($teamSlug: String!, $trackSlug: String!, $challengeID: String!, $tabID: String!) {
  userIsTrackDeveloper(teamSlug: $teamSlug, trackSlug: $trackSlug)
  challenge(challengeID: $challengeID) {
    id
  }
  tab(tabID: $tabID) {
    ...UpdateChallengeTabChallengeTab
  }
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    sandboxConfig {
      resources {
        containers {
          id
          name
        }
        virtualmachines {
          id
          name
        }
        virtualbrowsers {
          id
          name
        }
      }
    }
    config {
      id
      containers {
        id
        name
        image
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
  }
  team(teamSlug: $teamSlug) {
    id
    features {
      saas
    }
  }
}
    ${UpdateChallengeTabChallengeTabFragmentDoc}`;

/**
 * __useGetUpdateChallengeTabPageConfigQuery__
 *
 * To run a query within a React component, call `useGetUpdateChallengeTabPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateChallengeTabPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateChallengeTabPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeID: // value for 'challengeID'
 *      tabID: // value for 'tabID'
 *   },
 * });
 */
export function useGetUpdateChallengeTabPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetUpdateChallengeTabPageConfigQuery, GetUpdateChallengeTabPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpdateChallengeTabPageConfigQuery, GetUpdateChallengeTabPageConfigQueryVariables>(GetUpdateChallengeTabPageConfigDocument, options);
      }
export function useGetUpdateChallengeTabPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpdateChallengeTabPageConfigQuery, GetUpdateChallengeTabPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpdateChallengeTabPageConfigQuery, GetUpdateChallengeTabPageConfigQueryVariables>(GetUpdateChallengeTabPageConfigDocument, options);
        }
export type GetUpdateChallengeTabPageConfigQueryHookResult = ReturnType<typeof useGetUpdateChallengeTabPageConfigQuery>;
export type GetUpdateChallengeTabPageConfigLazyQueryHookResult = ReturnType<typeof useGetUpdateChallengeTabPageConfigLazyQuery>;
export type GetUpdateChallengeTabPageConfigQueryResult = Apollo.QueryResult<GetUpdateChallengeTabPageConfigQuery, GetUpdateChallengeTabPageConfigQueryVariables>;
export const UpdateChallengeTabPageUpdateChallengeTabDocument = gql`
    mutation updateChallengeTabPageUpdateChallengeTab($tab: ChallengeTabInput!) {
  updateChallengeTab(tab: $tab) {
    ...UpdateChallengeTabChallengeTab
  }
}
    ${UpdateChallengeTabChallengeTabFragmentDoc}`;
export type UpdateChallengeTabPageUpdateChallengeTabMutationFn = Apollo.MutationFunction<UpdateChallengeTabPageUpdateChallengeTabMutation, UpdateChallengeTabPageUpdateChallengeTabMutationVariables>;

/**
 * __useUpdateChallengeTabPageUpdateChallengeTabMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTabPageUpdateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTabPageUpdateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTabPageUpdateChallengeTabMutation, { data, loading, error }] = useUpdateChallengeTabPageUpdateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useUpdateChallengeTabPageUpdateChallengeTabMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeTabPageUpdateChallengeTabMutation, UpdateChallengeTabPageUpdateChallengeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeTabPageUpdateChallengeTabMutation, UpdateChallengeTabPageUpdateChallengeTabMutationVariables>(UpdateChallengeTabPageUpdateChallengeTabDocument, options);
      }
export type UpdateChallengeTabPageUpdateChallengeTabMutationHookResult = ReturnType<typeof useUpdateChallengeTabPageUpdateChallengeTabMutation>;
export type UpdateChallengeTabPageUpdateChallengeTabMutationResult = Apollo.MutationResult<UpdateChallengeTabPageUpdateChallengeTabMutation>;
export type UpdateChallengeTabPageUpdateChallengeTabMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeTabPageUpdateChallengeTabMutation, UpdateChallengeTabPageUpdateChallengeTabMutationVariables>;
export const UpdateTrackPageUpdateTrackDocument = gql`
    mutation updateTrackPageUpdateTrack($track: TrackInput!) {
  updateTrack(track: $track) {
    id
    slug
  }
}
    `;
export type UpdateTrackPageUpdateTrackMutationFn = Apollo.MutationFunction<UpdateTrackPageUpdateTrackMutation, UpdateTrackPageUpdateTrackMutationVariables>;

/**
 * __useUpdateTrackPageUpdateTrackMutation__
 *
 * To run a mutation, you first call `useUpdateTrackPageUpdateTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackPageUpdateTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackPageUpdateTrackMutation, { data, loading, error }] = useUpdateTrackPageUpdateTrackMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackPageUpdateTrackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackPageUpdateTrackMutation, UpdateTrackPageUpdateTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackPageUpdateTrackMutation, UpdateTrackPageUpdateTrackMutationVariables>(UpdateTrackPageUpdateTrackDocument, options);
      }
export type UpdateTrackPageUpdateTrackMutationHookResult = ReturnType<typeof useUpdateTrackPageUpdateTrackMutation>;
export type UpdateTrackPageUpdateTrackMutationResult = Apollo.MutationResult<UpdateTrackPageUpdateTrackMutation>;
export type UpdateTrackPageUpdateTrackMutationOptions = Apollo.BaseMutationOptions<UpdateTrackPageUpdateTrackMutation, UpdateTrackPageUpdateTrackMutationVariables>;
export const TrackReviewsDocument = gql`
    query trackReviews($teamSlug: String!, $trackSlug: String!) {
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    trackReviews {
      nodes {
        id
        score
        created_at
        content
      }
    }
    statistics(start: "1970-01-01T00:00:00+00:00", end: "2970-01-01T00:00:00+00:00") {
      happiness {
        score
        count
      }
    }
  }
}
    `;

/**
 * __useTrackReviewsQuery__
 *
 * To run a query within a React component, call `useTrackReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackReviewsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useTrackReviewsQuery(baseOptions: Apollo.QueryHookOptions<TrackReviewsQuery, TrackReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackReviewsQuery, TrackReviewsQueryVariables>(TrackReviewsDocument, options);
      }
export function useTrackReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackReviewsQuery, TrackReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackReviewsQuery, TrackReviewsQueryVariables>(TrackReviewsDocument, options);
        }
export type TrackReviewsQueryHookResult = ReturnType<typeof useTrackReviewsQuery>;
export type TrackReviewsLazyQueryHookResult = ReturnType<typeof useTrackReviewsLazyQuery>;
export type TrackReviewsQueryResult = Apollo.QueryResult<TrackReviewsQuery, TrackReviewsQueryVariables>;
export const DeleteTrackButtonDocument = gql`
    mutation DeleteTrackButton($trackID: String!) {
  deleteTrack(trackID: $trackID)
}
    `;
export type DeleteTrackButtonMutationFn = Apollo.MutationFunction<DeleteTrackButtonMutation, DeleteTrackButtonMutationVariables>;

/**
 * __useDeleteTrackButtonMutation__
 *
 * To run a mutation, you first call `useDeleteTrackButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackButtonMutation, { data, loading, error }] = useDeleteTrackButtonMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useDeleteTrackButtonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrackButtonMutation, DeleteTrackButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrackButtonMutation, DeleteTrackButtonMutationVariables>(DeleteTrackButtonDocument, options);
      }
export type DeleteTrackButtonMutationHookResult = ReturnType<typeof useDeleteTrackButtonMutation>;
export type DeleteTrackButtonMutationResult = Apollo.MutationResult<DeleteTrackButtonMutation>;
export type DeleteTrackButtonMutationOptions = Apollo.BaseMutationOptions<DeleteTrackButtonMutation, DeleteTrackButtonMutationVariables>;
export const CheckUrlEmbeddableDocument = gql`
    query CheckURLEmbeddable($url: String) {
  isURLEmbeddable(url: $url)
}
    `;

/**
 * __useCheckUrlEmbeddableQuery__
 *
 * To run a query within a React component, call `useCheckUrlEmbeddableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUrlEmbeddableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUrlEmbeddableQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCheckUrlEmbeddableQuery(baseOptions?: Apollo.QueryHookOptions<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>(CheckUrlEmbeddableDocument, options);
      }
export function useCheckUrlEmbeddableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>(CheckUrlEmbeddableDocument, options);
        }
export type CheckUrlEmbeddableQueryHookResult = ReturnType<typeof useCheckUrlEmbeddableQuery>;
export type CheckUrlEmbeddableLazyQueryHookResult = ReturnType<typeof useCheckUrlEmbeddableLazyQuery>;
export type CheckUrlEmbeddableQueryResult = Apollo.QueryResult<CheckUrlEmbeddableQuery, CheckUrlEmbeddableQueryVariables>;
export const UserActivityLogEventsDocument = gql`
    query UserActivityLogEvents($claimID: String!) {
  trackInviteClaim(claimID: $claimID) {
    events {
      time
      message
      participantID
      track {
        id
        slug
      }
      challenge {
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useUserActivityLogEventsQuery__
 *
 * To run a query within a React component, call `useUserActivityLogEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserActivityLogEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserActivityLogEventsQuery({
 *   variables: {
 *      claimID: // value for 'claimID'
 *   },
 * });
 */
export function useUserActivityLogEventsQuery(baseOptions: Apollo.QueryHookOptions<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>(UserActivityLogEventsDocument, options);
      }
export function useUserActivityLogEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>(UserActivityLogEventsDocument, options);
        }
export type UserActivityLogEventsQueryHookResult = ReturnType<typeof useUserActivityLogEventsQuery>;
export type UserActivityLogEventsLazyQueryHookResult = ReturnType<typeof useUserActivityLogEventsLazyQuery>;
export type UserActivityLogEventsQueryResult = Apollo.QueryResult<UserActivityLogEventsQuery, UserActivityLogEventsQueryVariables>;
export const AddTrackToArcadeDocument = gql`
    mutation AddTrackToArcade($trackID: String!) {
  addTrackToArcade(trackID: $trackID)
}
    `;
export type AddTrackToArcadeMutationFn = Apollo.MutationFunction<AddTrackToArcadeMutation, AddTrackToArcadeMutationVariables>;

/**
 * __useAddTrackToArcadeMutation__
 *
 * To run a mutation, you first call `useAddTrackToArcadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTrackToArcadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTrackToArcadeMutation, { data, loading, error }] = useAddTrackToArcadeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useAddTrackToArcadeMutation(baseOptions?: Apollo.MutationHookOptions<AddTrackToArcadeMutation, AddTrackToArcadeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTrackToArcadeMutation, AddTrackToArcadeMutationVariables>(AddTrackToArcadeDocument, options);
      }
export type AddTrackToArcadeMutationHookResult = ReturnType<typeof useAddTrackToArcadeMutation>;
export type AddTrackToArcadeMutationResult = Apollo.MutationResult<AddTrackToArcadeMutation>;
export type AddTrackToArcadeMutationOptions = Apollo.BaseMutationOptions<AddTrackToArcadeMutation, AddTrackToArcadeMutationVariables>;
export const RemoveTrackFromArcadeDocument = gql`
    mutation RemoveTrackFromArcade($trackID: String!) {
  removeTrackFromArcade(trackID: $trackID)
}
    `;
export type RemoveTrackFromArcadeMutationFn = Apollo.MutationFunction<RemoveTrackFromArcadeMutation, RemoveTrackFromArcadeMutationVariables>;

/**
 * __useRemoveTrackFromArcadeMutation__
 *
 * To run a mutation, you first call `useRemoveTrackFromArcadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTrackFromArcadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTrackFromArcadeMutation, { data, loading, error }] = useRemoveTrackFromArcadeMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useRemoveTrackFromArcadeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTrackFromArcadeMutation, RemoveTrackFromArcadeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTrackFromArcadeMutation, RemoveTrackFromArcadeMutationVariables>(RemoveTrackFromArcadeDocument, options);
      }
export type RemoveTrackFromArcadeMutationHookResult = ReturnType<typeof useRemoveTrackFromArcadeMutation>;
export type RemoveTrackFromArcadeMutationResult = Apollo.MutationResult<RemoveTrackFromArcadeMutation>;
export type RemoveTrackFromArcadeMutationOptions = Apollo.BaseMutationOptions<RemoveTrackFromArcadeMutation, RemoveTrackFromArcadeMutationVariables>;
export const ArcadeUpdateMachineUpdateArcadeDocument = gql`
    mutation ArcadeUpdateMachineUpdateArcade($arcade: ArcadeInput!) {
  updateArcade(arcade: $arcade) {
    id
    alternative_url
  }
}
    `;
export type ArcadeUpdateMachineUpdateArcadeMutationFn = Apollo.MutationFunction<ArcadeUpdateMachineUpdateArcadeMutation, ArcadeUpdateMachineUpdateArcadeMutationVariables>;

/**
 * __useArcadeUpdateMachineUpdateArcadeMutation__
 *
 * To run a mutation, you first call `useArcadeUpdateMachineUpdateArcadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArcadeUpdateMachineUpdateArcadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arcadeUpdateMachineUpdateArcadeMutation, { data, loading, error }] = useArcadeUpdateMachineUpdateArcadeMutation({
 *   variables: {
 *      arcade: // value for 'arcade'
 *   },
 * });
 */
export function useArcadeUpdateMachineUpdateArcadeMutation(baseOptions?: Apollo.MutationHookOptions<ArcadeUpdateMachineUpdateArcadeMutation, ArcadeUpdateMachineUpdateArcadeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArcadeUpdateMachineUpdateArcadeMutation, ArcadeUpdateMachineUpdateArcadeMutationVariables>(ArcadeUpdateMachineUpdateArcadeDocument, options);
      }
export type ArcadeUpdateMachineUpdateArcadeMutationHookResult = ReturnType<typeof useArcadeUpdateMachineUpdateArcadeMutation>;
export type ArcadeUpdateMachineUpdateArcadeMutationResult = Apollo.MutationResult<ArcadeUpdateMachineUpdateArcadeMutation>;
export type ArcadeUpdateMachineUpdateArcadeMutationOptions = Apollo.BaseMutationOptions<ArcadeUpdateMachineUpdateArcadeMutation, ArcadeUpdateMachineUpdateArcadeMutationVariables>;
export const CreateChallengeFormDocument = gql`
    query CreateChallengeForm($trackSlug: String!, $teamSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
  }
}
    `;

/**
 * __useCreateChallengeFormQuery__
 *
 * To run a query within a React component, call `useCreateChallengeFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateChallengeFormQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useCreateChallengeFormQuery(baseOptions: Apollo.QueryHookOptions<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>(CreateChallengeFormDocument, options);
      }
export function useCreateChallengeFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>(CreateChallengeFormDocument, options);
        }
export type CreateChallengeFormQueryHookResult = ReturnType<typeof useCreateChallengeFormQuery>;
export type CreateChallengeFormLazyQueryHookResult = ReturnType<typeof useCreateChallengeFormLazyQuery>;
export type CreateChallengeFormQueryResult = Apollo.QueryResult<CreateChallengeFormQuery, CreateChallengeFormQueryVariables>;
export const CreateChallengeDocument = gql`
    mutation CreateChallenge($challenge: ChallengeInput!) {
  createChallenge(challenge: $challenge) {
    ...ChallengeFormData
  }
}
    ${ChallengeFormDataFragmentDoc}`;
export type CreateChallengeMutationFn = Apollo.MutationFunction<CreateChallengeMutation, CreateChallengeMutationVariables>;

/**
 * __useCreateChallengeMutation__
 *
 * To run a mutation, you first call `useCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeMutation, { data, loading, error }] = useCreateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useCreateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<CreateChallengeMutation, CreateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChallengeMutation, CreateChallengeMutationVariables>(CreateChallengeDocument, options);
      }
export type CreateChallengeMutationHookResult = ReturnType<typeof useCreateChallengeMutation>;
export type CreateChallengeMutationResult = Apollo.MutationResult<CreateChallengeMutation>;
export type CreateChallengeMutationOptions = Apollo.BaseMutationOptions<CreateChallengeMutation, CreateChallengeMutationVariables>;
export const ChallengeNoteDrawerDocument = gql`
    query ChallengeNoteDrawer($noteID: String!) {
  note(noteID: $noteID) {
    ...ChallengeNoteItem
  }
}
    ${ChallengeNoteItemFragmentDoc}`;

/**
 * __useChallengeNoteDrawerQuery__
 *
 * To run a query within a React component, call `useChallengeNoteDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeNoteDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeNoteDrawerQuery({
 *   variables: {
 *      noteID: // value for 'noteID'
 *   },
 * });
 */
export function useChallengeNoteDrawerQuery(baseOptions: Apollo.QueryHookOptions<ChallengeNoteDrawerQuery, ChallengeNoteDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeNoteDrawerQuery, ChallengeNoteDrawerQueryVariables>(ChallengeNoteDrawerDocument, options);
      }
export function useChallengeNoteDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeNoteDrawerQuery, ChallengeNoteDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeNoteDrawerQuery, ChallengeNoteDrawerQueryVariables>(ChallengeNoteDrawerDocument, options);
        }
export type ChallengeNoteDrawerQueryHookResult = ReturnType<typeof useChallengeNoteDrawerQuery>;
export type ChallengeNoteDrawerLazyQueryHookResult = ReturnType<typeof useChallengeNoteDrawerLazyQuery>;
export type ChallengeNoteDrawerQueryResult = Apollo.QueryResult<ChallengeNoteDrawerQuery, ChallengeNoteDrawerQueryVariables>;
export const UpdateChallengeNoteDocument = gql`
    mutation updateChallengeNote($note: ChallengeNoteInput!) {
  updateChallengeNote(note: $note) {
    ...ChallengeNoteItem
  }
}
    ${ChallengeNoteItemFragmentDoc}`;
export type UpdateChallengeNoteMutationFn = Apollo.MutationFunction<UpdateChallengeNoteMutation, UpdateChallengeNoteMutationVariables>;

/**
 * __useUpdateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeNoteMutation, { data, loading, error }] = useUpdateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useUpdateChallengeNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeNoteMutation, UpdateChallengeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeNoteMutation, UpdateChallengeNoteMutationVariables>(UpdateChallengeNoteDocument, options);
      }
export type UpdateChallengeNoteMutationHookResult = ReturnType<typeof useUpdateChallengeNoteMutation>;
export type UpdateChallengeNoteMutationResult = Apollo.MutationResult<UpdateChallengeNoteMutation>;
export type UpdateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeNoteMutation, UpdateChallengeNoteMutationVariables>;
export const CreateChallengeNoteDocument = gql`
    mutation createChallengeNote($note: ChallengeNoteInput!) {
  createChallengeNote(note: $note) {
    ...ChallengeNoteItem
  }
}
    ${ChallengeNoteItemFragmentDoc}`;
export type CreateChallengeNoteMutationFn = Apollo.MutationFunction<CreateChallengeNoteMutation, CreateChallengeNoteMutationVariables>;

/**
 * __useCreateChallengeNoteMutation__
 *
 * To run a mutation, you first call `useCreateChallengeNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeNoteMutation, { data, loading, error }] = useCreateChallengeNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *   },
 * });
 */
export function useCreateChallengeNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateChallengeNoteMutation, CreateChallengeNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChallengeNoteMutation, CreateChallengeNoteMutationVariables>(CreateChallengeNoteDocument, options);
      }
export type CreateChallengeNoteMutationHookResult = ReturnType<typeof useCreateChallengeNoteMutation>;
export type CreateChallengeNoteMutationResult = Apollo.MutationResult<CreateChallengeNoteMutation>;
export type CreateChallengeNoteMutationOptions = Apollo.BaseMutationOptions<CreateChallengeNoteMutation, CreateChallengeNoteMutationVariables>;
export const ChallengeNoteListSortNotesDocument = gql`
    mutation ChallengeNoteListSortNotes($challengeID: String!, $notes: [String!]!) {
  updateChallengeNoteIndexes(challengeID: $challengeID, notes: $notes) {
    id
    index
  }
}
    `;
export type ChallengeNoteListSortNotesMutationFn = Apollo.MutationFunction<ChallengeNoteListSortNotesMutation, ChallengeNoteListSortNotesMutationVariables>;

/**
 * __useChallengeNoteListSortNotesMutation__
 *
 * To run a mutation, you first call `useChallengeNoteListSortNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeNoteListSortNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeNoteListSortNotesMutation, { data, loading, error }] = useChallengeNoteListSortNotesMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useChallengeNoteListSortNotesMutation(baseOptions?: Apollo.MutationHookOptions<ChallengeNoteListSortNotesMutation, ChallengeNoteListSortNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChallengeNoteListSortNotesMutation, ChallengeNoteListSortNotesMutationVariables>(ChallengeNoteListSortNotesDocument, options);
      }
export type ChallengeNoteListSortNotesMutationHookResult = ReturnType<typeof useChallengeNoteListSortNotesMutation>;
export type ChallengeNoteListSortNotesMutationResult = Apollo.MutationResult<ChallengeNoteListSortNotesMutation>;
export type ChallengeNoteListSortNotesMutationOptions = Apollo.BaseMutationOptions<ChallengeNoteListSortNotesMutation, ChallengeNoteListSortNotesMutationVariables>;
export const ChallengeNoteListDeleteNoteDocument = gql`
    mutation ChallengeNoteListDeleteNote($noteID: String!) {
  deleteChallengeNote(noteID: $noteID)
}
    `;
export type ChallengeNoteListDeleteNoteMutationFn = Apollo.MutationFunction<ChallengeNoteListDeleteNoteMutation, ChallengeNoteListDeleteNoteMutationVariables>;

/**
 * __useChallengeNoteListDeleteNoteMutation__
 *
 * To run a mutation, you first call `useChallengeNoteListDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeNoteListDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeNoteListDeleteNoteMutation, { data, loading, error }] = useChallengeNoteListDeleteNoteMutation({
 *   variables: {
 *      noteID: // value for 'noteID'
 *   },
 * });
 */
export function useChallengeNoteListDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<ChallengeNoteListDeleteNoteMutation, ChallengeNoteListDeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChallengeNoteListDeleteNoteMutation, ChallengeNoteListDeleteNoteMutationVariables>(ChallengeNoteListDeleteNoteDocument, options);
      }
export type ChallengeNoteListDeleteNoteMutationHookResult = ReturnType<typeof useChallengeNoteListDeleteNoteMutation>;
export type ChallengeNoteListDeleteNoteMutationResult = Apollo.MutationResult<ChallengeNoteListDeleteNoteMutation>;
export type ChallengeNoteListDeleteNoteMutationOptions = Apollo.BaseMutationOptions<ChallengeNoteListDeleteNoteMutation, ChallengeNoteListDeleteNoteMutationVariables>;
export const UpdateChallengeTabDocument = gql`
    mutation updateChallengeTab($tab: ChallengeTabInput!) {
  result: updateChallengeTab(tab: $tab) {
    ...ChallengeTabItem
  }
}
    ${ChallengeTabItemFragmentDoc}`;
export type UpdateChallengeTabMutationFn = Apollo.MutationFunction<UpdateChallengeTabMutation, UpdateChallengeTabMutationVariables>;

/**
 * __useUpdateChallengeTabMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeTabMutation, { data, loading, error }] = useUpdateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useUpdateChallengeTabMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeTabMutation, UpdateChallengeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeTabMutation, UpdateChallengeTabMutationVariables>(UpdateChallengeTabDocument, options);
      }
export type UpdateChallengeTabMutationHookResult = ReturnType<typeof useUpdateChallengeTabMutation>;
export type UpdateChallengeTabMutationResult = Apollo.MutationResult<UpdateChallengeTabMutation>;
export type UpdateChallengeTabMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeTabMutation, UpdateChallengeTabMutationVariables>;
export const CreateChallengeTabDocument = gql`
    mutation createChallengeTab($tab: ChallengeTabInput!) {
  result: createChallengeTab(tab: $tab) {
    ...ChallengeTabItem
  }
}
    ${ChallengeTabItemFragmentDoc}`;
export type CreateChallengeTabMutationFn = Apollo.MutationFunction<CreateChallengeTabMutation, CreateChallengeTabMutationVariables>;

/**
 * __useCreateChallengeTabMutation__
 *
 * To run a mutation, you first call `useCreateChallengeTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeTabMutation, { data, loading, error }] = useCreateChallengeTabMutation({
 *   variables: {
 *      tab: // value for 'tab'
 *   },
 * });
 */
export function useCreateChallengeTabMutation(baseOptions?: Apollo.MutationHookOptions<CreateChallengeTabMutation, CreateChallengeTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChallengeTabMutation, CreateChallengeTabMutationVariables>(CreateChallengeTabDocument, options);
      }
export type CreateChallengeTabMutationHookResult = ReturnType<typeof useCreateChallengeTabMutation>;
export type CreateChallengeTabMutationResult = Apollo.MutationResult<CreateChallengeTabMutation>;
export type CreateChallengeTabMutationOptions = Apollo.BaseMutationOptions<CreateChallengeTabMutation, CreateChallengeTabMutationVariables>;
export const ChallengeTabListSortTabsDocument = gql`
    mutation ChallengeTabListSortTabs($challengeID: String!, $tabs: [String!]!) {
  updateChallengeTabIndexes(challengeID: $challengeID, tabs: $tabs) {
    id
    title
    index
  }
}
    `;
export type ChallengeTabListSortTabsMutationFn = Apollo.MutationFunction<ChallengeTabListSortTabsMutation, ChallengeTabListSortTabsMutationVariables>;

/**
 * __useChallengeTabListSortTabsMutation__
 *
 * To run a mutation, you first call `useChallengeTabListSortTabsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabListSortTabsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeTabListSortTabsMutation, { data, loading, error }] = useChallengeTabListSortTabsMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      tabs: // value for 'tabs'
 *   },
 * });
 */
export function useChallengeTabListSortTabsMutation(baseOptions?: Apollo.MutationHookOptions<ChallengeTabListSortTabsMutation, ChallengeTabListSortTabsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChallengeTabListSortTabsMutation, ChallengeTabListSortTabsMutationVariables>(ChallengeTabListSortTabsDocument, options);
      }
export type ChallengeTabListSortTabsMutationHookResult = ReturnType<typeof useChallengeTabListSortTabsMutation>;
export type ChallengeTabListSortTabsMutationResult = Apollo.MutationResult<ChallengeTabListSortTabsMutation>;
export type ChallengeTabListSortTabsMutationOptions = Apollo.BaseMutationOptions<ChallengeTabListSortTabsMutation, ChallengeTabListSortTabsMutationVariables>;
export const ChallengeTabListDeleteTabDocument = gql`
    mutation ChallengeTabListDeleteTab($tabID: String!) {
  deleteChallengeTab(tabID: $tabID)
}
    `;
export type ChallengeTabListDeleteTabMutationFn = Apollo.MutationFunction<ChallengeTabListDeleteTabMutation, ChallengeTabListDeleteTabMutationVariables>;

/**
 * __useChallengeTabListDeleteTabMutation__
 *
 * To run a mutation, you first call `useChallengeTabListDeleteTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabListDeleteTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeTabListDeleteTabMutation, { data, loading, error }] = useChallengeTabListDeleteTabMutation({
 *   variables: {
 *      tabID: // value for 'tabID'
 *   },
 * });
 */
export function useChallengeTabListDeleteTabMutation(baseOptions?: Apollo.MutationHookOptions<ChallengeTabListDeleteTabMutation, ChallengeTabListDeleteTabMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChallengeTabListDeleteTabMutation, ChallengeTabListDeleteTabMutationVariables>(ChallengeTabListDeleteTabDocument, options);
      }
export type ChallengeTabListDeleteTabMutationHookResult = ReturnType<typeof useChallengeTabListDeleteTabMutation>;
export type ChallengeTabListDeleteTabMutationResult = Apollo.MutationResult<ChallengeTabListDeleteTabMutation>;
export type ChallengeTabListDeleteTabMutationOptions = Apollo.BaseMutationOptions<ChallengeTabListDeleteTabMutation, ChallengeTabListDeleteTabMutationVariables>;
export const UpdateSettingsVirtualBrowserChallengeCheckDocument = gql`
    mutation updateSettingsVirtualBrowserChallengeCheck($check: VirtualBrowserCheckInput!) {
  upsertVirtualBrowserCheck(virtualBrowserCheck: $check) {
    id
    browserLocation {
      conditions {
        urlPart
        condition
      }
    }
    element {
      selector
      value
    }
    innerText {
      selector
      value
    }
  }
}
    `;
export type UpdateSettingsVirtualBrowserChallengeCheckMutationFn = Apollo.MutationFunction<UpdateSettingsVirtualBrowserChallengeCheckMutation, UpdateSettingsVirtualBrowserChallengeCheckMutationVariables>;

/**
 * __useUpdateSettingsVirtualBrowserChallengeCheckMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsVirtualBrowserChallengeCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsVirtualBrowserChallengeCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsVirtualBrowserChallengeCheckMutation, { data, loading, error }] = useUpdateSettingsVirtualBrowserChallengeCheckMutation({
 *   variables: {
 *      check: // value for 'check'
 *   },
 * });
 */
export function useUpdateSettingsVirtualBrowserChallengeCheckMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsVirtualBrowserChallengeCheckMutation, UpdateSettingsVirtualBrowserChallengeCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsVirtualBrowserChallengeCheckMutation, UpdateSettingsVirtualBrowserChallengeCheckMutationVariables>(UpdateSettingsVirtualBrowserChallengeCheckDocument, options);
      }
export type UpdateSettingsVirtualBrowserChallengeCheckMutationHookResult = ReturnType<typeof useUpdateSettingsVirtualBrowserChallengeCheckMutation>;
export type UpdateSettingsVirtualBrowserChallengeCheckMutationResult = Apollo.MutationResult<UpdateSettingsVirtualBrowserChallengeCheckMutation>;
export type UpdateSettingsVirtualBrowserChallengeCheckMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsVirtualBrowserChallengeCheckMutation, UpdateSettingsVirtualBrowserChallengeCheckMutationVariables>;
export const DeleteSettingsVirtualBrowserChallengeCheckDocument = gql`
    mutation deleteSettingsVirtualBrowserChallengeCheck($id: String!) {
  deleteVirtualBrowserCheck(id: $id)
}
    `;
export type DeleteSettingsVirtualBrowserChallengeCheckMutationFn = Apollo.MutationFunction<DeleteSettingsVirtualBrowserChallengeCheckMutation, DeleteSettingsVirtualBrowserChallengeCheckMutationVariables>;

/**
 * __useDeleteSettingsVirtualBrowserChallengeCheckMutation__
 *
 * To run a mutation, you first call `useDeleteSettingsVirtualBrowserChallengeCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSettingsVirtualBrowserChallengeCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSettingsVirtualBrowserChallengeCheckMutation, { data, loading, error }] = useDeleteSettingsVirtualBrowserChallengeCheckMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSettingsVirtualBrowserChallengeCheckMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSettingsVirtualBrowserChallengeCheckMutation, DeleteSettingsVirtualBrowserChallengeCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSettingsVirtualBrowserChallengeCheckMutation, DeleteSettingsVirtualBrowserChallengeCheckMutationVariables>(DeleteSettingsVirtualBrowserChallengeCheckDocument, options);
      }
export type DeleteSettingsVirtualBrowserChallengeCheckMutationHookResult = ReturnType<typeof useDeleteSettingsVirtualBrowserChallengeCheckMutation>;
export type DeleteSettingsVirtualBrowserChallengeCheckMutationResult = Apollo.MutationResult<DeleteSettingsVirtualBrowserChallengeCheckMutation>;
export type DeleteSettingsVirtualBrowserChallengeCheckMutationOptions = Apollo.BaseMutationOptions<DeleteSettingsVirtualBrowserChallengeCheckMutation, DeleteSettingsVirtualBrowserChallengeCheckMutationVariables>;
export const CopyTrackModalDocument = gql`
    query CopyTrackModal($trackID: String!) {
  track(trackID: $trackID) {
    id
    version
    slug
    icon
    title
    teaser
    description
    level
    trackTags {
      id
      value
    }
    idle_timeout
    timelimit
    status
    developers {
      profile {
        email
      }
    }
    maintenance
    show_timer
    skipping_enabled
    challenges {
      id
      type
      slug
      title
      teaser
      notes {
        type
        contents
        url
      }
      difficulty
      assignment
      timelimit
      tabs {
        cmd
        type
        title
        hostname
        path
        port
        url
        new_window
      }
      scripts {
        host
        action
        contents
      }
      answers
      solution
    }
    sandboxConfig {
      config {
        slug
      }
    }
    config {
      version
      containers {
        name
        image
        entrypoint
        cmd
        shell
        ports
        environment {
          key
          value
        }
        memory
      }
      virtualmachines {
        name
        image
        machine_type
        allow_external_ingress
        shell
        environment {
          key
          value
        }
        memory
        cpus
      }
      virtualbrowsers {
        name
        url
      }
      gcp_projects {
        name
        services
      }
      aws_accounts {
        name
        iam_policy
        managed_policies
        scp_policy
      }
      azure_subscriptions {
        name
        user_only
        roles
      }
    }
    scripts {
      id
      action
      contents
      host
    }
  }
}
    `;

/**
 * __useCopyTrackModalQuery__
 *
 * To run a query within a React component, call `useCopyTrackModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCopyTrackModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCopyTrackModalQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useCopyTrackModalQuery(baseOptions: Apollo.QueryHookOptions<CopyTrackModalQuery, CopyTrackModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CopyTrackModalQuery, CopyTrackModalQueryVariables>(CopyTrackModalDocument, options);
      }
export function useCopyTrackModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CopyTrackModalQuery, CopyTrackModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CopyTrackModalQuery, CopyTrackModalQueryVariables>(CopyTrackModalDocument, options);
        }
export type CopyTrackModalQueryHookResult = ReturnType<typeof useCopyTrackModalQuery>;
export type CopyTrackModalLazyQueryHookResult = ReturnType<typeof useCopyTrackModalLazyQuery>;
export type CopyTrackModalQueryResult = Apollo.QueryResult<CopyTrackModalQuery, CopyTrackModalQueryVariables>;
export const TrackExistsDocument = gql`
    query TrackExists($trackSlug: String!, $teamSlug: String!) {
  trackExists(trackSlug: $trackSlug, teamSlug: $teamSlug)
}
    `;

/**
 * __useTrackExistsQuery__
 *
 * To run a query within a React component, call `useTrackExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackExistsQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackExistsQuery(baseOptions: Apollo.QueryHookOptions<TrackExistsQuery, TrackExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackExistsQuery, TrackExistsQueryVariables>(TrackExistsDocument, options);
      }
export function useTrackExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackExistsQuery, TrackExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackExistsQuery, TrackExistsQueryVariables>(TrackExistsDocument, options);
        }
export type TrackExistsQueryHookResult = ReturnType<typeof useTrackExistsQuery>;
export type TrackExistsLazyQueryHookResult = ReturnType<typeof useTrackExistsLazyQuery>;
export type TrackExistsQueryResult = Apollo.QueryResult<TrackExistsQuery, TrackExistsQueryVariables>;
export const CopyTrackModalUpdateCompleteTrackDocument = gql`
    mutation CopyTrackModalUpdateCompleteTrack($track: TrackInput!) {
  updateCompleteTrack(track: $track) {
    id
    slug
    team {
      id
      slug
    }
    ...TeamContentTrack
  }
}
    ${TeamContentTrackFragmentDoc}`;
export type CopyTrackModalUpdateCompleteTrackMutationFn = Apollo.MutationFunction<CopyTrackModalUpdateCompleteTrackMutation, CopyTrackModalUpdateCompleteTrackMutationVariables>;

/**
 * __useCopyTrackModalUpdateCompleteTrackMutation__
 *
 * To run a mutation, you first call `useCopyTrackModalUpdateCompleteTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyTrackModalUpdateCompleteTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyTrackModalUpdateCompleteTrackMutation, { data, loading, error }] = useCopyTrackModalUpdateCompleteTrackMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useCopyTrackModalUpdateCompleteTrackMutation(baseOptions?: Apollo.MutationHookOptions<CopyTrackModalUpdateCompleteTrackMutation, CopyTrackModalUpdateCompleteTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyTrackModalUpdateCompleteTrackMutation, CopyTrackModalUpdateCompleteTrackMutationVariables>(CopyTrackModalUpdateCompleteTrackDocument, options);
      }
export type CopyTrackModalUpdateCompleteTrackMutationHookResult = ReturnType<typeof useCopyTrackModalUpdateCompleteTrackMutation>;
export type CopyTrackModalUpdateCompleteTrackMutationResult = Apollo.MutationResult<CopyTrackModalUpdateCompleteTrackMutation>;
export type CopyTrackModalUpdateCompleteTrackMutationOptions = Apollo.BaseMutationOptions<CopyTrackModalUpdateCompleteTrackMutation, CopyTrackModalUpdateCompleteTrackMutationVariables>;
export const CreateTrackFromModalDocument = gql`
    mutation CreateTrackFromModal($track: TrackInput!) {
  createTrack(track: $track) {
    id
    slug
    team {
      id
      slug
    }
    ...TeamContentTrack
  }
}
    ${TeamContentTrackFragmentDoc}`;
export type CreateTrackFromModalMutationFn = Apollo.MutationFunction<CreateTrackFromModalMutation, CreateTrackFromModalMutationVariables>;

/**
 * __useCreateTrackFromModalMutation__
 *
 * To run a mutation, you first call `useCreateTrackFromModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackFromModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackFromModalMutation, { data, loading, error }] = useCreateTrackFromModalMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useCreateTrackFromModalMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackFromModalMutation, CreateTrackFromModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackFromModalMutation, CreateTrackFromModalMutationVariables>(CreateTrackFromModalDocument, options);
      }
export type CreateTrackFromModalMutationHookResult = ReturnType<typeof useCreateTrackFromModalMutation>;
export type CreateTrackFromModalMutationResult = Apollo.MutationResult<CreateTrackFromModalMutation>;
export type CreateTrackFromModalMutationOptions = Apollo.BaseMutationOptions<CreateTrackFromModalMutation, CreateTrackFromModalMutationVariables>;
export const TeamExistsDocument = gql`
    query teamExists($teamSlug: String!) {
  teamExists(teamSlug: $teamSlug)
}
    `;

/**
 * __useTeamExistsQuery__
 *
 * To run a query within a React component, call `useTeamExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamExistsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTeamExistsQuery(baseOptions: Apollo.QueryHookOptions<TeamExistsQuery, TeamExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamExistsQuery, TeamExistsQueryVariables>(TeamExistsDocument, options);
      }
export function useTeamExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamExistsQuery, TeamExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamExistsQuery, TeamExistsQueryVariables>(TeamExistsDocument, options);
        }
export type TeamExistsQueryHookResult = ReturnType<typeof useTeamExistsQuery>;
export type TeamExistsLazyQueryHookResult = ReturnType<typeof useTeamExistsLazyQuery>;
export type TeamExistsQueryResult = Apollo.QueryResult<TeamExistsQuery, TeamExistsQueryVariables>;
export const UpdateLocalTeamDocument = gql`
    mutation UpdateLocalTeam($id: String!, $team: TeamInput!) {
  updateLocalTeam(id: $id, team: $team) @client {
    ...EditBrandingTeam
  }
}
    ${EditBrandingTeamFragmentDoc}`;
export type UpdateLocalTeamMutationFn = Apollo.MutationFunction<UpdateLocalTeamMutation, UpdateLocalTeamMutationVariables>;

/**
 * __useUpdateLocalTeamMutation__
 *
 * To run a mutation, you first call `useUpdateLocalTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalTeamMutation, { data, loading, error }] = useUpdateLocalTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      team: // value for 'team'
 *   },
 * });
 */
export function useUpdateLocalTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocalTeamMutation, UpdateLocalTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocalTeamMutation, UpdateLocalTeamMutationVariables>(UpdateLocalTeamDocument, options);
      }
export type UpdateLocalTeamMutationHookResult = ReturnType<typeof useUpdateLocalTeamMutation>;
export type UpdateLocalTeamMutationResult = Apollo.MutationResult<UpdateLocalTeamMutation>;
export type UpdateLocalTeamMutationOptions = Apollo.BaseMutationOptions<UpdateLocalTeamMutation, UpdateLocalTeamMutationVariables>;
export const UpdateRemoteTeamDocument = gql`
    mutation UpdateRemoteTeam($team: TeamInput!) {
  updateTeam(team: $team) {
    ...EditBrandingTeam
  }
}
    ${EditBrandingTeamFragmentDoc}`;
export type UpdateRemoteTeamMutationFn = Apollo.MutationFunction<UpdateRemoteTeamMutation, UpdateRemoteTeamMutationVariables>;

/**
 * __useUpdateRemoteTeamMutation__
 *
 * To run a mutation, you first call `useUpdateRemoteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemoteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemoteTeamMutation, { data, loading, error }] = useUpdateRemoteTeamMutation({
 *   variables: {
 *      team: // value for 'team'
 *   },
 * });
 */
export function useUpdateRemoteTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRemoteTeamMutation, UpdateRemoteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRemoteTeamMutation, UpdateRemoteTeamMutationVariables>(UpdateRemoteTeamDocument, options);
      }
export type UpdateRemoteTeamMutationHookResult = ReturnType<typeof useUpdateRemoteTeamMutation>;
export type UpdateRemoteTeamMutationResult = Apollo.MutationResult<UpdateRemoteTeamMutation>;
export type UpdateRemoteTeamMutationOptions = Apollo.BaseMutationOptions<UpdateRemoteTeamMutation, UpdateRemoteTeamMutationVariables>;
export const EditSidebarDocument = gql`
    query EditSidebar($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    ...EditBrandingTeam
  }
}
    ${EditBrandingTeamFragmentDoc}`;

/**
 * __useEditSidebarQuery__
 *
 * To run a query within a React component, call `useEditSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSidebarQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useEditSidebarQuery(baseOptions: Apollo.QueryHookOptions<EditSidebarQuery, EditSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditSidebarQuery, EditSidebarQueryVariables>(EditSidebarDocument, options);
      }
export function useEditSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditSidebarQuery, EditSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditSidebarQuery, EditSidebarQueryVariables>(EditSidebarDocument, options);
        }
export type EditSidebarQueryHookResult = ReturnType<typeof useEditSidebarQuery>;
export type EditSidebarLazyQueryHookResult = ReturnType<typeof useEditSidebarLazyQuery>;
export type EditSidebarQueryResult = Apollo.QueryResult<EditSidebarQuery, EditSidebarQueryVariables>;
export const EmbedDrawerConfigurationDocument = gql`
    query embedDrawerConfiguration($trackSlug: String!, $teamSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    embed_token
  }
}
    `;

/**
 * __useEmbedDrawerConfigurationQuery__
 *
 * To run a query within a React component, call `useEmbedDrawerConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbedDrawerConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbedDrawerConfigurationQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useEmbedDrawerConfigurationQuery(baseOptions: Apollo.QueryHookOptions<EmbedDrawerConfigurationQuery, EmbedDrawerConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmbedDrawerConfigurationQuery, EmbedDrawerConfigurationQueryVariables>(EmbedDrawerConfigurationDocument, options);
      }
export function useEmbedDrawerConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmbedDrawerConfigurationQuery, EmbedDrawerConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmbedDrawerConfigurationQuery, EmbedDrawerConfigurationQueryVariables>(EmbedDrawerConfigurationDocument, options);
        }
export type EmbedDrawerConfigurationQueryHookResult = ReturnType<typeof useEmbedDrawerConfigurationQuery>;
export type EmbedDrawerConfigurationLazyQueryHookResult = ReturnType<typeof useEmbedDrawerConfigurationLazyQuery>;
export type EmbedDrawerConfigurationQueryResult = Apollo.QueryResult<EmbedDrawerConfigurationQuery, EmbedDrawerConfigurationQueryVariables>;
export const GetFormConfigurationDocument = gql`
    query GetFormConfiguration($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    name
    form {
      ...FormConfigurationFragment
    }
  }
}
    ${FormConfigurationFragmentFragmentDoc}`;

/**
 * __useGetFormConfigurationQuery__
 *
 * To run a query within a React component, call `useGetFormConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormConfigurationQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetFormConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>(GetFormConfigurationDocument, options);
      }
export function useGetFormConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>(GetFormConfigurationDocument, options);
        }
export type GetFormConfigurationQueryHookResult = ReturnType<typeof useGetFormConfigurationQuery>;
export type GetFormConfigurationLazyQueryHookResult = ReturnType<typeof useGetFormConfigurationLazyQuery>;
export type GetFormConfigurationQueryResult = Apollo.QueryResult<GetFormConfigurationQuery, GetFormConfigurationQueryVariables>;
export const UpdateFormConfigurationDocument = gql`
    mutation UpdateFormConfiguration($form: FormInput!) {
  updateForm(form: $form) {
    ...FormConfigurationFragment
  }
}
    ${FormConfigurationFragmentFragmentDoc}`;
export type UpdateFormConfigurationMutationFn = Apollo.MutationFunction<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>;

/**
 * __useUpdateFormConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateFormConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormConfigurationMutation, { data, loading, error }] = useUpdateFormConfigurationMutation({
 *   variables: {
 *      form: // value for 'form'
 *   },
 * });
 */
export function useUpdateFormConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>(UpdateFormConfigurationDocument, options);
      }
export type UpdateFormConfigurationMutationHookResult = ReturnType<typeof useUpdateFormConfigurationMutation>;
export type UpdateFormConfigurationMutationResult = Apollo.MutationResult<UpdateFormConfigurationMutation>;
export type UpdateFormConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateFormConfigurationMutation, UpdateFormConfigurationMutationVariables>;
export const GetManageCloudAccountDrawerConfigDocument = gql`
    query getManageCloudAccountDrawerConfig($teamSlug: String!, $trackID: String!) {
  userIsTrackDeveloper(trackID: $trackID)
  team(teamSlug: $teamSlug) {
    id
    features {
      aws_accounts
      azure_subscriptions
      gcp_projects
    }
  }
  trackConfig(trackID: $trackID) {
    id
    ...ManageTrackHostResources
    ...ManageTrackCloudAccsResources
    secrets {
      ...SandboxConfigSecret
    }
  }
  trackScripts(trackID: $trackID) {
    id
    host
    action
    contents
  }
}
    ${ManageTrackHostResourcesFragmentDoc}
${ManageTrackCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;

/**
 * __useGetManageCloudAccountDrawerConfigQuery__
 *
 * To run a query within a React component, call `useGetManageCloudAccountDrawerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageCloudAccountDrawerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageCloudAccountDrawerConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetManageCloudAccountDrawerConfigQuery(baseOptions: Apollo.QueryHookOptions<GetManageCloudAccountDrawerConfigQuery, GetManageCloudAccountDrawerConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageCloudAccountDrawerConfigQuery, GetManageCloudAccountDrawerConfigQueryVariables>(GetManageCloudAccountDrawerConfigDocument, options);
      }
export function useGetManageCloudAccountDrawerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageCloudAccountDrawerConfigQuery, GetManageCloudAccountDrawerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageCloudAccountDrawerConfigQuery, GetManageCloudAccountDrawerConfigQueryVariables>(GetManageCloudAccountDrawerConfigDocument, options);
        }
export type GetManageCloudAccountDrawerConfigQueryHookResult = ReturnType<typeof useGetManageCloudAccountDrawerConfigQuery>;
export type GetManageCloudAccountDrawerConfigLazyQueryHookResult = ReturnType<typeof useGetManageCloudAccountDrawerConfigLazyQuery>;
export type GetManageCloudAccountDrawerConfigQueryResult = Apollo.QueryResult<GetManageCloudAccountDrawerConfigQuery, GetManageCloudAccountDrawerConfigQueryVariables>;
export const GetManageHostDrawerConfigDocument = gql`
    query getManageHostDrawerConfig($teamSlug: String!, $trackID: String!) {
  userIsTrackDeveloper(trackID: $trackID)
  team(teamSlug: $teamSlug) {
    id
    features {
      containers
      virtual_machines
      saas
      custom_machine_type
    }
  }
  trackConfigPresets {
    ...CreateTrackSandboxPresets
  }
  trackConfig(trackID: $trackID) {
    id
    ...ManageTrackHostResources
    ...ManageTrackCloudAccsResources
    secrets {
      ...SandboxConfigSecret
    }
  }
  trackScripts(trackID: $trackID) {
    id
    host
    action
    contents
  }
}
    ${CreateTrackSandboxPresetsFragmentDoc}
${ManageTrackHostResourcesFragmentDoc}
${ManageTrackCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;

/**
 * __useGetManageHostDrawerConfigQuery__
 *
 * To run a query within a React component, call `useGetManageHostDrawerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageHostDrawerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageHostDrawerConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetManageHostDrawerConfigQuery(baseOptions: Apollo.QueryHookOptions<GetManageHostDrawerConfigQuery, GetManageHostDrawerConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageHostDrawerConfigQuery, GetManageHostDrawerConfigQueryVariables>(GetManageHostDrawerConfigDocument, options);
      }
export function useGetManageHostDrawerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageHostDrawerConfigQuery, GetManageHostDrawerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageHostDrawerConfigQuery, GetManageHostDrawerConfigQueryVariables>(GetManageHostDrawerConfigDocument, options);
        }
export type GetManageHostDrawerConfigQueryHookResult = ReturnType<typeof useGetManageHostDrawerConfigQuery>;
export type GetManageHostDrawerConfigLazyQueryHookResult = ReturnType<typeof useGetManageHostDrawerConfigLazyQuery>;
export type GetManageHostDrawerConfigQueryResult = Apollo.QueryResult<GetManageHostDrawerConfigQuery, GetManageHostDrawerConfigQueryVariables>;
export const ManageHostDrawerRenameHostDocument = gql`
    mutation manageHostDrawerRenameHost($configID: String!, $hostName: String!, $newName: String!) {
  renameSandboxConfigHost(
    configID: $configID
    hostName: $hostName
    newName: $newName
  ) {
    id
  }
}
    `;
export type ManageHostDrawerRenameHostMutationFn = Apollo.MutationFunction<ManageHostDrawerRenameHostMutation, ManageHostDrawerRenameHostMutationVariables>;

/**
 * __useManageHostDrawerRenameHostMutation__
 *
 * To run a mutation, you first call `useManageHostDrawerRenameHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageHostDrawerRenameHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageHostDrawerRenameHostMutation, { data, loading, error }] = useManageHostDrawerRenameHostMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      hostName: // value for 'hostName'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useManageHostDrawerRenameHostMutation(baseOptions?: Apollo.MutationHookOptions<ManageHostDrawerRenameHostMutation, ManageHostDrawerRenameHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageHostDrawerRenameHostMutation, ManageHostDrawerRenameHostMutationVariables>(ManageHostDrawerRenameHostDocument, options);
      }
export type ManageHostDrawerRenameHostMutationHookResult = ReturnType<typeof useManageHostDrawerRenameHostMutation>;
export type ManageHostDrawerRenameHostMutationResult = Apollo.MutationResult<ManageHostDrawerRenameHostMutation>;
export type ManageHostDrawerRenameHostMutationOptions = Apollo.BaseMutationOptions<ManageHostDrawerRenameHostMutation, ManageHostDrawerRenameHostMutationVariables>;
export const AddTeamMemberSlugCheckDocument = gql`
    query AddTeamMemberSlugCheck($slug: String, $email: String) {
  user(slug: $slug, email: $email) {
    id
    profile {
      slug
    }
  }
}
    `;

/**
 * __useAddTeamMemberSlugCheckQuery__
 *
 * To run a query within a React component, call `useAddTeamMemberSlugCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberSlugCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddTeamMemberSlugCheckQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddTeamMemberSlugCheckQuery(baseOptions?: Apollo.QueryHookOptions<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>(AddTeamMemberSlugCheckDocument, options);
      }
export function useAddTeamMemberSlugCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>(AddTeamMemberSlugCheckDocument, options);
        }
export type AddTeamMemberSlugCheckQueryHookResult = ReturnType<typeof useAddTeamMemberSlugCheckQuery>;
export type AddTeamMemberSlugCheckLazyQueryHookResult = ReturnType<typeof useAddTeamMemberSlugCheckLazyQuery>;
export type AddTeamMemberSlugCheckQueryResult = Apollo.QueryResult<AddTeamMemberSlugCheckQuery, AddTeamMemberSlugCheckQueryVariables>;
export const AddTeamMemberDocument = gql`
    mutation AddTeamMember($teamID: String!, $userID: String, $email: String, $role: RoleName) {
  inviteTeamUser(teamID: $teamID, userID: $userID, email: $email, role: $role) {
    id
    name
    slug
    members {
      role
      user {
        id
        profile {
          display_name
          avatar
          slug
        }
      }
    }
    invites {
      email
      role
    }
  }
}
    `;
export type AddTeamMemberMutationFn = Apollo.MutationFunction<AddTeamMemberMutation, AddTeamMemberMutationVariables>;

/**
 * __useAddTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMemberMutation, { data, loading, error }] = useAddTeamMemberMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      userID: // value for 'userID'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMemberMutation, AddTeamMemberMutationVariables>(AddTeamMemberDocument, options);
      }
export type AddTeamMemberMutationHookResult = ReturnType<typeof useAddTeamMemberMutation>;
export type AddTeamMemberMutationResult = Apollo.MutationResult<AddTeamMemberMutation>;
export type AddTeamMemberMutationOptions = Apollo.BaseMutationOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>;
export const DeleteTeamInviteDocument = gql`
    mutation deleteTeamInvite($teamID: String!, $email: String!) {
  deleteTeamInvite(teamID: $teamID, email: $email) {
    ...InvitesTeam
  }
}
    ${InvitesTeamFragmentDoc}`;
export type DeleteTeamInviteMutationFn = Apollo.MutationFunction<DeleteTeamInviteMutation, DeleteTeamInviteMutationVariables>;

/**
 * __useDeleteTeamInviteMutation__
 *
 * To run a mutation, you first call `useDeleteTeamInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamInviteMutation, { data, loading, error }] = useDeleteTeamInviteMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDeleteTeamInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamInviteMutation, DeleteTeamInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamInviteMutation, DeleteTeamInviteMutationVariables>(DeleteTeamInviteDocument, options);
      }
export type DeleteTeamInviteMutationHookResult = ReturnType<typeof useDeleteTeamInviteMutation>;
export type DeleteTeamInviteMutationResult = Apollo.MutationResult<DeleteTeamInviteMutation>;
export type DeleteTeamInviteMutationOptions = Apollo.BaseMutationOptions<DeleteTeamInviteMutation, DeleteTeamInviteMutationVariables>;
export const RemoveTeamUserDocument = gql`
    mutation removeTeamUser($teamID: String!, $userID: String!) {
  removeTeamUser(teamID: $teamID, userID: $userID) {
    ...MembersTeam
  }
}
    ${MembersTeamFragmentDoc}`;
export type RemoveTeamUserMutationFn = Apollo.MutationFunction<RemoveTeamUserMutation, RemoveTeamUserMutationVariables>;

/**
 * __useRemoveTeamUserMutation__
 *
 * To run a mutation, you first call `useRemoveTeamUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamUserMutation, { data, loading, error }] = useRemoveTeamUserMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useRemoveTeamUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamUserMutation, RemoveTeamUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamUserMutation, RemoveTeamUserMutationVariables>(RemoveTeamUserDocument, options);
      }
export type RemoveTeamUserMutationHookResult = ReturnType<typeof useRemoveTeamUserMutation>;
export type RemoveTeamUserMutationResult = Apollo.MutationResult<RemoveTeamUserMutation>;
export type RemoveTeamUserMutationOptions = Apollo.BaseMutationOptions<RemoveTeamUserMutation, RemoveTeamUserMutationVariables>;
export const ChangeTeamUserRoleDocument = gql`
    mutation changeTeamUserRole($teamID: String!, $userID: String!, $role: RoleName!) {
  changeTeamUserRole(teamID: $teamID, userID: $userID, role: $role) {
    ...MembersTeam
  }
}
    ${MembersTeamFragmentDoc}`;
export type ChangeTeamUserRoleMutationFn = Apollo.MutationFunction<ChangeTeamUserRoleMutation, ChangeTeamUserRoleMutationVariables>;

/**
 * __useChangeTeamUserRoleMutation__
 *
 * To run a mutation, you first call `useChangeTeamUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTeamUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTeamUserRoleMutation, { data, loading, error }] = useChangeTeamUserRoleMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      userID: // value for 'userID'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useChangeTeamUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTeamUserRoleMutation, ChangeTeamUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTeamUserRoleMutation, ChangeTeamUserRoleMutationVariables>(ChangeTeamUserRoleDocument, options);
      }
export type ChangeTeamUserRoleMutationHookResult = ReturnType<typeof useChangeTeamUserRoleMutation>;
export type ChangeTeamUserRoleMutationResult = Apollo.MutationResult<ChangeTeamUserRoleMutation>;
export type ChangeTeamUserRoleMutationOptions = Apollo.BaseMutationOptions<ChangeTeamUserRoleMutation, ChangeTeamUserRoleMutationVariables>;
export const PlayActivityDrawerDocument = gql`
    query PlayActivityDrawer($playReportInput: PlayReportInput!, $playID: String!, $teamSlug: String!) {
  playReportItem(playID: $playID, input: $playReportInput) {
    ...PlayActivityDrawerPlayReportItem
  }
}
    ${PlayActivityDrawerPlayReportItemFragmentDoc}`;

/**
 * __usePlayActivityDrawerQuery__
 *
 * To run a query within a React component, call `usePlayActivityDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayActivityDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayActivityDrawerQuery({
 *   variables: {
 *      playReportInput: // value for 'playReportInput'
 *      playID: // value for 'playID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function usePlayActivityDrawerQuery(baseOptions: Apollo.QueryHookOptions<PlayActivityDrawerQuery, PlayActivityDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayActivityDrawerQuery, PlayActivityDrawerQueryVariables>(PlayActivityDrawerDocument, options);
      }
export function usePlayActivityDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayActivityDrawerQuery, PlayActivityDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayActivityDrawerQuery, PlayActivityDrawerQueryVariables>(PlayActivityDrawerDocument, options);
        }
export type PlayActivityDrawerQueryHookResult = ReturnType<typeof usePlayActivityDrawerQuery>;
export type PlayActivityDrawerLazyQueryHookResult = ReturnType<typeof usePlayActivityDrawerLazyQuery>;
export type PlayActivityDrawerQueryResult = Apollo.QueryResult<PlayActivityDrawerQuery, PlayActivityDrawerQueryVariables>;
export const SandboxPresetDiffModalGetDiffDocument = gql`
    query SandboxPresetDiffModalGetDiff($sourceConfigVersionID: String, $sourceConfigVersion: SandboxConfigInput, $targetConfigVersionID: String!) {
  sandboxConfigVersionDiff(
    sourceConfigVersionID: $sourceConfigVersionID
    sourceConfigVersion: $sourceConfigVersion
    targetConfigVersionID: $targetConfigVersionID
  ) {
    diff
  }
}
    `;

/**
 * __useSandboxPresetDiffModalGetDiffQuery__
 *
 * To run a query within a React component, call `useSandboxPresetDiffModalGetDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxPresetDiffModalGetDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxPresetDiffModalGetDiffQuery({
 *   variables: {
 *      sourceConfigVersionID: // value for 'sourceConfigVersionID'
 *      sourceConfigVersion: // value for 'sourceConfigVersion'
 *      targetConfigVersionID: // value for 'targetConfigVersionID'
 *   },
 * });
 */
export function useSandboxPresetDiffModalGetDiffQuery(baseOptions: Apollo.QueryHookOptions<SandboxPresetDiffModalGetDiffQuery, SandboxPresetDiffModalGetDiffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SandboxPresetDiffModalGetDiffQuery, SandboxPresetDiffModalGetDiffQueryVariables>(SandboxPresetDiffModalGetDiffDocument, options);
      }
export function useSandboxPresetDiffModalGetDiffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SandboxPresetDiffModalGetDiffQuery, SandboxPresetDiffModalGetDiffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SandboxPresetDiffModalGetDiffQuery, SandboxPresetDiffModalGetDiffQueryVariables>(SandboxPresetDiffModalGetDiffDocument, options);
        }
export type SandboxPresetDiffModalGetDiffQueryHookResult = ReturnType<typeof useSandboxPresetDiffModalGetDiffQuery>;
export type SandboxPresetDiffModalGetDiffLazyQueryHookResult = ReturnType<typeof useSandboxPresetDiffModalGetDiffLazyQuery>;
export type SandboxPresetDiffModalGetDiffQueryResult = Apollo.QueryResult<SandboxPresetDiffModalGetDiffQuery, SandboxPresetDiffModalGetDiffQueryVariables>;
export const GetSandboxPresetListCardInfoDocument = gql`
    query getSandboxPresetListCardInfo($configVersionID: String!) {
  sandboxConfigVersion(configVersionID: $configVersionID) {
    ...SandboxPresetCardInfo
  }
}
    ${SandboxPresetCardInfoFragmentDoc}`;

/**
 * __useGetSandboxPresetListCardInfoQuery__
 *
 * To run a query within a React component, call `useGetSandboxPresetListCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxPresetListCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxPresetListCardInfoQuery({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useGetSandboxPresetListCardInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSandboxPresetListCardInfoQuery, GetSandboxPresetListCardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSandboxPresetListCardInfoQuery, GetSandboxPresetListCardInfoQueryVariables>(GetSandboxPresetListCardInfoDocument, options);
      }
export function useGetSandboxPresetListCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSandboxPresetListCardInfoQuery, GetSandboxPresetListCardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSandboxPresetListCardInfoQuery, GetSandboxPresetListCardInfoQueryVariables>(GetSandboxPresetListCardInfoDocument, options);
        }
export type GetSandboxPresetListCardInfoQueryHookResult = ReturnType<typeof useGetSandboxPresetListCardInfoQuery>;
export type GetSandboxPresetListCardInfoLazyQueryHookResult = ReturnType<typeof useGetSandboxPresetListCardInfoLazyQuery>;
export type GetSandboxPresetListCardInfoQueryResult = Apollo.QueryResult<GetSandboxPresetListCardInfoQuery, GetSandboxPresetListCardInfoQueryVariables>;
export const CreateTrackFromScrachDocument = gql`
    mutation CreateTrackFromScrach($track: TrackInput!) {
  createTrack(track: $track) {
    id
    slug
    team {
      id
      slug
    }
    ...TeamContentTrack
  }
}
    ${TeamContentTrackFragmentDoc}`;
export type CreateTrackFromScrachMutationFn = Apollo.MutationFunction<CreateTrackFromScrachMutation, CreateTrackFromScrachMutationVariables>;

/**
 * __useCreateTrackFromScrachMutation__
 *
 * To run a mutation, you first call `useCreateTrackFromScrachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrackFromScrachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrackFromScrachMutation, { data, loading, error }] = useCreateTrackFromScrachMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useCreateTrackFromScrachMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrackFromScrachMutation, CreateTrackFromScrachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrackFromScrachMutation, CreateTrackFromScrachMutationVariables>(CreateTrackFromScrachDocument, options);
      }
export type CreateTrackFromScrachMutationHookResult = ReturnType<typeof useCreateTrackFromScrachMutation>;
export type CreateTrackFromScrachMutationResult = Apollo.MutationResult<CreateTrackFromScrachMutation>;
export type CreateTrackFromScrachMutationOptions = Apollo.BaseMutationOptions<CreateTrackFromScrachMutation, CreateTrackFromScrachMutationVariables>;
export const UpdateTrackChallengesOrderDocument = gql`
    mutation UpdateTrackChallengesOrder($trackID: String!, $challenges: [String!]!) {
  updateChallengeIndexes(trackID: $trackID, challenges: $challenges) {
    id
    index
  }
}
    `;
export type UpdateTrackChallengesOrderMutationFn = Apollo.MutationFunction<UpdateTrackChallengesOrderMutation, UpdateTrackChallengesOrderMutationVariables>;

/**
 * __useUpdateTrackChallengesOrderMutation__
 *
 * To run a mutation, you first call `useUpdateTrackChallengesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackChallengesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackChallengesOrderMutation, { data, loading, error }] = useUpdateTrackChallengesOrderMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challenges: // value for 'challenges'
 *   },
 * });
 */
export function useUpdateTrackChallengesOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackChallengesOrderMutation, UpdateTrackChallengesOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackChallengesOrderMutation, UpdateTrackChallengesOrderMutationVariables>(UpdateTrackChallengesOrderDocument, options);
      }
export type UpdateTrackChallengesOrderMutationHookResult = ReturnType<typeof useUpdateTrackChallengesOrderMutation>;
export type UpdateTrackChallengesOrderMutationResult = Apollo.MutationResult<UpdateTrackChallengesOrderMutation>;
export type UpdateTrackChallengesOrderMutationOptions = Apollo.BaseMutationOptions<UpdateTrackChallengesOrderMutation, UpdateTrackChallengesOrderMutationVariables>;
export const GetWidgetVirtualBrowserChallengeChecksDocument = gql`
    query getWidgetVirtualBrowserChallengeChecks($track: String!) {
  virtualBrowserChecks(track: $track) {
    ...VirtualBrowserCheckItem
  }
}
    ${VirtualBrowserCheckItemFragmentDoc}`;

/**
 * __useGetWidgetVirtualBrowserChallengeChecksQuery__
 *
 * To run a query within a React component, call `useGetWidgetVirtualBrowserChallengeChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWidgetVirtualBrowserChallengeChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWidgetVirtualBrowserChallengeChecksQuery({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useGetWidgetVirtualBrowserChallengeChecksQuery(baseOptions: Apollo.QueryHookOptions<GetWidgetVirtualBrowserChallengeChecksQuery, GetWidgetVirtualBrowserChallengeChecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWidgetVirtualBrowserChallengeChecksQuery, GetWidgetVirtualBrowserChallengeChecksQueryVariables>(GetWidgetVirtualBrowserChallengeChecksDocument, options);
      }
export function useGetWidgetVirtualBrowserChallengeChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWidgetVirtualBrowserChallengeChecksQuery, GetWidgetVirtualBrowserChallengeChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWidgetVirtualBrowserChallengeChecksQuery, GetWidgetVirtualBrowserChallengeChecksQueryVariables>(GetWidgetVirtualBrowserChallengeChecksDocument, options);
        }
export type GetWidgetVirtualBrowserChallengeChecksQueryHookResult = ReturnType<typeof useGetWidgetVirtualBrowserChallengeChecksQuery>;
export type GetWidgetVirtualBrowserChallengeChecksLazyQueryHookResult = ReturnType<typeof useGetWidgetVirtualBrowserChallengeChecksLazyQuery>;
export type GetWidgetVirtualBrowserChallengeChecksQueryResult = Apollo.QueryResult<GetWidgetVirtualBrowserChallengeChecksQuery, GetWidgetVirtualBrowserChallengeChecksQueryVariables>;
export const UpdateTrackDashboardOptionsDocument = gql`
    mutation UpdateTrackDashboardOptions($track: TrackInput!) {
  updateTrack(track: $track) {
    id
    maintenance
    show_timer
    skipping_enabled
    lab_config {
      hideStopButton
    }
  }
}
    `;
export type UpdateTrackDashboardOptionsMutationFn = Apollo.MutationFunction<UpdateTrackDashboardOptionsMutation, UpdateTrackDashboardOptionsMutationVariables>;

/**
 * __useUpdateTrackDashboardOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackDashboardOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackDashboardOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackDashboardOptionsMutation, { data, loading, error }] = useUpdateTrackDashboardOptionsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackDashboardOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackDashboardOptionsMutation, UpdateTrackDashboardOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackDashboardOptionsMutation, UpdateTrackDashboardOptionsMutationVariables>(UpdateTrackDashboardOptionsDocument, options);
      }
export type UpdateTrackDashboardOptionsMutationHookResult = ReturnType<typeof useUpdateTrackDashboardOptionsMutation>;
export type UpdateTrackDashboardOptionsMutationResult = Apollo.MutationResult<UpdateTrackDashboardOptionsMutation>;
export type UpdateTrackDashboardOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateTrackDashboardOptionsMutation, UpdateTrackDashboardOptionsMutationVariables>;
export const TrackDetailsFormDocument = gql`
    query TrackDetailsForm($trackSlug: String!, $teamSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    ...TrackDetailsFormData
  }
}
    ${TrackDetailsFormDataFragmentDoc}`;

/**
 * __useTrackDetailsFormQuery__
 *
 * To run a query within a React component, call `useTrackDetailsFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDetailsFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDetailsFormQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDetailsFormQuery(baseOptions: Apollo.QueryHookOptions<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>(TrackDetailsFormDocument, options);
      }
export function useTrackDetailsFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>(TrackDetailsFormDocument, options);
        }
export type TrackDetailsFormQueryHookResult = ReturnType<typeof useTrackDetailsFormQuery>;
export type TrackDetailsFormLazyQueryHookResult = ReturnType<typeof useTrackDetailsFormLazyQuery>;
export type TrackDetailsFormQueryResult = Apollo.QueryResult<TrackDetailsFormQuery, TrackDetailsFormQueryVariables>;
export const UpdateTrackDetailsDocument = gql`
    mutation updateTrackDetails($track: TrackInput!) {
  updateTrack(track: $track) {
    ...TrackDetailsFormData
  }
}
    ${TrackDetailsFormDataFragmentDoc}`;
export type UpdateTrackDetailsMutationFn = Apollo.MutationFunction<UpdateTrackDetailsMutation, UpdateTrackDetailsMutationVariables>;

/**
 * __useUpdateTrackDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateTrackDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackDetailsMutation, { data, loading, error }] = useUpdateTrackDetailsMutation({
 *   variables: {
 *      track: // value for 'track'
 *   },
 * });
 */
export function useUpdateTrackDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackDetailsMutation, UpdateTrackDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackDetailsMutation, UpdateTrackDetailsMutationVariables>(UpdateTrackDetailsDocument, options);
      }
export type UpdateTrackDetailsMutationHookResult = ReturnType<typeof useUpdateTrackDetailsMutation>;
export type UpdateTrackDetailsMutationResult = Apollo.MutationResult<UpdateTrackDetailsMutation>;
export type UpdateTrackDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateTrackDetailsMutation, UpdateTrackDetailsMutationVariables>;
export const TrackInvitesTableInvitesDocument = gql`
    query TrackInvitesTableInvites($teamSlug: String!, $filters: InviteFilters!) {
  trackInvites(teamSlug: $teamSlug, filters: $filters) {
    id
    shareMethod
    publicTitle
    title
    tracks {
      id
      title
    }
    inviteLimit
    claimCount
    expiresAt
    created
    playLimit
    type
    status
    startsAt
  }
  team(teamSlug: $teamSlug) {
    id
    features {
      hot_start
    }
  }
}
    `;

/**
 * __useTrackInvitesTableInvitesQuery__
 *
 * To run a query within a React component, call `useTrackInvitesTableInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackInvitesTableInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackInvitesTableInvitesQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useTrackInvitesTableInvitesQuery(baseOptions: Apollo.QueryHookOptions<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>(TrackInvitesTableInvitesDocument, options);
      }
export function useTrackInvitesTableInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>(TrackInvitesTableInvitesDocument, options);
        }
export type TrackInvitesTableInvitesQueryHookResult = ReturnType<typeof useTrackInvitesTableInvitesQuery>;
export type TrackInvitesTableInvitesLazyQueryHookResult = ReturnType<typeof useTrackInvitesTableInvitesLazyQuery>;
export type TrackInvitesTableInvitesQueryResult = Apollo.QueryResult<TrackInvitesTableInvitesQuery, TrackInvitesTableInvitesQueryVariables>;
export const TrackInvitesTableInviteDocument = gql`
    query TrackInvitesTableInvite($inviteID: String!, $teamSlug: String!) {
  trackInvite(inviteID: $inviteID) {
    claims {
      id
      claimedAt
      playLimit
      playTTL
      user {
        id
        profile {
          display_name
          email
        }
        details(teamSlug: $teamSlug) {
          firstName
          lastName
          email
          ...UserDetailsCollectedTableDetails
        }
      }
    }
    ...DownloadTrackInviteCsvTrackInvite
  }
}
    ${UserDetailsCollectedTableDetailsFragmentDoc}
${DownloadTrackInviteCsvTrackInviteFragmentDoc}`;

/**
 * __useTrackInvitesTableInviteQuery__
 *
 * To run a query within a React component, call `useTrackInvitesTableInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackInvitesTableInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackInvitesTableInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackInvitesTableInviteQuery(baseOptions: Apollo.QueryHookOptions<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>(TrackInvitesTableInviteDocument, options);
      }
export function useTrackInvitesTableInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>(TrackInvitesTableInviteDocument, options);
        }
export type TrackInvitesTableInviteQueryHookResult = ReturnType<typeof useTrackInvitesTableInviteQuery>;
export type TrackInvitesTableInviteLazyQueryHookResult = ReturnType<typeof useTrackInvitesTableInviteLazyQuery>;
export type TrackInvitesTableInviteQueryResult = Apollo.QueryResult<TrackInvitesTableInviteQuery, TrackInvitesTableInviteQueryVariables>;
export const DeleteTrackInviteDocument = gql`
    mutation deleteTrackInvite($inviteID: String!) {
  deleteTrackInvite(inviteID: $inviteID)
}
    `;
export type DeleteTrackInviteMutationFn = Apollo.MutationFunction<DeleteTrackInviteMutation, DeleteTrackInviteMutationVariables>;

/**
 * __useDeleteTrackInviteMutation__
 *
 * To run a mutation, you first call `useDeleteTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackInviteMutation, { data, loading, error }] = useDeleteTrackInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useDeleteTrackInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrackInviteMutation, DeleteTrackInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrackInviteMutation, DeleteTrackInviteMutationVariables>(DeleteTrackInviteDocument, options);
      }
export type DeleteTrackInviteMutationHookResult = ReturnType<typeof useDeleteTrackInviteMutation>;
export type DeleteTrackInviteMutationResult = Apollo.MutationResult<DeleteTrackInviteMutation>;
export type DeleteTrackInviteMutationOptions = Apollo.BaseMutationOptions<DeleteTrackInviteMutation, DeleteTrackInviteMutationVariables>;
export const TrackLtiDrawerDocument = gql`
    query TrackLtiDrawer($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    lti_credentials {
      consumer_name
      consumer_key
    }
  }
}
    `;

/**
 * __useTrackLtiDrawerQuery__
 *
 * To run a query within a React component, call `useTrackLtiDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackLtiDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackLtiDrawerQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackLtiDrawerQuery(baseOptions: Apollo.QueryHookOptions<TrackLtiDrawerQuery, TrackLtiDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackLtiDrawerQuery, TrackLtiDrawerQueryVariables>(TrackLtiDrawerDocument, options);
      }
export function useTrackLtiDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackLtiDrawerQuery, TrackLtiDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackLtiDrawerQuery, TrackLtiDrawerQueryVariables>(TrackLtiDrawerDocument, options);
        }
export type TrackLtiDrawerQueryHookResult = ReturnType<typeof useTrackLtiDrawerQuery>;
export type TrackLtiDrawerLazyQueryHookResult = ReturnType<typeof useTrackLtiDrawerLazyQuery>;
export type TrackLtiDrawerQueryResult = Apollo.QueryResult<TrackLtiDrawerQuery, TrackLtiDrawerQueryVariables>;
export const UserReportDrawerDocument = gql`
    query UserReportDrawer($userID: String!, $teamSlug: String!, $userReportInput: UserReportInput!, $playReportInput: PlayReportInput!) {
  user(userID: $userID) {
    id
    details(teamSlug: $teamSlug) {
      id
      firstName
      lastName
      email
      companyName
      phoneNumber
      jobTitle
      jobLevel
      countryCode
      usState
      consent
    }
    profile {
      display_name
      email
    }
    reportItem(input: $userReportInput) {
      tracksStarted
      tracksCompleted
      averageProgressPercent
      timeSpent
      lastStartedAt
      playReportItems(input: $playReportInput) {
        ...UserPlayCardItem
      }
    }
  }
}
    ${UserPlayCardItemFragmentDoc}`;

/**
 * __useUserReportDrawerQuery__
 *
 * To run a query within a React component, call `useUserReportDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReportDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReportDrawerQuery({
 *   variables: {
 *      userID: // value for 'userID'
 *      teamSlug: // value for 'teamSlug'
 *      userReportInput: // value for 'userReportInput'
 *      playReportInput: // value for 'playReportInput'
 *   },
 * });
 */
export function useUserReportDrawerQuery(baseOptions: Apollo.QueryHookOptions<UserReportDrawerQuery, UserReportDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReportDrawerQuery, UserReportDrawerQueryVariables>(UserReportDrawerDocument, options);
      }
export function useUserReportDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReportDrawerQuery, UserReportDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReportDrawerQuery, UserReportDrawerQueryVariables>(UserReportDrawerDocument, options);
        }
export type UserReportDrawerQueryHookResult = ReturnType<typeof useUserReportDrawerQuery>;
export type UserReportDrawerLazyQueryHookResult = ReturnType<typeof useUserReportDrawerLazyQuery>;
export type UserReportDrawerQueryResult = Apollo.QueryResult<UserReportDrawerQuery, UserReportDrawerQueryVariables>;
export const GetTeamSaasFeatureFlagDocument = gql`
    query getTeamSaasFeatureFlag($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    features {
      saas
    }
  }
}
    `;

/**
 * __useGetTeamSaasFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetTeamSaasFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSaasFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSaasFeatureFlagQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTeamSaasFeatureFlagQuery(baseOptions: Apollo.QueryHookOptions<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>(GetTeamSaasFeatureFlagDocument, options);
      }
export function useGetTeamSaasFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>(GetTeamSaasFeatureFlagDocument, options);
        }
export type GetTeamSaasFeatureFlagQueryHookResult = ReturnType<typeof useGetTeamSaasFeatureFlagQuery>;
export type GetTeamSaasFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetTeamSaasFeatureFlagLazyQuery>;
export type GetTeamSaasFeatureFlagQueryResult = Apollo.QueryResult<GetTeamSaasFeatureFlagQuery, GetTeamSaasFeatureFlagQueryVariables>;
export const WizardTrackDetailsTrackExistsDocument = gql`
    query WizardTrackDetailsTrackExists($trackSlug: String!, $teamSlug: String!) {
  trackExists(trackSlug: $trackSlug, teamSlug: $teamSlug)
}
    `;

/**
 * __useWizardTrackDetailsTrackExistsQuery__
 *
 * To run a query within a React component, call `useWizardTrackDetailsTrackExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWizardTrackDetailsTrackExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWizardTrackDetailsTrackExistsQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useWizardTrackDetailsTrackExistsQuery(baseOptions: Apollo.QueryHookOptions<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>(WizardTrackDetailsTrackExistsDocument, options);
      }
export function useWizardTrackDetailsTrackExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>(WizardTrackDetailsTrackExistsDocument, options);
        }
export type WizardTrackDetailsTrackExistsQueryHookResult = ReturnType<typeof useWizardTrackDetailsTrackExistsQuery>;
export type WizardTrackDetailsTrackExistsLazyQueryHookResult = ReturnType<typeof useWizardTrackDetailsTrackExistsLazyQuery>;
export type WizardTrackDetailsTrackExistsQueryResult = Apollo.QueryResult<WizardTrackDetailsTrackExistsQuery, WizardTrackDetailsTrackExistsQueryVariables>;
export const ApiKeysDocument = gql`
    query ApiKeys($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    api_key
    features {
      lti_enabled
    }
    lti_credentials {
      consumer_name
      consumer_key
    }
  }
}
    `;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const ApiKeysGenerateTeamApiKeyDocument = gql`
    mutation ApiKeysGenerateTeamAPIKey($teamSlug: String!) {
  generateTeamAPIKey(teamSlug: $teamSlug)
}
    `;
export type ApiKeysGenerateTeamApiKeyMutationFn = Apollo.MutationFunction<ApiKeysGenerateTeamApiKeyMutation, ApiKeysGenerateTeamApiKeyMutationVariables>;

/**
 * __useApiKeysGenerateTeamApiKeyMutation__
 *
 * To run a mutation, you first call `useApiKeysGenerateTeamApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeysGenerateTeamApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeysGenerateTeamApiKeyMutation, { data, loading, error }] = useApiKeysGenerateTeamApiKeyMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useApiKeysGenerateTeamApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeysGenerateTeamApiKeyMutation, ApiKeysGenerateTeamApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeysGenerateTeamApiKeyMutation, ApiKeysGenerateTeamApiKeyMutationVariables>(ApiKeysGenerateTeamApiKeyDocument, options);
      }
export type ApiKeysGenerateTeamApiKeyMutationHookResult = ReturnType<typeof useApiKeysGenerateTeamApiKeyMutation>;
export type ApiKeysGenerateTeamApiKeyMutationResult = Apollo.MutationResult<ApiKeysGenerateTeamApiKeyMutation>;
export type ApiKeysGenerateTeamApiKeyMutationOptions = Apollo.BaseMutationOptions<ApiKeysGenerateTeamApiKeyMutation, ApiKeysGenerateTeamApiKeyMutationVariables>;
export const ApiKeysGenerateTeamLtiCredentialsDocument = gql`
    mutation ApiKeysGenerateTeamLTICredentials($teamSlug: String!) {
  generateTeamLTICredentials(teamSlug: $teamSlug) {
    consumer_name
    consumer_key
  }
}
    `;
export type ApiKeysGenerateTeamLtiCredentialsMutationFn = Apollo.MutationFunction<ApiKeysGenerateTeamLtiCredentialsMutation, ApiKeysGenerateTeamLtiCredentialsMutationVariables>;

/**
 * __useApiKeysGenerateTeamLtiCredentialsMutation__
 *
 * To run a mutation, you first call `useApiKeysGenerateTeamLtiCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApiKeysGenerateTeamLtiCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [apiKeysGenerateTeamLtiCredentialsMutation, { data, loading, error }] = useApiKeysGenerateTeamLtiCredentialsMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useApiKeysGenerateTeamLtiCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<ApiKeysGenerateTeamLtiCredentialsMutation, ApiKeysGenerateTeamLtiCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApiKeysGenerateTeamLtiCredentialsMutation, ApiKeysGenerateTeamLtiCredentialsMutationVariables>(ApiKeysGenerateTeamLtiCredentialsDocument, options);
      }
export type ApiKeysGenerateTeamLtiCredentialsMutationHookResult = ReturnType<typeof useApiKeysGenerateTeamLtiCredentialsMutation>;
export type ApiKeysGenerateTeamLtiCredentialsMutationResult = Apollo.MutationResult<ApiKeysGenerateTeamLtiCredentialsMutation>;
export type ApiKeysGenerateTeamLtiCredentialsMutationOptions = Apollo.BaseMutationOptions<ApiKeysGenerateTeamLtiCredentialsMutation, ApiKeysGenerateTeamLtiCredentialsMutationVariables>;
export const ArcadeEditPageDocument = gql`
    query ArcadeEditPage($arcadeID: String!) {
  arcade(arcadeID: $arcadeID) {
    id
    serial_number
    alternative_url
    active
  }
}
    `;

/**
 * __useArcadeEditPageQuery__
 *
 * To run a query within a React component, call `useArcadeEditPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeEditPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeEditPageQuery({
 *   variables: {
 *      arcadeID: // value for 'arcadeID'
 *   },
 * });
 */
export function useArcadeEditPageQuery(baseOptions: Apollo.QueryHookOptions<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>(ArcadeEditPageDocument, options);
      }
export function useArcadeEditPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>(ArcadeEditPageDocument, options);
        }
export type ArcadeEditPageQueryHookResult = ReturnType<typeof useArcadeEditPageQuery>;
export type ArcadeEditPageLazyQueryHookResult = ReturnType<typeof useArcadeEditPageLazyQuery>;
export type ArcadeEditPageQueryResult = Apollo.QueryResult<ArcadeEditPageQuery, ArcadeEditPageQueryVariables>;
export const ArcadeListPageDocument = gql`
    query ArcadeListPage($teamSlug: String!) {
  arcades(organizationSlug: $teamSlug) {
    id
    serial_number
    alternative_url
    organization
    active
  }
  tracks(teamSlug: $teamSlug) {
    id
    title
  }
  arcadetracks(organizationSlug: $teamSlug) {
    id
    title
    icon
  }
}
    `;

/**
 * __useArcadeListPageQuery__
 *
 * To run a query within a React component, call `useArcadeListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useArcadeListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArcadeListPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useArcadeListPageQuery(baseOptions: Apollo.QueryHookOptions<ArcadeListPageQuery, ArcadeListPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArcadeListPageQuery, ArcadeListPageQueryVariables>(ArcadeListPageDocument, options);
      }
export function useArcadeListPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArcadeListPageQuery, ArcadeListPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArcadeListPageQuery, ArcadeListPageQueryVariables>(ArcadeListPageDocument, options);
        }
export type ArcadeListPageQueryHookResult = ReturnType<typeof useArcadeListPageQuery>;
export type ArcadeListPageLazyQueryHookResult = ReturnType<typeof useArcadeListPageLazyQuery>;
export type ArcadeListPageQueryResult = Apollo.QueryResult<ArcadeListPageQuery, ArcadeListPageQueryVariables>;
export const ChallengeAssignmentPageDocument = gql`
    query ChallengeAssignmentPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    answers
    assignment
    difficulty
    id
    index
    slug
    solution
    teaser
    timelimit
    title
    type
  }
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
  }
}
    `;

/**
 * __useChallengeAssignmentPageQuery__
 *
 * To run a query within a React component, call `useChallengeAssignmentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeAssignmentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeAssignmentPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeAssignmentPageQuery(baseOptions: Apollo.QueryHookOptions<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>(ChallengeAssignmentPageDocument, options);
      }
export function useChallengeAssignmentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>(ChallengeAssignmentPageDocument, options);
        }
export type ChallengeAssignmentPageQueryHookResult = ReturnType<typeof useChallengeAssignmentPageQuery>;
export type ChallengeAssignmentPageLazyQueryHookResult = ReturnType<typeof useChallengeAssignmentPageLazyQuery>;
export type ChallengeAssignmentPageQueryResult = Apollo.QueryResult<ChallengeAssignmentPageQuery, ChallengeAssignmentPageQueryVariables>;
export const UpdateChallengeAssignmentPageDocument = gql`
    mutation UpdateChallengeAssignmentPage($challenge: ChallengeInput!) {
  updateChallenge(challenge: $challenge) {
    assignment
    id
  }
}
    `;
export type UpdateChallengeAssignmentPageMutationFn = Apollo.MutationFunction<UpdateChallengeAssignmentPageMutation, UpdateChallengeAssignmentPageMutationVariables>;

/**
 * __useUpdateChallengeAssignmentPageMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeAssignmentPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeAssignmentPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeAssignmentPageMutation, { data, loading, error }] = useUpdateChallengeAssignmentPageMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useUpdateChallengeAssignmentPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeAssignmentPageMutation, UpdateChallengeAssignmentPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeAssignmentPageMutation, UpdateChallengeAssignmentPageMutationVariables>(UpdateChallengeAssignmentPageDocument, options);
      }
export type UpdateChallengeAssignmentPageMutationHookResult = ReturnType<typeof useUpdateChallengeAssignmentPageMutation>;
export type UpdateChallengeAssignmentPageMutationResult = Apollo.MutationResult<UpdateChallengeAssignmentPageMutation>;
export type UpdateChallengeAssignmentPageMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeAssignmentPageMutation, UpdateChallengeAssignmentPageMutationVariables>;
export const ChallengeDetailsPageDocument = gql`
    query ChallengeDetailsPage($trackSlug: String!, $teamSlug: String!, $challengeSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
  }
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    ...ChallengeFormData
  }
}
    ${ChallengeFormDataFragmentDoc}`;

/**
 * __useChallengeDetailsPageQuery__
 *
 * To run a query within a React component, call `useChallengeDetailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeDetailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeDetailsPageQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeDetailsPageQuery(baseOptions: Apollo.QueryHookOptions<ChallengeDetailsPageQuery, ChallengeDetailsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeDetailsPageQuery, ChallengeDetailsPageQueryVariables>(ChallengeDetailsPageDocument, options);
      }
export function useChallengeDetailsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeDetailsPageQuery, ChallengeDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeDetailsPageQuery, ChallengeDetailsPageQueryVariables>(ChallengeDetailsPageDocument, options);
        }
export type ChallengeDetailsPageQueryHookResult = ReturnType<typeof useChallengeDetailsPageQuery>;
export type ChallengeDetailsPageLazyQueryHookResult = ReturnType<typeof useChallengeDetailsPageLazyQuery>;
export type ChallengeDetailsPageQueryResult = Apollo.QueryResult<ChallengeDetailsPageQuery, ChallengeDetailsPageQueryVariables>;
export const ChallengeDetailsPageUpdateChallengeDocument = gql`
    mutation ChallengeDetailsPageUpdateChallenge($challenge: ChallengeInput!) {
  updateChallenge(challenge: $challenge) {
    ...ChallengeFormData
  }
}
    ${ChallengeFormDataFragmentDoc}`;
export type ChallengeDetailsPageUpdateChallengeMutationFn = Apollo.MutationFunction<ChallengeDetailsPageUpdateChallengeMutation, ChallengeDetailsPageUpdateChallengeMutationVariables>;

/**
 * __useChallengeDetailsPageUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useChallengeDetailsPageUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeDetailsPageUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeDetailsPageUpdateChallengeMutation, { data, loading, error }] = useChallengeDetailsPageUpdateChallengeMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useChallengeDetailsPageUpdateChallengeMutation(baseOptions?: Apollo.MutationHookOptions<ChallengeDetailsPageUpdateChallengeMutation, ChallengeDetailsPageUpdateChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChallengeDetailsPageUpdateChallengeMutation, ChallengeDetailsPageUpdateChallengeMutationVariables>(ChallengeDetailsPageUpdateChallengeDocument, options);
      }
export type ChallengeDetailsPageUpdateChallengeMutationHookResult = ReturnType<typeof useChallengeDetailsPageUpdateChallengeMutation>;
export type ChallengeDetailsPageUpdateChallengeMutationResult = Apollo.MutationResult<ChallengeDetailsPageUpdateChallengeMutation>;
export type ChallengeDetailsPageUpdateChallengeMutationOptions = Apollo.BaseMutationOptions<ChallengeDetailsPageUpdateChallengeMutation, ChallengeDetailsPageUpdateChallengeMutationVariables>;
export const ChallengeGuardrailsPageDocument = gql`
    query ChallengeGuardrailsPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    id
    type
    title
    slug
  }
}
    `;

/**
 * __useChallengeGuardrailsPageQuery__
 *
 * To run a query within a React component, call `useChallengeGuardrailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeGuardrailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeGuardrailsPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeGuardrailsPageQuery(baseOptions: Apollo.QueryHookOptions<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>(ChallengeGuardrailsPageDocument, options);
      }
export function useChallengeGuardrailsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>(ChallengeGuardrailsPageDocument, options);
        }
export type ChallengeGuardrailsPageQueryHookResult = ReturnType<typeof useChallengeGuardrailsPageQuery>;
export type ChallengeGuardrailsPageLazyQueryHookResult = ReturnType<typeof useChallengeGuardrailsPageLazyQuery>;
export type ChallengeGuardrailsPageQueryResult = Apollo.QueryResult<ChallengeGuardrailsPageQuery, ChallengeGuardrailsPageQueryVariables>;
export const ChallengeNotesPageDocument = gql`
    query ChallengeNotesPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
  }
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    id
    type
    title
    slug
    notes {
      id
      type
      contents
      url
      index
    }
  }
}
    `;

/**
 * __useChallengeNotesPageQuery__
 *
 * To run a query within a React component, call `useChallengeNotesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeNotesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeNotesPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeNotesPageQuery(baseOptions: Apollo.QueryHookOptions<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>(ChallengeNotesPageDocument, options);
      }
export function useChallengeNotesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>(ChallengeNotesPageDocument, options);
        }
export type ChallengeNotesPageQueryHookResult = ReturnType<typeof useChallengeNotesPageQuery>;
export type ChallengeNotesPageLazyQueryHookResult = ReturnType<typeof useChallengeNotesPageLazyQuery>;
export type ChallengeNotesPageQueryResult = Apollo.QueryResult<ChallengeNotesPageQuery, ChallengeNotesPageQueryVariables>;
export const UpdateChallengeNotesOrderDocument = gql`
    mutation UpdateChallengeNotesOrder($challengeID: String!, $notes: [String!]!) {
  updateChallengeNoteIndexes(challengeID: $challengeID, notes: $notes) {
    id
    index
  }
}
    `;
export type UpdateChallengeNotesOrderMutationFn = Apollo.MutationFunction<UpdateChallengeNotesOrderMutation, UpdateChallengeNotesOrderMutationVariables>;

/**
 * __useUpdateChallengeNotesOrderMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeNotesOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeNotesOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeNotesOrderMutation, { data, loading, error }] = useUpdateChallengeNotesOrderMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateChallengeNotesOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeNotesOrderMutation, UpdateChallengeNotesOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeNotesOrderMutation, UpdateChallengeNotesOrderMutationVariables>(UpdateChallengeNotesOrderDocument, options);
      }
export type UpdateChallengeNotesOrderMutationHookResult = ReturnType<typeof useUpdateChallengeNotesOrderMutation>;
export type UpdateChallengeNotesOrderMutationResult = Apollo.MutationResult<UpdateChallengeNotesOrderMutation>;
export type UpdateChallengeNotesOrderMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeNotesOrderMutation, UpdateChallengeNotesOrderMutationVariables>;
export const ChallengeQuizPageDocument = gql`
    query ChallengeQuizPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    answers
    assignment
    difficulty
    id
    index
    slug
    solution
    teaser
    timelimit
    title
    type
  }
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
  }
}
    `;

/**
 * __useChallengeQuizPageQuery__
 *
 * To run a query within a React component, call `useChallengeQuizPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeQuizPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeQuizPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeQuizPageQuery(baseOptions: Apollo.QueryHookOptions<ChallengeQuizPageQuery, ChallengeQuizPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeQuizPageQuery, ChallengeQuizPageQueryVariables>(ChallengeQuizPageDocument, options);
      }
export function useChallengeQuizPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeQuizPageQuery, ChallengeQuizPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeQuizPageQuery, ChallengeQuizPageQueryVariables>(ChallengeQuizPageDocument, options);
        }
export type ChallengeQuizPageQueryHookResult = ReturnType<typeof useChallengeQuizPageQuery>;
export type ChallengeQuizPageLazyQueryHookResult = ReturnType<typeof useChallengeQuizPageLazyQuery>;
export type ChallengeQuizPageQueryResult = Apollo.QueryResult<ChallengeQuizPageQuery, ChallengeQuizPageQueryVariables>;
export const UpdateChallengeQuizPageDocument = gql`
    mutation UpdateChallengeQuizPage($challenge: ChallengeInput!) {
  updateChallenge(challenge: $challenge) {
    id
    assignment
    answers
    solution
  }
}
    `;
export type UpdateChallengeQuizPageMutationFn = Apollo.MutationFunction<UpdateChallengeQuizPageMutation, UpdateChallengeQuizPageMutationVariables>;

/**
 * __useUpdateChallengeQuizPageMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeQuizPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeQuizPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeQuizPageMutation, { data, loading, error }] = useUpdateChallengeQuizPageMutation({
 *   variables: {
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useUpdateChallengeQuizPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeQuizPageMutation, UpdateChallengeQuizPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeQuizPageMutation, UpdateChallengeQuizPageMutationVariables>(UpdateChallengeQuizPageDocument, options);
      }
export type UpdateChallengeQuizPageMutationHookResult = ReturnType<typeof useUpdateChallengeQuizPageMutation>;
export type UpdateChallengeQuizPageMutationResult = Apollo.MutationResult<UpdateChallengeQuizPageMutation>;
export type UpdateChallengeQuizPageMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeQuizPageMutation, UpdateChallengeQuizPageMutationVariables>;
export const ChallengeScriptsPageDocument = gql`
    query ChallengeScriptsPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    sandboxConfig {
      resources {
        containers {
          id
          name
        }
        virtualmachines {
          id
          name
        }
        virtualbrowsers {
          id
          name
        }
      }
    }
    trackConfig {
      id
      containers {
        id
        name
      }
      virtualmachines {
        id
        name
      }
      virtualbrowsers {
        id
        name
      }
    }
  }
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    id
    type
    title
    slug
    scripts {
      action
      contents
      host
      id
    }
  }
}
    `;

/**
 * __useChallengeScriptsPageQuery__
 *
 * To run a query within a React component, call `useChallengeScriptsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeScriptsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeScriptsPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeScriptsPageQuery(baseOptions: Apollo.QueryHookOptions<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>(ChallengeScriptsPageDocument, options);
      }
export function useChallengeScriptsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>(ChallengeScriptsPageDocument, options);
        }
export type ChallengeScriptsPageQueryHookResult = ReturnType<typeof useChallengeScriptsPageQuery>;
export type ChallengeScriptsPageLazyQueryHookResult = ReturnType<typeof useChallengeScriptsPageLazyQuery>;
export type ChallengeScriptsPageQueryResult = Apollo.QueryResult<ChallengeScriptsPageQuery, ChallengeScriptsPageQueryVariables>;
export const ChallengeTabsPageDocument = gql`
    query ChallengeTabsPage($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    id
    type
    title
    slug
    tabs {
      ...ChallengeTabItem
    }
    track {
      id
      sandboxConfig {
        ...TabsConfigVersion
      }
      trackConfig {
        ...TabsTrackConfig
      }
    }
  }
  team(teamSlug: $teamSlug) {
    id
    features {
      saas
    }
  }
}
    ${ChallengeTabItemFragmentDoc}
${TabsConfigVersionFragmentDoc}
${TabsTrackConfigFragmentDoc}`;

/**
 * __useChallengeTabsPageQuery__
 *
 * To run a query within a React component, call `useChallengeTabsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeTabsPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeTabsPageQuery(baseOptions: Apollo.QueryHookOptions<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>(ChallengeTabsPageDocument, options);
      }
export function useChallengeTabsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>(ChallengeTabsPageDocument, options);
        }
export type ChallengeTabsPageQueryHookResult = ReturnType<typeof useChallengeTabsPageQuery>;
export type ChallengeTabsPageLazyQueryHookResult = ReturnType<typeof useChallengeTabsPageLazyQuery>;
export type ChallengeTabsPageQueryResult = Apollo.QueryResult<ChallengeTabsPageQuery, ChallengeTabsPageQueryVariables>;
export const ChallengeTabListSortDocument = gql`
    mutation ChallengeTabListSort($challengeID: String!, $tabs: [String!]!) {
  updateChallengeTabIndexes(challengeID: $challengeID, tabs: $tabs) {
    id
    index
  }
}
    `;
export type ChallengeTabListSortMutationFn = Apollo.MutationFunction<ChallengeTabListSortMutation, ChallengeTabListSortMutationVariables>;

/**
 * __useChallengeTabListSortMutation__
 *
 * To run a mutation, you first call `useChallengeTabListSortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChallengeTabListSortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [challengeTabListSortMutation, { data, loading, error }] = useChallengeTabListSortMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      tabs: // value for 'tabs'
 *   },
 * });
 */
export function useChallengeTabListSortMutation(baseOptions?: Apollo.MutationHookOptions<ChallengeTabListSortMutation, ChallengeTabListSortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChallengeTabListSortMutation, ChallengeTabListSortMutationVariables>(ChallengeTabListSortDocument, options);
      }
export type ChallengeTabListSortMutationHookResult = ReturnType<typeof useChallengeTabListSortMutation>;
export type ChallengeTabListSortMutationResult = Apollo.MutationResult<ChallengeTabListSortMutation>;
export type ChallengeTabListSortMutationOptions = Apollo.BaseMutationOptions<ChallengeTabListSortMutation, ChallengeTabListSortMutationVariables>;
export const GetCustomResourcesListPageConfigDocument = gql`
    query getCustomResourcesListPageConfig($teamSlug: String!) {
  customResources(teamSlug: $teamSlug) {
    ...CustomResourcesListResource
  }
}
    ${CustomResourcesListResourceFragmentDoc}`;

/**
 * __useGetCustomResourcesListPageConfigQuery__
 *
 * To run a query within a React component, call `useGetCustomResourcesListPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomResourcesListPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomResourcesListPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetCustomResourcesListPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCustomResourcesListPageConfigQuery, GetCustomResourcesListPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomResourcesListPageConfigQuery, GetCustomResourcesListPageConfigQueryVariables>(GetCustomResourcesListPageConfigDocument, options);
      }
export function useGetCustomResourcesListPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomResourcesListPageConfigQuery, GetCustomResourcesListPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomResourcesListPageConfigQuery, GetCustomResourcesListPageConfigQueryVariables>(GetCustomResourcesListPageConfigDocument, options);
        }
export type GetCustomResourcesListPageConfigQueryHookResult = ReturnType<typeof useGetCustomResourcesListPageConfigQuery>;
export type GetCustomResourcesListPageConfigLazyQueryHookResult = ReturnType<typeof useGetCustomResourcesListPageConfigLazyQuery>;
export type GetCustomResourcesListPageConfigQueryResult = Apollo.QueryResult<GetCustomResourcesListPageConfigQuery, GetCustomResourcesListPageConfigQueryVariables>;
export const GetHotStartPoolDetailsConfigDocument = gql`
    query GetHotStartPoolDetailsConfig($id: String!) {
  hotStartPool(id: $id) {
    id
    size
    created
    name
    auto_refill
    starts_at
    ends_at
    status
    type
    region
    created_by {
      id
      profile {
        display_name
      }
    }
    team {
      id
      features {
        shared_hotstart_pools
        global_sandboxes
      }
    }
    tracks {
      claimed
      available
      creating
      node {
        id
        title
        slug
      }
    }
    configs {
      claimed
      available
      creating
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetHotStartPoolDetailsConfigQuery__
 *
 * To run a query within a React component, call `useGetHotStartPoolDetailsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPoolDetailsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPoolDetailsConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHotStartPoolDetailsConfigQuery(baseOptions: Apollo.QueryHookOptions<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>(GetHotStartPoolDetailsConfigDocument, options);
      }
export function useGetHotStartPoolDetailsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>(GetHotStartPoolDetailsConfigDocument, options);
        }
export type GetHotStartPoolDetailsConfigQueryHookResult = ReturnType<typeof useGetHotStartPoolDetailsConfigQuery>;
export type GetHotStartPoolDetailsConfigLazyQueryHookResult = ReturnType<typeof useGetHotStartPoolDetailsConfigLazyQuery>;
export type GetHotStartPoolDetailsConfigQueryResult = Apollo.QueryResult<GetHotStartPoolDetailsConfigQuery, GetHotStartPoolDetailsConfigQueryVariables>;
export const GetHotStartPageConfigDocument = gql`
    query getHotStartPageConfig($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    features {
      shared_hotstart_pools
    }
  }
  hotStartPools(teamSlug: $teamSlug) {
    edges {
      node {
        ...HotStartPagePool
      }
    }
  }
}
    ${HotStartPagePoolFragmentDoc}`;

/**
 * __useGetHotStartPageConfigQuery__
 *
 * To run a query within a React component, call `useGetHotStartPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetHotStartPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>(GetHotStartPageConfigDocument, options);
      }
export function useGetHotStartPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>(GetHotStartPageConfigDocument, options);
        }
export type GetHotStartPageConfigQueryHookResult = ReturnType<typeof useGetHotStartPageConfigQuery>;
export type GetHotStartPageConfigLazyQueryHookResult = ReturnType<typeof useGetHotStartPageConfigLazyQuery>;
export type GetHotStartPageConfigQueryResult = Apollo.QueryResult<GetHotStartPageConfigQuery, GetHotStartPageConfigQueryVariables>;
export const HotStartPageDeleteHotStartPoolDocument = gql`
    mutation hotStartPageDeleteHotStartPool($poolID: ID!) {
  deleteHotStartPool(poolID: $poolID)
}
    `;
export type HotStartPageDeleteHotStartPoolMutationFn = Apollo.MutationFunction<HotStartPageDeleteHotStartPoolMutation, HotStartPageDeleteHotStartPoolMutationVariables>;

/**
 * __useHotStartPageDeleteHotStartPoolMutation__
 *
 * To run a mutation, you first call `useHotStartPageDeleteHotStartPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHotStartPageDeleteHotStartPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hotStartPageDeleteHotStartPoolMutation, { data, loading, error }] = useHotStartPageDeleteHotStartPoolMutation({
 *   variables: {
 *      poolID: // value for 'poolID'
 *   },
 * });
 */
export function useHotStartPageDeleteHotStartPoolMutation(baseOptions?: Apollo.MutationHookOptions<HotStartPageDeleteHotStartPoolMutation, HotStartPageDeleteHotStartPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HotStartPageDeleteHotStartPoolMutation, HotStartPageDeleteHotStartPoolMutationVariables>(HotStartPageDeleteHotStartPoolDocument, options);
      }
export type HotStartPageDeleteHotStartPoolMutationHookResult = ReturnType<typeof useHotStartPageDeleteHotStartPoolMutation>;
export type HotStartPageDeleteHotStartPoolMutationResult = Apollo.MutationResult<HotStartPageDeleteHotStartPoolMutation>;
export type HotStartPageDeleteHotStartPoolMutationOptions = Apollo.BaseMutationOptions<HotStartPageDeleteHotStartPoolMutation, HotStartPageDeleteHotStartPoolMutationVariables>;
export const InsightsFiltersDocument = gql`
    query InsightsFilters($teamSlug: String) {
  team(teamSlug: $teamSlug) {
    id
    tracks {
      ...TrackFilterTrack
      developers {
        ...AuthorFilterListItem
      }
    }
    tags {
      ...TeamContentTag
    }
    tagGroups {
      ...TeamPageTagGroup
    }
  }
  trackInvites(teamSlug: $teamSlug) {
    ...InviteFilterListItem
  }
}
    ${TrackFilterTrackFragmentDoc}
${AuthorFilterListItemFragmentDoc}
${TeamContentTagFragmentDoc}
${TeamPageTagGroupFragmentDoc}
${InviteFilterListItemFragmentDoc}`;

/**
 * __useInsightsFiltersQuery__
 *
 * To run a query within a React component, call `useInsightsFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsFiltersQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useInsightsFiltersQuery(baseOptions?: Apollo.QueryHookOptions<InsightsFiltersQuery, InsightsFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsFiltersQuery, InsightsFiltersQueryVariables>(InsightsFiltersDocument, options);
      }
export function useInsightsFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsFiltersQuery, InsightsFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsFiltersQuery, InsightsFiltersQueryVariables>(InsightsFiltersDocument, options);
        }
export type InsightsFiltersQueryHookResult = ReturnType<typeof useInsightsFiltersQuery>;
export type InsightsFiltersLazyQueryHookResult = ReturnType<typeof useInsightsFiltersLazyQuery>;
export type InsightsFiltersQueryResult = Apollo.QueryResult<InsightsFiltersQuery, InsightsFiltersQueryVariables>;
export const InsightsOverviewDocument = gql`
    query InsightsOverview($teamSlug: String!, $previousPlayInsightSeriesInput: PlayInsightSeriesInput!, $currentPlayInsightSeriesInput: PlayInsightSeriesInput!) {
  team(teamSlug: $teamSlug) {
    id
    insights {
      play {
        previous: series(input: $previousPlayInsightSeriesInput) {
          granularity
          ...InsightsOverviewSeries
        }
        current: series(input: $currentPlayInsightSeriesInput) {
          granularity
          ...InsightsOverviewSeries
        }
      }
    }
  }
}
    ${InsightsOverviewSeriesFragmentDoc}`;

/**
 * __useInsightsOverviewQuery__
 *
 * To run a query within a React component, call `useInsightsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsOverviewQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      previousPlayInsightSeriesInput: // value for 'previousPlayInsightSeriesInput'
 *      currentPlayInsightSeriesInput: // value for 'currentPlayInsightSeriesInput'
 *   },
 * });
 */
export function useInsightsOverviewQuery(baseOptions: Apollo.QueryHookOptions<InsightsOverviewQuery, InsightsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsOverviewQuery, InsightsOverviewQueryVariables>(InsightsOverviewDocument, options);
      }
export function useInsightsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsOverviewQuery, InsightsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsOverviewQuery, InsightsOverviewQueryVariables>(InsightsOverviewDocument, options);
        }
export type InsightsOverviewQueryHookResult = ReturnType<typeof useInsightsOverviewQuery>;
export type InsightsOverviewLazyQueryHookResult = ReturnType<typeof useInsightsOverviewLazyQuery>;
export type InsightsOverviewQueryResult = Apollo.QueryResult<InsightsOverviewQuery, InsightsOverviewQueryVariables>;
export const InsightsContentTableDocument = gql`
    query InsightsContentTable($teamSlug: String!, $trackInsightPageInput: TrackInsightPageInput!) {
  team(teamSlug: $teamSlug) {
    id
    insights {
      track {
        page(input: $trackInsightPageInput) {
          totalItems
          items {
            ...InsightsContentTableItem
          }
        }
      }
    }
  }
}
    ${InsightsContentTableItemFragmentDoc}`;

/**
 * __useInsightsContentTableQuery__
 *
 * To run a query within a React component, call `useInsightsContentTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsContentTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsContentTableQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackInsightPageInput: // value for 'trackInsightPageInput'
 *   },
 * });
 */
export function useInsightsContentTableQuery(baseOptions: Apollo.QueryHookOptions<InsightsContentTableQuery, InsightsContentTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsContentTableQuery, InsightsContentTableQueryVariables>(InsightsContentTableDocument, options);
      }
export function useInsightsContentTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsContentTableQuery, InsightsContentTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsContentTableQuery, InsightsContentTableQueryVariables>(InsightsContentTableDocument, options);
        }
export type InsightsContentTableQueryHookResult = ReturnType<typeof useInsightsContentTableQuery>;
export type InsightsContentTableLazyQueryHookResult = ReturnType<typeof useInsightsContentTableLazyQuery>;
export type InsightsContentTableQueryResult = Apollo.QueryResult<InsightsContentTableQuery, InsightsContentTableQueryVariables>;
export const InsightsOverviewCsvDocument = gql`
    query InsightsOverviewCSV($teamSlug: String!, $playInsightSeriesInput: PlayInsightSeriesInput!) {
  team(teamSlug: $teamSlug) {
    id
    insights {
      play {
        series(input: $playInsightSeriesInput) {
          ...InsightsOverviewCSV
        }
      }
    }
  }
}
    ${InsightsOverviewCsvFragmentDoc}`;

/**
 * __useInsightsOverviewCsvQuery__
 *
 * To run a query within a React component, call `useInsightsOverviewCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsOverviewCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsOverviewCsvQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      playInsightSeriesInput: // value for 'playInsightSeriesInput'
 *   },
 * });
 */
export function useInsightsOverviewCsvQuery(baseOptions: Apollo.QueryHookOptions<InsightsOverviewCsvQuery, InsightsOverviewCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsOverviewCsvQuery, InsightsOverviewCsvQueryVariables>(InsightsOverviewCsvDocument, options);
      }
export function useInsightsOverviewCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsOverviewCsvQuery, InsightsOverviewCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsOverviewCsvQuery, InsightsOverviewCsvQueryVariables>(InsightsOverviewCsvDocument, options);
        }
export type InsightsOverviewCsvQueryHookResult = ReturnType<typeof useInsightsOverviewCsvQuery>;
export type InsightsOverviewCsvLazyQueryHookResult = ReturnType<typeof useInsightsOverviewCsvLazyQuery>;
export type InsightsOverviewCsvQueryResult = Apollo.QueryResult<InsightsOverviewCsvQuery, InsightsOverviewCsvQueryVariables>;
export const InsightsAllContentCsvDocument = gql`
    query InsightsAllContentCSV($teamSlug: String!, $trackInsightPageInput: TrackInsightPageInput!) {
  team(teamSlug: $teamSlug) {
    id
    insights {
      track {
        page(input: $trackInsightPageInput) {
          items {
            ...InsightsAllContentCSV
          }
        }
      }
    }
  }
}
    ${InsightsAllContentCsvFragmentDoc}`;

/**
 * __useInsightsAllContentCsvQuery__
 *
 * To run a query within a React component, call `useInsightsAllContentCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsAllContentCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsAllContentCsvQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackInsightPageInput: // value for 'trackInsightPageInput'
 *   },
 * });
 */
export function useInsightsAllContentCsvQuery(baseOptions: Apollo.QueryHookOptions<InsightsAllContentCsvQuery, InsightsAllContentCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsAllContentCsvQuery, InsightsAllContentCsvQueryVariables>(InsightsAllContentCsvDocument, options);
      }
export function useInsightsAllContentCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsAllContentCsvQuery, InsightsAllContentCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsAllContentCsvQuery, InsightsAllContentCsvQueryVariables>(InsightsAllContentCsvDocument, options);
        }
export type InsightsAllContentCsvQueryHookResult = ReturnType<typeof useInsightsAllContentCsvQuery>;
export type InsightsAllContentCsvLazyQueryHookResult = ReturnType<typeof useInsightsAllContentCsvLazyQuery>;
export type InsightsAllContentCsvQueryResult = Apollo.QueryResult<InsightsAllContentCsvQuery, InsightsAllContentCsvQueryVariables>;
export const InspirationLibraryDocument = gql`
    query InspirationLibrary {
  templates: tracks(teamSlug: "templates") {
    challenges {
      permalink
    }
    icon
    id
    maintenance
    slug
    teaser
    title
  }
  examples: tracks(teamSlug: "examples") {
    challenges {
      permalink
    }
    icon
    id
    maintenance
    slug
    teaser
    title
  }
  tutorials: tracks(teamSlug: "tutorials") {
    challenges {
      permalink
    }
    icon
    id
    maintenance
    slug
    teaser
    title
  }
}
    `;

/**
 * __useInspirationLibraryQuery__
 *
 * To run a query within a React component, call `useInspirationLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspirationLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspirationLibraryQuery({
 *   variables: {
 *   },
 * });
 */
export function useInspirationLibraryQuery(baseOptions?: Apollo.QueryHookOptions<InspirationLibraryQuery, InspirationLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspirationLibraryQuery, InspirationLibraryQueryVariables>(InspirationLibraryDocument, options);
      }
export function useInspirationLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspirationLibraryQuery, InspirationLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspirationLibraryQuery, InspirationLibraryQueryVariables>(InspirationLibraryDocument, options);
        }
export type InspirationLibraryQueryHookResult = ReturnType<typeof useInspirationLibraryQuery>;
export type InspirationLibraryLazyQueryHookResult = ReturnType<typeof useInspirationLibraryLazyQuery>;
export type InspirationLibraryQueryResult = Apollo.QueryResult<InspirationLibraryQuery, InspirationLibraryQueryVariables>;
export const GetManageHotStartPageConfigDocument = gql`
    query getManageHotStartPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
  team(teamSlug: $teamSlug) {
    features {
      max_hot_start_pool_size_always_on
      max_hot_start_pool_size_scheduled
      shared_hotstart_pools
      global_sandboxes
    }
  }
  tracks(teamSlug: $teamSlug) {
    ...HotStartFormTrack
  }
  sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
    ...HotStartSandboxPreset
  }
}
    ${HotStartFormTrackFragmentDoc}
${HotStartSandboxPresetFragmentDoc}`;

/**
 * __useGetManageHotStartPageConfigQuery__
 *
 * To run a query within a React component, call `useGetManageHotStartPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageHotStartPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageHotStartPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetManageHotStartPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>(GetManageHotStartPageConfigDocument, options);
      }
export function useGetManageHotStartPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>(GetManageHotStartPageConfigDocument, options);
        }
export type GetManageHotStartPageConfigQueryHookResult = ReturnType<typeof useGetManageHotStartPageConfigQuery>;
export type GetManageHotStartPageConfigLazyQueryHookResult = ReturnType<typeof useGetManageHotStartPageConfigLazyQuery>;
export type GetManageHotStartPageConfigQueryResult = Apollo.QueryResult<GetManageHotStartPageConfigQuery, GetManageHotStartPageConfigQueryVariables>;
export const CreateHotStartPoolDocument = gql`
    mutation CreateHotStartPool($input: HotStartPoolInput!) {
  createHotStartPool(pool: $input) {
    id
  }
}
    `;
export type CreateHotStartPoolMutationFn = Apollo.MutationFunction<CreateHotStartPoolMutation, CreateHotStartPoolMutationVariables>;

/**
 * __useCreateHotStartPoolMutation__
 *
 * To run a mutation, you first call `useCreateHotStartPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHotStartPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHotStartPoolMutation, { data, loading, error }] = useCreateHotStartPoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHotStartPoolMutation(baseOptions?: Apollo.MutationHookOptions<CreateHotStartPoolMutation, CreateHotStartPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHotStartPoolMutation, CreateHotStartPoolMutationVariables>(CreateHotStartPoolDocument, options);
      }
export type CreateHotStartPoolMutationHookResult = ReturnType<typeof useCreateHotStartPoolMutation>;
export type CreateHotStartPoolMutationResult = Apollo.MutationResult<CreateHotStartPoolMutation>;
export type CreateHotStartPoolMutationOptions = Apollo.BaseMutationOptions<CreateHotStartPoolMutation, CreateHotStartPoolMutationVariables>;
export const UpdateHotStartPoolDocument = gql`
    mutation UpdateHotStartPool($poolID: ID!, $input: HotStartPoolInput!) {
  updateHotStartPool(id: $poolID, pool: $input) {
    id
  }
}
    `;
export type UpdateHotStartPoolMutationFn = Apollo.MutationFunction<UpdateHotStartPoolMutation, UpdateHotStartPoolMutationVariables>;

/**
 * __useUpdateHotStartPoolMutation__
 *
 * To run a mutation, you first call `useUpdateHotStartPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHotStartPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHotStartPoolMutation, { data, loading, error }] = useUpdateHotStartPoolMutation({
 *   variables: {
 *      poolID: // value for 'poolID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHotStartPoolMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHotStartPoolMutation, UpdateHotStartPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHotStartPoolMutation, UpdateHotStartPoolMutationVariables>(UpdateHotStartPoolDocument, options);
      }
export type UpdateHotStartPoolMutationHookResult = ReturnType<typeof useUpdateHotStartPoolMutation>;
export type UpdateHotStartPoolMutationResult = Apollo.MutationResult<UpdateHotStartPoolMutation>;
export type UpdateHotStartPoolMutationOptions = Apollo.BaseMutationOptions<UpdateHotStartPoolMutation, UpdateHotStartPoolMutationVariables>;
export const GetHotStartPoolToDuplicateDocument = gql`
    query GetHotStartPoolToDuplicate($poolID: String!) {
  hotStartPool(id: $poolID) {
    ...HotStartPoolExistingPool
  }
}
    ${HotStartPoolExistingPoolFragmentDoc}`;

/**
 * __useGetHotStartPoolToDuplicateQuery__
 *
 * To run a query within a React component, call `useGetHotStartPoolToDuplicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPoolToDuplicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPoolToDuplicateQuery({
 *   variables: {
 *      poolID: // value for 'poolID'
 *   },
 * });
 */
export function useGetHotStartPoolToDuplicateQuery(baseOptions: Apollo.QueryHookOptions<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>(GetHotStartPoolToDuplicateDocument, options);
      }
export function useGetHotStartPoolToDuplicateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>(GetHotStartPoolToDuplicateDocument, options);
        }
export type GetHotStartPoolToDuplicateQueryHookResult = ReturnType<typeof useGetHotStartPoolToDuplicateQuery>;
export type GetHotStartPoolToDuplicateLazyQueryHookResult = ReturnType<typeof useGetHotStartPoolToDuplicateLazyQuery>;
export type GetHotStartPoolToDuplicateQueryResult = Apollo.QueryResult<GetHotStartPoolToDuplicateQuery, GetHotStartPoolToDuplicateQueryVariables>;
export const GetHotStartInviteDocument = gql`
    query GetHotStartInvite($inviteID: String!) {
  trackInvite(inviteID: $inviteID) {
    ...HotStartInvite
  }
}
    ${HotStartInviteFragmentDoc}`;

/**
 * __useGetHotStartInviteQuery__
 *
 * To run a query within a React component, call `useGetHotStartInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useGetHotStartInviteQuery(baseOptions: Apollo.QueryHookOptions<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>(GetHotStartInviteDocument, options);
      }
export function useGetHotStartInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>(GetHotStartInviteDocument, options);
        }
export type GetHotStartInviteQueryHookResult = ReturnType<typeof useGetHotStartInviteQuery>;
export type GetHotStartInviteLazyQueryHookResult = ReturnType<typeof useGetHotStartInviteLazyQuery>;
export type GetHotStartInviteQueryResult = Apollo.QueryResult<GetHotStartInviteQuery, GetHotStartInviteQueryVariables>;
export const GetHotStartPoolExistingPoolDocument = gql`
    query GetHotStartPoolExistingPool($poolID: String!) {
  hotStartPool(id: $poolID) {
    ...HotStartPoolExistingPool
  }
}
    ${HotStartPoolExistingPoolFragmentDoc}`;

/**
 * __useGetHotStartPoolExistingPoolQuery__
 *
 * To run a query within a React component, call `useGetHotStartPoolExistingPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotStartPoolExistingPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotStartPoolExistingPoolQuery({
 *   variables: {
 *      poolID: // value for 'poolID'
 *   },
 * });
 */
export function useGetHotStartPoolExistingPoolQuery(baseOptions: Apollo.QueryHookOptions<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>(GetHotStartPoolExistingPoolDocument, options);
      }
export function useGetHotStartPoolExistingPoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>(GetHotStartPoolExistingPoolDocument, options);
        }
export type GetHotStartPoolExistingPoolQueryHookResult = ReturnType<typeof useGetHotStartPoolExistingPoolQuery>;
export type GetHotStartPoolExistingPoolLazyQueryHookResult = ReturnType<typeof useGetHotStartPoolExistingPoolLazyQuery>;
export type GetHotStartPoolExistingPoolQueryResult = Apollo.QueryResult<GetHotStartPoolExistingPoolQuery, GetHotStartPoolExistingPoolQueryVariables>;
export const GetManageSandboxPresetConfigDocument = gql`
    query getManageSandboxPresetConfig($teamSlug: String!) {
  userInTeam(teamSlug: $teamSlug)
  team(teamSlug: $teamSlug) {
    id
    features {
      containers
      virtual_machines
      saas
      custom_machine_type
      aws_accounts
      azure_subscriptions
      gcp_projects
      shared_hotstart_pools
    }
  }
  trackConfigPresets {
    ...CreateTrackSandboxPresets
  }
  teamSecrets(teamSlug: $teamSlug) {
    name
    description
  }
}
    ${CreateTrackSandboxPresetsFragmentDoc}`;

/**
 * __useGetManageSandboxPresetConfigQuery__
 *
 * To run a query within a React component, call `useGetManageSandboxPresetConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSandboxPresetConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSandboxPresetConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetManageSandboxPresetConfigQuery(baseOptions: Apollo.QueryHookOptions<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>(GetManageSandboxPresetConfigDocument, options);
      }
export function useGetManageSandboxPresetConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>(GetManageSandboxPresetConfigDocument, options);
        }
export type GetManageSandboxPresetConfigQueryHookResult = ReturnType<typeof useGetManageSandboxPresetConfigQuery>;
export type GetManageSandboxPresetConfigLazyQueryHookResult = ReturnType<typeof useGetManageSandboxPresetConfigLazyQuery>;
export type GetManageSandboxPresetConfigQueryResult = Apollo.QueryResult<GetManageSandboxPresetConfigQuery, GetManageSandboxPresetConfigQueryVariables>;
export const ManageSandboxPresetCreatePresetDocument = gql`
    mutation manageSandboxPresetCreatePreset($teamID: String!, $teamSlug: String!, $name: String!, $slug: String!, $config: SandboxConfigInput!) {
  createSandboxConfig(
    teamID: $teamID
    teamSlug: $teamSlug
    name: $name
    slug: $slug
    config: $config
  ) {
    id
    config {
      id
    }
  }
}
    `;
export type ManageSandboxPresetCreatePresetMutationFn = Apollo.MutationFunction<ManageSandboxPresetCreatePresetMutation, ManageSandboxPresetCreatePresetMutationVariables>;

/**
 * __useManageSandboxPresetCreatePresetMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetCreatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetCreatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetCreatePresetMutation, { data, loading, error }] = useManageSandboxPresetCreatePresetMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamSlug: // value for 'teamSlug'
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useManageSandboxPresetCreatePresetMutation(baseOptions?: Apollo.MutationHookOptions<ManageSandboxPresetCreatePresetMutation, ManageSandboxPresetCreatePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageSandboxPresetCreatePresetMutation, ManageSandboxPresetCreatePresetMutationVariables>(ManageSandboxPresetCreatePresetDocument, options);
      }
export type ManageSandboxPresetCreatePresetMutationHookResult = ReturnType<typeof useManageSandboxPresetCreatePresetMutation>;
export type ManageSandboxPresetCreatePresetMutationResult = Apollo.MutationResult<ManageSandboxPresetCreatePresetMutation>;
export type ManageSandboxPresetCreatePresetMutationOptions = Apollo.BaseMutationOptions<ManageSandboxPresetCreatePresetMutation, ManageSandboxPresetCreatePresetMutationVariables>;
export const ManageSandboxPresetUpdatePresetDocument = gql`
    mutation manageSandboxPresetUpdatePreset($configID: String!, $config: SandboxConfigInput!) {
  updateSandboxConfig(configID: $configID, config: $config) {
    id
    config {
      id
    }
  }
}
    `;
export type ManageSandboxPresetUpdatePresetMutationFn = Apollo.MutationFunction<ManageSandboxPresetUpdatePresetMutation, ManageSandboxPresetUpdatePresetMutationVariables>;

/**
 * __useManageSandboxPresetUpdatePresetMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetUpdatePresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetUpdatePresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetUpdatePresetMutation, { data, loading, error }] = useManageSandboxPresetUpdatePresetMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useManageSandboxPresetUpdatePresetMutation(baseOptions?: Apollo.MutationHookOptions<ManageSandboxPresetUpdatePresetMutation, ManageSandboxPresetUpdatePresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageSandboxPresetUpdatePresetMutation, ManageSandboxPresetUpdatePresetMutationVariables>(ManageSandboxPresetUpdatePresetDocument, options);
      }
export type ManageSandboxPresetUpdatePresetMutationHookResult = ReturnType<typeof useManageSandboxPresetUpdatePresetMutation>;
export type ManageSandboxPresetUpdatePresetMutationResult = Apollo.MutationResult<ManageSandboxPresetUpdatePresetMutation>;
export type ManageSandboxPresetUpdatePresetMutationOptions = Apollo.BaseMutationOptions<ManageSandboxPresetUpdatePresetMutation, ManageSandboxPresetUpdatePresetMutationVariables>;
export const ManageSandboxPresetPublishConfigDocument = gql`
    mutation manageSandboxPresetPublishConfig($configID: String!, $changeLogEntry: String!) {
  publishSandboxConfig(configID: $configID, changeLogEntry: $changeLogEntry) {
    id
  }
}
    `;
export type ManageSandboxPresetPublishConfigMutationFn = Apollo.MutationFunction<ManageSandboxPresetPublishConfigMutation, ManageSandboxPresetPublishConfigMutationVariables>;

/**
 * __useManageSandboxPresetPublishConfigMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetPublishConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetPublishConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetPublishConfigMutation, { data, loading, error }] = useManageSandboxPresetPublishConfigMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      changeLogEntry: // value for 'changeLogEntry'
 *   },
 * });
 */
export function useManageSandboxPresetPublishConfigMutation(baseOptions?: Apollo.MutationHookOptions<ManageSandboxPresetPublishConfigMutation, ManageSandboxPresetPublishConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageSandboxPresetPublishConfigMutation, ManageSandboxPresetPublishConfigMutationVariables>(ManageSandboxPresetPublishConfigDocument, options);
      }
export type ManageSandboxPresetPublishConfigMutationHookResult = ReturnType<typeof useManageSandboxPresetPublishConfigMutation>;
export type ManageSandboxPresetPublishConfigMutationResult = Apollo.MutationResult<ManageSandboxPresetPublishConfigMutation>;
export type ManageSandboxPresetPublishConfigMutationOptions = Apollo.BaseMutationOptions<ManageSandboxPresetPublishConfigMutation, ManageSandboxPresetPublishConfigMutationVariables>;
export const ManageSandboxPresetRenameSandboxDocument = gql`
    mutation manageSandboxPresetRenameSandbox($configID: String!, $name: String!) {
  renameSandboxConfig(configID: $configID, name: $name) {
    id
  }
}
    `;
export type ManageSandboxPresetRenameSandboxMutationFn = Apollo.MutationFunction<ManageSandboxPresetRenameSandboxMutation, ManageSandboxPresetRenameSandboxMutationVariables>;

/**
 * __useManageSandboxPresetRenameSandboxMutation__
 *
 * To run a mutation, you first call `useManageSandboxPresetRenameSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageSandboxPresetRenameSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageSandboxPresetRenameSandboxMutation, { data, loading, error }] = useManageSandboxPresetRenameSandboxMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useManageSandboxPresetRenameSandboxMutation(baseOptions?: Apollo.MutationHookOptions<ManageSandboxPresetRenameSandboxMutation, ManageSandboxPresetRenameSandboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageSandboxPresetRenameSandboxMutation, ManageSandboxPresetRenameSandboxMutationVariables>(ManageSandboxPresetRenameSandboxDocument, options);
      }
export type ManageSandboxPresetRenameSandboxMutationHookResult = ReturnType<typeof useManageSandboxPresetRenameSandboxMutation>;
export type ManageSandboxPresetRenameSandboxMutationResult = Apollo.MutationResult<ManageSandboxPresetRenameSandboxMutation>;
export type ManageSandboxPresetRenameSandboxMutationOptions = Apollo.BaseMutationOptions<ManageSandboxPresetRenameSandboxMutation, ManageSandboxPresetRenameSandboxMutationVariables>;
export const GetManageSandboxPresetVersionDocument = gql`
    query getManageSandboxPresetVersion($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
  sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
    ...ManageSandboxPresetVersion
  }
}
    ${ManageSandboxPresetVersionFragmentDoc}`;

/**
 * __useGetManageSandboxPresetVersionQuery__
 *
 * To run a query within a React component, call `useGetManageSandboxPresetVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSandboxPresetVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSandboxPresetVersionQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetManageSandboxPresetVersionQuery(baseOptions: Apollo.QueryHookOptions<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>(GetManageSandboxPresetVersionDocument, options);
      }
export function useGetManageSandboxPresetVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>(GetManageSandboxPresetVersionDocument, options);
        }
export type GetManageSandboxPresetVersionQueryHookResult = ReturnType<typeof useGetManageSandboxPresetVersionQuery>;
export type GetManageSandboxPresetVersionLazyQueryHookResult = ReturnType<typeof useGetManageSandboxPresetVersionLazyQuery>;
export type GetManageSandboxPresetVersionQueryResult = Apollo.QueryResult<GetManageSandboxPresetVersionQuery, GetManageSandboxPresetVersionQueryVariables>;
export const GetManageSandboxPresetTrackDocument = gql`
    query getManageSandboxPresetTrack($trackID: String!) {
  trackConfig(trackID: $trackID) {
    ...ManageTrackHostResources
    ...ManageTrackCloudAccsResources
    secrets {
      ...SandboxConfigSecret
    }
  }
  trackScripts(trackID: $trackID) {
    host
    action
    contents
  }
}
    ${ManageTrackHostResourcesFragmentDoc}
${ManageTrackCloudAccsResourcesFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;

/**
 * __useGetManageSandboxPresetTrackQuery__
 *
 * To run a query within a React component, call `useGetManageSandboxPresetTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSandboxPresetTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSandboxPresetTrackQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useGetManageSandboxPresetTrackQuery(baseOptions: Apollo.QueryHookOptions<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>(GetManageSandboxPresetTrackDocument, options);
      }
export function useGetManageSandboxPresetTrackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>(GetManageSandboxPresetTrackDocument, options);
        }
export type GetManageSandboxPresetTrackQueryHookResult = ReturnType<typeof useGetManageSandboxPresetTrackQuery>;
export type GetManageSandboxPresetTrackLazyQueryHookResult = ReturnType<typeof useGetManageSandboxPresetTrackLazyQuery>;
export type GetManageSandboxPresetTrackQueryResult = Apollo.QueryResult<GetManageSandboxPresetTrackQuery, GetManageSandboxPresetTrackQueryVariables>;
export const ManageTagsPageConfigDocument = gql`
    query ManageTagsPageConfig($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    tags {
      ...TagsTableTag
      ...TagGroupsTableTag
    }
    tagGroups {
      ...TagGroupsTableGroup
    }
  }
}
    ${TagsTableTagFragmentDoc}
${TagGroupsTableTagFragmentDoc}
${TagGroupsTableGroupFragmentDoc}`;

/**
 * __useManageTagsPageConfigQuery__
 *
 * To run a query within a React component, call `useManageTagsPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageTagsPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageTagsPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useManageTagsPageConfigQuery(baseOptions: Apollo.QueryHookOptions<ManageTagsPageConfigQuery, ManageTagsPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageTagsPageConfigQuery, ManageTagsPageConfigQueryVariables>(ManageTagsPageConfigDocument, options);
      }
export function useManageTagsPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageTagsPageConfigQuery, ManageTagsPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageTagsPageConfigQuery, ManageTagsPageConfigQueryVariables>(ManageTagsPageConfigDocument, options);
        }
export type ManageTagsPageConfigQueryHookResult = ReturnType<typeof useManageTagsPageConfigQuery>;
export type ManageTagsPageConfigLazyQueryHookResult = ReturnType<typeof useManageTagsPageConfigLazyQuery>;
export type ManageTagsPageConfigQueryResult = Apollo.QueryResult<ManageTagsPageConfigQuery, ManageTagsPageConfigQueryVariables>;
export const ManageTagsPageCreateTagDocument = gql`
    mutation ManageTagsPageCreateTag($teamID: ID!, $input: TagInput!) {
  createTag(teamID: $teamID, input: $input) {
    ...TagsTableTag
  }
}
    ${TagsTableTagFragmentDoc}`;
export type ManageTagsPageCreateTagMutationFn = Apollo.MutationFunction<ManageTagsPageCreateTagMutation, ManageTagsPageCreateTagMutationVariables>;

/**
 * __useManageTagsPageCreateTagMutation__
 *
 * To run a mutation, you first call `useManageTagsPageCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageTagsPageCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageTagsPageCreateTagMutation, { data, loading, error }] = useManageTagsPageCreateTagMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManageTagsPageCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<ManageTagsPageCreateTagMutation, ManageTagsPageCreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageTagsPageCreateTagMutation, ManageTagsPageCreateTagMutationVariables>(ManageTagsPageCreateTagDocument, options);
      }
export type ManageTagsPageCreateTagMutationHookResult = ReturnType<typeof useManageTagsPageCreateTagMutation>;
export type ManageTagsPageCreateTagMutationResult = Apollo.MutationResult<ManageTagsPageCreateTagMutation>;
export type ManageTagsPageCreateTagMutationOptions = Apollo.BaseMutationOptions<ManageTagsPageCreateTagMutation, ManageTagsPageCreateTagMutationVariables>;
export const ManageTagsPageUpdateTagDocument = gql`
    mutation ManageTagsPageUpdateTag($id: ID!, $input: TagInput!) {
  updateTag(id: $id, input: $input) {
    ...TagsTableTag
  }
}
    ${TagsTableTagFragmentDoc}`;
export type ManageTagsPageUpdateTagMutationFn = Apollo.MutationFunction<ManageTagsPageUpdateTagMutation, ManageTagsPageUpdateTagMutationVariables>;

/**
 * __useManageTagsPageUpdateTagMutation__
 *
 * To run a mutation, you first call `useManageTagsPageUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageTagsPageUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageTagsPageUpdateTagMutation, { data, loading, error }] = useManageTagsPageUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManageTagsPageUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<ManageTagsPageUpdateTagMutation, ManageTagsPageUpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageTagsPageUpdateTagMutation, ManageTagsPageUpdateTagMutationVariables>(ManageTagsPageUpdateTagDocument, options);
      }
export type ManageTagsPageUpdateTagMutationHookResult = ReturnType<typeof useManageTagsPageUpdateTagMutation>;
export type ManageTagsPageUpdateTagMutationResult = Apollo.MutationResult<ManageTagsPageUpdateTagMutation>;
export type ManageTagsPageUpdateTagMutationOptions = Apollo.BaseMutationOptions<ManageTagsPageUpdateTagMutation, ManageTagsPageUpdateTagMutationVariables>;
export const ManageTagsPageDeleteTagDocument = gql`
    mutation ManageTagsPageDeleteTag($id: ID!) {
  deleteTag(id: $id)
}
    `;
export type ManageTagsPageDeleteTagMutationFn = Apollo.MutationFunction<ManageTagsPageDeleteTagMutation, ManageTagsPageDeleteTagMutationVariables>;

/**
 * __useManageTagsPageDeleteTagMutation__
 *
 * To run a mutation, you first call `useManageTagsPageDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageTagsPageDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageTagsPageDeleteTagMutation, { data, loading, error }] = useManageTagsPageDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManageTagsPageDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<ManageTagsPageDeleteTagMutation, ManageTagsPageDeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageTagsPageDeleteTagMutation, ManageTagsPageDeleteTagMutationVariables>(ManageTagsPageDeleteTagDocument, options);
      }
export type ManageTagsPageDeleteTagMutationHookResult = ReturnType<typeof useManageTagsPageDeleteTagMutation>;
export type ManageTagsPageDeleteTagMutationResult = Apollo.MutationResult<ManageTagsPageDeleteTagMutation>;
export type ManageTagsPageDeleteTagMutationOptions = Apollo.BaseMutationOptions<ManageTagsPageDeleteTagMutation, ManageTagsPageDeleteTagMutationVariables>;
export const ManageTagsPageCreateTagGroupDocument = gql`
    mutation ManageTagsPageCreateTagGroup($teamID: ID!, $input: TagGroupInput!, $tagIDs: [ID!]!) {
  createTagGroup(teamID: $teamID, input: $input, tagIDs: $tagIDs) {
    ...TagGroupsTableGroup
  }
}
    ${TagGroupsTableGroupFragmentDoc}`;
export type ManageTagsPageCreateTagGroupMutationFn = Apollo.MutationFunction<ManageTagsPageCreateTagGroupMutation, ManageTagsPageCreateTagGroupMutationVariables>;

/**
 * __useManageTagsPageCreateTagGroupMutation__
 *
 * To run a mutation, you first call `useManageTagsPageCreateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageTagsPageCreateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageTagsPageCreateTagGroupMutation, { data, loading, error }] = useManageTagsPageCreateTagGroupMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      input: // value for 'input'
 *      tagIDs: // value for 'tagIDs'
 *   },
 * });
 */
export function useManageTagsPageCreateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<ManageTagsPageCreateTagGroupMutation, ManageTagsPageCreateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageTagsPageCreateTagGroupMutation, ManageTagsPageCreateTagGroupMutationVariables>(ManageTagsPageCreateTagGroupDocument, options);
      }
export type ManageTagsPageCreateTagGroupMutationHookResult = ReturnType<typeof useManageTagsPageCreateTagGroupMutation>;
export type ManageTagsPageCreateTagGroupMutationResult = Apollo.MutationResult<ManageTagsPageCreateTagGroupMutation>;
export type ManageTagsPageCreateTagGroupMutationOptions = Apollo.BaseMutationOptions<ManageTagsPageCreateTagGroupMutation, ManageTagsPageCreateTagGroupMutationVariables>;
export const ManageTagsPageUpdateTagGroupDocument = gql`
    mutation ManageTagsPageUpdateTagGroup($id: ID!, $input: TagGroupInput!, $tagIDs: [ID!]!) {
  updateTagGroup(id: $id, input: $input, tagIDs: $tagIDs) {
    ...TagGroupsTableGroup
  }
}
    ${TagGroupsTableGroupFragmentDoc}`;
export type ManageTagsPageUpdateTagGroupMutationFn = Apollo.MutationFunction<ManageTagsPageUpdateTagGroupMutation, ManageTagsPageUpdateTagGroupMutationVariables>;

/**
 * __useManageTagsPageUpdateTagGroupMutation__
 *
 * To run a mutation, you first call `useManageTagsPageUpdateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageTagsPageUpdateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageTagsPageUpdateTagGroupMutation, { data, loading, error }] = useManageTagsPageUpdateTagGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      tagIDs: // value for 'tagIDs'
 *   },
 * });
 */
export function useManageTagsPageUpdateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<ManageTagsPageUpdateTagGroupMutation, ManageTagsPageUpdateTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageTagsPageUpdateTagGroupMutation, ManageTagsPageUpdateTagGroupMutationVariables>(ManageTagsPageUpdateTagGroupDocument, options);
      }
export type ManageTagsPageUpdateTagGroupMutationHookResult = ReturnType<typeof useManageTagsPageUpdateTagGroupMutation>;
export type ManageTagsPageUpdateTagGroupMutationResult = Apollo.MutationResult<ManageTagsPageUpdateTagGroupMutation>;
export type ManageTagsPageUpdateTagGroupMutationOptions = Apollo.BaseMutationOptions<ManageTagsPageUpdateTagGroupMutation, ManageTagsPageUpdateTagGroupMutationVariables>;
export const ManageTagsPageDeleteTagGroupDocument = gql`
    mutation ManageTagsPageDeleteTagGroup($id: ID!) {
  deleteTagGroup(id: $id)
}
    `;
export type ManageTagsPageDeleteTagGroupMutationFn = Apollo.MutationFunction<ManageTagsPageDeleteTagGroupMutation, ManageTagsPageDeleteTagGroupMutationVariables>;

/**
 * __useManageTagsPageDeleteTagGroupMutation__
 *
 * To run a mutation, you first call `useManageTagsPageDeleteTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManageTagsPageDeleteTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manageTagsPageDeleteTagGroupMutation, { data, loading, error }] = useManageTagsPageDeleteTagGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManageTagsPageDeleteTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<ManageTagsPageDeleteTagGroupMutation, ManageTagsPageDeleteTagGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManageTagsPageDeleteTagGroupMutation, ManageTagsPageDeleteTagGroupMutationVariables>(ManageTagsPageDeleteTagGroupDocument, options);
      }
export type ManageTagsPageDeleteTagGroupMutationHookResult = ReturnType<typeof useManageTagsPageDeleteTagGroupMutation>;
export type ManageTagsPageDeleteTagGroupMutationResult = Apollo.MutationResult<ManageTagsPageDeleteTagGroupMutation>;
export type ManageTagsPageDeleteTagGroupMutationOptions = Apollo.BaseMutationOptions<ManageTagsPageDeleteTagGroupMutation, ManageTagsPageDeleteTagGroupMutationVariables>;
export const MembersPageDocument = gql`
    query MembersPage($teamSlug: String!) {
  userInTeam(teamSlug: $teamSlug)
  team(teamSlug: $teamSlug) {
    id
    ...MembersTeam
    ...InvitesTeam
  }
}
    ${MembersTeamFragmentDoc}
${InvitesTeamFragmentDoc}`;

/**
 * __useMembersPageQuery__
 *
 * To run a query within a React component, call `useMembersPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembersPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useMembersPageQuery(baseOptions: Apollo.QueryHookOptions<MembersPageQuery, MembersPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MembersPageQuery, MembersPageQueryVariables>(MembersPageDocument, options);
      }
export function useMembersPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MembersPageQuery, MembersPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MembersPageQuery, MembersPageQueryVariables>(MembersPageDocument, options);
        }
export type MembersPageQueryHookResult = ReturnType<typeof useMembersPageQuery>;
export type MembersPageLazyQueryHookResult = ReturnType<typeof useMembersPageLazyQuery>;
export type MembersPageQueryResult = Apollo.QueryResult<MembersPageQuery, MembersPageQueryVariables>;
export const PlayActivityReportPageDocument = gql`
    query PlayActivityReportPage($playReportInput: PlayReportInput!, $teamSlug: String!) {
  playReports(input: $playReportInput) {
    items {
      ...PlayActivityReportsTable
    }
    totalItems
  }
}
    ${PlayActivityReportsTableFragmentDoc}`;

/**
 * __usePlayActivityReportPageQuery__
 *
 * To run a query within a React component, call `usePlayActivityReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayActivityReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayActivityReportPageQuery({
 *   variables: {
 *      playReportInput: // value for 'playReportInput'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function usePlayActivityReportPageQuery(baseOptions: Apollo.QueryHookOptions<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>(PlayActivityReportPageDocument, options);
      }
export function usePlayActivityReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>(PlayActivityReportPageDocument, options);
        }
export type PlayActivityReportPageQueryHookResult = ReturnType<typeof usePlayActivityReportPageQuery>;
export type PlayActivityReportPageLazyQueryHookResult = ReturnType<typeof usePlayActivityReportPageLazyQuery>;
export type PlayActivityReportPageQueryResult = Apollo.QueryResult<PlayActivityReportPageQuery, PlayActivityReportPageQueryVariables>;
export const PlayActivityReportFiltersDocument = gql`
    query PlayActivityReportFilters($teamSlug: String!) {
  tracks(teamSlug: $teamSlug) {
    ...TrackFilterTrack
  }
  team(teamSlug: $teamSlug) {
    userDetails {
      ...UserFilterListItem
    }
  }
  trackInvites(teamSlug: $teamSlug) {
    ...InviteFilterListItem
  }
}
    ${TrackFilterTrackFragmentDoc}
${UserFilterListItemFragmentDoc}
${InviteFilterListItemFragmentDoc}`;

/**
 * __usePlayActivityReportFiltersQuery__
 *
 * To run a query within a React component, call `usePlayActivityReportFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayActivityReportFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayActivityReportFiltersQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function usePlayActivityReportFiltersQuery(baseOptions: Apollo.QueryHookOptions<PlayActivityReportFiltersQuery, PlayActivityReportFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayActivityReportFiltersQuery, PlayActivityReportFiltersQueryVariables>(PlayActivityReportFiltersDocument, options);
      }
export function usePlayActivityReportFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayActivityReportFiltersQuery, PlayActivityReportFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayActivityReportFiltersQuery, PlayActivityReportFiltersQueryVariables>(PlayActivityReportFiltersDocument, options);
        }
export type PlayActivityReportFiltersQueryHookResult = ReturnType<typeof usePlayActivityReportFiltersQuery>;
export type PlayActivityReportFiltersLazyQueryHookResult = ReturnType<typeof usePlayActivityReportFiltersLazyQuery>;
export type PlayActivityReportFiltersQueryResult = Apollo.QueryResult<PlayActivityReportFiltersQuery, PlayActivityReportFiltersQueryVariables>;
export const PlayActivityReportCsvDocument = gql`
    query PlayActivityReportCSV($playReportInput: PlayReportInput!, $teamSlug: String!) {
  playReports(input: $playReportInput) {
    items {
      ...DownloadPlayActivityReportCSV
    }
  }
}
    ${DownloadPlayActivityReportCsvFragmentDoc}`;

/**
 * __usePlayActivityReportCsvQuery__
 *
 * To run a query within a React component, call `usePlayActivityReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayActivityReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayActivityReportCsvQuery({
 *   variables: {
 *      playReportInput: // value for 'playReportInput'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function usePlayActivityReportCsvQuery(baseOptions: Apollo.QueryHookOptions<PlayActivityReportCsvQuery, PlayActivityReportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayActivityReportCsvQuery, PlayActivityReportCsvQueryVariables>(PlayActivityReportCsvDocument, options);
      }
export function usePlayActivityReportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayActivityReportCsvQuery, PlayActivityReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayActivityReportCsvQuery, PlayActivityReportCsvQueryVariables>(PlayActivityReportCsvDocument, options);
        }
export type PlayActivityReportCsvQueryHookResult = ReturnType<typeof usePlayActivityReportCsvQuery>;
export type PlayActivityReportCsvLazyQueryHookResult = ReturnType<typeof usePlayActivityReportCsvLazyQuery>;
export type PlayActivityReportCsvQueryResult = Apollo.QueryResult<PlayActivityReportCsvQuery, PlayActivityReportCsvQueryVariables>;
export const GetPreviewSandboxPresetPageConfigDocument = gql`
    query getPreviewSandboxPresetPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
  userInTeam(teamSlug: $teamSlug)
  team(teamSlug: $teamSlug) {
    id
    features {
      containers
      virtual_machines
      saas
      custom_machine_type
      aws_accounts
      azure_subscriptions
      gcp_projects
      shared_hotstart_pools
    }
  }
  sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
    ...PreviewSandboxPresetVersion
  }
}
    ${PreviewSandboxPresetVersionFragmentDoc}`;

/**
 * __useGetPreviewSandboxPresetPageConfigQuery__
 *
 * To run a query within a React component, call `useGetPreviewSandboxPresetPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewSandboxPresetPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewSandboxPresetPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPreviewSandboxPresetPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewSandboxPresetPageConfigQuery, GetPreviewSandboxPresetPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewSandboxPresetPageConfigQuery, GetPreviewSandboxPresetPageConfigQueryVariables>(GetPreviewSandboxPresetPageConfigDocument, options);
      }
export function useGetPreviewSandboxPresetPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewSandboxPresetPageConfigQuery, GetPreviewSandboxPresetPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewSandboxPresetPageConfigQuery, GetPreviewSandboxPresetPageConfigQueryVariables>(GetPreviewSandboxPresetPageConfigDocument, options);
        }
export type GetPreviewSandboxPresetPageConfigQueryHookResult = ReturnType<typeof useGetPreviewSandboxPresetPageConfigQuery>;
export type GetPreviewSandboxPresetPageConfigLazyQueryHookResult = ReturnType<typeof useGetPreviewSandboxPresetPageConfigLazyQuery>;
export type GetPreviewSandboxPresetPageConfigQueryResult = Apollo.QueryResult<GetPreviewSandboxPresetPageConfigQuery, GetPreviewSandboxPresetPageConfigQueryVariables>;
export const PreviewSandboxPresetDeleteSandboxConfigDocument = gql`
    mutation previewSandboxPresetDeleteSandboxConfig($configVersionID: String!) {
  deleteSandboxConfig(configVersionID: $configVersionID)
}
    `;
export type PreviewSandboxPresetDeleteSandboxConfigMutationFn = Apollo.MutationFunction<PreviewSandboxPresetDeleteSandboxConfigMutation, PreviewSandboxPresetDeleteSandboxConfigMutationVariables>;

/**
 * __usePreviewSandboxPresetDeleteSandboxConfigMutation__
 *
 * To run a mutation, you first call `usePreviewSandboxPresetDeleteSandboxConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewSandboxPresetDeleteSandboxConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewSandboxPresetDeleteSandboxConfigMutation, { data, loading, error }] = usePreviewSandboxPresetDeleteSandboxConfigMutation({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function usePreviewSandboxPresetDeleteSandboxConfigMutation(baseOptions?: Apollo.MutationHookOptions<PreviewSandboxPresetDeleteSandboxConfigMutation, PreviewSandboxPresetDeleteSandboxConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewSandboxPresetDeleteSandboxConfigMutation, PreviewSandboxPresetDeleteSandboxConfigMutationVariables>(PreviewSandboxPresetDeleteSandboxConfigDocument, options);
      }
export type PreviewSandboxPresetDeleteSandboxConfigMutationHookResult = ReturnType<typeof usePreviewSandboxPresetDeleteSandboxConfigMutation>;
export type PreviewSandboxPresetDeleteSandboxConfigMutationResult = Apollo.MutationResult<PreviewSandboxPresetDeleteSandboxConfigMutation>;
export type PreviewSandboxPresetDeleteSandboxConfigMutationOptions = Apollo.BaseMutationOptions<PreviewSandboxPresetDeleteSandboxConfigMutation, PreviewSandboxPresetDeleteSandboxConfigMutationVariables>;
export const GetSandboxPresetsListPageConfigDocument = gql`
    query getSandboxPresetsListPageConfig($teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
  team(teamSlug: $teamSlug) {
    id
    features {
      shared_hotstart_pools
    }
  }
  sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
    ...SandboxPresetListCard
  }
}
    ${SandboxPresetListCardFragmentDoc}`;

/**
 * __useGetSandboxPresetsListPageConfigQuery__
 *
 * To run a query within a React component, call `useGetSandboxPresetsListPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSandboxPresetsListPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSandboxPresetsListPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSandboxPresetsListPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetSandboxPresetsListPageConfigQuery, GetSandboxPresetsListPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSandboxPresetsListPageConfigQuery, GetSandboxPresetsListPageConfigQueryVariables>(GetSandboxPresetsListPageConfigDocument, options);
      }
export function useGetSandboxPresetsListPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSandboxPresetsListPageConfigQuery, GetSandboxPresetsListPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSandboxPresetsListPageConfigQuery, GetSandboxPresetsListPageConfigQueryVariables>(GetSandboxPresetsListPageConfigDocument, options);
        }
export type GetSandboxPresetsListPageConfigQueryHookResult = ReturnType<typeof useGetSandboxPresetsListPageConfigQuery>;
export type GetSandboxPresetsListPageConfigLazyQueryHookResult = ReturnType<typeof useGetSandboxPresetsListPageConfigLazyQuery>;
export type GetSandboxPresetsListPageConfigQueryResult = Apollo.QueryResult<GetSandboxPresetsListPageConfigQuery, GetSandboxPresetsListPageConfigQueryVariables>;
export const SandboxPresetsListPagePublishConfigDocument = gql`
    mutation sandboxPresetsListPagePublishConfig($configID: String!, $changeLogEntry: String!) {
  publishSandboxConfig(configID: $configID, changeLogEntry: $changeLogEntry) {
    id
  }
}
    `;
export type SandboxPresetsListPagePublishConfigMutationFn = Apollo.MutationFunction<SandboxPresetsListPagePublishConfigMutation, SandboxPresetsListPagePublishConfigMutationVariables>;

/**
 * __useSandboxPresetsListPagePublishConfigMutation__
 *
 * To run a mutation, you first call `useSandboxPresetsListPagePublishConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxPresetsListPagePublishConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxPresetsListPagePublishConfigMutation, { data, loading, error }] = useSandboxPresetsListPagePublishConfigMutation({
 *   variables: {
 *      configID: // value for 'configID'
 *      changeLogEntry: // value for 'changeLogEntry'
 *   },
 * });
 */
export function useSandboxPresetsListPagePublishConfigMutation(baseOptions?: Apollo.MutationHookOptions<SandboxPresetsListPagePublishConfigMutation, SandboxPresetsListPagePublishConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxPresetsListPagePublishConfigMutation, SandboxPresetsListPagePublishConfigMutationVariables>(SandboxPresetsListPagePublishConfigDocument, options);
      }
export type SandboxPresetsListPagePublishConfigMutationHookResult = ReturnType<typeof useSandboxPresetsListPagePublishConfigMutation>;
export type SandboxPresetsListPagePublishConfigMutationResult = Apollo.MutationResult<SandboxPresetsListPagePublishConfigMutation>;
export type SandboxPresetsListPagePublishConfigMutationOptions = Apollo.BaseMutationOptions<SandboxPresetsListPagePublishConfigMutation, SandboxPresetsListPagePublishConfigMutationVariables>;
export const SandboxPresetsListDeleteSandboxConfigDocument = gql`
    mutation sandboxPresetsListDeleteSandboxConfig($configVersionID: String!) {
  deleteSandboxConfig(configVersionID: $configVersionID)
}
    `;
export type SandboxPresetsListDeleteSandboxConfigMutationFn = Apollo.MutationFunction<SandboxPresetsListDeleteSandboxConfigMutation, SandboxPresetsListDeleteSandboxConfigMutationVariables>;

/**
 * __useSandboxPresetsListDeleteSandboxConfigMutation__
 *
 * To run a mutation, you first call `useSandboxPresetsListDeleteSandboxConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSandboxPresetsListDeleteSandboxConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sandboxPresetsListDeleteSandboxConfigMutation, { data, loading, error }] = useSandboxPresetsListDeleteSandboxConfigMutation({
 *   variables: {
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useSandboxPresetsListDeleteSandboxConfigMutation(baseOptions?: Apollo.MutationHookOptions<SandboxPresetsListDeleteSandboxConfigMutation, SandboxPresetsListDeleteSandboxConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SandboxPresetsListDeleteSandboxConfigMutation, SandboxPresetsListDeleteSandboxConfigMutationVariables>(SandboxPresetsListDeleteSandboxConfigDocument, options);
      }
export type SandboxPresetsListDeleteSandboxConfigMutationHookResult = ReturnType<typeof useSandboxPresetsListDeleteSandboxConfigMutation>;
export type SandboxPresetsListDeleteSandboxConfigMutationResult = Apollo.MutationResult<SandboxPresetsListDeleteSandboxConfigMutation>;
export type SandboxPresetsListDeleteSandboxConfigMutationOptions = Apollo.BaseMutationOptions<SandboxPresetsListDeleteSandboxConfigMutation, SandboxPresetsListDeleteSandboxConfigMutationVariables>;
export const SandboxesFormDataDocument = gql`
    query sandboxesFormData($teamSlug: String!) {
  tracks(teamSlug: $teamSlug) {
    id
    title
  }
  trackInvites(teamSlug: $teamSlug) {
    id
    title
    publicTitle
  }
  hotStartPools(teamSlug: $teamSlug) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSandboxesFormDataQuery__
 *
 * To run a query within a React component, call `useSandboxesFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxesFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxesFormDataQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useSandboxesFormDataQuery(baseOptions: Apollo.QueryHookOptions<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>(SandboxesFormDataDocument, options);
      }
export function useSandboxesFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>(SandboxesFormDataDocument, options);
        }
export type SandboxesFormDataQueryHookResult = ReturnType<typeof useSandboxesFormDataQuery>;
export type SandboxesFormDataLazyQueryHookResult = ReturnType<typeof useSandboxesFormDataLazyQuery>;
export type SandboxesFormDataQueryResult = Apollo.QueryResult<SandboxesFormDataQuery, SandboxesFormDataQueryVariables>;
export const SandboxesDocument = gql`
    query sandboxes($teamSlug: String!, $filter: SandboxFilterInput!, $paging: Pagination!, $ordering: Ordering!) {
  sandboxes(
    teamSlug: $teamSlug
    filter: $filter
    paging: $paging
    ordering: $ordering
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        hot_start_pool {
          id
          name
        }
        created
        ttl
        state
        id
        invite {
          id
          title
          publicTitle
        }
        track {
          id
          slug
          title
        }
        user {
          id
          profile {
            display_name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSandboxesQuery__
 *
 * To run a query within a React component, call `useSandboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxesQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      ordering: // value for 'ordering'
 *   },
 * });
 */
export function useSandboxesQuery(baseOptions: Apollo.QueryHookOptions<SandboxesQuery, SandboxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SandboxesQuery, SandboxesQueryVariables>(SandboxesDocument, options);
      }
export function useSandboxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SandboxesQuery, SandboxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SandboxesQuery, SandboxesQueryVariables>(SandboxesDocument, options);
        }
export type SandboxesQueryHookResult = ReturnType<typeof useSandboxesQuery>;
export type SandboxesLazyQueryHookResult = ReturnType<typeof useSandboxesLazyQuery>;
export type SandboxesQueryResult = Apollo.QueryResult<SandboxesQuery, SandboxesQueryVariables>;
export const UpdateSandboxTtlDocument = gql`
    mutation updateSandboxTTL($sandboxID: String!, $until: Time!) {
  updateSandboxTTL(sandboxID: $sandboxID, until: $until) {
    id
  }
}
    `;
export type UpdateSandboxTtlMutationFn = Apollo.MutationFunction<UpdateSandboxTtlMutation, UpdateSandboxTtlMutationVariables>;

/**
 * __useUpdateSandboxTtlMutation__
 *
 * To run a mutation, you first call `useUpdateSandboxTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSandboxTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSandboxTtlMutation, { data, loading, error }] = useUpdateSandboxTtlMutation({
 *   variables: {
 *      sandboxID: // value for 'sandboxID'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useUpdateSandboxTtlMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSandboxTtlMutation, UpdateSandboxTtlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSandboxTtlMutation, UpdateSandboxTtlMutationVariables>(UpdateSandboxTtlDocument, options);
      }
export type UpdateSandboxTtlMutationHookResult = ReturnType<typeof useUpdateSandboxTtlMutation>;
export type UpdateSandboxTtlMutationResult = Apollo.MutationResult<UpdateSandboxTtlMutation>;
export type UpdateSandboxTtlMutationOptions = Apollo.BaseMutationOptions<UpdateSandboxTtlMutation, UpdateSandboxTtlMutationVariables>;
export const StopSandboxDocument = gql`
    mutation stopSandbox($sandboxID: String!) {
  stopSandbox(sandboxID: $sandboxID) {
    id
  }
}
    `;
export type StopSandboxMutationFn = Apollo.MutationFunction<StopSandboxMutation, StopSandboxMutationVariables>;

/**
 * __useStopSandboxMutation__
 *
 * To run a mutation, you first call `useStopSandboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopSandboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopSandboxMutation, { data, loading, error }] = useStopSandboxMutation({
 *   variables: {
 *      sandboxID: // value for 'sandboxID'
 *   },
 * });
 */
export function useStopSandboxMutation(baseOptions?: Apollo.MutationHookOptions<StopSandboxMutation, StopSandboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopSandboxMutation, StopSandboxMutationVariables>(StopSandboxDocument, options);
      }
export type StopSandboxMutationHookResult = ReturnType<typeof useStopSandboxMutation>;
export type StopSandboxMutationResult = Apollo.MutationResult<StopSandboxMutation>;
export type StopSandboxMutationOptions = Apollo.BaseMutationOptions<StopSandboxMutation, StopSandboxMutationVariables>;
export const SsoManagementDocument = gql`
    query SSOManagement($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    ssoConnection {
      options {
        ...SSOConfigDrawerOptions
      }
      name
      strategy
      organizationID
    }
  }
}
    ${SsoConfigDrawerOptionsFragmentDoc}`;

/**
 * __useSsoManagementQuery__
 *
 * To run a query within a React component, call `useSsoManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoManagementQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useSsoManagementQuery(baseOptions: Apollo.QueryHookOptions<SsoManagementQuery, SsoManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsoManagementQuery, SsoManagementQueryVariables>(SsoManagementDocument, options);
      }
export function useSsoManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsoManagementQuery, SsoManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsoManagementQuery, SsoManagementQueryVariables>(SsoManagementDocument, options);
        }
export type SsoManagementQueryHookResult = ReturnType<typeof useSsoManagementQuery>;
export type SsoManagementLazyQueryHookResult = ReturnType<typeof useSsoManagementLazyQuery>;
export type SsoManagementQueryResult = Apollo.QueryResult<SsoManagementQuery, SsoManagementQueryVariables>;
export const CreateSamlSsoConnectionDocument = gql`
    mutation createSamlSsoConnection($teamID: ID!, $ssoConnection: SsoSamlConnectionInput!) {
  createSamlSsoConnection(teamID: $teamID, ssoConnection: $ssoConnection) {
    options {
      ...SSOConfigDrawerOptions
    }
    name
    strategy
    organizationID
  }
}
    ${SsoConfigDrawerOptionsFragmentDoc}`;
export type CreateSamlSsoConnectionMutationFn = Apollo.MutationFunction<CreateSamlSsoConnectionMutation, CreateSamlSsoConnectionMutationVariables>;

/**
 * __useCreateSamlSsoConnectionMutation__
 *
 * To run a mutation, you first call `useCreateSamlSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSamlSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSamlSsoConnectionMutation, { data, loading, error }] = useCreateSamlSsoConnectionMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      ssoConnection: // value for 'ssoConnection'
 *   },
 * });
 */
export function useCreateSamlSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSamlSsoConnectionMutation, CreateSamlSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSamlSsoConnectionMutation, CreateSamlSsoConnectionMutationVariables>(CreateSamlSsoConnectionDocument, options);
      }
export type CreateSamlSsoConnectionMutationHookResult = ReturnType<typeof useCreateSamlSsoConnectionMutation>;
export type CreateSamlSsoConnectionMutationResult = Apollo.MutationResult<CreateSamlSsoConnectionMutation>;
export type CreateSamlSsoConnectionMutationOptions = Apollo.BaseMutationOptions<CreateSamlSsoConnectionMutation, CreateSamlSsoConnectionMutationVariables>;
export const UpdateSamlSsoConnectionDocument = gql`
    mutation updateSamlSsoConnection($teamID: ID!, $ssoConnection: SsoSamlConnectionInput!, $connectionName: String!) {
  updateSamlSsoConnection(
    teamID: $teamID
    ssoConnection: $ssoConnection
    connectionName: $connectionName
  ) {
    options {
      ...SSOConfigDrawerOptions
    }
    name
    strategy
    organizationID
  }
}
    ${SsoConfigDrawerOptionsFragmentDoc}`;
export type UpdateSamlSsoConnectionMutationFn = Apollo.MutationFunction<UpdateSamlSsoConnectionMutation, UpdateSamlSsoConnectionMutationVariables>;

/**
 * __useUpdateSamlSsoConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateSamlSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSamlSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSamlSsoConnectionMutation, { data, loading, error }] = useUpdateSamlSsoConnectionMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      ssoConnection: // value for 'ssoConnection'
 *      connectionName: // value for 'connectionName'
 *   },
 * });
 */
export function useUpdateSamlSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSamlSsoConnectionMutation, UpdateSamlSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSamlSsoConnectionMutation, UpdateSamlSsoConnectionMutationVariables>(UpdateSamlSsoConnectionDocument, options);
      }
export type UpdateSamlSsoConnectionMutationHookResult = ReturnType<typeof useUpdateSamlSsoConnectionMutation>;
export type UpdateSamlSsoConnectionMutationResult = Apollo.MutationResult<UpdateSamlSsoConnectionMutation>;
export type UpdateSamlSsoConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateSamlSsoConnectionMutation, UpdateSamlSsoConnectionMutationVariables>;
export const CreateSsoConnectionDocument = gql`
    mutation createSsoConnection($teamID: ID!, $ssoConnection: SsoConnectionInput!) {
  createSsoConnection(teamID: $teamID, ssoConnection: $ssoConnection) {
    options {
      ...SSOConfigDrawerOptions
    }
    name
    strategy
    organizationID
  }
}
    ${SsoConfigDrawerOptionsFragmentDoc}`;
export type CreateSsoConnectionMutationFn = Apollo.MutationFunction<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>;

/**
 * __useCreateSsoConnectionMutation__
 *
 * To run a mutation, you first call `useCreateSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSsoConnectionMutation, { data, loading, error }] = useCreateSsoConnectionMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      ssoConnection: // value for 'ssoConnection'
 *   },
 * });
 */
export function useCreateSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>(CreateSsoConnectionDocument, options);
      }
export type CreateSsoConnectionMutationHookResult = ReturnType<typeof useCreateSsoConnectionMutation>;
export type CreateSsoConnectionMutationResult = Apollo.MutationResult<CreateSsoConnectionMutation>;
export type CreateSsoConnectionMutationOptions = Apollo.BaseMutationOptions<CreateSsoConnectionMutation, CreateSsoConnectionMutationVariables>;
export const UpdateSsoConnectionDocument = gql`
    mutation updateSsoConnection($teamID: ID!, $ssoConnection: SsoConnectionInput!, $connectionName: String!) {
  updateSsoConnection(
    teamID: $teamID
    ssoConnection: $ssoConnection
    connectionName: $connectionName
  ) {
    options {
      ...SSOConfigDrawerOptions
    }
    name
    strategy
    organizationID
  }
}
    ${SsoConfigDrawerOptionsFragmentDoc}`;
export type UpdateSsoConnectionMutationFn = Apollo.MutationFunction<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>;

/**
 * __useUpdateSsoConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoConnectionMutation, { data, loading, error }] = useUpdateSsoConnectionMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      ssoConnection: // value for 'ssoConnection'
 *      connectionName: // value for 'connectionName'
 *   },
 * });
 */
export function useUpdateSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>(UpdateSsoConnectionDocument, options);
      }
export type UpdateSsoConnectionMutationHookResult = ReturnType<typeof useUpdateSsoConnectionMutation>;
export type UpdateSsoConnectionMutationResult = Apollo.MutationResult<UpdateSsoConnectionMutation>;
export type UpdateSsoConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateSsoConnectionMutation, UpdateSsoConnectionMutationVariables>;
export const DeleteSsoConnectionDocument = gql`
    mutation deleteSsoConnection($teamID: ID!, $connectionName: String!) {
  deleteSsoConnection(teamID: $teamID, connectionName: $connectionName)
}
    `;
export type DeleteSsoConnectionMutationFn = Apollo.MutationFunction<DeleteSsoConnectionMutation, DeleteSsoConnectionMutationVariables>;

/**
 * __useDeleteSsoConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteSsoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSsoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSsoConnectionMutation, { data, loading, error }] = useDeleteSsoConnectionMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      connectionName: // value for 'connectionName'
 *   },
 * });
 */
export function useDeleteSsoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSsoConnectionMutation, DeleteSsoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSsoConnectionMutation, DeleteSsoConnectionMutationVariables>(DeleteSsoConnectionDocument, options);
      }
export type DeleteSsoConnectionMutationHookResult = ReturnType<typeof useDeleteSsoConnectionMutation>;
export type DeleteSsoConnectionMutationResult = Apollo.MutationResult<DeleteSsoConnectionMutation>;
export type DeleteSsoConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteSsoConnectionMutation, DeleteSsoConnectionMutationVariables>;
export const TeamPageDocument = gql`
    query TeamPage($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    name
    logo
    title
    subtitle
    slug
    primary_link_text
    primary_link_url
    secondary_link_text
    secondary_link_url
    tracks {
      ...TeamContentTrack
    }
    tags {
      ...TeamContentTag
    }
    tagGroups {
      ...TeamPageTagGroup
    }
    theme {
      foreground_color
      foreground_image
      background_color
      background_image
      primary_foreground_color
      primary_background_color
      secondary_foreground_color
      secondary_background_color
    }
  }
}
    ${TeamContentTrackFragmentDoc}
${TeamContentTagFragmentDoc}
${TeamPageTagGroupFragmentDoc}`;

/**
 * __useTeamPageQuery__
 *
 * To run a query within a React component, call `useTeamPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTeamPageQuery(baseOptions: Apollo.QueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
      }
export function useTeamPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamPageQuery, TeamPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamPageQuery, TeamPageQueryVariables>(TeamPageDocument, options);
        }
export type TeamPageQueryHookResult = ReturnType<typeof useTeamPageQuery>;
export type TeamPageLazyQueryHookResult = ReturnType<typeof useTeamPageLazyQuery>;
export type TeamPageQueryResult = Apollo.QueryResult<TeamPageQuery, TeamPageQueryVariables>;
export const TeamPageDeleteTrackDocument = gql`
    mutation TeamPageDeleteTrack($trackID: String!) {
  deleteTrack(trackID: $trackID)
}
    `;
export type TeamPageDeleteTrackMutationFn = Apollo.MutationFunction<TeamPageDeleteTrackMutation, TeamPageDeleteTrackMutationVariables>;

/**
 * __useTeamPageDeleteTrackMutation__
 *
 * To run a mutation, you first call `useTeamPageDeleteTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamPageDeleteTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamPageDeleteTrackMutation, { data, loading, error }] = useTeamPageDeleteTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useTeamPageDeleteTrackMutation(baseOptions?: Apollo.MutationHookOptions<TeamPageDeleteTrackMutation, TeamPageDeleteTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamPageDeleteTrackMutation, TeamPageDeleteTrackMutationVariables>(TeamPageDeleteTrackDocument, options);
      }
export type TeamPageDeleteTrackMutationHookResult = ReturnType<typeof useTeamPageDeleteTrackMutation>;
export type TeamPageDeleteTrackMutationResult = Apollo.MutationResult<TeamPageDeleteTrackMutation>;
export type TeamPageDeleteTrackMutationOptions = Apollo.BaseMutationOptions<TeamPageDeleteTrackMutation, TeamPageDeleteTrackMutationVariables>;
export const TeamSecretsUpsertTeamSecretDocument = gql`
    mutation TeamSecretsUpsertTeamSecret($teamSlug: String!, $name: String!, $description: String!, $secret: String!) {
  upsertTeamSecret(
    teamSlug: $teamSlug
    name: $name
    description: $description
    secret: $secret
  ) {
    name
  }
}
    `;
export type TeamSecretsUpsertTeamSecretMutationFn = Apollo.MutationFunction<TeamSecretsUpsertTeamSecretMutation, TeamSecretsUpsertTeamSecretMutationVariables>;

/**
 * __useTeamSecretsUpsertTeamSecretMutation__
 *
 * To run a mutation, you first call `useTeamSecretsUpsertTeamSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamSecretsUpsertTeamSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamSecretsUpsertTeamSecretMutation, { data, loading, error }] = useTeamSecretsUpsertTeamSecretMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      secret: // value for 'secret'
 *   },
 * });
 */
export function useTeamSecretsUpsertTeamSecretMutation(baseOptions?: Apollo.MutationHookOptions<TeamSecretsUpsertTeamSecretMutation, TeamSecretsUpsertTeamSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamSecretsUpsertTeamSecretMutation, TeamSecretsUpsertTeamSecretMutationVariables>(TeamSecretsUpsertTeamSecretDocument, options);
      }
export type TeamSecretsUpsertTeamSecretMutationHookResult = ReturnType<typeof useTeamSecretsUpsertTeamSecretMutation>;
export type TeamSecretsUpsertTeamSecretMutationResult = Apollo.MutationResult<TeamSecretsUpsertTeamSecretMutation>;
export type TeamSecretsUpsertTeamSecretMutationOptions = Apollo.BaseMutationOptions<TeamSecretsUpsertTeamSecretMutation, TeamSecretsUpsertTeamSecretMutationVariables>;
export const TeamSecretsDeleteTeamSecretDocument = gql`
    mutation TeamSecretsDeleteTeamSecret($teamSlug: String!, $name: String!) {
  deleteTeamSecret(teamSlug: $teamSlug, name: $name)
}
    `;
export type TeamSecretsDeleteTeamSecretMutationFn = Apollo.MutationFunction<TeamSecretsDeleteTeamSecretMutation, TeamSecretsDeleteTeamSecretMutationVariables>;

/**
 * __useTeamSecretsDeleteTeamSecretMutation__
 *
 * To run a mutation, you first call `useTeamSecretsDeleteTeamSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamSecretsDeleteTeamSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamSecretsDeleteTeamSecretMutation, { data, loading, error }] = useTeamSecretsDeleteTeamSecretMutation({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useTeamSecretsDeleteTeamSecretMutation(baseOptions?: Apollo.MutationHookOptions<TeamSecretsDeleteTeamSecretMutation, TeamSecretsDeleteTeamSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamSecretsDeleteTeamSecretMutation, TeamSecretsDeleteTeamSecretMutationVariables>(TeamSecretsDeleteTeamSecretDocument, options);
      }
export type TeamSecretsDeleteTeamSecretMutationHookResult = ReturnType<typeof useTeamSecretsDeleteTeamSecretMutation>;
export type TeamSecretsDeleteTeamSecretMutationResult = Apollo.MutationResult<TeamSecretsDeleteTeamSecretMutation>;
export type TeamSecretsDeleteTeamSecretMutationOptions = Apollo.BaseMutationOptions<TeamSecretsDeleteTeamSecretMutation, TeamSecretsDeleteTeamSecretMutationVariables>;
export const TeamSecretsGetTeamSecretsDocument = gql`
    query TeamSecretsGetTeamSecrets($teamSlug: String!) {
  teamSecrets(teamSlug: $teamSlug) {
    teamID
    name
    description
    updated_at
    created_at
    created_by {
      id
      profile {
        avatar
        display_name
      }
    }
    updated_by {
      id
      profile {
        avatar
        display_name
      }
    }
  }
}
    `;

/**
 * __useTeamSecretsGetTeamSecretsQuery__
 *
 * To run a query within a React component, call `useTeamSecretsGetTeamSecretsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamSecretsGetTeamSecretsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamSecretsGetTeamSecretsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTeamSecretsGetTeamSecretsQuery(baseOptions: Apollo.QueryHookOptions<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>(TeamSecretsGetTeamSecretsDocument, options);
      }
export function useTeamSecretsGetTeamSecretsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>(TeamSecretsGetTeamSecretsDocument, options);
        }
export type TeamSecretsGetTeamSecretsQueryHookResult = ReturnType<typeof useTeamSecretsGetTeamSecretsQuery>;
export type TeamSecretsGetTeamSecretsLazyQueryHookResult = ReturnType<typeof useTeamSecretsGetTeamSecretsLazyQuery>;
export type TeamSecretsGetTeamSecretsQueryResult = Apollo.QueryResult<TeamSecretsGetTeamSecretsQuery, TeamSecretsGetTeamSecretsQueryVariables>;
export const GetInsightsStatisticsDocument = gql`
    query getInsightsStatistics($teamSlug: String!, $trackIDs: [String!], $start: Time, $end: Time, $filterDevelopers: Boolean) {
  teamStatistics(
    teamSlug: $teamSlug
    trackIDs: $trackIDs
    start: $start
    end: $end
    filterDevelopers: $filterDevelopers
  ) {
    ...InsightsStatistics
  }
}
    ${InsightsStatisticsFragmentDoc}`;

/**
 * __useGetInsightsStatisticsQuery__
 *
 * To run a query within a React component, call `useGetInsightsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightsStatisticsQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackIDs: // value for 'trackIDs'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      filterDevelopers: // value for 'filterDevelopers'
 *   },
 * });
 */
export function useGetInsightsStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetInsightsStatisticsQuery, GetInsightsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightsStatisticsQuery, GetInsightsStatisticsQueryVariables>(GetInsightsStatisticsDocument, options);
      }
export function useGetInsightsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightsStatisticsQuery, GetInsightsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightsStatisticsQuery, GetInsightsStatisticsQueryVariables>(GetInsightsStatisticsDocument, options);
        }
export type GetInsightsStatisticsQueryHookResult = ReturnType<typeof useGetInsightsStatisticsQuery>;
export type GetInsightsStatisticsLazyQueryHookResult = ReturnType<typeof useGetInsightsStatisticsLazyQuery>;
export type GetInsightsStatisticsQueryResult = Apollo.QueryResult<GetInsightsStatisticsQuery, GetInsightsStatisticsQueryVariables>;
export const GetInsightsTracksDocument = gql`
    query getInsightsTracks($teamSlug: String!) {
  tracks(teamSlug: $teamSlug) {
    ...InsightsFilterFormTrack
  }
}
    ${InsightsFilterFormTrackFragmentDoc}`;

/**
 * __useGetInsightsTracksQuery__
 *
 * To run a query within a React component, call `useGetInsightsTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsightsTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsightsTracksQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetInsightsTracksQuery(baseOptions: Apollo.QueryHookOptions<GetInsightsTracksQuery, GetInsightsTracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsightsTracksQuery, GetInsightsTracksQueryVariables>(GetInsightsTracksDocument, options);
      }
export function useGetInsightsTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsightsTracksQuery, GetInsightsTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsightsTracksQuery, GetInsightsTracksQueryVariables>(GetInsightsTracksDocument, options);
        }
export type GetInsightsTracksQueryHookResult = ReturnType<typeof useGetInsightsTracksQuery>;
export type GetInsightsTracksLazyQueryHookResult = ReturnType<typeof useGetInsightsTracksLazyQuery>;
export type GetInsightsTracksQueryResult = Apollo.QueryResult<GetInsightsTracksQuery, GetInsightsTracksQueryVariables>;
export const TerraformRegistryPageSearchDocument = gql`
    query TerraformRegistryPageSearch($query: String!) {
  searchTerraformModules(query: $query) {
    modules {
      ...TerraformModuleListEntry
    }
  }
}
    ${TerraformModuleListEntryFragmentDoc}`;

/**
 * __useTerraformRegistryPageSearchQuery__
 *
 * To run a query within a React component, call `useTerraformRegistryPageSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTerraformRegistryPageSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTerraformRegistryPageSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useTerraformRegistryPageSearchQuery(baseOptions: Apollo.QueryHookOptions<TerraformRegistryPageSearchQuery, TerraformRegistryPageSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TerraformRegistryPageSearchQuery, TerraformRegistryPageSearchQueryVariables>(TerraformRegistryPageSearchDocument, options);
      }
export function useTerraformRegistryPageSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TerraformRegistryPageSearchQuery, TerraformRegistryPageSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TerraformRegistryPageSearchQuery, TerraformRegistryPageSearchQueryVariables>(TerraformRegistryPageSearchDocument, options);
        }
export type TerraformRegistryPageSearchQueryHookResult = ReturnType<typeof useTerraformRegistryPageSearchQuery>;
export type TerraformRegistryPageSearchLazyQueryHookResult = ReturnType<typeof useTerraformRegistryPageSearchLazyQuery>;
export type TerraformRegistryPageSearchQueryResult = Apollo.QueryResult<TerraformRegistryPageSearchQuery, TerraformRegistryPageSearchQueryVariables>;
export const TrackDashboardHappinessDocument = gql`
    query TrackDashboardHappiness($trackSlug: String!, $teamSlug: String!) {
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    trackReviews {
      nodes {
        id
        score
        created_at
        content
      }
    }
    statistics(start: "1970-01-01T00:00:00+00:00", end: "2970-01-01T00:00:00+00:00") {
      happiness {
        score
        count
      }
    }
  }
}
    `;

/**
 * __useTrackDashboardHappinessQuery__
 *
 * To run a query within a React component, call `useTrackDashboardHappinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardHappinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDashboardHappinessQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDashboardHappinessQuery(baseOptions: Apollo.QueryHookOptions<TrackDashboardHappinessQuery, TrackDashboardHappinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackDashboardHappinessQuery, TrackDashboardHappinessQueryVariables>(TrackDashboardHappinessDocument, options);
      }
export function useTrackDashboardHappinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackDashboardHappinessQuery, TrackDashboardHappinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackDashboardHappinessQuery, TrackDashboardHappinessQueryVariables>(TrackDashboardHappinessDocument, options);
        }
export type TrackDashboardHappinessQueryHookResult = ReturnType<typeof useTrackDashboardHappinessQuery>;
export type TrackDashboardHappinessLazyQueryHookResult = ReturnType<typeof useTrackDashboardHappinessLazyQuery>;
export type TrackDashboardHappinessQueryResult = Apollo.QueryResult<TrackDashboardHappinessQuery, TrackDashboardHappinessQueryVariables>;
export const TrackDashboardLogsConfigDocument = gql`
    query TrackDashboardLogsConfig($trackSlug: String!, $teamSlug: String!) {
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
}
    `;

/**
 * __useTrackDashboardLogsConfigQuery__
 *
 * To run a query within a React component, call `useTrackDashboardLogsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardLogsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDashboardLogsConfigQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDashboardLogsConfigQuery(baseOptions: Apollo.QueryHookOptions<TrackDashboardLogsConfigQuery, TrackDashboardLogsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackDashboardLogsConfigQuery, TrackDashboardLogsConfigQueryVariables>(TrackDashboardLogsConfigDocument, options);
      }
export function useTrackDashboardLogsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackDashboardLogsConfigQuery, TrackDashboardLogsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackDashboardLogsConfigQuery, TrackDashboardLogsConfigQueryVariables>(TrackDashboardLogsConfigDocument, options);
        }
export type TrackDashboardLogsConfigQueryHookResult = ReturnType<typeof useTrackDashboardLogsConfigQuery>;
export type TrackDashboardLogsConfigLazyQueryHookResult = ReturnType<typeof useTrackDashboardLogsConfigLazyQuery>;
export type TrackDashboardLogsConfigQueryResult = Apollo.QueryResult<TrackDashboardLogsConfigQuery, TrackDashboardLogsConfigQueryVariables>;
export const TrackDashboardStatisticsDocument = gql`
    query TrackDashboardStatistics($trackSlug: String, $teamSlug: String, $start: Time, $end: Time, $filterDevelopers: Boolean) {
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  statistics(
    trackSlug: $trackSlug
    teamSlug: $teamSlug
    start: $start
    end: $end
    filterDevelopers: $filterDevelopers
  ) {
    track {
      ...TotalTrackStartsTrackStatistics
      track_series {
        ...DailyTrackStartsTrackSeries
      }
      challenge_series {
        ...DailyTrackStartsChallengeSeries
      }
      happiness {
        ...UserHappinessHappinessCount
      }
      challenges {
        ...TotalChallengeStartsChallengeStatistics
        ...ChallengeAttemptsChallengeStatistics
        ...ChallengeDurationChallengeStatistics
      }
    }
  }
}
    ${TotalTrackStartsTrackStatisticsFragmentDoc}
${DailyTrackStartsTrackSeriesFragmentDoc}
${DailyTrackStartsChallengeSeriesFragmentDoc}
${UserHappinessHappinessCountFragmentDoc}
${TotalChallengeStartsChallengeStatisticsFragmentDoc}
${ChallengeAttemptsChallengeStatisticsFragmentDoc}
${ChallengeDurationChallengeStatisticsFragmentDoc}`;

/**
 * __useTrackDashboardStatisticsQuery__
 *
 * To run a query within a React component, call `useTrackDashboardStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDashboardStatisticsQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      filterDevelopers: // value for 'filterDevelopers'
 *   },
 * });
 */
export function useTrackDashboardStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<TrackDashboardStatisticsQuery, TrackDashboardStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackDashboardStatisticsQuery, TrackDashboardStatisticsQueryVariables>(TrackDashboardStatisticsDocument, options);
      }
export function useTrackDashboardStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackDashboardStatisticsQuery, TrackDashboardStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackDashboardStatisticsQuery, TrackDashboardStatisticsQueryVariables>(TrackDashboardStatisticsDocument, options);
        }
export type TrackDashboardStatisticsQueryHookResult = ReturnType<typeof useTrackDashboardStatisticsQuery>;
export type TrackDashboardStatisticsLazyQueryHookResult = ReturnType<typeof useTrackDashboardStatisticsLazyQuery>;
export type TrackDashboardStatisticsQueryResult = Apollo.QueryResult<TrackDashboardStatisticsQuery, TrackDashboardStatisticsQueryVariables>;
export const TrackDashboardDocument = gql`
    query TrackDashboard($trackSlug: String!, $teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    features {
      members_skip_to_challenge
    }
  }
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  userInTeam(teamSlug: $teamSlug)
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    status
    challenges {
      ...DashboardChallengesItem
      ...ChecksWidgetChallenge
    }
    statistics {
      ...DashboardTrackStatistics
    }
    ...DashboardHeaderTrack
    ...DashboardApplicationsTrack
    ...DashboardSettingsTrack
    ...DashboardSourceTrack
    ...DashboardChallengesTrack
  }
}
    ${DashboardChallengesItemFragmentDoc}
${ChecksWidgetChallengeFragmentDoc}
${DashboardTrackStatisticsFragmentDoc}
${DashboardHeaderTrackFragmentDoc}
${DashboardApplicationsTrackFragmentDoc}
${DashboardSettingsTrackFragmentDoc}
${DashboardSourceTrackFragmentDoc}
${DashboardChallengesTrackFragmentDoc}`;

/**
 * __useTrackDashboardQuery__
 *
 * To run a query within a React component, call `useTrackDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDashboardQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackDashboardQuery(baseOptions: Apollo.QueryHookOptions<TrackDashboardQuery, TrackDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackDashboardQuery, TrackDashboardQueryVariables>(TrackDashboardDocument, options);
      }
export function useTrackDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackDashboardQuery, TrackDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackDashboardQuery, TrackDashboardQueryVariables>(TrackDashboardDocument, options);
        }
export type TrackDashboardQueryHookResult = ReturnType<typeof useTrackDashboardQuery>;
export type TrackDashboardLazyQueryHookResult = ReturnType<typeof useTrackDashboardLazyQuery>;
export type TrackDashboardQueryResult = Apollo.QueryResult<TrackDashboardQuery, TrackDashboardQueryVariables>;
export const TrackDashboardDeleteChallengeDocument = gql`
    mutation TrackDashboardDeleteChallenge($challengeID: String!) {
  deleteChallenge(challengeID: $challengeID)
}
    `;
export type TrackDashboardDeleteChallengeMutationFn = Apollo.MutationFunction<TrackDashboardDeleteChallengeMutation, TrackDashboardDeleteChallengeMutationVariables>;

/**
 * __useTrackDashboardDeleteChallengeMutation__
 *
 * To run a mutation, you first call `useTrackDashboardDeleteChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardDeleteChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackDashboardDeleteChallengeMutation, { data, loading, error }] = useTrackDashboardDeleteChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useTrackDashboardDeleteChallengeMutation(baseOptions?: Apollo.MutationHookOptions<TrackDashboardDeleteChallengeMutation, TrackDashboardDeleteChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackDashboardDeleteChallengeMutation, TrackDashboardDeleteChallengeMutationVariables>(TrackDashboardDeleteChallengeDocument, options);
      }
export type TrackDashboardDeleteChallengeMutationHookResult = ReturnType<typeof useTrackDashboardDeleteChallengeMutation>;
export type TrackDashboardDeleteChallengeMutationResult = Apollo.MutationResult<TrackDashboardDeleteChallengeMutation>;
export type TrackDashboardDeleteChallengeMutationOptions = Apollo.BaseMutationOptions<TrackDashboardDeleteChallengeMutation, TrackDashboardDeleteChallengeMutationVariables>;
export const TrackDashboardStopTrackDocument = gql`
    mutation TrackDashboardStopTrack($trackID: String!) {
  stopTrack(trackID: $trackID) {
    id
    status
  }
}
    `;
export type TrackDashboardStopTrackMutationFn = Apollo.MutationFunction<TrackDashboardStopTrackMutation, TrackDashboardStopTrackMutationVariables>;

/**
 * __useTrackDashboardStopTrackMutation__
 *
 * To run a mutation, you first call `useTrackDashboardStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackDashboardStopTrackMutation, { data, loading, error }] = useTrackDashboardStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useTrackDashboardStopTrackMutation(baseOptions?: Apollo.MutationHookOptions<TrackDashboardStopTrackMutation, TrackDashboardStopTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackDashboardStopTrackMutation, TrackDashboardStopTrackMutationVariables>(TrackDashboardStopTrackDocument, options);
      }
export type TrackDashboardStopTrackMutationHookResult = ReturnType<typeof useTrackDashboardStopTrackMutation>;
export type TrackDashboardStopTrackMutationResult = Apollo.MutationResult<TrackDashboardStopTrackMutation>;
export type TrackDashboardStopTrackMutationOptions = Apollo.BaseMutationOptions<TrackDashboardStopTrackMutation, TrackDashboardStopTrackMutationVariables>;
export const GetActivityPageDocument = gql`
    query GetActivityPage($inviteID: ID!, $inviteIDLegacy: String!, $userID: ID!, $teamSlug: String!) {
  student(inviteID: $inviteID, userID: $userID) {
    activeSandboxesTotal
    inspectable
    user {
      ...StudentName
    }
  }
  trackInvite(inviteID: $inviteIDLegacy) {
    expiresAt
    publicDescription
    publicTitle
    startsAt
    status
    type
  }
  students(inviteID: $inviteID) {
    user {
      ...StudentName
    }
  }
}
    ${StudentNameFragmentDoc}`;

/**
 * __useGetActivityPageQuery__
 *
 * To run a query within a React component, call `useGetActivityPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      inviteIDLegacy: // value for 'inviteIDLegacy'
 *      userID: // value for 'userID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetActivityPageQuery(baseOptions: Apollo.QueryHookOptions<GetActivityPageQuery, GetActivityPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityPageQuery, GetActivityPageQueryVariables>(GetActivityPageDocument, options);
      }
export function useGetActivityPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityPageQuery, GetActivityPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityPageQuery, GetActivityPageQueryVariables>(GetActivityPageDocument, options);
        }
export type GetActivityPageQueryHookResult = ReturnType<typeof useGetActivityPageQuery>;
export type GetActivityPageLazyQueryHookResult = ReturnType<typeof useGetActivityPageLazyQuery>;
export type GetActivityPageQueryResult = Apollo.QueryResult<GetActivityPageQuery, GetActivityPageQueryVariables>;
export const GetActivityLogAndSandboxesDocument = gql`
    query GetActivityLogAndSandboxes($teamSlug: String!, $inviteID: String!, $userID: String!, $filter: SandboxFilterInput!) {
  trackInviteClaim(inviteID: $inviteID, userID: $userID) {
    events {
      challenge {
        slug
      }
      message
      participantID
      time
      track {
        slug
      }
    }
    user {
      profile {
        display_name
      }
    }
  }
  sandboxes(teamSlug: $teamSlug, filter: $filter) {
    totalCount
    edges {
      node {
        ...Sandbox
      }
    }
  }
}
    ${SandboxFragmentDoc}`;

/**
 * __useGetActivityLogAndSandboxesQuery__
 *
 * To run a query within a React component, call `useGetActivityLogAndSandboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogAndSandboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogAndSandboxesQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetActivityLogAndSandboxesQuery(baseOptions: Apollo.QueryHookOptions<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>(GetActivityLogAndSandboxesDocument, options);
      }
export function useGetActivityLogAndSandboxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>(GetActivityLogAndSandboxesDocument, options);
        }
export type GetActivityLogAndSandboxesQueryHookResult = ReturnType<typeof useGetActivityLogAndSandboxesQuery>;
export type GetActivityLogAndSandboxesLazyQueryHookResult = ReturnType<typeof useGetActivityLogAndSandboxesLazyQuery>;
export type GetActivityLogAndSandboxesQueryResult = Apollo.QueryResult<GetActivityLogAndSandboxesQuery, GetActivityLogAndSandboxesQueryVariables>;
export const ActivityReportPageDocument = gql`
    query ActivityReportPage($teamSlug: String!, $inviteID: String!) {
  trackInvite(inviteID: $inviteID) {
    id
    type
    allowAnonymous
    allowedEmailAddressesOnly
    title
    publicTitle
    tracks {
      id
    }
    claims {
      id
      claimedAt
      playLimit
      playTTL
      user {
        id
        profile {
          display_name
          email
        }
        details(teamSlug: $teamSlug) {
          firstName
          lastName
          email
          ...UserDetailsCollectedTableDetails
        }
      }
    }
    ...DownloadTrackInviteCsvTrackInvite
  }
}
    ${UserDetailsCollectedTableDetailsFragmentDoc}
${DownloadTrackInviteCsvTrackInviteFragmentDoc}`;

/**
 * __useActivityReportPageQuery__
 *
 * To run a query within a React component, call `useActivityReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityReportPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useActivityReportPageQuery(baseOptions: Apollo.QueryHookOptions<ActivityReportPageQuery, ActivityReportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityReportPageQuery, ActivityReportPageQueryVariables>(ActivityReportPageDocument, options);
      }
export function useActivityReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityReportPageQuery, ActivityReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityReportPageQuery, ActivityReportPageQueryVariables>(ActivityReportPageDocument, options);
        }
export type ActivityReportPageQueryHookResult = ReturnType<typeof useActivityReportPageQuery>;
export type ActivityReportPageLazyQueryHookResult = ReturnType<typeof useActivityReportPageLazyQuery>;
export type ActivityReportPageQueryResult = Apollo.QueryResult<ActivityReportPageQuery, ActivityReportPageQueryVariables>;
export const GetClassroomPageDocument = gql`
    query GetClassroomPage($inviteID: ID!, $inviteIDLegacy: String!, $teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
    features {
      hot_start
    }
  }
  studentStatistics(inviteID: $inviteID) {
    inProgressTotal
    completedTotal
  }
  trackInvite(inviteID: $inviteIDLegacy) {
    id
    inviteLimit
    expiresAt
    publicDescription
    publicTitle
    startsAt
    tracks {
      icon
      id
      studentStatistics(inviteID: $inviteID) {
        inProgressTotal
        completedTotal
      }
      title
    }
    type
    status
  }
}
    `;

/**
 * __useGetClassroomPageQuery__
 *
 * To run a query within a React component, call `useGetClassroomPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassroomPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassroomPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      inviteIDLegacy: // value for 'inviteIDLegacy'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetClassroomPageQuery(baseOptions: Apollo.QueryHookOptions<GetClassroomPageQuery, GetClassroomPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassroomPageQuery, GetClassroomPageQueryVariables>(GetClassroomPageDocument, options);
      }
export function useGetClassroomPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassroomPageQuery, GetClassroomPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassroomPageQuery, GetClassroomPageQueryVariables>(GetClassroomPageDocument, options);
        }
export type GetClassroomPageQueryHookResult = ReturnType<typeof useGetClassroomPageQuery>;
export type GetClassroomPageLazyQueryHookResult = ReturnType<typeof useGetClassroomPageLazyQuery>;
export type GetClassroomPageQueryResult = Apollo.QueryResult<GetClassroomPageQuery, GetClassroomPageQueryVariables>;
export const GetStudentsDocument = gql`
    query GetStudents($inviteID: ID!, $teamSlug: String!) {
  students(inviteID: $inviteID) {
    completed_at
    activeSandboxesTotal
    inspectable
    last_activity_at
    accessed_at
    challenge {
      index
      started
      title
    }
    claim {
      id
    }
    track {
      challenges {
        id
      }
      id
      title
    }
    user {
      ...StudentName
    }
  }
}
    ${StudentNameFragmentDoc}`;

/**
 * __useGetStudentsQuery__
 *
 * To run a query within a React component, call `useGetStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetStudentsQuery(baseOptions: Apollo.QueryHookOptions<GetStudentsQuery, GetStudentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStudentsQuery, GetStudentsQueryVariables>(GetStudentsDocument, options);
      }
export function useGetStudentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStudentsQuery, GetStudentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStudentsQuery, GetStudentsQueryVariables>(GetStudentsDocument, options);
        }
export type GetStudentsQueryHookResult = ReturnType<typeof useGetStudentsQuery>;
export type GetStudentsLazyQueryHookResult = ReturnType<typeof useGetStudentsLazyQuery>;
export type GetStudentsQueryResult = Apollo.QueryResult<GetStudentsQuery, GetStudentsQueryVariables>;
export const DeleteTrackInviteClaimDocument = gql`
    mutation deleteTrackInviteClaim($claimID: String!) {
  deleteTrackInviteClaim(claimID: $claimID)
}
    `;
export type DeleteTrackInviteClaimMutationFn = Apollo.MutationFunction<DeleteTrackInviteClaimMutation, DeleteTrackInviteClaimMutationVariables>;

/**
 * __useDeleteTrackInviteClaimMutation__
 *
 * To run a mutation, you first call `useDeleteTrackInviteClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrackInviteClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrackInviteClaimMutation, { data, loading, error }] = useDeleteTrackInviteClaimMutation({
 *   variables: {
 *      claimID: // value for 'claimID'
 *   },
 * });
 */
export function useDeleteTrackInviteClaimMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrackInviteClaimMutation, DeleteTrackInviteClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrackInviteClaimMutation, DeleteTrackInviteClaimMutationVariables>(DeleteTrackInviteClaimDocument, options);
      }
export type DeleteTrackInviteClaimMutationHookResult = ReturnType<typeof useDeleteTrackInviteClaimMutation>;
export type DeleteTrackInviteClaimMutationResult = Apollo.MutationResult<DeleteTrackInviteClaimMutation>;
export type DeleteTrackInviteClaimMutationOptions = Apollo.BaseMutationOptions<DeleteTrackInviteClaimMutation, DeleteTrackInviteClaimMutationVariables>;
export const CreateInvitePageDocument = gql`
    query CreateInvitePage($teamSlug: String!) {
  tracks(teamSlug: $teamSlug) {
    ...InviteFormTrack
  }
  team(teamSlug: $teamSlug) {
    ...InviteFormTeam
  }
  teamSecrets(teamSlug: $teamSlug) {
    ...InviteTeamSecrets
  }
}
    ${InviteFormTrackFragmentDoc}
${InviteFormTeamFragmentDoc}
${InviteTeamSecretsFragmentDoc}`;

/**
 * __useCreateInvitePageQuery__
 *
 * To run a query within a React component, call `useCreateInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateInvitePageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useCreateInvitePageQuery(baseOptions: Apollo.QueryHookOptions<CreateInvitePageQuery, CreateInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateInvitePageQuery, CreateInvitePageQueryVariables>(CreateInvitePageDocument, options);
      }
export function useCreateInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateInvitePageQuery, CreateInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateInvitePageQuery, CreateInvitePageQueryVariables>(CreateInvitePageDocument, options);
        }
export type CreateInvitePageQueryHookResult = ReturnType<typeof useCreateInvitePageQuery>;
export type CreateInvitePageLazyQueryHookResult = ReturnType<typeof useCreateInvitePageLazyQuery>;
export type CreateInvitePageQueryResult = Apollo.QueryResult<CreateInvitePageQuery, CreateInvitePageQueryVariables>;
export const CreateInviteCreateTrackInviteDocument = gql`
    mutation CreateInviteCreateTrackInvite($invite: TrackInviteInput!) {
  createTrackInvite(invite: $invite) {
    id
  }
}
    `;
export type CreateInviteCreateTrackInviteMutationFn = Apollo.MutationFunction<CreateInviteCreateTrackInviteMutation, CreateInviteCreateTrackInviteMutationVariables>;

/**
 * __useCreateInviteCreateTrackInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteCreateTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteCreateTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteCreateTrackInviteMutation, { data, loading, error }] = useCreateInviteCreateTrackInviteMutation({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useCreateInviteCreateTrackInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreateInviteCreateTrackInviteMutation, CreateInviteCreateTrackInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInviteCreateTrackInviteMutation, CreateInviteCreateTrackInviteMutationVariables>(CreateInviteCreateTrackInviteDocument, options);
      }
export type CreateInviteCreateTrackInviteMutationHookResult = ReturnType<typeof useCreateInviteCreateTrackInviteMutation>;
export type CreateInviteCreateTrackInviteMutationResult = Apollo.MutationResult<CreateInviteCreateTrackInviteMutation>;
export type CreateInviteCreateTrackInviteMutationOptions = Apollo.BaseMutationOptions<CreateInviteCreateTrackInviteMutation, CreateInviteCreateTrackInviteMutationVariables>;
export const DuplicateInvitePageDocument = gql`
    query DuplicateInvitePage($inviteID: String!, $teamSlug: String!) {
  trackInvite(inviteID: $inviteID) {
    ...InviteFormTrackInvite
  }
  tracks(teamSlug: $teamSlug) {
    ...InviteFormTrack
  }
  team(teamSlug: $teamSlug) {
    ...InviteFormTeam
  }
  teamSecrets(teamSlug: $teamSlug) {
    ...InviteTeamSecrets
  }
}
    ${InviteFormTrackInviteFragmentDoc}
${InviteFormTrackFragmentDoc}
${InviteFormTeamFragmentDoc}
${InviteTeamSecretsFragmentDoc}`;

/**
 * __useDuplicateInvitePageQuery__
 *
 * To run a query within a React component, call `useDuplicateInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicateInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicateInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useDuplicateInvitePageQuery(baseOptions: Apollo.QueryHookOptions<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>(DuplicateInvitePageDocument, options);
      }
export function useDuplicateInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>(DuplicateInvitePageDocument, options);
        }
export type DuplicateInvitePageQueryHookResult = ReturnType<typeof useDuplicateInvitePageQuery>;
export type DuplicateInvitePageLazyQueryHookResult = ReturnType<typeof useDuplicateInvitePageLazyQuery>;
export type DuplicateInvitePageQueryResult = Apollo.QueryResult<DuplicateInvitePageQuery, DuplicateInvitePageQueryVariables>;
export const DuplicateInviteCreateTrackInviteDocument = gql`
    mutation DuplicateInviteCreateTrackInvite($invite: TrackInviteInput!) {
  createTrackInvite(invite: $invite) {
    id
  }
}
    `;
export type DuplicateInviteCreateTrackInviteMutationFn = Apollo.MutationFunction<DuplicateInviteCreateTrackInviteMutation, DuplicateInviteCreateTrackInviteMutationVariables>;

/**
 * __useDuplicateInviteCreateTrackInviteMutation__
 *
 * To run a mutation, you first call `useDuplicateInviteCreateTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateInviteCreateTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateInviteCreateTrackInviteMutation, { data, loading, error }] = useDuplicateInviteCreateTrackInviteMutation({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useDuplicateInviteCreateTrackInviteMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateInviteCreateTrackInviteMutation, DuplicateInviteCreateTrackInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateInviteCreateTrackInviteMutation, DuplicateInviteCreateTrackInviteMutationVariables>(DuplicateInviteCreateTrackInviteDocument, options);
      }
export type DuplicateInviteCreateTrackInviteMutationHookResult = ReturnType<typeof useDuplicateInviteCreateTrackInviteMutation>;
export type DuplicateInviteCreateTrackInviteMutationResult = Apollo.MutationResult<DuplicateInviteCreateTrackInviteMutation>;
export type DuplicateInviteCreateTrackInviteMutationOptions = Apollo.BaseMutationOptions<DuplicateInviteCreateTrackInviteMutation, DuplicateInviteCreateTrackInviteMutationVariables>;
export const EditInvitePageDocument = gql`
    query EditInvitePage($inviteID: String!, $teamSlug: String!) {
  trackInvite(inviteID: $inviteID) {
    ...InviteFormTrackInvite
  }
  tracks(teamSlug: $teamSlug) {
    ...InviteFormTrack
  }
  team(teamSlug: $teamSlug) {
    ...InviteFormTeam
  }
  teamSecrets(teamSlug: $teamSlug) {
    ...InviteTeamSecrets
  }
}
    ${InviteFormTrackInviteFragmentDoc}
${InviteFormTrackFragmentDoc}
${InviteFormTeamFragmentDoc}
${InviteTeamSecretsFragmentDoc}`;

/**
 * __useEditInvitePageQuery__
 *
 * To run a query within a React component, call `useEditInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useEditInvitePageQuery(baseOptions: Apollo.QueryHookOptions<EditInvitePageQuery, EditInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditInvitePageQuery, EditInvitePageQueryVariables>(EditInvitePageDocument, options);
      }
export function useEditInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditInvitePageQuery, EditInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditInvitePageQuery, EditInvitePageQueryVariables>(EditInvitePageDocument, options);
        }
export type EditInvitePageQueryHookResult = ReturnType<typeof useEditInvitePageQuery>;
export type EditInvitePageLazyQueryHookResult = ReturnType<typeof useEditInvitePageLazyQuery>;
export type EditInvitePageQueryResult = Apollo.QueryResult<EditInvitePageQuery, EditInvitePageQueryVariables>;
export const EditInviteUpdateTrackInviteDocument = gql`
    mutation EditInviteUpdateTrackInvite($invite: TrackInviteInput!) {
  updateTrackInvite(invite: $invite) {
    id
  }
}
    `;
export type EditInviteUpdateTrackInviteMutationFn = Apollo.MutationFunction<EditInviteUpdateTrackInviteMutation, EditInviteUpdateTrackInviteMutationVariables>;

/**
 * __useEditInviteUpdateTrackInviteMutation__
 *
 * To run a mutation, you first call `useEditInviteUpdateTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInviteUpdateTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInviteUpdateTrackInviteMutation, { data, loading, error }] = useEditInviteUpdateTrackInviteMutation({
 *   variables: {
 *      invite: // value for 'invite'
 *   },
 * });
 */
export function useEditInviteUpdateTrackInviteMutation(baseOptions?: Apollo.MutationHookOptions<EditInviteUpdateTrackInviteMutation, EditInviteUpdateTrackInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditInviteUpdateTrackInviteMutation, EditInviteUpdateTrackInviteMutationVariables>(EditInviteUpdateTrackInviteDocument, options);
      }
export type EditInviteUpdateTrackInviteMutationHookResult = ReturnType<typeof useEditInviteUpdateTrackInviteMutation>;
export type EditInviteUpdateTrackInviteMutationResult = Apollo.MutationResult<EditInviteUpdateTrackInviteMutation>;
export type EditInviteUpdateTrackInviteMutationOptions = Apollo.BaseMutationOptions<EditInviteUpdateTrackInviteMutation, EditInviteUpdateTrackInviteMutationVariables>;
export const GetInspectStudentPageDocument = gql`
    query GetInspectStudentPage($inviteID: ID!, $userID: ID!, $teamSlug: String!) {
  student(inviteID: $inviteID, userID: $userID) {
    inspectable
    last_activity_at
    challenge {
      index
      permalink
    }
    user {
      ...StudentName
    }
  }
  students(inviteID: $inviteID) {
    user {
      ...StudentName
    }
  }
}
    ${StudentNameFragmentDoc}`;

/**
 * __useGetInspectStudentPageQuery__
 *
 * To run a query within a React component, call `useGetInspectStudentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspectStudentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspectStudentPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetInspectStudentPageQuery(baseOptions: Apollo.QueryHookOptions<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>(GetInspectStudentPageDocument, options);
      }
export function useGetInspectStudentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>(GetInspectStudentPageDocument, options);
        }
export type GetInspectStudentPageQueryHookResult = ReturnType<typeof useGetInspectStudentPageQuery>;
export type GetInspectStudentPageLazyQueryHookResult = ReturnType<typeof useGetInspectStudentPageLazyQuery>;
export type GetInspectStudentPageQueryResult = Apollo.QueryResult<GetInspectStudentPageQuery, GetInspectStudentPageQueryVariables>;
export const ViewInvitePageDocument = gql`
    query ViewInvitePage($inviteID: String!) {
  trackInvite(inviteID: $inviteID) {
    ...TrackInviteDetailsTrackInvite
  }
}
    ${TrackInviteDetailsTrackInviteFragmentDoc}`;

/**
 * __useViewInvitePageQuery__
 *
 * To run a query within a React component, call `useViewInvitePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewInvitePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewInvitePageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useViewInvitePageQuery(baseOptions: Apollo.QueryHookOptions<ViewInvitePageQuery, ViewInvitePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewInvitePageQuery, ViewInvitePageQueryVariables>(ViewInvitePageDocument, options);
      }
export function useViewInvitePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewInvitePageQuery, ViewInvitePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewInvitePageQuery, ViewInvitePageQueryVariables>(ViewInvitePageDocument, options);
        }
export type ViewInvitePageQueryHookResult = ReturnType<typeof useViewInvitePageQuery>;
export type ViewInvitePageLazyQueryHookResult = ReturnType<typeof useViewInvitePageLazyQuery>;
export type ViewInvitePageQueryResult = Apollo.QueryResult<ViewInvitePageQuery, ViewInvitePageQueryVariables>;
export const GetTrackLimitsPageConfigDocument = gql`
    query getTrackLimitsPageConfig($teamSlug: String!) {
  team(teamSlug: $teamSlug) {
    id
  }
  tracks(teamSlug: $teamSlug) {
    ...TrackLimitsTableTrack
  }
  trackPlayLimits(teamSlug: $teamSlug) {
    ...TrackLimitsTableTrackLimits
  }
}
    ${TrackLimitsTableTrackFragmentDoc}
${TrackLimitsTableTrackLimitsFragmentDoc}`;

/**
 * __useGetTrackLimitsPageConfigQuery__
 *
 * To run a query within a React component, call `useGetTrackLimitsPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackLimitsPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackLimitsPageConfigQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTrackLimitsPageConfigQuery(baseOptions: Apollo.QueryHookOptions<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>(GetTrackLimitsPageConfigDocument, options);
      }
export function useGetTrackLimitsPageConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>(GetTrackLimitsPageConfigDocument, options);
        }
export type GetTrackLimitsPageConfigQueryHookResult = ReturnType<typeof useGetTrackLimitsPageConfigQuery>;
export type GetTrackLimitsPageConfigLazyQueryHookResult = ReturnType<typeof useGetTrackLimitsPageConfigLazyQuery>;
export type GetTrackLimitsPageConfigQueryResult = Apollo.QueryResult<GetTrackLimitsPageConfigQuery, GetTrackLimitsPageConfigQueryVariables>;
export const LimitsPageSaveLimitsDocument = gql`
    mutation limitsPageSaveLimits($trackID: String, $teamSlug: String!, $trackPlayLimits: TrackPlayLimitInput!) {
  saveTrackPlayLimits(
    trackID: $trackID
    teamSlug: $teamSlug
    trackPlayLimits: $trackPlayLimits
  ) {
    ...TrackLimitsTableTrackLimits
  }
}
    ${TrackLimitsTableTrackLimitsFragmentDoc}`;
export type LimitsPageSaveLimitsMutationFn = Apollo.MutationFunction<LimitsPageSaveLimitsMutation, LimitsPageSaveLimitsMutationVariables>;

/**
 * __useLimitsPageSaveLimitsMutation__
 *
 * To run a mutation, you first call `useLimitsPageSaveLimitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLimitsPageSaveLimitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [limitsPageSaveLimitsMutation, { data, loading, error }] = useLimitsPageSaveLimitsMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      teamSlug: // value for 'teamSlug'
 *      trackPlayLimits: // value for 'trackPlayLimits'
 *   },
 * });
 */
export function useLimitsPageSaveLimitsMutation(baseOptions?: Apollo.MutationHookOptions<LimitsPageSaveLimitsMutation, LimitsPageSaveLimitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LimitsPageSaveLimitsMutation, LimitsPageSaveLimitsMutationVariables>(LimitsPageSaveLimitsDocument, options);
      }
export type LimitsPageSaveLimitsMutationHookResult = ReturnType<typeof useLimitsPageSaveLimitsMutation>;
export type LimitsPageSaveLimitsMutationResult = Apollo.MutationResult<LimitsPageSaveLimitsMutation>;
export type LimitsPageSaveLimitsMutationOptions = Apollo.BaseMutationOptions<LimitsPageSaveLimitsMutation, LimitsPageSaveLimitsMutationVariables>;
export const TrackDashboardSandboxesDocument = gql`
    query TrackDashboardSandboxes($trackSlug: String!, $teamSlug: String!, $filter: SandboxConfigVersionsFilterInput!) {
  userInTeam(teamSlug: $teamSlug)
  team(teamSlug: $teamSlug) {
    id
    features {
      containers
      virtual_machines
      saas
      gcp_projects
      aws_accounts
      azure_subscriptions
      custom_machine_type
      shared_hotstart_pools
    }
  }
  teamSecrets(teamSlug: $teamSlug) {
    name
    description
  }
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    sandboxConfig {
      ...ManageTrackSandboxConfigVersion
    }
    trackConfig {
      id
      containers {
        ...ContainerFormContainer
      }
      virtualmachines {
        ...VirtualMachineFormVirtualMachine
      }
      virtualbrowsers {
        ...VirtualBrowserFormVirtualBrowser
      }
      gcp_projects {
        ...GoogleCloudFormGcpProject
      }
      aws_accounts {
        ...AwsAccountFormAwsAccount
      }
      azure_subscriptions {
        ...AzureSubscriptionFormAzureSubscription
      }
      secrets {
        ...SandboxConfigSecret
      }
    }
    scripts {
      id
      host
      action
      contents
    }
  }
  sandboxConfigVersions(teamSlug: $teamSlug, filter: $filter) {
    ...ManageTrackSandboxConfigVersion
  }
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
}
    ${ManageTrackSandboxConfigVersionFragmentDoc}
${ContainerFormContainerFragmentDoc}
${VirtualMachineFormVirtualMachineFragmentDoc}
${VirtualBrowserFormVirtualBrowserFragmentDoc}
${GoogleCloudFormGcpProjectFragmentDoc}
${AwsAccountFormAwsAccountFragmentDoc}
${AzureSubscriptionFormAzureSubscriptionFragmentDoc}
${SandboxConfigSecretFragmentDoc}`;

/**
 * __useTrackDashboardSandboxesQuery__
 *
 * To run a query within a React component, call `useTrackDashboardSandboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackDashboardSandboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackDashboardSandboxesQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useTrackDashboardSandboxesQuery(baseOptions: Apollo.QueryHookOptions<TrackDashboardSandboxesQuery, TrackDashboardSandboxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackDashboardSandboxesQuery, TrackDashboardSandboxesQueryVariables>(TrackDashboardSandboxesDocument, options);
      }
export function useTrackDashboardSandboxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackDashboardSandboxesQuery, TrackDashboardSandboxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackDashboardSandboxesQuery, TrackDashboardSandboxesQueryVariables>(TrackDashboardSandboxesDocument, options);
        }
export type TrackDashboardSandboxesQueryHookResult = ReturnType<typeof useTrackDashboardSandboxesQuery>;
export type TrackDashboardSandboxesLazyQueryHookResult = ReturnType<typeof useTrackDashboardSandboxesLazyQuery>;
export type TrackDashboardSandboxesQueryResult = Apollo.QueryResult<TrackDashboardSandboxesQuery, TrackDashboardSandboxesQueryVariables>;
export const TrackSandboxSetPresetDocument = gql`
    mutation trackSandboxSetPreset($trackID: String!, $configVersionID: String) {
  setTrackSandboxConfigVersion(
    trackID: $trackID
    configVersionID: $configVersionID
  )
}
    `;
export type TrackSandboxSetPresetMutationFn = Apollo.MutationFunction<TrackSandboxSetPresetMutation, TrackSandboxSetPresetMutationVariables>;

/**
 * __useTrackSandboxSetPresetMutation__
 *
 * To run a mutation, you first call `useTrackSandboxSetPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackSandboxSetPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackSandboxSetPresetMutation, { data, loading, error }] = useTrackSandboxSetPresetMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      configVersionID: // value for 'configVersionID'
 *   },
 * });
 */
export function useTrackSandboxSetPresetMutation(baseOptions?: Apollo.MutationHookOptions<TrackSandboxSetPresetMutation, TrackSandboxSetPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackSandboxSetPresetMutation, TrackSandboxSetPresetMutationVariables>(TrackSandboxSetPresetDocument, options);
      }
export type TrackSandboxSetPresetMutationHookResult = ReturnType<typeof useTrackSandboxSetPresetMutation>;
export type TrackSandboxSetPresetMutationResult = Apollo.MutationResult<TrackSandboxSetPresetMutation>;
export type TrackSandboxSetPresetMutationOptions = Apollo.BaseMutationOptions<TrackSandboxSetPresetMutation, TrackSandboxSetPresetMutationVariables>;
export const GetUpdateScriptsPageQueryDocument = gql`
    query getUpdateScriptsPageQuery($trackSlug: String!, $teamSlug: String!) {
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    ...UpdateTrackScripts
  }
}
    ${UpdateTrackScriptsFragmentDoc}`;

/**
 * __useGetUpdateScriptsPageQueryQuery__
 *
 * To run a query within a React component, call `useGetUpdateScriptsPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpdateScriptsPageQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpdateScriptsPageQueryQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetUpdateScriptsPageQueryQuery(baseOptions: Apollo.QueryHookOptions<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>(GetUpdateScriptsPageQueryDocument, options);
      }
export function useGetUpdateScriptsPageQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>(GetUpdateScriptsPageQueryDocument, options);
        }
export type GetUpdateScriptsPageQueryQueryHookResult = ReturnType<typeof useGetUpdateScriptsPageQueryQuery>;
export type GetUpdateScriptsPageQueryLazyQueryHookResult = ReturnType<typeof useGetUpdateScriptsPageQueryLazyQuery>;
export type GetUpdateScriptsPageQueryQueryResult = Apollo.QueryResult<GetUpdateScriptsPageQueryQuery, GetUpdateScriptsPageQueryQueryVariables>;
export const UpdateTrackScriptDocument = gql`
    mutation updateTrackScript($script: TrackScriptInput!, $base64Encoded: Boolean!) {
  saveTrackScript(script: $script, base64Encoded: $base64Encoded) {
    ...UpdateTrackScriptResult
  }
}
    ${UpdateTrackScriptResultFragmentDoc}`;
export type UpdateTrackScriptMutationFn = Apollo.MutationFunction<UpdateTrackScriptMutation, UpdateTrackScriptMutationVariables>;

/**
 * __useUpdateTrackScriptMutation__
 *
 * To run a mutation, you first call `useUpdateTrackScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackScriptMutation, { data, loading, error }] = useUpdateTrackScriptMutation({
 *   variables: {
 *      script: // value for 'script'
 *      base64Encoded: // value for 'base64Encoded'
 *   },
 * });
 */
export function useUpdateTrackScriptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackScriptMutation, UpdateTrackScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackScriptMutation, UpdateTrackScriptMutationVariables>(UpdateTrackScriptDocument, options);
      }
export type UpdateTrackScriptMutationHookResult = ReturnType<typeof useUpdateTrackScriptMutation>;
export type UpdateTrackScriptMutationResult = Apollo.MutationResult<UpdateTrackScriptMutation>;
export type UpdateTrackScriptMutationOptions = Apollo.BaseMutationOptions<UpdateTrackScriptMutation, UpdateTrackScriptMutationVariables>;
export const UpdateChallengeScriptDocument = gql`
    mutation updateChallengeScript($script: ChallengeScriptInput!, $base64Encoded: Boolean!) {
  saveChallengeScript(script: $script, base64Encoded: $base64Encoded) {
    ...UpdateChallengeScriptResult
  }
}
    ${UpdateChallengeScriptResultFragmentDoc}`;
export type UpdateChallengeScriptMutationFn = Apollo.MutationFunction<UpdateChallengeScriptMutation, UpdateChallengeScriptMutationVariables>;

/**
 * __useUpdateChallengeScriptMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeScriptMutation, { data, loading, error }] = useUpdateChallengeScriptMutation({
 *   variables: {
 *      script: // value for 'script'
 *      base64Encoded: // value for 'base64Encoded'
 *   },
 * });
 */
export function useUpdateChallengeScriptMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChallengeScriptMutation, UpdateChallengeScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChallengeScriptMutation, UpdateChallengeScriptMutationVariables>(UpdateChallengeScriptDocument, options);
      }
export type UpdateChallengeScriptMutationHookResult = ReturnType<typeof useUpdateChallengeScriptMutation>;
export type UpdateChallengeScriptMutationResult = Apollo.MutationResult<UpdateChallengeScriptMutation>;
export type UpdateChallengeScriptMutationOptions = Apollo.BaseMutationOptions<UpdateChallengeScriptMutation, UpdateChallengeScriptMutationVariables>;
export const DeleteChallengeScriptDocument = gql`
    mutation deleteChallengeScript($challengeScriptID: String!) {
  deleteChallengeScript(challengeScriptID: $challengeScriptID)
}
    `;
export type DeleteChallengeScriptMutationFn = Apollo.MutationFunction<DeleteChallengeScriptMutation, DeleteChallengeScriptMutationVariables>;

/**
 * __useDeleteChallengeScriptMutation__
 *
 * To run a mutation, you first call `useDeleteChallengeScriptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChallengeScriptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChallengeScriptMutation, { data, loading, error }] = useDeleteChallengeScriptMutation({
 *   variables: {
 *      challengeScriptID: // value for 'challengeScriptID'
 *   },
 * });
 */
export function useDeleteChallengeScriptMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChallengeScriptMutation, DeleteChallengeScriptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChallengeScriptMutation, DeleteChallengeScriptMutationVariables>(DeleteChallengeScriptDocument, options);
      }
export type DeleteChallengeScriptMutationHookResult = ReturnType<typeof useDeleteChallengeScriptMutation>;
export type DeleteChallengeScriptMutationResult = Apollo.MutationResult<DeleteChallengeScriptMutation>;
export type DeleteChallengeScriptMutationOptions = Apollo.BaseMutationOptions<DeleteChallengeScriptMutation, DeleteChallengeScriptMutationVariables>;
export const UserReportPageDocument = gql`
    query UserReportPage($teamSlug: String!, $userReportInput: UserReportInput!) {
  team(teamSlug: $teamSlug) {
    id
    userReportPage(input: $userReportInput) {
      items {
        ...UserReportTableItem
      }
      totalItems
    }
  }
}
    ${UserReportTableItemFragmentDoc}`;

/**
 * __useUserReportPageQuery__
 *
 * To run a query within a React component, call `useUserReportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReportPageQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      userReportInput: // value for 'userReportInput'
 *   },
 * });
 */
export function useUserReportPageQuery(baseOptions: Apollo.QueryHookOptions<UserReportPageQuery, UserReportPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReportPageQuery, UserReportPageQueryVariables>(UserReportPageDocument, options);
      }
export function useUserReportPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReportPageQuery, UserReportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReportPageQuery, UserReportPageQueryVariables>(UserReportPageDocument, options);
        }
export type UserReportPageQueryHookResult = ReturnType<typeof useUserReportPageQuery>;
export type UserReportPageLazyQueryHookResult = ReturnType<typeof useUserReportPageLazyQuery>;
export type UserReportPageQueryResult = Apollo.QueryResult<UserReportPageQuery, UserReportPageQueryVariables>;
export const UserReportFiltersDocument = gql`
    query UserReportFilters($teamSlug: String) {
  team(teamSlug: $teamSlug) {
    id
    userDetails {
      ...UserFilterListItem
    }
    tracks {
      ...TrackFilterTrack
    }
  }
  trackInvites(teamSlug: $teamSlug) {
    ...InviteFilterListItem
  }
}
    ${UserFilterListItemFragmentDoc}
${TrackFilterTrackFragmentDoc}
${InviteFilterListItemFragmentDoc}`;

/**
 * __useUserReportFiltersQuery__
 *
 * To run a query within a React component, call `useUserReportFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReportFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReportFiltersQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useUserReportFiltersQuery(baseOptions?: Apollo.QueryHookOptions<UserReportFiltersQuery, UserReportFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReportFiltersQuery, UserReportFiltersQueryVariables>(UserReportFiltersDocument, options);
      }
export function useUserReportFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReportFiltersQuery, UserReportFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReportFiltersQuery, UserReportFiltersQueryVariables>(UserReportFiltersDocument, options);
        }
export type UserReportFiltersQueryHookResult = ReturnType<typeof useUserReportFiltersQuery>;
export type UserReportFiltersLazyQueryHookResult = ReturnType<typeof useUserReportFiltersLazyQuery>;
export type UserReportFiltersQueryResult = Apollo.QueryResult<UserReportFiltersQuery, UserReportFiltersQueryVariables>;
export const UserReportCsvDocument = gql`
    query UserReportCSV($teamSlug: String!, $userReportInput: UserReportInput!) {
  team(teamSlug: $teamSlug) {
    id
    userReportPage(input: $userReportInput) {
      items {
        ...UserReportCSV
      }
    }
  }
}
    ${UserReportCsvFragmentDoc}`;

/**
 * __useUserReportCsvQuery__
 *
 * To run a query within a React component, call `useUserReportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReportCsvQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      userReportInput: // value for 'userReportInput'
 *   },
 * });
 */
export function useUserReportCsvQuery(baseOptions: Apollo.QueryHookOptions<UserReportCsvQuery, UserReportCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReportCsvQuery, UserReportCsvQueryVariables>(UserReportCsvDocument, options);
      }
export function useUserReportCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReportCsvQuery, UserReportCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReportCsvQuery, UserReportCsvQueryVariables>(UserReportCsvDocument, options);
        }
export type UserReportCsvQueryHookResult = ReturnType<typeof useUserReportCsvQuery>;
export type UserReportCsvLazyQueryHookResult = ReturnType<typeof useUserReportCsvLazyQuery>;
export type UserReportCsvQueryResult = Apollo.QueryResult<UserReportCsvQuery, UserReportCsvQueryVariables>;
export const GetTeamSvixUrlDocument = gql`
    query GetTeamSvixURL($teamSlug: String) {
  team(teamSlug: $teamSlug) {
    webhook_dashboard_url
  }
}
    `;

/**
 * __useGetTeamSvixUrlQuery__
 *
 * To run a query within a React component, call `useGetTeamSvixUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamSvixUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamSvixUrlQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useGetTeamSvixUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamSvixUrlQuery, GetTeamSvixUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamSvixUrlQuery, GetTeamSvixUrlQueryVariables>(GetTeamSvixUrlDocument, options);
      }
export function useGetTeamSvixUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamSvixUrlQuery, GetTeamSvixUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamSvixUrlQuery, GetTeamSvixUrlQueryVariables>(GetTeamSvixUrlDocument, options);
        }
export type GetTeamSvixUrlQueryHookResult = ReturnType<typeof useGetTeamSvixUrlQuery>;
export type GetTeamSvixUrlLazyQueryHookResult = ReturnType<typeof useGetTeamSvixUrlLazyQuery>;
export type GetTeamSvixUrlQueryResult = Apollo.QueryResult<GetTeamSvixUrlQuery, GetTeamSvixUrlQueryVariables>;
export const ChallengeTemplateDocument = gql`
    query ChallengeTemplate($teamSlug: String!, $trackSlug: String!, $challengeSlug: String!) {
  userIsTrackDeveloper(trackSlug: $trackSlug, teamSlug: $teamSlug)
  challenge(
    teamSlug: $teamSlug
    trackSlug: $trackSlug
    challengeSlug: $challengeSlug
  ) {
    id
    slug
    ...PreviewChallenge
  }
}
    ${PreviewChallengeFragmentDoc}`;

/**
 * __useChallengeTemplateQuery__
 *
 * To run a query within a React component, call `useChallengeTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeTemplateQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *   },
 * });
 */
export function useChallengeTemplateQuery(baseOptions: Apollo.QueryHookOptions<ChallengeTemplateQuery, ChallengeTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeTemplateQuery, ChallengeTemplateQueryVariables>(ChallengeTemplateDocument, options);
      }
export function useChallengeTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeTemplateQuery, ChallengeTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeTemplateQuery, ChallengeTemplateQueryVariables>(ChallengeTemplateDocument, options);
        }
export type ChallengeTemplateQueryHookResult = ReturnType<typeof useChallengeTemplateQuery>;
export type ChallengeTemplateLazyQueryHookResult = ReturnType<typeof useChallengeTemplateLazyQuery>;
export type ChallengeTemplateQueryResult = Apollo.QueryResult<ChallengeTemplateQuery, ChallengeTemplateQueryVariables>;
export const PlayAppContainerDocument = gql`
    query PlayAppContainer($trackSlug: String!, $teamSlug: String!, $userID: String) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug, userID: $userID) {
    id
    challenges {
      id
      timelimit
    }
    median_starttime
    idle_timeout
    timelimit
    participant {
      id
      hotStartPool {
        id
      }
    }
  }
  ...IsSkippingEnabledQuery
}
    ${IsSkippingEnabledQueryFragmentDoc}`;

/**
 * __usePlayAppContainerQuery__
 *
 * To run a query within a React component, call `usePlayAppContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayAppContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayAppContainerQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function usePlayAppContainerQuery(baseOptions: Apollo.QueryHookOptions<PlayAppContainerQuery, PlayAppContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayAppContainerQuery, PlayAppContainerQueryVariables>(PlayAppContainerDocument, options);
      }
export function usePlayAppContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayAppContainerQuery, PlayAppContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayAppContainerQuery, PlayAppContainerQueryVariables>(PlayAppContainerDocument, options);
        }
export type PlayAppContainerQueryHookResult = ReturnType<typeof usePlayAppContainerQuery>;
export type PlayAppContainerLazyQueryHookResult = ReturnType<typeof usePlayAppContainerLazyQuery>;
export type PlayAppContainerQueryResult = Apollo.QueryResult<PlayAppContainerQuery, PlayAppContainerQueryVariables>;
export const GetVirtualBrowserChecksForAutoChecksDocument = gql`
    query getVirtualBrowserChecksForAutoChecks($challenge: String!, $host: String!) {
  virtualBrowserCheck(challenge: $challenge, host: $host) {
    id
    host
    browserLocation {
      errorMsg
      conditions {
        urlPart
        condition
      }
    }
    element {
      selector
      value
      errorMsg
    }
    innerText {
      selector
      value
      errorMsg
    }
  }
}
    `;

/**
 * __useGetVirtualBrowserChecksForAutoChecksQuery__
 *
 * To run a query within a React component, call `useGetVirtualBrowserChecksForAutoChecksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVirtualBrowserChecksForAutoChecksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVirtualBrowserChecksForAutoChecksQuery({
 *   variables: {
 *      challenge: // value for 'challenge'
 *      host: // value for 'host'
 *   },
 * });
 */
export function useGetVirtualBrowserChecksForAutoChecksQuery(baseOptions: Apollo.QueryHookOptions<GetVirtualBrowserChecksForAutoChecksQuery, GetVirtualBrowserChecksForAutoChecksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVirtualBrowserChecksForAutoChecksQuery, GetVirtualBrowserChecksForAutoChecksQueryVariables>(GetVirtualBrowserChecksForAutoChecksDocument, options);
      }
export function useGetVirtualBrowserChecksForAutoChecksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVirtualBrowserChecksForAutoChecksQuery, GetVirtualBrowserChecksForAutoChecksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVirtualBrowserChecksForAutoChecksQuery, GetVirtualBrowserChecksForAutoChecksQueryVariables>(GetVirtualBrowserChecksForAutoChecksDocument, options);
        }
export type GetVirtualBrowserChecksForAutoChecksQueryHookResult = ReturnType<typeof useGetVirtualBrowserChecksForAutoChecksQuery>;
export type GetVirtualBrowserChecksForAutoChecksLazyQueryHookResult = ReturnType<typeof useGetVirtualBrowserChecksForAutoChecksLazyQuery>;
export type GetVirtualBrowserChecksForAutoChecksQueryResult = Apollo.QueryResult<GetVirtualBrowserChecksForAutoChecksQuery, GetVirtualBrowserChecksForAutoChecksQueryVariables>;
export const GetAssignmentVirtualBrowserChallengeCheckDocument = gql`
    query getAssignmentVirtualBrowserChallengeCheck($challenge: String!, $host: String!) {
  virtualBrowserCheck(challenge: $challenge, host: $host) {
    id
    host
    browserLocation {
      errorMsg
      conditions {
        urlPart
        condition
      }
    }
    element {
      selector
      value
      errorMsg
    }
    innerText {
      selector
      value
      errorMsg
    }
  }
}
    `;

/**
 * __useGetAssignmentVirtualBrowserChallengeCheckQuery__
 *
 * To run a query within a React component, call `useGetAssignmentVirtualBrowserChallengeCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentVirtualBrowserChallengeCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentVirtualBrowserChallengeCheckQuery({
 *   variables: {
 *      challenge: // value for 'challenge'
 *      host: // value for 'host'
 *   },
 * });
 */
export function useGetAssignmentVirtualBrowserChallengeCheckQuery(baseOptions: Apollo.QueryHookOptions<GetAssignmentVirtualBrowserChallengeCheckQuery, GetAssignmentVirtualBrowserChallengeCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssignmentVirtualBrowserChallengeCheckQuery, GetAssignmentVirtualBrowserChallengeCheckQueryVariables>(GetAssignmentVirtualBrowserChallengeCheckDocument, options);
      }
export function useGetAssignmentVirtualBrowserChallengeCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssignmentVirtualBrowserChallengeCheckQuery, GetAssignmentVirtualBrowserChallengeCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssignmentVirtualBrowserChallengeCheckQuery, GetAssignmentVirtualBrowserChallengeCheckQueryVariables>(GetAssignmentVirtualBrowserChallengeCheckDocument, options);
        }
export type GetAssignmentVirtualBrowserChallengeCheckQueryHookResult = ReturnType<typeof useGetAssignmentVirtualBrowserChallengeCheckQuery>;
export type GetAssignmentVirtualBrowserChallengeCheckLazyQueryHookResult = ReturnType<typeof useGetAssignmentVirtualBrowserChallengeCheckLazyQuery>;
export type GetAssignmentVirtualBrowserChallengeCheckQueryResult = Apollo.QueryResult<GetAssignmentVirtualBrowserChallengeCheckQuery, GetAssignmentVirtualBrowserChallengeCheckQueryVariables>;
export const UpdateAssignmentVirtualBrowserChallengeCheckDocument = gql`
    mutation updateAssignmentVirtualBrowserChallengeCheck($check: VirtualBrowserCheckInput!) {
  upsertVirtualBrowserCheck(virtualBrowserCheck: $check) {
    id
    browserLocation {
      errorMsg
      conditions {
        urlPart
        condition
      }
    }
    element {
      selector
      value
      errorMsg
    }
    innerText {
      selector
      value
      errorMsg
    }
  }
}
    `;
export type UpdateAssignmentVirtualBrowserChallengeCheckMutationFn = Apollo.MutationFunction<UpdateAssignmentVirtualBrowserChallengeCheckMutation, UpdateAssignmentVirtualBrowserChallengeCheckMutationVariables>;

/**
 * __useUpdateAssignmentVirtualBrowserChallengeCheckMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentVirtualBrowserChallengeCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentVirtualBrowserChallengeCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentVirtualBrowserChallengeCheckMutation, { data, loading, error }] = useUpdateAssignmentVirtualBrowserChallengeCheckMutation({
 *   variables: {
 *      check: // value for 'check'
 *   },
 * });
 */
export function useUpdateAssignmentVirtualBrowserChallengeCheckMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentVirtualBrowserChallengeCheckMutation, UpdateAssignmentVirtualBrowserChallengeCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentVirtualBrowserChallengeCheckMutation, UpdateAssignmentVirtualBrowserChallengeCheckMutationVariables>(UpdateAssignmentVirtualBrowserChallengeCheckDocument, options);
      }
export type UpdateAssignmentVirtualBrowserChallengeCheckMutationHookResult = ReturnType<typeof useUpdateAssignmentVirtualBrowserChallengeCheckMutation>;
export type UpdateAssignmentVirtualBrowserChallengeCheckMutationResult = Apollo.MutationResult<UpdateAssignmentVirtualBrowserChallengeCheckMutation>;
export type UpdateAssignmentVirtualBrowserChallengeCheckMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentVirtualBrowserChallengeCheckMutation, UpdateAssignmentVirtualBrowserChallengeCheckMutationVariables>;
export const DeleteAssignmentVirtualBrowserChallengeCheckDocument = gql`
    mutation deleteAssignmentVirtualBrowserChallengeCheck($id: String!) {
  deleteVirtualBrowserCheck(id: $id)
}
    `;
export type DeleteAssignmentVirtualBrowserChallengeCheckMutationFn = Apollo.MutationFunction<DeleteAssignmentVirtualBrowserChallengeCheckMutation, DeleteAssignmentVirtualBrowserChallengeCheckMutationVariables>;

/**
 * __useDeleteAssignmentVirtualBrowserChallengeCheckMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentVirtualBrowserChallengeCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentVirtualBrowserChallengeCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentVirtualBrowserChallengeCheckMutation, { data, loading, error }] = useDeleteAssignmentVirtualBrowserChallengeCheckMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentVirtualBrowserChallengeCheckMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentVirtualBrowserChallengeCheckMutation, DeleteAssignmentVirtualBrowserChallengeCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentVirtualBrowserChallengeCheckMutation, DeleteAssignmentVirtualBrowserChallengeCheckMutationVariables>(DeleteAssignmentVirtualBrowserChallengeCheckDocument, options);
      }
export type DeleteAssignmentVirtualBrowserChallengeCheckMutationHookResult = ReturnType<typeof useDeleteAssignmentVirtualBrowserChallengeCheckMutation>;
export type DeleteAssignmentVirtualBrowserChallengeCheckMutationResult = Apollo.MutationResult<DeleteAssignmentVirtualBrowserChallengeCheckMutation>;
export type DeleteAssignmentVirtualBrowserChallengeCheckMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentVirtualBrowserChallengeCheckMutation, DeleteAssignmentVirtualBrowserChallengeCheckMutationVariables>;
export const StopTrackDocument = gql`
    mutation StopTrack($trackID: String!) {
  stopTrack(trackID: $trackID) {
    id
    status
    challenges {
      id
      slug
      title
      teaser
      status
    }
  }
}
    `;
export type StopTrackMutationFn = Apollo.MutationFunction<StopTrackMutation, StopTrackMutationVariables>;

/**
 * __useStopTrackMutation__
 *
 * To run a mutation, you first call `useStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTrackMutation, { data, loading, error }] = useStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useStopTrackMutation(baseOptions?: Apollo.MutationHookOptions<StopTrackMutation, StopTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopTrackMutation, StopTrackMutationVariables>(StopTrackDocument, options);
      }
export type StopTrackMutationHookResult = ReturnType<typeof useStopTrackMutation>;
export type StopTrackMutationResult = Apollo.MutationResult<StopTrackMutation>;
export type StopTrackMutationOptions = Apollo.BaseMutationOptions<StopTrackMutation, StopTrackMutationVariables>;
export const UpdateTrackReviewDocument = gql`
    mutation UpdateTrackReview($id: String!, $content: String!) {
  updateTrackReview(id: $id, content: $content) {
    id
  }
}
    `;
export type UpdateTrackReviewMutationFn = Apollo.MutationFunction<UpdateTrackReviewMutation, UpdateTrackReviewMutationVariables>;

/**
 * __useUpdateTrackReviewMutation__
 *
 * To run a mutation, you first call `useUpdateTrackReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrackReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrackReviewMutation, { data, loading, error }] = useUpdateTrackReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateTrackReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrackReviewMutation, UpdateTrackReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrackReviewMutation, UpdateTrackReviewMutationVariables>(UpdateTrackReviewDocument, options);
      }
export type UpdateTrackReviewMutationHookResult = ReturnType<typeof useUpdateTrackReviewMutation>;
export type UpdateTrackReviewMutationResult = Apollo.MutationResult<UpdateTrackReviewMutation>;
export type UpdateTrackReviewMutationOptions = Apollo.BaseMutationOptions<UpdateTrackReviewMutation, UpdateTrackReviewMutationVariables>;
export const TrackReviewSaveRatingDocument = gql`
    mutation TrackReviewSaveRating($trackID: String!, $participantID: String!, $score: Int!) {
  createTrackReview(
    trackID: $trackID
    participantID: $participantID
    score: $score
  ) {
    id
  }
}
    `;
export type TrackReviewSaveRatingMutationFn = Apollo.MutationFunction<TrackReviewSaveRatingMutation, TrackReviewSaveRatingMutationVariables>;

/**
 * __useTrackReviewSaveRatingMutation__
 *
 * To run a mutation, you first call `useTrackReviewSaveRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackReviewSaveRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackReviewSaveRatingMutation, { data, loading, error }] = useTrackReviewSaveRatingMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      participantID: // value for 'participantID'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useTrackReviewSaveRatingMutation(baseOptions?: Apollo.MutationHookOptions<TrackReviewSaveRatingMutation, TrackReviewSaveRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackReviewSaveRatingMutation, TrackReviewSaveRatingMutationVariables>(TrackReviewSaveRatingDocument, options);
      }
export type TrackReviewSaveRatingMutationHookResult = ReturnType<typeof useTrackReviewSaveRatingMutation>;
export type TrackReviewSaveRatingMutationResult = Apollo.MutationResult<TrackReviewSaveRatingMutation>;
export type TrackReviewSaveRatingMutationOptions = Apollo.BaseMutationOptions<TrackReviewSaveRatingMutation, TrackReviewSaveRatingMutationVariables>;
export const TrackReviewRatingGetTrackDocument = gql`
    query TrackReviewRatingGetTrack($trackSlug: String!, $teamSlug: String!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    slug
    participant {
      id
    }
  }
}
    `;

/**
 * __useTrackReviewRatingGetTrackQuery__
 *
 * To run a query within a React component, call `useTrackReviewRatingGetTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackReviewRatingGetTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackReviewRatingGetTrackQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *   },
 * });
 */
export function useTrackReviewRatingGetTrackQuery(baseOptions: Apollo.QueryHookOptions<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>(TrackReviewRatingGetTrackDocument, options);
      }
export function useTrackReviewRatingGetTrackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>(TrackReviewRatingGetTrackDocument, options);
        }
export type TrackReviewRatingGetTrackQueryHookResult = ReturnType<typeof useTrackReviewRatingGetTrackQuery>;
export type TrackReviewRatingGetTrackLazyQueryHookResult = ReturnType<typeof useTrackReviewRatingGetTrackLazyQuery>;
export type TrackReviewRatingGetTrackQueryResult = Apollo.QueryResult<TrackReviewRatingGetTrackQuery, TrackReviewRatingGetTrackQueryVariables>;
export const TrackAndChallengeStatusDocument = gql`
    query TrackAndChallengeStatus($trackID: String!, $challengeID: String!, $userID: String, $inviteID: String) {
  track(trackID: $trackID, userID: $userID, inviteID: $inviteID) {
    id
    slug
    status
    creating
  }
  challenge(challengeID: $challengeID, userID: $userID, inviteID: $inviteID) {
    id
    status
    failMessage
  }
}
    `;

/**
 * __useTrackAndChallengeStatusQuery__
 *
 * To run a query within a React component, call `useTrackAndChallengeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrackAndChallengeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrackAndChallengeStatusQuery({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useTrackAndChallengeStatusQuery(baseOptions: Apollo.QueryHookOptions<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>(TrackAndChallengeStatusDocument, options);
      }
export function useTrackAndChallengeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>(TrackAndChallengeStatusDocument, options);
        }
export type TrackAndChallengeStatusQueryHookResult = ReturnType<typeof useTrackAndChallengeStatusQuery>;
export type TrackAndChallengeStatusLazyQueryHookResult = ReturnType<typeof useTrackAndChallengeStatusLazyQuery>;
export type TrackAndChallengeStatusQueryResult = Apollo.QueryResult<TrackAndChallengeStatusQuery, TrackAndChallengeStatusQueryVariables>;
export const SetupChallengeDocument = gql`
    mutation SetupChallenge($challengeID: String!) {
  setupChallenge(challengeID: $challengeID) {
    id
  }
}
    `;
export type SetupChallengeMutationFn = Apollo.MutationFunction<SetupChallengeMutation, SetupChallengeMutationVariables>;

/**
 * __useSetupChallengeMutation__
 *
 * To run a mutation, you first call `useSetupChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupChallengeMutation, { data, loading, error }] = useSetupChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useSetupChallengeMutation(baseOptions?: Apollo.MutationHookOptions<SetupChallengeMutation, SetupChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupChallengeMutation, SetupChallengeMutationVariables>(SetupChallengeDocument, options);
      }
export type SetupChallengeMutationHookResult = ReturnType<typeof useSetupChallengeMutation>;
export type SetupChallengeMutationResult = Apollo.MutationResult<SetupChallengeMutation>;
export type SetupChallengeMutationOptions = Apollo.BaseMutationOptions<SetupChallengeMutation, SetupChallengeMutationVariables>;
export const ClaimGatedEmbedTrackInviteDocument = gql`
    mutation ClaimGatedEmbedTrackInvite($inviteID: String!, $userDetails: UserDetailsInput, $customParameters: [CustomParametersInput!]) {
  claimTrackInvite(
    inviteID: $inviteID
    userDetails: $userDetails
    customParameters: $customParameters
  ) {
    id
    trackInvite {
      id
      currentUserClaim {
        id
        playTTL
      }
    }
  }
}
    `;
export type ClaimGatedEmbedTrackInviteMutationFn = Apollo.MutationFunction<ClaimGatedEmbedTrackInviteMutation, ClaimGatedEmbedTrackInviteMutationVariables>;

/**
 * __useClaimGatedEmbedTrackInviteMutation__
 *
 * To run a mutation, you first call `useClaimGatedEmbedTrackInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimGatedEmbedTrackInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimGatedEmbedTrackInviteMutation, { data, loading, error }] = useClaimGatedEmbedTrackInviteMutation({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *      userDetails: // value for 'userDetails'
 *      customParameters: // value for 'customParameters'
 *   },
 * });
 */
export function useClaimGatedEmbedTrackInviteMutation(baseOptions?: Apollo.MutationHookOptions<ClaimGatedEmbedTrackInviteMutation, ClaimGatedEmbedTrackInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimGatedEmbedTrackInviteMutation, ClaimGatedEmbedTrackInviteMutationVariables>(ClaimGatedEmbedTrackInviteDocument, options);
      }
export type ClaimGatedEmbedTrackInviteMutationHookResult = ReturnType<typeof useClaimGatedEmbedTrackInviteMutation>;
export type ClaimGatedEmbedTrackInviteMutationResult = Apollo.MutationResult<ClaimGatedEmbedTrackInviteMutation>;
export type ClaimGatedEmbedTrackInviteMutationOptions = Apollo.BaseMutationOptions<ClaimGatedEmbedTrackInviteMutation, ClaimGatedEmbedTrackInviteMutationVariables>;
export const ConsentToTeamPrivacyPolicyGatedEmbedDocument = gql`
    mutation ConsentToTeamPrivacyPolicyGatedEmbed($teamID: String!, $consent: Boolean!) {
  consentToTeamPrivacyPolicy(teamID: $teamID, consent: $consent)
}
    `;
export type ConsentToTeamPrivacyPolicyGatedEmbedMutationFn = Apollo.MutationFunction<ConsentToTeamPrivacyPolicyGatedEmbedMutation, ConsentToTeamPrivacyPolicyGatedEmbedMutationVariables>;

/**
 * __useConsentToTeamPrivacyPolicyGatedEmbedMutation__
 *
 * To run a mutation, you first call `useConsentToTeamPrivacyPolicyGatedEmbedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsentToTeamPrivacyPolicyGatedEmbedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consentToTeamPrivacyPolicyGatedEmbedMutation, { data, loading, error }] = useConsentToTeamPrivacyPolicyGatedEmbedMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useConsentToTeamPrivacyPolicyGatedEmbedMutation(baseOptions?: Apollo.MutationHookOptions<ConsentToTeamPrivacyPolicyGatedEmbedMutation, ConsentToTeamPrivacyPolicyGatedEmbedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsentToTeamPrivacyPolicyGatedEmbedMutation, ConsentToTeamPrivacyPolicyGatedEmbedMutationVariables>(ConsentToTeamPrivacyPolicyGatedEmbedDocument, options);
      }
export type ConsentToTeamPrivacyPolicyGatedEmbedMutationHookResult = ReturnType<typeof useConsentToTeamPrivacyPolicyGatedEmbedMutation>;
export type ConsentToTeamPrivacyPolicyGatedEmbedMutationResult = Apollo.MutationResult<ConsentToTeamPrivacyPolicyGatedEmbedMutation>;
export type ConsentToTeamPrivacyPolicyGatedEmbedMutationOptions = Apollo.BaseMutationOptions<ConsentToTeamPrivacyPolicyGatedEmbedMutation, ConsentToTeamPrivacyPolicyGatedEmbedMutationVariables>;
export const GatedEmbedPageDocument = gql`
    query GatedEmbedPage($inviteID: String!) {
  trackInvite(inviteID: $inviteID) {
    id
    title
    publicTitle
    publicDescription
    tracks {
      id
      title
      slug
      challenges {
        id
        slug
      }
    }
    team {
      id
      name
      logo
      privacy_policy
      slug
      form {
        formTitle
        consentNotice
        validateWorkEmail
        fields {
          id
          fieldName
          isRequired
        }
      }
      theme {
        foreground_color
        background_color
        background_image
      }
      features {
        accept_terms_checkbox
      }
    }
    currentUserClaim {
      id
      playTTL
    }
  }
}
    `;

/**
 * __useGatedEmbedPageQuery__
 *
 * To run a query within a React component, call `useGatedEmbedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGatedEmbedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGatedEmbedPageQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useGatedEmbedPageQuery(baseOptions: Apollo.QueryHookOptions<GatedEmbedPageQuery, GatedEmbedPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GatedEmbedPageQuery, GatedEmbedPageQueryVariables>(GatedEmbedPageDocument, options);
      }
export function useGatedEmbedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GatedEmbedPageQuery, GatedEmbedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GatedEmbedPageQuery, GatedEmbedPageQueryVariables>(GatedEmbedPageDocument, options);
        }
export type GatedEmbedPageQueryHookResult = ReturnType<typeof useGatedEmbedPageQuery>;
export type GatedEmbedPageLazyQueryHookResult = ReturnType<typeof useGatedEmbedPageLazyQuery>;
export type GatedEmbedPageQueryResult = Apollo.QueryResult<GatedEmbedPageQuery, GatedEmbedPageQueryVariables>;
export const CheckChallengeDocument = gql`
    mutation CheckChallenge($challengeID: String!, $inviteID: String, $userID: String) {
  checkChallenge(challengeID: $challengeID, inviteID: $inviteID, userID: $userID) {
    id
    status
    attempts {
      timestamp
      message
    }
    unlocks {
      id
      permalink
    }
  }
}
    `;
export type CheckChallengeMutationFn = Apollo.MutationFunction<CheckChallengeMutation, CheckChallengeMutationVariables>;

/**
 * __useCheckChallengeMutation__
 *
 * To run a mutation, you first call `useCheckChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkChallengeMutation, { data, loading, error }] = useCheckChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useCheckChallengeMutation(baseOptions?: Apollo.MutationHookOptions<CheckChallengeMutation, CheckChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckChallengeMutation, CheckChallengeMutationVariables>(CheckChallengeDocument, options);
      }
export type CheckChallengeMutationHookResult = ReturnType<typeof useCheckChallengeMutation>;
export type CheckChallengeMutationResult = Apollo.MutationResult<CheckChallengeMutation>;
export type CheckChallengeMutationOptions = Apollo.BaseMutationOptions<CheckChallengeMutation, CheckChallengeMutationVariables>;
export const CheckQuizDocument = gql`
    mutation CheckQuiz($challengeID: String!, $userID: String, $inviteID: String, $solution: [Int!]!) {
  checkQuiz(
    challengeID: $challengeID
    userID: $userID
    inviteID: $inviteID
    solution: $solution
  ) {
    id
    status
    attempts {
      timestamp
      message
    }
    unlocks {
      id
      permalink
    }
  }
}
    `;
export type CheckQuizMutationFn = Apollo.MutationFunction<CheckQuizMutation, CheckQuizMutationVariables>;

/**
 * __useCheckQuizMutation__
 *
 * To run a mutation, you first call `useCheckQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkQuizMutation, { data, loading, error }] = useCheckQuizMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *      solution: // value for 'solution'
 *   },
 * });
 */
export function useCheckQuizMutation(baseOptions?: Apollo.MutationHookOptions<CheckQuizMutation, CheckQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckQuizMutation, CheckQuizMutationVariables>(CheckQuizDocument, options);
      }
export type CheckQuizMutationHookResult = ReturnType<typeof useCheckQuizMutation>;
export type CheckQuizMutationResult = Apollo.MutationResult<CheckQuizMutation>;
export type CheckQuizMutationOptions = Apollo.BaseMutationOptions<CheckQuizMutation, CheckQuizMutationVariables>;
export const LearnEnvironmentKeepAliveDocument = gql`
    mutation LearnEnvironmentKeepAlive($trackId: ID!) {
  keepAlive(trackID: $trackId)
}
    `;
export type LearnEnvironmentKeepAliveMutationFn = Apollo.MutationFunction<LearnEnvironmentKeepAliveMutation, LearnEnvironmentKeepAliveMutationVariables>;

/**
 * __useLearnEnvironmentKeepAliveMutation__
 *
 * To run a mutation, you first call `useLearnEnvironmentKeepAliveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentKeepAliveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learnEnvironmentKeepAliveMutation, { data, loading, error }] = useLearnEnvironmentKeepAliveMutation({
 *   variables: {
 *      trackId: // value for 'trackId'
 *   },
 * });
 */
export function useLearnEnvironmentKeepAliveMutation(baseOptions?: Apollo.MutationHookOptions<LearnEnvironmentKeepAliveMutation, LearnEnvironmentKeepAliveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearnEnvironmentKeepAliveMutation, LearnEnvironmentKeepAliveMutationVariables>(LearnEnvironmentKeepAliveDocument, options);
      }
export type LearnEnvironmentKeepAliveMutationHookResult = ReturnType<typeof useLearnEnvironmentKeepAliveMutation>;
export type LearnEnvironmentKeepAliveMutationResult = Apollo.MutationResult<LearnEnvironmentKeepAliveMutation>;
export type LearnEnvironmentKeepAliveMutationOptions = Apollo.BaseMutationOptions<LearnEnvironmentKeepAliveMutation, LearnEnvironmentKeepAliveMutationVariables>;
export const LearnEnvironmentDocument = gql`
    query LearnEnvironment($trackSlug: String!, $challengeSlug: String!, $teamSlug: String!, $userID: String, $inviteID: String) {
  team(teamSlug: $teamSlug) {
    id
    slug
    name
    features {
      track_reviews
      service_tab_focus_overlay
      members_skip_to_challenge
      use_new_terminal
    }
  }
  track(trackSlug: $trackSlug, teamSlug: $teamSlug, userID: $userID) {
    id
    title
    permalink
    slug
    status
    started
    creating
    created
    failed
    stopped
    completed
    cleaned
    show_timer
    ttl
    idle_timeout
    challenges {
      id
      status
      index
      permalink
      ...ProgressChallenge
    }
    participant {
      id
      ttlExtendedByUser
    }
    lab_config {
      overlay
      position
      width
      extendTTL
    }
    ...ProgressTrack
    ...ExpiredScreenTrack
  }
  userInTeam(teamSlug: $teamSlug)
  challenge(
    trackSlug: $trackSlug
    teamSlug: $teamSlug
    challengeSlug: $challengeSlug
    userID: $userID
    inviteID: $inviteID
    parseAssignmentVariables: true
  ) {
    id
    type
    index
    teaser
    permalink
    title
    slug
    status
    assignment
    answers
    can_check
    failed
    notes {
      id
      type
      contents
      url
    }
    attempts {
      timestamp
      message
    }
    tabs {
      hostname
    }
    ...WorkspaceChallenge
  }
  ...IsSkippingEnabledQuery
}
    ${ProgressChallengeFragmentDoc}
${ProgressTrackFragmentDoc}
${ExpiredScreenTrackFragmentDoc}
${WorkspaceChallengeFragmentDoc}
${IsSkippingEnabledQueryFragmentDoc}`;

/**
 * __useLearnEnvironmentQuery__
 *
 * To run a query within a React component, call `useLearnEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnEnvironmentQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *      teamSlug: // value for 'teamSlug'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useLearnEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>(LearnEnvironmentDocument, options);
      }
export function useLearnEnvironmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>(LearnEnvironmentDocument, options);
        }
export type LearnEnvironmentQueryHookResult = ReturnType<typeof useLearnEnvironmentQuery>;
export type LearnEnvironmentLazyQueryHookResult = ReturnType<typeof useLearnEnvironmentLazyQuery>;
export type LearnEnvironmentQueryResult = Apollo.QueryResult<LearnEnvironmentQuery, LearnEnvironmentQueryVariables>;
export const ExtendSandboxTtlDocument = gql`
    mutation extendSandboxTTL($sandboxID: String!, $until: Time!) {
  updateSandboxTTL(sandboxID: $sandboxID, until: $until) {
    id
    track {
      id
      ttl
      participant {
        id
        ttlExtendedByUser
      }
    }
  }
}
    `;
export type ExtendSandboxTtlMutationFn = Apollo.MutationFunction<ExtendSandboxTtlMutation, ExtendSandboxTtlMutationVariables>;

/**
 * __useExtendSandboxTtlMutation__
 *
 * To run a mutation, you first call `useExtendSandboxTtlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtendSandboxTtlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extendSandboxTtlMutation, { data, loading, error }] = useExtendSandboxTtlMutation({
 *   variables: {
 *      sandboxID: // value for 'sandboxID'
 *      until: // value for 'until'
 *   },
 * });
 */
export function useExtendSandboxTtlMutation(baseOptions?: Apollo.MutationHookOptions<ExtendSandboxTtlMutation, ExtendSandboxTtlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtendSandboxTtlMutation, ExtendSandboxTtlMutationVariables>(ExtendSandboxTtlDocument, options);
      }
export type ExtendSandboxTtlMutationHookResult = ReturnType<typeof useExtendSandboxTtlMutation>;
export type ExtendSandboxTtlMutationResult = Apollo.MutationResult<ExtendSandboxTtlMutation>;
export type ExtendSandboxTtlMutationOptions = Apollo.BaseMutationOptions<ExtendSandboxTtlMutation, ExtendSandboxTtlMutationVariables>;
export const LearnEnvironmentStopTrackDocument = gql`
    mutation LearnEnvironmentStopTrack($trackID: String!) {
  stopTrack(trackID: $trackID) {
    id
  }
}
    `;
export type LearnEnvironmentStopTrackMutationFn = Apollo.MutationFunction<LearnEnvironmentStopTrackMutation, LearnEnvironmentStopTrackMutationVariables>;

/**
 * __useLearnEnvironmentStopTrackMutation__
 *
 * To run a mutation, you first call `useLearnEnvironmentStopTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentStopTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [learnEnvironmentStopTrackMutation, { data, loading, error }] = useLearnEnvironmentStopTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *   },
 * });
 */
export function useLearnEnvironmentStopTrackMutation(baseOptions?: Apollo.MutationHookOptions<LearnEnvironmentStopTrackMutation, LearnEnvironmentStopTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LearnEnvironmentStopTrackMutation, LearnEnvironmentStopTrackMutationVariables>(LearnEnvironmentStopTrackDocument, options);
      }
export type LearnEnvironmentStopTrackMutationHookResult = ReturnType<typeof useLearnEnvironmentStopTrackMutation>;
export type LearnEnvironmentStopTrackMutationResult = Apollo.MutationResult<LearnEnvironmentStopTrackMutation>;
export type LearnEnvironmentStopTrackMutationOptions = Apollo.BaseMutationOptions<LearnEnvironmentStopTrackMutation, LearnEnvironmentStopTrackMutationVariables>;
export const LearnEnvironmentInviteDocument = gql`
    query learnEnvironmentInvite($inviteID: String!) {
  trackInvite(inviteID: $inviteID) {
    id
    canClaim
    enableLearnerSharing
    allowAnonymous
    allowedEmailAddresses
  }
}
    `;

/**
 * __useLearnEnvironmentInviteQuery__
 *
 * To run a query within a React component, call `useLearnEnvironmentInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearnEnvironmentInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearnEnvironmentInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useLearnEnvironmentInviteQuery(baseOptions: Apollo.QueryHookOptions<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>(LearnEnvironmentInviteDocument, options);
      }
export function useLearnEnvironmentInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>(LearnEnvironmentInviteDocument, options);
        }
export type LearnEnvironmentInviteQueryHookResult = ReturnType<typeof useLearnEnvironmentInviteQuery>;
export type LearnEnvironmentInviteLazyQueryHookResult = ReturnType<typeof useLearnEnvironmentInviteLazyQuery>;
export type LearnEnvironmentInviteQueryResult = Apollo.QueryResult<LearnEnvironmentInviteQuery, LearnEnvironmentInviteQueryVariables>;
export const NotesContainerStartTrackDocument = gql`
    mutation NotesContainerStartTrack($trackID: String!, $inviteID: String, $mode: Mode, $customParameters: [CustomParametersInput!], $runtimeParameters: RuntimeParametersInput, $forceStart: Boolean, $region: String) {
  startTrack(
    trackID: $trackID
    inviteID: $inviteID
    recaptchaToken: ""
    mode: $mode
    customParameters: $customParameters
    runtimeParameters: $runtimeParameters
    force: $forceStart
    region: $region
  ) {
    id
    status
    permalink
    challenges {
      id
      slug
      status
    }
  }
}
    `;
export type NotesContainerStartTrackMutationFn = Apollo.MutationFunction<NotesContainerStartTrackMutation, NotesContainerStartTrackMutationVariables>;

/**
 * __useNotesContainerStartTrackMutation__
 *
 * To run a mutation, you first call `useNotesContainerStartTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerStartTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesContainerStartTrackMutation, { data, loading, error }] = useNotesContainerStartTrackMutation({
 *   variables: {
 *      trackID: // value for 'trackID'
 *      inviteID: // value for 'inviteID'
 *      mode: // value for 'mode'
 *      customParameters: // value for 'customParameters'
 *      runtimeParameters: // value for 'runtimeParameters'
 *      forceStart: // value for 'forceStart'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useNotesContainerStartTrackMutation(baseOptions?: Apollo.MutationHookOptions<NotesContainerStartTrackMutation, NotesContainerStartTrackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesContainerStartTrackMutation, NotesContainerStartTrackMutationVariables>(NotesContainerStartTrackDocument, options);
      }
export type NotesContainerStartTrackMutationHookResult = ReturnType<typeof useNotesContainerStartTrackMutation>;
export type NotesContainerStartTrackMutationResult = Apollo.MutationResult<NotesContainerStartTrackMutation>;
export type NotesContainerStartTrackMutationOptions = Apollo.BaseMutationOptions<NotesContainerStartTrackMutation, NotesContainerStartTrackMutationVariables>;
export const NotesContainerStartChallengeDocument = gql`
    mutation NotesContainerStartChallenge($challengeID: String!) {
  startChallenge(challengeID: $challengeID) {
    id
    status
    assignment
    tabs {
      type
      title
      target
    }
  }
}
    `;
export type NotesContainerStartChallengeMutationFn = Apollo.MutationFunction<NotesContainerStartChallengeMutation, NotesContainerStartChallengeMutationVariables>;

/**
 * __useNotesContainerStartChallengeMutation__
 *
 * To run a mutation, you first call `useNotesContainerStartChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerStartChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notesContainerStartChallengeMutation, { data, loading, error }] = useNotesContainerStartChallengeMutation({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *   },
 * });
 */
export function useNotesContainerStartChallengeMutation(baseOptions?: Apollo.MutationHookOptions<NotesContainerStartChallengeMutation, NotesContainerStartChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotesContainerStartChallengeMutation, NotesContainerStartChallengeMutationVariables>(NotesContainerStartChallengeDocument, options);
      }
export type NotesContainerStartChallengeMutationHookResult = ReturnType<typeof useNotesContainerStartChallengeMutation>;
export type NotesContainerStartChallengeMutationResult = Apollo.MutationResult<NotesContainerStartChallengeMutation>;
export type NotesContainerStartChallengeMutationOptions = Apollo.BaseMutationOptions<NotesContainerStartChallengeMutation, NotesContainerStartChallengeMutationVariables>;
export const NotesContainerDocument = gql`
    query notesContainer($trackSlug: String, $challengeSlug: String!, $teamSlug: String!, $inviteID: String, $userID: String) {
  track(
    trackSlug: $trackSlug
    teamSlug: $teamSlug
    userID: $userID
    inviteID: $inviteID
  ) {
    id
    permalink
    slug
    status
    creating
    completed
    median_starttime
    participant {
      id
    }
    challenges {
      id
      title
      status
      permalink
      ...ProgressChallenge
    }
    team {
      id
      name
    }
  }
  challenge(
    trackSlug: $trackSlug
    teamSlug: $teamSlug
    challengeSlug: $challengeSlug
    userID: $userID
    inviteID: $inviteID
  ) {
    id
    index
    title
    permalink
    slug
    status
    teaser
    type
    failed
    notes {
      id
      type
      contents
      url
    }
  }
  ...IsSkippingEnabledQuery
}
    ${ProgressChallengeFragmentDoc}
${IsSkippingEnabledQueryFragmentDoc}`;

/**
 * __useNotesContainerQuery__
 *
 * To run a query within a React component, call `useNotesContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesContainerQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      challengeSlug: // value for 'challengeSlug'
 *      teamSlug: // value for 'teamSlug'
 *      inviteID: // value for 'inviteID'
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useNotesContainerQuery(baseOptions: Apollo.QueryHookOptions<NotesContainerQuery, NotesContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesContainerQuery, NotesContainerQueryVariables>(NotesContainerDocument, options);
      }
export function useNotesContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesContainerQuery, NotesContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesContainerQuery, NotesContainerQueryVariables>(NotesContainerDocument, options);
        }
export type NotesContainerQueryHookResult = ReturnType<typeof useNotesContainerQuery>;
export type NotesContainerLazyQueryHookResult = ReturnType<typeof useNotesContainerLazyQuery>;
export type NotesContainerQueryResult = Apollo.QueryResult<NotesContainerQuery, NotesContainerQueryVariables>;
export const NotesContainerInviteDocument = gql`
    query notesContainerInvite($inviteID: String!) {
  trackInvite(inviteID: $inviteID) {
    id
    canClaim
    enableLearnerSharing
    allowAnonymous
    allowedEmailAddresses
  }
}
    `;

/**
 * __useNotesContainerInviteQuery__
 *
 * To run a query within a React component, call `useNotesContainerInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesContainerInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesContainerInviteQuery({
 *   variables: {
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useNotesContainerInviteQuery(baseOptions: Apollo.QueryHookOptions<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>(NotesContainerInviteDocument, options);
      }
export function useNotesContainerInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>(NotesContainerInviteDocument, options);
        }
export type NotesContainerInviteQueryHookResult = ReturnType<typeof useNotesContainerInviteQuery>;
export type NotesContainerInviteLazyQueryHookResult = ReturnType<typeof useNotesContainerInviteLazyQuery>;
export type NotesContainerInviteQueryResult = Apollo.QueryResult<NotesContainerInviteQuery, NotesContainerInviteQueryVariables>;
export const RecapDocument = gql`
    query Recap($trackSlug: String!, $teamSlug: String!, $inviteID: String!, $skipInvite: Boolean!) {
  track(trackSlug: $trackSlug, teamSlug: $teamSlug) {
    id
    title
    permalink
    ...ProgressTrack
    challenges {
      permalink
      ...ProgressChallenge
    }
    participant {
      id
    }
  }
  trackInvite(inviteID: $inviteID) @skip(if: $skipInvite) {
    id
    canClaim
    enableLearnerSharing
    allowAnonymous
    allowedEmailAddresses
  }
  ...IsSkippingEnabledQuery
}
    ${ProgressTrackFragmentDoc}
${ProgressChallengeFragmentDoc}
${IsSkippingEnabledQueryFragmentDoc}`;

/**
 * __useRecapQuery__
 *
 * To run a query within a React component, call `useRecapQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecapQuery({
 *   variables: {
 *      trackSlug: // value for 'trackSlug'
 *      teamSlug: // value for 'teamSlug'
 *      inviteID: // value for 'inviteID'
 *      skipInvite: // value for 'skipInvite'
 *   },
 * });
 */
export function useRecapQuery(baseOptions: Apollo.QueryHookOptions<RecapQuery, RecapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecapQuery, RecapQueryVariables>(RecapDocument, options);
      }
export function useRecapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecapQuery, RecapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecapQuery, RecapQueryVariables>(RecapDocument, options);
        }
export type RecapQueryHookResult = ReturnType<typeof useRecapQuery>;
export type RecapLazyQueryHookResult = ReturnType<typeof useRecapLazyQuery>;
export type RecapQueryResult = Apollo.QueryResult<RecapQuery, RecapQueryVariables>;
export const SplashScreenDocument = gql`
    query SplashScreen($teamSlug: String!, $trackSlug: String!) {
  track(teamSlug: $teamSlug, trackSlug: $trackSlug) {
    id
    title
    teaser
    status
    challenges {
      status
      slug
      started
      permalink
      completed
      title
    }
    participant {
      id
    }
  }
}
    `;

/**
 * __useSplashScreenQuery__
 *
 * To run a query within a React component, call `useSplashScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSplashScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSplashScreenQuery({
 *   variables: {
 *      teamSlug: // value for 'teamSlug'
 *      trackSlug: // value for 'trackSlug'
 *   },
 * });
 */
export function useSplashScreenQuery(baseOptions: Apollo.QueryHookOptions<SplashScreenQuery, SplashScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SplashScreenQuery, SplashScreenQueryVariables>(SplashScreenDocument, options);
      }
export function useSplashScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SplashScreenQuery, SplashScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SplashScreenQuery, SplashScreenQueryVariables>(SplashScreenDocument, options);
        }
export type SplashScreenQueryHookResult = ReturnType<typeof useSplashScreenQuery>;
export type SplashScreenLazyQueryHookResult = ReturnType<typeof useSplashScreenLazyQuery>;
export type SplashScreenQueryResult = Apollo.QueryResult<SplashScreenQuery, SplashScreenQueryVariables>;
export const ChallengeStatusDocument = gql`
    query ChallengeStatus($challengeID: String!, $userID: String, $inviteID: String) {
  challenge(challengeID: $challengeID, userID: $userID, inviteID: $inviteID) {
    status
    failed
    failMessage
  }
}
    `;

/**
 * __useChallengeStatusQuery__
 *
 * To run a query within a React component, call `useChallengeStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useChallengeStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChallengeStatusQuery({
 *   variables: {
 *      challengeID: // value for 'challengeID'
 *      userID: // value for 'userID'
 *      inviteID: // value for 'inviteID'
 *   },
 * });
 */
export function useChallengeStatusQuery(baseOptions: Apollo.QueryHookOptions<ChallengeStatusQuery, ChallengeStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChallengeStatusQuery, ChallengeStatusQueryVariables>(ChallengeStatusDocument, options);
      }
export function useChallengeStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChallengeStatusQuery, ChallengeStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChallengeStatusQuery, ChallengeStatusQueryVariables>(ChallengeStatusDocument, options);
        }
export type ChallengeStatusQueryHookResult = ReturnType<typeof useChallengeStatusQuery>;
export type ChallengeStatusLazyQueryHookResult = ReturnType<typeof useChallengeStatusLazyQuery>;
export type ChallengeStatusQueryResult = Apollo.QueryResult<ChallengeStatusQuery, ChallengeStatusQueryVariables>;
export const GetInstruqtUserDocument = gql`
    query GetInstruqtUser {
  me {
    ...AuthenticationUser
  }
}
    ${AuthenticationUserFragmentDoc}`;

/**
 * __useGetInstruqtUserQuery__
 *
 * To run a query within a React component, call `useGetInstruqtUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstruqtUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstruqtUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInstruqtUserQuery(baseOptions?: Apollo.QueryHookOptions<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>(GetInstruqtUserDocument, options);
      }
export function useGetInstruqtUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>(GetInstruqtUserDocument, options);
        }
export type GetInstruqtUserQueryHookResult = ReturnType<typeof useGetInstruqtUserQuery>;
export type GetInstruqtUserLazyQueryHookResult = ReturnType<typeof useGetInstruqtUserLazyQuery>;
export type GetInstruqtUserQueryResult = Apollo.QueryResult<GetInstruqtUserQuery, GetInstruqtUserQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Progress": [
      "LearningPathProgress",
      "TrackProgress"
    ],
    "SsoConnectionOptions": [
      "DefaultSsoConnectionOptions",
      "SamlSsoConnectionOptions"
    ]
  }
};
      export default result;
    